export default [
  {
    "slug": "vzp",
    "updateDate": "30.3.2026",
    "companyBenefitsLink": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky",
    "genders": [
      {
        "name": {
          "cs": "Muži",
          "sk": "Muži",
          "en": "Men"
        },
        "benefits": [
          {
            "type": {
              "cs": "Pohybové aktivity a dentální hygiena",
              "sk": "Pohybové a športové aktivity alebo dentálna hygiena",
              "en": "Physical activity and dental hygiene"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 500 Kč na pohybové aktivity a sportovní aktivity nebo dentální hygienu od 18 do 65 let",
              "sk": "Až 500 Kč na pohybové aktivity a športové aktivity alebo dentálne hygienu od 18 do 65 let",
              "en": "Up to 500 CZK for physical and sports activities or dental hygiene for people aged 18 to 65"
            },
            "description": {
              "cs": "Příspěvek je určen na pravidelnou pohybovou a zároveň sportovní aktivitu dlouhodobého charakteru nebo poskytnutou fyzioterapeutem a dentální hygienu (ošetření a instruktáž).\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok je poskytovaný na pravidelnú pohybovú a zároveň športové aktivitu (např. aerobic, badminton, florbal, fotbal, kalanetika, plavání, spinning, pilates, kruhový trénink, jóga aj.) alebo dentálne hygienu (ošetření a instruktáž).\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution is intended for regular, long-term physical and sports activities, or those provided by a physical therapist, as well as dental hygiene (treatment and instruction).\n\nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/pohyb-a-dentalni-hygiena/dospely",
            "category": "Muži"
          },
          {
            "type": {
              "cs": "Rehabilitační procedury",
              "sk": "Rehabilitačné a rekondičné aktivity",
              "en": "Rehabilitation treatments"
            },
            "icon": "heart",
            "benefit": {
              "cs": "Příspěvek do max. výše 1 000 Kč pro pojištěnce (nad 18 let)",
              "sk": "Až 1000 Kč na rehabilitačné a rekondičné aktivity pre dospělé nad 18 let",
              "en": "A contribution of up to 1,000 CZK for insured person (over 18 years of age)"
            },
            "description": {
              "cs": "Příspěvek je na rehabilitační a rekondiční aktivity lázeňského typu nehrazené z v.z.p. Jedná se například o masáže, saunu, plavání, solné jeskyně, kryokomory nebo kneippovy chodníky. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok sa vzťahuje na rehabilitačné a rekreačné aktivity kúpeľného charakteru, ktoré nie sú hradené zo zdravotného poistenia. Ide napríklad o masáže, saunu, plávanie, soľné jaskyne, kryokomory alebo Kneippove chodníky. \nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution covers spa-style rehabilitation and wellness activities not covered by health insurance. These include, for example, massages, saunas, swimming, salt caves, cryochambers, and Kneipp paths. \nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/rehabilitacni-procedury",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 14 900 Kč na různé druhy očkování",
              "sk": "Až 14 900 Kč na rôzne druhy očkovania",
              "en": "Up to CZK 14 900 for various types of vaccination"
            },
            "description": {
              "cs": "Příspěvek je poskytován na očkování, která nejsou hrazena z veřejného zdravotního pojištění, tj., kde si pojištěnec plně platí vakcínu i její aplikaci. Příspěvek se nevztahuje na úhradu případného doplatku rozdílu mezi úhradou z veřejného zdravotního pojištění a platbou u lékaře.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok sa poskytuje na očkovania, ktoré nie sú hradené z verejného zdravotného poistenia, t. j. v prípadoch, keď poistenec v plnej výške hradí vakcínu aj jej podanie. Príspevok sa nevzťahuje na úhradu prípadného doplatku rozdielu medzi úhradou z verejného zdravotného poistenia a platbou u lekára.\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.“",
              "en": "This contribution is for vaccination that is not funded by public health insurance, i.e., where the insured pays for the vaccine as well as its application in full. The contribution does not apply to payment of any difference between funding from public health insurance and a payment to a doctor.\nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/ockovani/dospely",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora při nemoci diabetes mellitus",
              "sk": "Podpora pri cukrovke",
              "en": "Support for people with diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 6 000 Kč pro diabetiky",
              "sk": "Až 6 000 Kč pre diabetikov",
              "en": "Up to 6,000 CZK for people with diabetes"
            },
            "description": {
              "cs": "Jedná se o příspěvek na na edukační pobyty, na přístrojové ošetření nohou a 1 vybrané rehabilitační procedury/terapie lázeňského typu.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Ide o príspevok na vzdelávacie pobyty, na prístrojovú starostlivosť o nohy a 1 vybranú rehabilitačnú procedúru/terapiu kúpeľného typu.\nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "This is a contribution to educational stays, instrumental foot treatments, and one selected spa-type rehabilitation procedure or therapy.\nFor more information, visit the health insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/diabetes-mellitus",
            "category": null
          },
          {
            "type": {
              "cs": "Speciální diety",
              "sk": "Špeciálne diéty",
              "en": "Special diets"
            },
            "icon": "zdravy-talir",
            "benefit": {
              "cs": "Až 8 000 Kč na bezlepkovou dietu a až 12 000 Kč na nízkobílkovinnou dietu pro pojištěnce do 26 let",
              "sk": "Až 8 000 Kč na bezlepkovú stravu a až 12 000 Kč na nízkobielkovinovú stravu pre poistencov do 26 rokov",
              "en": "Up to 8,000 CZK for a gluten-free diet and up to 12,000 CZK for a low-protein diet for insured individuals under 26 years of age"
            },
            "description": {
              "cs": "Příspěvek na bezlepkové potraviny nebo na platbu bezlepkových obědů ve školní jídelně nebo na nízkobílkovinné, bezlaktózové nebo bezlepkové potraviny. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok na bezlepkové potraviny alebo na úhradu bezlepkových obedov v školskej jedálni, prípadne na nízkobielkovinové, bezlaktózové alebo bezlepkové potraviny. \nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution for gluten-free foods, for gluten-free lunches in the school cafeteria, or for low-protein, lactose-free, or gluten-free foods. \nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/specialni-diety",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora při onkologické léčbě nebo alopecii",
              "sk": "Podpora pri onkologickej liečbe alebo alopécii",
              "en": "Support during cancer treatment or alopecia"
            },
            "icon": "care",
            "benefit": {
              "cs": "Příspěvek do max. výše 2 000 Kč pojištěncům bez omezení věku při onkologické léčbě nebo alopecii",
              "sk": "Príspevok vo výške maximálne 2 000 Kč poistencom bez vekového obmedzenia v prípade onkologickej liečby alebo alopécie",
              "en": "A benefit of up to 2,000 CZK for insured persons of any age undergoing cancer treatment or suffering from alopecia"
            },
            "description": {
              "cs": "Příspěvěk lze využít na zakoupení paruky, příčesku a úhradu ceny za využití chladicí čepice při chemoterapii.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok je možné využiť na nákup parochne, príčesku, špeciálnej protetickej podprsenky po mastektómii a na úhradu nákladov na použitie chladiacej čiapky počas chemoterapie.\nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution can be used to purchase a wig, hairpiece, or special prosthetic bra following a mastectomy, or to cover the cost of a cooling cap during chemotherapy.\nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/prispevek-na-pomucky-pri-onkologicke-lecbe-nebo-alopecii",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykanie od fajčenia",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 2 500 Kč v rámci prevence kardiovaskulárních a dalších závažných onemocnění můžete získat příspěvek na odvykání kouření",
              "sk": "V rámci prevencie kardiovaskulárnych a ďalších závažných ochorení môžete získať príspevok na odvykanie od fajčenia až do výšky 2 500 Kč",
              "en": "Up to CZK 2 500: as part of prevention of cardiovascular and other serious diseases, you can receive a contribution toward quitting smoking"
            },
            "description": {
              "cs": "Příspěvek na léčivý přípravek Champix, který je předepisován lékařem na recept, nebo na volně prodejné léčivé přípravky (např. Defumoxan) zakoupené v lékárně (tj. na náhradní léčbu nikotinem v následujících formách: náplasti, pastilky, orodispergovatelný film, ústní spreje, žvýkačky).\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok na liek Champix, ktorý predpisuje lekár na recept, alebo na voľne predajné lieky (napr. Defumoxan) zakúpené v lekárni (t. j. na náhradnú liečbu nikotínom v nasledujúcich formách: náplasti, pastilky, orodispergovateľný film, ústne spreje, žuvačky).\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for Champix, a prescription medication, or for over-the-counter products (e.g., Defumoxan) purchased at a pharmacy (i.e., for nicotine substitution therapy in the following forms: patches, lozenges, orally disintegrating films, oral sprays, chewing gum).\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/odvykani-koureni",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření kožních znamének",
              "sk": "Vyšetrenie kožných znamienok",
              "en": "Examination of skin marks"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření kožních znamének dermatoskopem v ordinaci praktického lékaře nebo dermatologa",
              "sk": "Až 500 Kč na vyšetrenie kožných znamienok dermatoskopom v ambulancii všeobecného lekára alebo dermatológa",
              "en": "Up to CZK 500 for the examination of skin marks with a dermatoscope by a GP or dermatologist"
            },
            "description": {
              "cs": "Příspěvek na prevenci onkologického onemocnění kůže (melanomu) Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok na prevenciu onkologických ochorení kože (melanómu) \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for skin cancer (melanoma) prevention. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/vysetreni-koznich-znamenek",
            "category": null
          },
          {
            "type": {
              "cs": "Ultrazvukové vyšetření prsou",
              "sk": "Ultrazvukové vyšetrenie prsníkov",
              "en": "Ultrasound breast exam"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 500 Kč na ultrazvukové vyšetření prsu (sonografii)",
              "sk": "Až 500 Kč na ultrazvukové vyšetrenie prsníkov (sonografiu)",
              "en": "Up to CZK 500 for an ultrasound breast exam (sonography)"
            },
            "description": {
              "cs": "Příspěvek je na ultrazvukové vyšetření prsu (sonografii), které musí být provedeno výhradně v akreditovaném mamografickém screeningovém centru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok sa vzťahuje na ultrazvukové vyšetrenie prsníkov (sonografiu), ktoré sa musí vykonať výlučne v akreditovanom mamografickom screeningovom centre. \nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for an ultrasound breast exam (sonography), which must be performed by an accredited mammography screening centre. More information (in Czech only) is available on the insurance company's website here: link"
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/ultrazvukove-vysetreni-prsou",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence onkologických onemocnění",
              "sk": "Prevencia onkologických ochorení",
              "en": "Cancer prevention"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 3 000 Kč na komplexní onkologickou preventivní prohlídku",
              "sk": "Až 3 000 Kč na komplexné onkologické preventívne vyšetrenie",
              "en": "Up to CZK 3000 for comprehensive preventive cancer screening"
            },
            "description": {
              "cs": "Příspěvek na komplexní onkologickou preventivní prohlídku absolvovanou v Komplexních onkologických centrech. Příspěvek je určen pro pojištěnce VZP ve věku od 35 let, bez horní věkové hranice.\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok na komplexné onkologické preventívne vyšetrenie absolvované v komplexných onkologických centrách. Príspevok je určený pre poistencov VZP vo veku od 35 rokov, bez vekového obmedzenia.\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for comprehensive cancer screening at comprehensive oncology centres. This contribution is intended for those insured with VZP, starting at age 35 with no upper age limit.\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/komplexni-onkologicka-prohlidka",
            "category": null
          },
          {
            "type": {
              "cs": "Pro aktivní dárce krve",
              "sk": "Pre aktívnych darcov krvi",
              "en": "For active blood donors"
            },
            "icon": "bloodtest",
            "benefit": {
              "cs": "Až 3 000 Kč na rehabilitační/rekondiční aktivity a až 1 000 Kč na dentální hygienu",
              "sk": "Až 3 000 Kč na rehabilitačné/rekondičné aktivity a až 1 000 Kč na dentálnu hygienu",
              "en": "Up to 3,000 CZK for rehabilitation/reconditioning activities and up to 1,000 CZK for dental hygiene"
            },
            "description": {
              "cs": "Příspěvek až 3 000 Kč na rehabilitační/rekondiční aktivity a až 1 000 Kč na dentální hygienu (ošetření a instruktáž).  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok až 3 000 Kč na rehabilitačné/rekondičné aktivity a až 1 000 Kč na dentálnu hygienu (ošetrenie a inštruktáž).\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution of up to 3,000 CZK for rehabilitation/reconditioning activities and up to 1,000 CZK for dental hygiene (treatment and instruction).  For more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve",
            "category": null
          },
          {
            "type": {
              "cs": "Pro neaktivní dárce krve",
              "sk": "Pre neaktívnych darcov krvi",
              "en": "For inactive blood donors"
            },
            "icon": "bloodtest",
            "benefit": {
              "cs": "Až 500 Kč na rehabilitační/rekondiční aktivity",
              "sk": "Až 500 Kč na rehabilitačné/rekondičné aktivity    ",
              "en": "Up to 500 CZK for rehabilitation/reconditioning activities"
            },
            "description": {
              "cs": "Příspěvek až 500 Kč na rehabilitační/rekondiční aktivity.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok až 500 Kč na rehabilitačné/rekondičné aktivity.\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution of up to 500 CZK for rehabilitation/reconditioning activities.  For more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve",
            "category": null
          },
          {
            "type": {
              "cs": "Psychosociální podpora",
              "sk": "Psychosociálna podpora",
              "en": "Psycho-social support"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného terapeuta",
              "sk": "Až 5 000 Kč na zvýšenie dostupnosti psychosociálnej podpory u vybraného terapeuta",
              "en": "Up to CZK 5000 to increase the availability of psycho-social support from a selected therapist"
            },
            "description": {
              "cs": "Příspěvek je určen pojištěncům ve věku od 7 let na sezení u vybraného terapeuta dle zveřejněného seznamu v max. počtu 10 sezení. \n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok je určený poistencom vo veku od 7 rokov na sedenia u vybraného terapeuta podľa zverejneného zoznamu v maximálnom počte 10 sedení. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution is intended for insured persons aged 7 years and older for a session with a selected therapist according to the published list for a maximum of 10 sessions. \n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku/",
            "category": null
          },
          {
            "type": {
              "cs": "Trénink/testování paměti pro seniory\n",
              "sk": "Trénovanie/testovanie pamäti pre seniorov",
              "en": "Memory training/testing for seniors"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na kognitivní pomůcky nebo testování paměti",
              "sk": "Až 500 Kč na kognitívne pomôcky alebo testovanie pamäti",
              "en": "Up to CZK 500 for cognitive aids or memory testing"
            },
            "description": {
              "cs": "Pokud je vám více než 65 let, můžete využít příspěvek: na kognitivní pomůcky doporučené Českou alzheimerovskou společností pro trénink paměti nebo testování paměti ve vybrané síti lékáren. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Ak máte viac ako 65 rokov, môžete využiť príspevok na kognitívne pomôcky odporúčané Českou alzheimerovskou spoločnosťou na trénovanie pamäti alebo na testovanie pamäti vo vybranej sieti lekární. \nViac informácií nájdete na webových stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "If you are over the age of 65, you can take advantage of a contribution for cognitive aids recommended by the Czech Alzheimer Society for memory training or memory testing in a selected chain of pharmacies. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpurne-programy/trenink-testovani-pameti-pro-seniory",
            "category": null
          },
          {
            "type": {
              "cs": "Psychosociální podpora pro válečné uprchlíky z Ukrajiny",
              "sk": "Psychosociálna podpora pre vojnových utečencov z Ukrajiny",
              "en": "Psychosocial support for war refugees from Ukraine"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného poskytovatele terapeutických služeb zařazeného do projektu",
              "sk": "Až 5 000 Kč na zvýšenie dostupnosti psychosociálnej podpory u vybraného poskytovateľa terapeutických služieb zaradeného do projektu    ",
              "en": "Up to CZK 5,000 to increase the availability of psychosocial support at a selected therapeutic service provider included in the project"
            },
            "description": {
              "cs": "Příspěvek je poskytován na maximálně 10 sezení v maximální výši 500 Kč na jedno sezení ve věku od 7 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok sa poskytuje na maximálne 10 sedení v maximálnej výške 500 Kč na jedno sedenie vo veku od 7 rokov. Viac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution is provided for a maximum of 10 sessions at a maximum amount of CZK 500 per session for ages 7 and up. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku-ua/",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Ženy",
          "sk": "Ženy",
          "en": "Women"
        },
        "benefits": [
          {
            "type": {
              "cs": "Pohybové aktivity a dentální hygiena",
              "sk": "Pohybové a športové aktivity alebo dentálna hygiena",
              "en": "Physical activity and dental hygiene"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 500 Kč na pohybové aktivity a sportovní aktivity nebo dentální hygienu od 18 do 65 let",
              "sk": "Až 500 Kč na pohybové aktivity a športové aktivity alebo dentálne hygienu od 18 do 65 let",
              "en": "Up to 500 CZK for physical and sports activities or dental hygiene for people aged 18 to 65"
            },
            "description": {
              "cs": "Příspěvek je určen na pravidelnou pohybovou a zároveň sportovní aktivitu dlouhodobého charakteru nebo poskytnutou fyzioterapeutem a dentální hygienu (ošetření a instruktáž).\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok je poskytovaný na pravidelnú pohybovú a zároveň športové aktivitu (např. aerobic, badminton, florbal, fotbal, kalanetika, plavání, spinning, pilates, kruhový trénink, jóga aj.) alebo dentálne hygienu (ošetření a instruktáž).\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution is intended for regular, long-term physical and sports activities, or those provided by a physical therapist, as well as dental hygiene (treatment and instruction).\n\nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/pohyb-a-dentalni-hygiena/dospely",
            "category": "Ženy"
          },
          {
            "type": {
              "cs": "Rehabilitační procedury",
              "sk": "Rehabilitačné a rekondičné aktivity",
              "en": "Rehabilitation treatments"
            },
            "icon": "heart",
            "benefit": {
              "cs": "Příspěvek do max. výše 1 000 Kč pro pojištěnce (nad 18 let)",
              "sk": "Až 1000 Kč na rehabilitačné a rekondičné aktivity pre dospělé nad 18 let",
              "en": "A contribution of up to 1,000 CZK for insured person (over 18 years of age)"
            },
            "description": {
              "cs": "Příspěvek je na rehabilitační a rekondiční aktivity lázeňského typu nehrazené z v.z.p. Jedná se například o masáže, saunu, plavání, solné jeskyně, kryokomory nebo kneippovy chodníky. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok sa vzťahuje na rehabilitačné a rekreačné aktivity kúpeľného charakteru, ktoré nie sú hradené zo zdravotného poistenia. Ide napríklad o masáže, saunu, plávanie, soľné jaskyne, kryokomory alebo Kneippove chodníky. \nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution covers spa-style rehabilitation and wellness activities not covered by health insurance. These include, for example, massages, saunas, swimming, salt caves, cryochambers, and Kneipp paths. \nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/rehabilitacni-procedury",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 14 900 Kč na různé druhy očkování",
              "sk": "Až 14 900 Kč na rôzne druhy očkovania",
              "en": "Up to CZK 14 900 for various types of vaccination"
            },
            "description": {
              "cs": "Příspěvek je poskytován na očkování, která nejsou hrazena z veřejného zdravotního pojištění, tj., kde si pojištěnec plně platí vakcínu i její aplikaci. Příspěvek se nevztahuje na úhradu případného doplatku rozdílu mezi úhradou z veřejného zdravotního pojištění a platbou u lékaře.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok sa poskytuje na očkovania, ktoré nie sú hradené z verejného zdravotného poistenia, t. j. v prípadoch, keď poistenec v plnej výške hradí vakcínu aj jej podanie. Príspevok sa nevzťahuje na úhradu prípadného doplatku rozdielu medzi úhradou z verejného zdravotného poistenia a platbou u lekára.\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.“",
              "en": "This contribution is for vaccination that is not funded by public health insurance, i.e., where the insured pays for the vaccine as well as its application in full. The contribution does not apply to payment of any difference between funding from public health insurance and a payment to a doctor.\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/ockovani/dospely",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora při nemoci diabetes mellitus",
              "sk": "Podpora pri cukrovke",
              "en": "Support for people with diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 6 000 Kč pro diabetiky",
              "sk": "Až 6 000 Kč pre diabetikov",
              "en": "Up to 6,000 CZK for people with diabetes"
            },
            "description": {
              "cs": "Jedná se o příspěvek na na edukační pobyty, na přístrojové ošetření nohou a 1 vybrané rehabilitační procedury/terapie lázeňského typu.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Ide o príspevok na vzdelávacie pobyty, na prístrojovú starostlivosť o nohy a 1 vybranú rehabilitačnú procedúru/terapiu kúpeľného typu.\nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "his is a contribution to educational stays, instrumental foot treatments, and one selected spa-type rehabilitation procedure or therapy.\nFor more information, visit the health insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/diabetes-mellitus",
            "category": null
          },
          {
            "type": {
              "cs": "Speciální diety",
              "sk": "Špeciálne diéty",
              "en": "Special diets"
            },
            "icon": "zdravy-talir",
            "benefit": {
              "cs": "Až 8 000 Kč na bezlepkovou dietu a až 12 000 Kč na nízkobílkovinnou dietu pro pojištěnce do 26 let",
              "sk": "Až 8 000 Kč na bezlepkovú stravu a až 12 000 Kč na nízkobielkovinovú stravu pre poistencov do 26 rokov",
              "en": "Up to 8,000 CZK for a gluten-free diet and up to 12,000 CZK for a low-protein diet for insured individuals under 26 years of age"
            },
            "description": {
              "cs": "Příspěvek na bezlepkové potraviny nebo na platbu bezlepkových obědů ve školní jídelně nebo na nízkobílkovinné, bezlaktózové nebo bezlepkové potraviny. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok na bezlepkové potraviny alebo na úhradu bezlepkových obedov v školskej jedálni, prípadne na nízkobielkovinové, bezlaktózové alebo bezlepkové potraviny. \nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution for gluten-free foods, for gluten-free lunches in the school cafeteria, or for low-protein, lactose-free, or gluten-free foods. \nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/specialni-diety",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora při onkologické léčbě nebo alopecii",
              "sk": "Podpora pri onkologickej liečbe alebo alopécii",
              "en": "Support during cancer treatment or alopecia"
            },
            "icon": "care",
            "benefit": {
              "cs": "Příspěvek do max. výše 2 000 Kč pojištěncům bez omezení věku při onkologické léčbě nebo alopecii",
              "sk": "Príspevok vo výške maximálne 2 000 Kč poistencom bez vekového obmedzenia v prípade onkologickej liečby alebo alopécie",
              "en": "A benefit of up to 2,000 CZK for insured persons of any age undergoing cancer treatment or suffering from alopecia"
            },
            "description": {
              "cs": "Příspěvěk lze využít na zakoupení paruky, příčesku a úhradu ceny za využití chladicí čepice při chemoterapii.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok je možné využiť na nákup parochne, príčesku, špeciálnej protetickej podprsenky po mastektómii a na úhradu nákladov na použitie chladiacej čiapky počas chemoterapie.\nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution can be used to purchase a wig, hairpiece, or special prosthetic bra following a mastectomy, or to cover the cost of a cooling cap during chemotherapy.\nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/prispevek-na-pomucky-pri-onkologicke-lecbe-nebo-alopecii",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykanie od fajčenia",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 2 500 Kč v rámci prevence kardiovaskulárních a dalších závažných onemocnění můžete získat příspěvek na odvykání kouření",
              "sk": "V rámci prevencie kardiovaskulárnych a ďalších závažných ochorení môžete získať príspevok na odvykanie od fajčenia až do výšky 2 500 Kč",
              "en": "Up to CZK 2 500: as part of prevention of cardiovascular and other serious diseases, you can receive a contribution toward quitting smoking"
            },
            "description": {
              "cs": "Příspěvek na léčivý přípravek Champix, který je předepisován lékařem na recept, nebo na volně prodejné léčivé přípravky (např. Defumoxan) zakoupené v lékárně (tj. na náhradní léčbu nikotinem v následujících formách: náplasti, pastilky, orodispergovatelný film, ústní spreje, žvýkačky).\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok na liek Champix, ktorý predpisuje lekár na recept, alebo na voľne predajné lieky (napr. Defumoxan) zakúpené v lekárni (t. j. na náhradnú liečbu nikotínom v nasledujúcich formách: náplasti, pastilky, orodispergovateľný film, ústne spreje, žuvačky).\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for Champix, a prescription medication, or for over-the-counter products (e.g., Defumoxan) purchased at a pharmacy (i.e., for nicotine substitution therapy in the following forms: patches, lozenges, orally disintegrating films, oral sprays, chewing gum).\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/odvykani-koureni",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření kožních znamének",
              "sk": "Vyšetrenie kožných znamienok",
              "en": "Examination of skin marks"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření kožních znamének dermatoskopem v ordinaci praktického lékaře nebo dermatologa",
              "sk": "Až 500 Kč na vyšetrenie kožných znamienok dermatoskopom v ambulancii všeobecného lekára alebo dermatológa",
              "en": "Up to CZK 500 for the examination of skin marks with a dermatoscope by a GP or dermatologist"
            },
            "description": {
              "cs": "Příspěvek na prevenci onkologického onemocnění kůže (melanomu) Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok na prevenciu onkologických ochorení kože (melanómu) \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for skin cancer (melanoma) prevention. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/vysetreni-koznich-znamenek",
            "category": null
          },
          {
            "type": {
              "cs": "Ultrazvukové vyšetření prsou",
              "sk": "Ultrazvukové vyšetrenie prsníkov",
              "en": "Ultrasound breast exam"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 500 Kč na ultrazvukové vyšetření prsu (sonografii)",
              "sk": "Až 500 Kč na ultrazvukové vyšetrenie prsníkov (sonografiu)",
              "en": "Up to CZK 500 for an ultrasound breast exam (sonography)"
            },
            "description": {
              "cs": "Příspěvek je na ultrazvukové vyšetření prsu (sonografii), které musí být provedeno výhradně v akreditovaném mamografickém screeningovém centru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok sa vzťahuje na ultrazvukové vyšetrenie prsníkov (sonografiu), ktoré sa musí vykonať výlučne v akreditovanom mamografickom screeningovom centre. \nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for an ultrasound breast exam (sonography), which must be performed by an accredited mammography screening centre. More information (in Czech only) is available on the insurance company's website here: link"
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/ultrazvukove-vysetreni-prsou",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence onkologických onemocnění",
              "sk": "Prevencia onkologických ochorení",
              "en": "Cancer prevention"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 3 000 Kč na komplexní onkologickou preventivní prohlídku",
              "sk": "Až 3 000 Kč na komplexné onkologické preventívne vyšetrenie",
              "en": "Up to CZK 3000 for comprehensive preventive cancer screening"
            },
            "description": {
              "cs": "Příspěvek na komplexní onkologickou preventivní prohlídku absolvovanou v Komplexních onkologických centrech. Příspěvek je určen pro pojištěnce VZP ve věku od 35 let, bez horní věkové hranice.\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok na komplexné onkologické preventívne vyšetrenie absolvované v komplexných onkologických centrách. Príspevok je určený pre poistencov VZP vo veku od 35 rokov, bez vekového obmedzenia.\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for comprehensive cancer screening at comprehensive oncology centres. This contribution is intended for those insured with VZP, starting at age 35 with no upper age limit.\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/komplexni-onkologicka-prohlidka",
            "category": null
          },
          {
            "type": {
              "cs": "Pro aktivní dárce krve",
              "sk": "Pre aktívnych darcov krvi",
              "en": "For active blood donors"
            },
            "icon": "bloodtest",
            "benefit": {
              "cs": "Až 3 000 Kč na rehabilitační/rekondiční aktivity a až 1 000 Kč na dentální hygienu",
              "sk": "Až 3 000 Kč na rehabilitačné/rekondičné aktivity a až 1 000 Kč na dentálnu hygienu",
              "en": "Up to 3,000 CZK for rehabilitation/reconditioning activities and up to 1,000 CZK for dental hygiene"
            },
            "description": {
              "cs": "Příspěvek až 3 000 Kč na rehabilitační/rekondiční aktivity a až 1 000 Kč na dentální hygienu (ošetření a instruktáž).  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok až 3 000 Kč na rehabilitačné/rekondičné aktivity a až 1 000 Kč na dentálnu hygienu (ošetrenie a inštruktáž).\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution of up to 3,000 CZK for rehabilitation/reconditioning activities and up to 1,000 CZK for dental hygiene (treatment and instruction).  For more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve",
            "category": null
          },
          {
            "type": {
              "cs": "Pro neaktivní dárce krve",
              "sk": "Pre neaktívnych darcov krvi",
              "en": "For inactive blood donors"
            },
            "icon": "bloodtest",
            "benefit": {
              "cs": "Až 500 Kč na rehabilitační/rekondiční aktivity",
              "sk": "Až 500 Kč na rehabilitačné/rekondičné aktivity    ",
              "en": "Up to 500 CZK for rehabilitation/reconditioning activities"
            },
            "description": {
              "cs": "Příspěvek až 500 Kč na rehabilitační/rekondiční aktivity.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok až 500 Kč na rehabilitačné/rekondičné aktivity.\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution of up to 500 CZK for rehabilitation/reconditioning activities.  For more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve",
            "category": null
          },
          {
            "type": {
              "cs": "Psychosociální podpora",
              "sk": "Psychosociálna podpora",
              "en": "Psycho-social support"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného terapeuta",
              "sk": "Až 5 000 Kč na zvýšenie dostupnosti psychosociálnej podpory u vybraného terapeuta",
              "en": "Up to CZK 5000 to increase the availability of psycho-social support from a selected therapist"
            },
            "description": {
              "cs": "Příspěvek je určen pojištěncům ve věku od 7 let na sezení u vybraného terapeuta dle zveřejněného seznamu v max. počtu 10 sezení. \n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok je určený poistencom vo veku od 7 rokov na sedenia u vybraného terapeuta podľa zverejneného zoznamu v maximálnom počte 10 sedení. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution is intended for insured persons aged 7 years and older for a session with a selected therapist according to the published list for a maximum of 10 sessions. \n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku/",
            "category": null
          },
          {
            "type": {
              "cs": "Pro těhotné ženy a maminky",
              "sk": "Pre tehotné ženy a mamičky",
              "en": "For pregnant women and mothers"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 5 000 Kč na vybrané služby a pomůcky",
              "sk": "Až 5 000 Kč na vybrané služby a pomôcky",
              "en": "Up to CZK 5 000 for selected services and aids"
            },
            "description": {
              "cs": "V době těhotenství a následně až do 12 měsíců po porodu můžete svůj finanční příspěvek na vybrané služby jako: screening, kurz přípravy k porodu, pomůcky ke kojení, monitor dechu, a jiné.\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Počas tehotenstva a následne až do 12 mesiacov po pôrode môžete využiť finančný príspevok na vybrané služby, ako sú: skríning, kurz prípravy na pôrod, pomôcky na dojčenie, monitor dýchania a iné.\n\nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "During pregnancy and up to 12 months after delivery, you can use your financial contribution for selected services such as: screening, a delivery preparation course, lactation aids, a breath monitor, etc.\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/tehotne-do-12-mesicu",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro nedonošené miminko",
              "sk": "Príspevok pre nedonosené dieťa",
              "en": "Contribution for premature babies"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 3 000 Kč na nákup umělé výživy, nákup mateřského mléka z banky, rehabilitační péči pro tyto děti",
              "sk": "Až 3 000 Kč na nákup umelej výživy, nákup materského mlieka z banky, rehabilitačnú starostlivosť pre tieto deti",
              "en": "Up to CZK 3000 toward the purchase of formula, mother's milk from a bank, rehabilitation care for these children"
            },
            "description": {
              "cs": "Na podporu zdravého vývoje dětí a prevence možných následků předčasně ukončeného nitroděložního vývoje je poskytován příspěvek pro nedonošené novorozence s porodní váhou do 1 500 g. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Na podporu zdravého vývoja detí a prevenciu možných následkov predčasne ukončeného vnútromaternicového vývoja sa poskytuje príspevok pre nedonosené novorodencov s pôrodnou hmotnosťou do 1 500 g. Viac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "In support of healthy development of children and prevention of the possible consequences of premature cessation of development in the womb, a contribution is provided for premature babies with a birth weight of up to 1500 g. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/nedonosene",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro miminko s rozštěpem rtu",
              "sk": "Príspevok pre dieťa s rozštepom pery",
              "en": "Donation for a baby with a cleft lip"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 4 500 Kč na nákup nostril v lékárně nebo v nemocnici",
              "sk": "Až 4 500 Kč na nákup nostril v lekárni alebo v nemocnici",
              "en": "Up to 4,500 CZK toward the purchase of nostrils at a pharmacy or hospital"
            },
            "description": {
              "cs": "Příspěvek pro miminko do 12 měsíců na nákup nostril v lékárně nebo v nemocnici.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok pre dieťa do 12 mesiacov na nákup nostril v lekárni alebo v nemocnici.  Viac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for infants under 12 months of age to purchase nostrils at a pharmacy or hospital.  For more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/novorozenec-s-rozstepem-rtu",
            "category": null
          },
          {
            "type": {
              "cs": "Trénink/testování paměti pro seniory\n",
              "sk": "Trénovanie/testovanie pamäti pre seniorov",
              "en": "Memory training/testing for seniors"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na kognitivní pomůcky nebo testování paměti",
              "sk": "Až 500 Kč na kognitívne pomôcky alebo testovanie pamäti",
              "en": "Up to CZK 500 for cognitive aids or memory testing"
            },
            "description": {
              "cs": "Pokud je vám více než 65 let, můžete využít příspěvek: na kognitivní pomůcky doporučené Českou alzheimerovskou společností pro trénink paměti nebo testování paměti ve vybrané síti lékáren. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Ak máte viac ako 65 rokov, môžete využiť príspevok na kognitívne pomôcky odporúčané Českou alzheimerovskou spoločnosťou na trénovanie pamäti alebo na testovanie pamäti vo vybranej sieti lekární. \nViac informácií nájdete na webových stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "If you are over the age of 65, you can take advantage of a contribution for cognitive aids recommended by the Czech Alzheimer Society for memory training or memory testing in a selected chain of pharmacies. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpurne-programy/trenink-testovani-pameti-pro-seniory",
            "category": null
          },
          {
            "type": {
              "cs": "Psychosociální podpora pro válečné uprchlíky z Ukrajiny",
              "sk": "Psychosociálna podpora pre vojnových utečencov z Ukrajiny",
              "en": "Psychosocial support for war refugees from Ukraine"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného poskytovatele terapeutických služeb zařazeného do projektu",
              "sk": "Až 5 000 Kč na zvýšenie dostupnosti psychosociálnej podpory u vybraného poskytovateľa terapeutických služieb zaradeného do projektu    ",
              "en": "Up to CZK 5,000 to increase the availability of psychosocial support at a selected therapeutic service provider included in the project"
            },
            "description": {
              "cs": "Příspěvek je poskytován na maximálně 10 sezení v maximální výši 500 Kč na jedno sezení ve věku od 7 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok sa poskytuje na maximálne 10 sedení v maximálnej výške 500 Kč na jedno sedenie vo veku od 7 rokov. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution is provided for a maximum of 10 sessions at a maximum amount of CZK 500 per session for ages 7 and up. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku-ua/",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Děti",
          "sk": "Deti",
          "en": "Children"
        },
        "benefits": [
          {
            "type": {
              "cs": "Pohybové aktivity a dentální hygiena",
              "sk": "Pohybové aktivity a dentálne hygienu",
              "en": "Physical activity and dental hygiene"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 2 000 Kč na pohybové aktivity pro děti ve věku 0-18 let.",
              "sk": "Až 2 000 Kč na pohybové aktivity pre deti vo veku 0–18 rokov.",
              "en": "Up to 2,000 CZK for physical activities for children aged 0–18."
            },
            "description": {
              "cs": "Příspěvěk pro děti ve věku 0-18 let roku, např. plavání kojenců a vaničkování organizované v kroužcích, spolcích, klubech, na pravidelné pohybové a zároveň sportovní aktivity dlouhodobého charakteru organizované v kroužcích, spolcích, sportovních klubech, apod., např. aerobic, atletika, florbal, fotbal, hokej, gymnastika, lyžařský kurz pořádaný školou apod. Příspěvek lze využít také na dentální hygienu (1-18 let).\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok pre deti vo veku 0–18 rokov, napr. plávanie dojčiat a kúpanie v detských vaničkách organizované v krúžkoch, spolkoch, kluboch, na pravidelné pohybové a zároveň športové aktivity dlhodobého charakteru organizované v krúžkoch, spolkoch, športových kluboch atď., napr. aerobik, atletika, florbal, futbal, hokej, gymnastika, lyžiarsky kurz organizovaný školou atď. Príspevok je možné využiť aj na dentálnu hygienu (1–18 rokov).\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for children aged 0–18, e.g., baby swimming and infant bathing classes organized by clubs, associations, or other groups; regular long-term physical and sports activities organized by clubs, associations, sports clubs, etc., such as aerobics, track and field, floorball, soccer, hockey, gymnastics, ski courses organized by schools, etc. The subsidy can also be used for dental hygiene (ages 1–18).\n\nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/pohyb-a-dentalni-hygiena/deti",
            "category": "Deti"
          },
          {
            "type": {
              "cs": "Podpora při nemoci diabetes mellitus",
              "sk": "Podpora pri cukrovke",
              "en": "Support for people with diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 3 000 Kč pro diabetiky",
              "sk": "Až 6 000 Kč pre diabetikov",
              "en": "Up to 3,000 CZK for people with diabetes"
            },
            "description": {
              "cs": "Jedná se o příspěvek na na edukační pobyty, vybrané rehabilitační procedury/terapie lázeňského typu.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Ide o príspevok na vzdelávacie pobyty a vybranú rehabilitačnú procedúru/terapiu kúpeľného typu.\nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "his is a contribution to educational stays and selected spa-type rehabilitation procedure or therapy.\nFor more information, visit the health insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/diabetes-mellitus",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 9 500 Kč na různé druhy očkování",
              "sk": "Až 9 500 Kč na rôzne druhy očkovania",
              "en": "Up to CZK 9,500 for various types of vaccination"
            },
            "description": {
              "cs": "Příspěvek je poskytován na očkování, která nejsou hrazena z veřejného zdravotního pojištění, tj., kde si pojištěnec plně platí vakcínu i její aplikaci. Příspěvek se nevztahuje na úhradu případného doplatku rozdílu mezi úhradou z veřejného zdravotního pojištění a platbou u lékaře.\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok sa poskytuje na očkovania, ktoré nie sú hradené z verejného zdravotného poistenia, t. j. v prípadoch, keď poistenec v plnej výške hradí vakcínu aj jej podanie. Príspevok sa nevzťahuje na úhradu prípadného doplatku rozdielu medzi úhradou z verejného zdravotného poistenia a platbou u lekára.\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "This contribution is for vaccination that is not funded by public health insurance, i.e., where the insured pays for the vaccine as well as its application in full. The contribution does not apply to payment of any difference between funding from public health insurance and a payment to a doctor.\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Speciální diety",
              "sk": "Špeciálne diéty",
              "en": "Special diets"
            },
            "icon": "zdravy-talir",
            "benefit": {
              "cs": "Až 8 000 Kč na bezlepkovou dietu a až 12 000 Kč na nízkobílkovinnou dietu pro pojištěnce do 26 let",
              "sk": "Až 8 000 Kč na bezlepkovú stravu a až 12 000 Kč na nízkobielkovinovú stravu pre poistencov do 26 rokov",
              "en": "Up to 8,000 CZK for a gluten-free diet and up to 12,000 CZK for a low-protein diet for insured individuals under 26 years of age"
            },
            "description": {
              "cs": "Příspěvek na bezlepkové potraviny nebo na platbu bezlepkových obědů ve školní jídelně nebo na nízkobílkovinné, bezlaktózové nebo bezlepkové potraviny. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok na bezlepkové potraviny alebo na úhradu bezlepkových obedov v školskej jedálni, prípadne na nízkobielkovinové, bezlaktózové alebo bezlepkové potraviny. \nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution for gluten-free foods, for gluten-free lunches in the school cafeteria, or for low-protein, lactose-free, or gluten-free foods. \nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/specialni-diety",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na odlehčené sádry a fixace pro děti",
              "sk": "Príspevok na ľahké sadrové obväzy a fixačné pomôcky pre deti",
              "en": "Contribution for lightweight casts and splints for children"
            },
            "icon": "person-happy",
            "benefit": {
              "cs": "Až 1 500 Kč na odlehčené a lehké sádry",
              "sk": "Až 1 500 Kč na odľahčené a ľahké sadrové obväzy",
              "en": "Up to 1,500 CZK for lightweight and ultra-lightweight casts"
            },
            "description": {
              "cs": "Příspěvek je určen pro děti do 18 let věku na odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok je určený pre deti do 18 rokov na odľahčené a ľahké sadrové obväzy z plastov, živice a uhlíkových vlákien. \nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "This benefit is intended for children under 18 years of age for lightweight casts made of plastic, resin, and carbon fiber. For more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/odlehcene-sadry-a-fixace",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření kožních znamének",
              "sk": "Vyšetrenie kožných znamienok",
              "en": "Examination of skin marks"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření kožních znamének dermatoskopem v ordinaci praktického lékaře nebo dermatologa",
              "sk": "Až 500 Kč na vyšetrenie kožných znamienok dermatoskopom v ambulancii všeobecného lekára alebo dermatológa",
              "en": "Up to CZK 500 for the examination of skin marks with a dermatoscope by a GP or dermatologist"
            },
            "description": {
              "cs": "Příspěvek na prevenci onkologického onemocnění kůže (melanomu) Více informací se dozvíte na stránkách zdravotní pojišťovny zde:  odkaz.",
              "sk": "Príspevok na prevenciu onkologických ochorení kože (melanómu) \nViac informácií nájdete na stránkach zdravotnej poisťovne tu:  odkaz.",
              "en": "A contribution for skin cancer (melanoma) prevention. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/vysetreni-koznich-znamenek",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na pomůcky při onkologické léčbě nebo alopecii",
              "sk": "Príspevok na pomôcky pri onkologickej liečbe alebo alopécii",
              "en": "Contribution for aids for cancer treatment or alopecia"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 2 000 Kč na pomůcky",
              "sk": "Až 2 000 Kč na pomôcky",
              "en": "Up to CZK 2,000 for aids"
            },
            "description": {
              "cs": "Příspěvek pacientům, kteří podstoupili onkologickou léčbu nebo i pojištěncům s diagnózou alopecie. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok pre pacientov, ktorí podstúpili onkologickú liečbu, alebo aj poistencov s diagnózou alopécie. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "Contribution to patients who have undergone oncological treatment or insured patients with a diagnosis of alopecia. \n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/prispevek-na-pomucky-pri-onkologicke-lecbe-nebo-alopecii",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro nedonošené miminko",
              "sk": "Príspevok pre nedonosené dieťa",
              "en": "Contribution for premature babies"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 3 000 Kč na nákup umělé výživy, nákup mateřského mléka z banky, rehabilitační péči pro tyto děti",
              "sk": "Až 3 000 Kč na nákup umelej výživy, nákup materského mlieka z banky, rehabilitačnú starostlivosť pre tieto deti",
              "en": "Up to CZK 3000 toward the purchase of formula, mother's milk from a bank, rehabilitation care for these children"
            },
            "description": {
              "cs": "Na podporu zdravého vývoje dětí a prevence možných následků předčasně ukončeného nitroděložního vývoje je poskytován příspěvek pro nedonošené novorozence s porodní váhou do 1 500 g. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Na podporu zdravého vývoja detí a prevenciu možných následkov predčasne ukončeného vnútromaternicového vývoja sa poskytuje príspevok pre nedonosené novorodencov s pôrodnou hmotnosťou do 1 500 g. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "In support of healthy development of children and prevention of the possible consequences of premature cessation of development in the womb, a contribution is provided for premature babies with a birth weight of up to 1500 g. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/nedonosene",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro miminko s rozštěpem rtu",
              "sk": "Príspevok pre dieťa s rozštepom pery",
              "en": "Donation for a baby with a cleft lip"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 4 500 Kč na nákup nostril v lékárně nebo v nemocnici",
              "sk": "Až 4 500 Kč na nákup nostril v lekárni alebo v nemocnici",
              "en": "Up to 4,500 CZK toward the purchase of nostrils at a pharmacy or hospital"
            },
            "description": {
              "cs": "Příspěvek pro miminko do 12 měsíců na nákup nostril v lékárně nebo v nemocnici.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok pre dieťa do 12 mesiacov na nákup nostril v lekárni alebo v nemocnici.\nViac informácií nájdete na webovej stránke zdravotnej poisťovne tu: odkaz.",
              "en": "A contribution for infants under 12 months of age to purchase nostrils at a pharmacy or hospital.  For more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/novorozenec-s-rozstepem-rtu",
            "category": null
          },
          {
            "type": {
              "cs": "Psychosociální podpora",
              "sk": "Psychosociálna podpora",
              "en": "Psycho-social support"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného terapeuta",
              "sk": "Až 5 000 Kč na zvýšenie dostupnosti psychosociálnej podpory u vybraného terapeuta",
              "en": "Up to CZK 5,000 to increase the availability of psycho-social support from a selected therapist"
            },
            "description": {
              "cs": "Příspěvek je určen pojištěncům ve věku od 7 let na sezení u vybraného terapeuta dle zveřejněného seznamu v max. počtu 10 sezení. \n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok je určený poistencom vo veku od 7 rokov na sedenia u vybraného terapeuta podľa zverejneného zoznamu, a to v maximálnom počte 10 sedení. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution is intended for insured persons aged 7 years and older for a session with a selected therapist according to the published list for a maximum of 10 sessions. \n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku/",
            "category": null
          },
          {
            "type": {
              "cs": "Psychosociální podpora pro válečné uprchlíky z Ukrajiny",
              "sk": "Psychosociálna podpora pre vojnových utečencov z Ukrajiny",
              "en": "Psychosocial support for war refugees from Ukraine"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného poskytovatele terapeutických služeb zařazeného do projektu",
              "sk": "Až 5 000 Kč na zvýšenie dostupnosti psychosociálnej podpory u vybraného poskytovateľa terapeutických služieb zaradeného do projektu",
              "en": "Up to CZK 5,000 to increase the availability of psychosocial support at a selected therapeutic service provider included in the project"
            },
            "description": {
              "cs": "Příspěvek je poskytován na maximálně 10 sezení v maximální výši 500 Kč na jedno sezení ve věku od 7 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok sa poskytuje na maximálne 10 sedení v maximálnej výške 500 Kč na jedno sedenie vo veku od 7 rokov. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "The contribution is provided for a maximum of 10 sessions at a maximum amount of CZK 500 per session for ages 7 and up. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku-ua/",
            "category": null
          }
        ]
      }
    ]
  },
  {
    "slug": "zpmv",
    "genders": [
      {
        "name": {
          "cs": "Muži",
          "sk": "Muži",
          "en": "Men"
        },
        "benefits": [
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 2 000 Kč na očkování",
              "sk": "Až 2 000 Kč na očkovanie",
              "en": "Up to CZK 2 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na všechna očkování, která nejsou hrazena z veřejného zdravotního pojištění (nebo mimo věkovou hranici, kdy hrazena jsou).\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 2 000 Kč na všetky očkovania, ktoré nie sú hradené z verejného zdravotného poistenia (alebo sú mimo vekovú hranicu, do ktorej sú hradené).\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 2 000 for all vaccination not covered by public health insurance (or outside the age range where it is covered).\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ockovani-pro-dospele",
            "category": "Muži"
          },
          {
            "type": {
              "cs": "Sportovní pohybové aktivity pro dospělé\n",
              "sk": "Športové pohybové aktivity pre dospelých",
              "en": "Sports and physical activities for adults\n"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 500 Kč na sportovní aktivity",
              "sk": "Až 500 Kč na športové aktivity",
              "en": "Up to CZK 500 for sports activities"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na sportovní aktivity určené pro dospělé. Jedná se o aktivity a sporty dlouhodobého charakteru, rozvíjející sílu, koordinaci, flexibilitu, posílení středu těla, napomáhající ke zlepšení či podpoře kondice.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 500 Kč na športové aktivity určené pre dospelých. Ide o aktivity a športy dlhodobého charakteru, ktoré rozvíjajú silu, koordináciu, flexibilitu, posilňujú stred tela a pomáhajú zlepšiť alebo podporiť kondíciu.\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.“",
              "en": "We contribute up to CZK 500 to sports activities intended for adults. This includes long-term activities and sports that develop strength, coordination, flexibility, and core strength, helping to improve or maintain fitness.\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-pohybove-aktivity-pro-dospele",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní preventivní prohlídka",
              "sk": "Preventívna prehliadka pre športovcov",
              "en": "Preventive examination for athletes"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 500 Kč sportovcům na preventivní prohlídku",
              "sk": "Až 500 Kč pre športovcov na preventívnu prehliadku",
              "en": "Up to CZK 500 for athletes for preventive medical examinations"
            },
            "description": {
              "cs": "Přispíváme dospělým až 500 Kč na preventivní prohlídku, kterou vyžadují sportovní kluby a svazy. Obsahem prohlídky je zpravidla základní interní vyšetření, základní anamnéza, zhodnocení rozboru krve a vyšetření moči, základní vyšetření pohybového aparátu, antropometrie, popř. klidová spirometrie; určení tělesné skladby bioimpedanční metodou, klidové i zátěžové EKG (na běžeckém pásu nebo cyklotrenažeru).\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame dospelým až 500 Kč na preventívnu prehliadku, ktorú vyžadujú športové kluby a zväzy. Prehliadka zvyčajne zahŕňa základné interné vyšetrenie, základnú anamnézu, vyhodnotenie krvných a močových testov, základné vyšetrenie pohybového aparátu, antropometriu, prípadne spirometriu v kľude; stanovenie telesného zloženia bioimpedančnou metódou, EKG v kľude aj pri záťaži (na bežeckom páse alebo cyklotrenažéri).\nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 500 for a preventive examination required by sports clubs and associations. The examination is usually includes a basic internal examination, basic history, assessment of blood and urine tests, basic examination of the musculoskeletal apparatus, anthropometry or resting spirometry; body composition analysis using the bioimpedance method, resting and active ECG (on a treadmill or stationary bicycle).\nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-preventivni-prohlidka",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence nadváhy a obezity\n",
              "sk": "Prevencia nadváhy a obezity",
              "en": "Overweight and obesity prevention"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou",
              "sk": "Až 500 Kč na vyšetrenie, ktoré zahŕňa analýzu zloženia tela, najmä bioimpedančnou metódou",
              "en": "Up to CZK 500 for an examination that includes body composition analysis, particularly using the bioelectric impedance method."
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 500 Kč na vyšetrenie, ktoré zahŕňa analýzu zloženia tela, najmä bioimpedančnou metódou. Viac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 500 for and examination that includes body composition analysis, particularly using the bioelectrical impedance method. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-nadvahy-a-obezity",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu tlustého střeva a konečníku\n",
              "sk": "Prevencia rakoviny hrubého čreva a konečníka",
              "en": "Prevention of colon and anal cancer\n"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru tlustého střeva a konečníku",
              "sk": "Až 500 Kč na vyšetrenie, ktorého cieľom je včasné odhalenie zhubného nádoru hrubého čreva a konečníka",
              "en": "Up to CZK 500 for an examination for the timely detection of malignant cancer of the colon and anus"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru tlustého střeva a konečníku, aby byla šance na vyléčení co největší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 500 Kč na vyšetrenie, ktorého cieľom je včasné odhalenie zhubného nádoru hrubého čreva a konečníka, aby bola šanca na vyliečenie čo najväčšia. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 500 for screening for timely detection of malignant cancer of the colon and anus so that chances of recovery are as great as possible. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-tlusteho-streva-a-konecniku",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu kůže\n",
              "sk": "Prevencia rakoviny kože",
              "en": "Skin cancer prevention"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření dermatoskopem",
              "sk": "Až 500 Kč na vyšetrenie dermatoskopom",
              "en": "Up to CZK 500 for an examination using a dermatoscope"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření dermatoskopem, které slouží k včasnému zachycení kožního zhoubného nádoru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 500 Kč na vyšetrenie dermatoskopom, ktoré slúži na včasné zachytenie zhubného nádoru kože. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 500 for an examination using a dermatoscope, which is used for timely detection of malignant skin cancer. \n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-kuze",
            "category": null
          },
          {
            "type": {
              "cs": "Zdravotnické prostředky\n",
              "sk": "Zdravotnícke pomôcky",
              "en": "Medical devices\n"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 500 Kč nad rámec ostatních preventivních programů na nákup zdravotnických prostředků",
              "sk": "Až 500 Kč nad rámec ostatných preventívnych programov na nákup zdravotníckych pomôcok",
              "en": "Up to CZK 500 beyond the scope of other preventive programmes for the purchase of medical devices"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na nákup zdravotnických prostředků, které souvisejí s chronickým onemocněním a nejsou hrazeny z veřejného zdravotního pojištění. Např. Diabetes mellitus (cukrovka), Onemocnění respiračního systému (astma), Chronické onemocnění trávicího a močového systému a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 500 Kč na nákup zdravotníckych pomôcok, ktoré súvisia s chronickými ochoreniami a nie sú hradené z verejného zdravotného poistenia. Napr. diabetes mellitus (cukrovka), ochorenia dýchacieho systému (astma), chronické ochorenia tráviaceho a močového systému a ďalšie. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 500 for the purchase of medical devices related to a chronic illness that are not covered by public health insurance. For example diabetes, respiratory diseases (Asthma), Chronic gastrointestinal diseases, Chronic urinary system diseases and others. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/zdravotnicke-prostredky",
            "category": null
          },
          {
            "type": {
              "cs": "Specifické diety\n",
              "sk": "Špecifické diéty",
              "en": "Support for specific diets"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci",
              "sk": "Až 2 000 Kč na nákup špeciálnych potravín a obedov vhodných pri alergiách alebo neznášanlivosti",
              "en": "Up to CZK 2 000 for the purchases of special foods and meals suitable for allergies or intolerances"
            },
            "description": {
              "cs": "Přispíváme dospělým s potravinovou intolerancí až 2 000 Kč nad rámec ostatních preventivních programů na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci. Napři: při celiakii, fenylketonurii a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame dospelým s potravinovou intoleranciou až 2 000 Kč nad rámec ostatných preventívnych programov na nákup špeciálnych potravín a obedov vhodných pri alergiách alebo intoleranciách. Napríklad: pri celiakii, fenylketonúrii a ďalších. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 2 000 for adults with food intolerance beyond the scope of other preventive programmes for the purchase of special foods and meals suitable for allergies or intolerance. For example: in the case of coeliac disease, phenylketonuria, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specificke-diety",
            "category": null
          },
          {
            "type": {
              "cs": "Sestavení jídelníčku nutričním terapeutem\n",
              "sk": "Vypracovanie jedálneho lístka výživovým terapeutom",
              "en": "Dietary recommendations by a nutritional therapist "
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 500 Kč na službu nutričního terapeuta ",
              "sk": "Až 500 Kč na služby výživového terapeuta",
              "en": "Up to CZK 500 for the services of a nutritional therapist "
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na službu nutričního terapeuta, který sestaví jídelníček pro dosažení a udržení zdravé hmotnosti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 500 Kč na služby výživového terapeuta, ktorý vypracuje jedálny lístok na dosiahnutie a udržanie zdravej hmotnosti. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 500 for the services of a nutritional therapist, who will make dietary recommendations to achieve and maintain healthy weight. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sestaveni-jidelnicku-nutricnim-terapeutem",
            "category": null
          },
          {
            "type": {
              "cs": "Dentální hygiena pro dospělé\n",
              "sk": "Dentálna hygiena pre dospelých",
              "en": "Dental hygiene for adults"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 500 Kč na dentální hygienu",
              "sk": "Až 500 Kč na dentálnu hygienu",
              "en": "Up to CZK 500 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na dentální hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 500 Kč na dentálnu hygienu vrátane nácviku (inštruktáže) správneho čistenia zubov v rámci nehradených služieb. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 500 for training in proper dental cleaning as part of an unpaid dental hygiene service by a dental hygienist. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-dospele",
            "category": null
          },
          {
            "type": {
              "cs": "Komplexní onkologické vyšetření\n",
              "sk": "Komplexní onkologické vyšetrení\n",
              "en": "Comprehensive oncology examination"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 2 000 Kč na preventivní onkologické prohlídky ",
              "sk": "Až 2 000 Kč na preventivní onkologické prehlídky",
              "en": "Up to CZK 2 000 for preventive oncological examinations "
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na preventivní onkologické prohlídky v rámci nabídky Komplexních onkologických center. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na preventivní onkologické prehlídky v rámci nabídky Komplexních onkologických center. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for preventive oncological examinations within the offer of the Comprehensive Cancer Centres. \nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/komplexni-onkologicke-vysetreni",
            "category": null
          },
          {
            "type": {
              "cs": "Telemonitoring",
              "sk": "Telemonitoring",
              "en": "Telemonitoring"
            },
            "icon": "register",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům zapojených do programů telemonitoringu",
              "sk": "Až 2 000 Kč pojištěncům zapojených do pregramů telemonitoringu",
              "en": "Up to CZK 2 000 for clients participating in telemonitoring programmes"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních programů pojištěncům zapojeným do programů telemonitoringu. Např. Telemonitoring pro pojištěnce s chronickým srdečním selháním, Telemonitoring pro pojištěnce s podezřením na poruchy srdečního rytmu nebo léčenou srdeční arytmií a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních pregramů pojištěncům zapojeným do pregramů telemonitoringu. Např. Telemonitoring pre pojištěnce s chronickým srdečním selháním, Telemonitoring pre pojištěnce s podezřením na poruchy srdečního rytmu alebo léčenou srdeční arytmií a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes to clients participating in telemonitoring programmes. For example telemonitoring for clients with chronic heart failure, telemonitoring for clients with suspected heart rhythm disturbances or being treated for heart arrhythmia, and others. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/telemonitoring",
            "category": null
          },
          {
            "type": {
              "cs": "Klinická psychologie - dospělí\n",
              "sk": "Klinická psychologie - dospelí\n",
              "en": "Clinical psychology - Adults"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 4 000 Kč na vyšetření v oboru klinické psychologie",
              "sk": "Až 4 000 Kč na vyšetření v oboru klinické psychologie",
              "en": "Up to CZK 4 000 for examinations in the field of clinical psychology"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické psychologie, která nejsou hrazena z veřejného zdravotního pojištění, a jejichž účelem je především pomoc se zvládáním stresu a z něj pocházejících psychických problémů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické psychologie, ktoré nesou hrazena z veřejného zdravotního pojištění, a jejichž účelem je především pomoc se zvládáním stresu a z něj pocházejících psychických preblémů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for up to 10 examinations (i.e. up to CZK 400 per examination) in the field of clinical psychology, which are not covered by public health insurance and whose purpose is primarily to help manage stress and the psychological problems arising from it. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-psychologie-dospeli",
            "category": null
          },
          {
            "type": {
              "cs": "Klinická logopedie - dospělí\n",
              "sk": "Klinická logopedie - dospelí\n",
              "en": "Clinical speech therapy - Adults"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 4 000 Kč na vyšetření v oboru klinické logopedie",
              "sk": "Až 4 000 Kč na vyšetření v oboru klinické logopedie",
              "en": "Up to CZK 4 000 for examinations in the field of clinical speech therapy"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for up to 10 examinations (i.e. up to CZK 400 per examination) in the field of clinical speech therapy. (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-logopedie-dospeli",
            "category": null
          },
          {
            "type": {
              "cs": "Paruky, podprsenky a další prostředky pro onkologické pacienty\n",
              "sk": "Paruky, podprsenky a další prestredky pre onkologické pacienty\n",
              "en": "Wigs, bras, and other items for cancer patients\n"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod.",
              "sk": "Až 2 000 Kč na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod.",
              "en": "Up to CZK 2 000 for the purchase of a wig or headscarf, medicinal products containing panthenol for the treatment of burns after radiation therapy (radiotherapy), etc."
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč dospělým, kteří podstupují nebo podstoupili protinádorovou léčbu (chemoterapii), ozařování nebo operaci, na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč dospělým, kteří podstupují alebo podstoupili pretinádorovou léčbu (chemoterapii), ozařování alebo operaci, na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes for patients who are undergoing or have undergone anti-cancer treatment (chemotherapy), toward the purchase of a wig or a kerchief. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/paruky-podprsenky-a-dalsi-prostredky-pro-onkologicke-pacienty",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační pobyty pro klienty s diabetem II. typu\n",
              "sk": "Edukační pobyty pre klienty s diabetem II. typu\n",
              "en": "Educational stays for clients with Type II diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty",
              "en": "Up to CZK 2000 for clients with Type II diabetes for educational stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty, které jsou organizované pacientskými organizacemi, např. členy Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty, které jsou organizované pacientskými organizacemi, např. členy Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to adults who are undergoing or have undergone cancer treatment (chemotherapy), radiation therapy, or surgery for the purchase of a wig or scarf, medicinal products containing panthenol for the treatment of burns after radiation therapy (radiotherapy), etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-ii-typu",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření kognitivních funkcí a pomůcky pro trénování paměti\n",
              "sk": "Vyšetrení kognitivních funkcí a pomúcky pre trénování pameti\n",
              "en": "Cognitive function testing and memory training aids\n\n"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření, jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby nebo dalších forem demence",
              "sk": "Až 500 Kč na vyšetření, jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby alebo dalších forem demence",
              "en": "Up to CZK 500 for examinations whose primary purpose is timely diagnosis of memory impairment due to Alzheimer's disease or other forms of dementia"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na následující vyšetření, která nejsou hrazena z veřejného zdravotního pojištění, a jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby nebo dalších forem demence. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na následující vyšetření, ktoré nesou hrazena z veřejného zdravotního pojištění, a jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby alebo dalších forem demence. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for examinations whose primary purpose is timely diagnosis of memory impairment due to Alzheimer's disease or other forms of dementia. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vysetreni-kognitivnich-funkci-a-pomucky-pro-trenovani-pameti",
            "category": null
          },
          {
            "type": {
              "cs": "Dopravně psychologické vyšetření\n",
              "sk": "Dopravne psychologické vyšetrení\n",
              "en": "Traffic psychological examination"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření u dopravního psychologa",
              "sk": "Až 500 Kč na vyšetření u dopravního psychologa",
              "en": "Up to CZK 500 for an examination by a traffic psychologist"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření u dopravního psychologa.\nDopravně psychologické vyšetření je povinné pro některé skupiny řidičských oprávnění, popřípadě si jej může vyžádat praktický lékař. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na vyšetření u dopravního psychologa.\nDopravně psychologické vyšetření je povinné pre některé skupiny řidičských oprávnění, popřípadě si jej může vyžádat praktický lékař. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for an examination by a traffic psychologist.\nA traffic psychology examination is mandatory for some groups of driver's licences, or can be requested by a GP. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dopravne-psychologicke-vysetreni",
            "category": null
          },
          {
            "type": {
              "cs": "Kurz pro rodiče - péče o dětské zuby\n",
              "sk": "Kurz pre rodiče - péče o detské zuby\n",
              "en": "Course for parents – children's dental care\n"
            },
            "icon": "tooth",
            "benefit": {
              "cs": "Až 500 Kč na úhradu kurzu pro rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů",
              "sk": "Až 500 Kč na úhradu kurzu pre rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů",
              "en": "Up to CZK 500 to pay for a course for parents focused on caring for children's teeth, including on-line courses"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na úhradu kurzu pro rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů.\nKurz musí být veden odborníkem, tj. zubním lékařem, zubní hygienistkou, zdravotní sestrou apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na úhradu kurzu pre rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů.\nKurz musí být veden odborníkem, tj. zubním lékařem, zubní hygienistkou, zdravotní sestrou apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to pay for a course for parents focused on caring for children's teeth, including on-line courses.\n The course must be given by a professional, i.e. a dentist, dental hygienist, nurse, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/kurz-pro-rodice-pece-o-detske-zuby",
            "category": null
          },
          {
            "type": {
              "cs": "Nutriční poradenství v souvislosti se specifickou dietou\n",
              "sk": "Nutriční poradenství v souvislosti se specifickou dietou\n",
              "en": "Nutritional counselling for special diets"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 2 000 Kč na sestavení jídelníčku s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii",
              "sk": "Až 2 000 Kč na sestavení jídelníčku s ohledem na např. nově zjištěnou potravinovou intoleranci alebo alergii",
              "en": "Up to CZK 2 000 for the creation of a special diet, for example due to a newly diagnosed food intolerance or allergy"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na konzultaci u nutričního terapeuta klientům, kteří potřebují sestavit jídelníček s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na konzultaci u nutričního terapeuta klientům, kteří potřebují sestavit jídelníček s ohledem na např. nově zjištěnou potravinovou intoleranci alebo alergii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to clients who need a special diet, for example due to a newly diagnosed food intolerance or allergy. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/nutricni-poradenstvi-v-souvislosti-se-specifickou-dietou",
            "category": null
          },
          {
            "type": {
              "cs": "Edukačně-rekondiční pobyty pro klienty s roztroušenou sklerózou\n",
              "sk": "Edukačne-rekondičné pobyty pre klienty s roztroušenou sklerózou\n",
              "en": "Educational recuperative stays for clients with multiple sclerosis"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondičné pobyty",
              "en": "Up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondičné pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti alebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays organized in cooperation with professional associations, clinics, or foundations lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacne-rekondicni-pobyty-pro-klienty-s-roztrousenou",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační pobyty pro klienty s diabetem I. typu\n",
              "sk": "Edukační pobyty pre klienty s diabetem I. typu\n",
              "en": "Educational stays for clients with Type I diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty ",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty",
              "en": "Up to CZK 2 000 for clients with Type I diabetes for educational stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované pacientskými organizacemi, jako např. Sdružení rodičů a přátel diabetických dětí a Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované pacientskými organizacemi, jako např. Sdružení rodičů a přátel diabetických dětí a Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for clients with Type I diabetes for educational stays lasting at least 3 days (2 nights) organized by patient organizations such as the Association and Friends of Diabetic Children and the Alliance of Patients with Diabetes CR. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-i-typu",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora screeningových vyšetření\n",
              "sk": "Podpora screeningových vyšetrení\n",
              "en": "Support for screening examinations"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 500 Kč na ambulantní rehabilitaci ",
              "sk": "Až 500 Kč na ambulantní rehabilitaci",
              "en": "Up to CZK 500 for outpatient rehabilitation"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na ambulantní rehabilitaci. Příspěvek je možné čerpat po ověření absolvování alespoň jednoho ze screeningových vyšetření od 1. ledna 2026. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na ambulantní rehabilitaci. Príspevok je možné čerpat po ověření absolvování alespoň jednoho ze screeningových vyšetření od 1. ledna 2026. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards outpatient rehabilitation. The contribution can be drawn after verification of completion of at least one screening examination from January 1, 2026. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-screeningovych-vysetreni",
            "category": null
          },
          {
            "type": {
              "cs": "Psychoterapie\n",
              "sk": "Psychoterapie\n",
              "en": "Psychotherapy"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 4 000 Kč u psychoterapeuta",
              "sk": "Až 4 000 Kč u psychoterapeuta",
              "en": "Up to CZK 4 000 for a psychotherapist"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na až 10 sezení (konzultací) u psychoterapeuta (tedy až 400 Kč na jedno sezení). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na až 10 sezení (konzultací) u psychoterapeuta (tedy až 400 Kč na jedno sezení). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for up to 10 sessions (consultations) with a psychotherapist (up to CZK 400 per session). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/psychoterapie",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační pobyty pro klienty s poruchou autistického spektra\n",
              "sk": "Edukační pobyty pre klienty s poruchou autistického spektra\n",
              "en": "Educational stays for clients with autistic spectrum disorders"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty ",
              "sk": "Až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty",
              "en": "Up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo neziskovými organizacemi.Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti alebo neziskovými organizacemi.Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays lasting at least 3 days (2 nights) that are organized in cooperation with professional associations, clinics, or non-profit organizations. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-poruchou-autistickeho-spektra",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační kurz pro klienty s obezitou",
              "sk": "Edukační kurz pre klienty s obezitou",
              "en": "Educational course for clients with obesity"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 2 000 Kč na edukační kurz či pobyt ",
              "sk": "Až 2 000 Kč na edukační kurz či pobyt",
              "en": "Up to CZK 2 000 for an educational course or stay"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč našim pojištěncům na edukační kurz či pobyt v trvání alespoň 3 dny (2 noci), který je určen ke zlepšení zdravotního stavu - zhubnutí a udržení zdravé hmotnosti a změny životního stylu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč našim pojištěncům na edukační kurz či pobyt v trvání alespoň 3 dny (2 noci), který je určen ke zlepšení zdravotního stavu - zhubnutí a udržení zdravé hmotnosti a změny životního stylu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to our clients for an educational course or stay of at least 3 days (2 nights) intended to improve their health – weight loss and maintenance of a healthy weight, and lifestyle changes. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-kurz-pro-klienty-s-obezitou",
            "category": null
          },
          {
            "type": {
              "cs": "Rekondiční pobyty pro klienty s revmatoidní artritidou\n",
              "sk": "Rekondičné pobyty pre klienty s revmatoidní artritidou\n",
              "en": "Reconditioning stays for clients with rheumatoid arthritis"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondičné pobyty",
              "en": "Up to CZK 2 000 for insured persons with rheumatoid arthritis for convalescent stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondičné pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti alebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to insured persons with rheumatoid arthritis for convalescent stays that are organized in cooperation with professional societies, clinical workplaces or foundations, lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/komplexni-onkologicke-vysetreni",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora léčby obezity\n",
              "sk": "Podpora léčby obezity\n",
              "en": "Obesity treatment support\n"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 2 000 Kč klientům, kteří úspěšně absolvují dlouhodobou léčbu obezity",
              "sk": "Až 2 000 Kč klientům, kteří úspěšně absolvují dlouhodobou léčbu obezity",
              "en": "Up to CZK 2 000 for clients who successfully complete long-term treatment for obesity"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč klientům, kteří úspěšně absolvují dlouhodobou léčbu obezity u smluvního poskytovatele zdravotních služeb nebo nutričního terapeuta, na další léčbu, případně další redukci hmotnosti pod dohledem zdravotníka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč klientům, kteří úspěšně absolvují dlouhodobou léčbu obezity u smluvního poskytovatele zdravotních služeb alebo nutričního terapeuta, na další léčbu, případně další redukci hmotnosti pod dohledem zdravotníka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to clients who successfully complete long-term obesity treatment with a contracted health care provider or nutritional therapist for further treatment or further weight reduction under the supervision of a health care professional. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-lecby-obezity",
            "category": null
          },
          {
            "type": {
              "cs": "Program pro dárce ",
              "sk": "Pregram pre dárce",
              "en": "Donor Program "
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 10 000 Kč pro dárce krve, kostní dřeně a orgánů",
              "sk": "Až 10 000 Kč pre dárce krve, kostní dřeně a orgánů",
              "en": "Up to CZK 10 000 for blood, bone marrow, and organ donors"
            },
            "description": {
              "cs": "Přispíváme až 10 000 Kč pro dárce krve nebo jejích součástí, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 10 000 Kč pre dárce krve alebo jejích součástí, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 10 000 for donors of blood or blood components, bone marrow, and organs. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-pro-darce-krve-nebo-jejich-soucasti-kostni-drene-a-organu",
            "category": null
          },
          {
            "type": {
              "cs": "Program na podporu profesí - zaměstnanci bezpečnostních sborů",
              "sk": "Program na podporu povolaní – zamestnanci bezpečnostných zložiek",
              "en": "Program to Support Professions - Law Enforcement Personnel"
            },
            "icon": "siren",
            "benefit": {
              "cs": "Až 1 000 Kč pojištěncům, kteří jsou zaměstnáni u bezpečnostních sborů",
              "sk": "Až 1 000 Kč poistencom, ktorí sú zamestnaní v bezpečnostných zložkách",
              "en": "Up to 1,000 CZK for insured individuals employed by law enforcement agencies"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům, kteří jsou zaměstnáni u HZS ČR, PČR, Vězeňské služby ČR nebo Celní správy ČR, na preventivní vyšetření a jiné zdravotně prospěšné aktivity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame sumou až 1 000 Kč poistencom, ktorí sú zamestnaní v Hasičskom a záchrannom zbore Českej republiky, Policajnom zbore Českej republiky, Vězeňskej službe Českej republiky alebo Colnej správe Českej republiky, na preventívne vyšetrenia a iné zdravotne prospešné aktivity. Viac informácií nájdete na webových stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We provide a contribution of up to 1,000 CZK to insured individuals employed by the Fire and Rescue Service of the Czech Republic, the Police of the Czech Republic, the Prison Service of the Czech Republic, or the Customs Administration of the Czech Republic, to cover preventive medical examinations and other health-promoting activities. For more information, please visit the health insurance company’s website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-na-podporu-profesi-zamestnanci-bezpecnostnich-sboru",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu prsu",
              "sk": "Prevence karcinomu prsu",
              "en": "Breast cancer prevention"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření karcinomu prsu",
              "sk": "Až 500 Kč na vyšetření karcinomu prsu",
              "en": "Up to CZK 500 for breast cancer screening"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru prsu, aby byla šance na vyléčení co největší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru prsu, aby byla šance na vyléčení co nevětší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for screening for timely detection of malignant breast cancer so that chances of recovery are as great as possible. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-prsu",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Ženy",
          "sk": "Ženy",
          "en": "Women"
        },
        "benefits": [
          {
            "type": {
              "cs": "Vyšetření v těhotenství",
              "sk": "Vyšetrení v tehotenství",
              "en": "Examination during pregnancy"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 3 000 Kč pojištěnkám na vyšetření v těhotenství",
              "sk": "Až 3 000 Kč pojištěnkám na vyšetření v těhotenství",
              "en": "Up to CZK 3 000to female clients for an examination during pregnancy"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na vyšetření, která nejsou hrazena z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, alebo od 1. ledna 2026 do 31. presince 2026 porodily (do 6 měsíců po porodu), na vyšetření, ktoré nesou hrazena z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 000 to female clients who are pregnant in 2026 or who gave birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for examinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vysetreni-v-tehotenstvi",
            "category": "Ženy"
          },
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 2 000 Kč na očkování",
              "sk": "Až 2 000 Kč na očkovanie",
              "en": "Up to CZK 2 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na všechna očkování, která nejsou hrazena z veřejného zdravotního pojištění (nebo mimo věkovou hranici, kdy hrazena jsou).\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n",
              "sk": "Přispíváme až 2 000 Kč na všechna očkovanie, ktoré nesou hrazena z veřejného zdravotního pojištění (alebo mimo věkovou hranici, kdy hrazena jsou).\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n",
              "en": "We contribute up to CZK 2 000 for all vaccination not covered by public health insurance (or outside the age range where it is covered).\nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ockovani-pro-dospele",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní pohybové aktivity pro dospělé\n",
              "sk": "Športové pohybové aktivity pre dospelé\n",
              "en": "Sports and physical activities for adults\n"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 500 Kč na sportovní aktivity",
              "sk": "Až 500 Kč na športové aktivity",
              "en": "Up to CZK 500 for sports activities"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na sportovní aktivity určené pro dospělé. Jedná se o aktivity a sporty dlouhodobého charakteru, rozvíjející sílu, koordinaci, flexibilitu, posílení středu těla, napomáhající ke zlepšení či podpoře kondice.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n",
              "sk": "Přispíváme až 500 Kč na športové aktivity určené pre dospělé. Jedná se o aktivity a sporty dlouhodobého charakteru, rozvíjející sílu, koordinaci, flexibilitu, posílení středu těla, napomáhající ke zlepšení či podpoře kondice.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n",
              "en": "We contribute up to CZK 500 to sports activities intended for adults. This includes long-term activities and sports that develop strength, coordination, flexibility, and core strength, helping to improve or maintain fitness.\nMore information (in Czech only) is available on the insurance company's website here: link.\" More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-pohybove-aktivity-pro-dospele",
            "category": null
          },
          {
            "type": {
              "cs": "Genetické vyšetření při užívání hormonální antikoncepce pro ženy od 19 let\n",
              "sk": "Genetické vyšetrení pri užívání hormonální antikoncepce pre ženy od 19 let\n",
              "en": "Genetic tests for women from 19 years of age using hormonal contraception\n"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 500 Kč na preventivní vyšetření rizika tromboembolické nemoci (TEN)",
              "sk": "Až 500 Kč na preventivní vyšetření rizika tromboembolické nemoci (TEN)",
              "en": "Až 500 Kč na preventivní vyšetření rizika tromboembolické nemoci "
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na preventivní vyšetření rizika tromboembolické nemoci (TEN) při užívání hormonální antikoncepce nebo hormonální substituce. Jedná se o vyšetření na trombofilní mutace, Leidenskou mutaci, mutace FII. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na preventivní vyšetření rizika tromboembolické nemoci (TEN) při užívání hormonální antikoncepce alebo hormonální substituce. Jedná se o vyšetření na trombofilní mutace, Leidenskou mutaci, mutace FII. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "en": "We contribute up to CZK 500 for preventive screening for the risk of thromboembolic disease (TEN) when using hormonal contraception or hormone replacement therapy. This involves screening for thrombophilic mutations, Leiden mutation, and FII mutation. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/geneticke-vysetreni-pro-zeny-od-19-let",
            "category": null
          },
          {
            "type": {
              "cs": "Předporodní kurz",
              "sk": "Predporodní kurz",
              "en": "Prenatal course"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 3 000 Kč pojištěnkám na předporodní kurz",
              "sk": "Až 3 000 Kč pojištěnkám na předporodní kurz",
              "en": "Up to CZK 3 000 to female clients for a prenatal course"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na předporodní kurz. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, alebo od 1. ledna 2026 do 31. presince 2026 porodily (do 6 měsíců po porodu), na předporodní kurz. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 000 to female clients who are pregnant in 2026 or who gave birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for prenatal course. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/predporodni-kurz",
            "category": null
          },
          {
            "type": {
              "cs": "Vitamíny a minerály pro těhotné nebo ženy po porodu\n",
              "sk": "Vitamíny a minerály pre tehotné alebo ženy po porodu\n",
              "en": "Vitamins and food supplements during pregnancy and after childbirth"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 1 000 Kč pojištěnkám na vitamíny a minerály pro těhotné nebo ženy po porodu",
              "sk": "Až 1 000 Kč pojištěnkám na vitamíny a minerály pre těhotné alebo ženy po porodu",
              "en": "Up to CZK 1 000 to female clients for vitamins and food supplements"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na vitamíny a minerály. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, alebo od 1. ledna 2026 do 31. presince 2026 porodily (do 6 měsíců po porodu), na vitamíny a minerály. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to female clients who are pregnant in 2026 or who gave birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for vitamins and food supplements. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vitaminy-a-mineraly-pro-tehotne-nebo-zeny-po-porodu",
            "category": null
          },
          {
            "type": {
              "cs": "Pomůcky pro kojení",
              "sk": "Pomúcky pre kojení",
              "en": "Breastfeeding aids"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 3 000 Kč pojištěnkám na pomůcky pro kojení",
              "sk": "Až 3 000 Kč pojištěnkám na pomůcky pre kojení",
              "en": "Up to CZK 3 000 to female clients for breastfeeding aids"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na pomůcky pro kojení. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, alebo od 1. ledna 2026 do 31. presince 2026 porodily (do 6 měsíců po porodu), na pomůcky pre kojení. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 000 to female clients who are pregnant in 2026 or who gave birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for breastfeeding aids. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/pomucky-pro-kojeni",
            "category": null
          },
          {
            "type": {
              "cs": "Služby laktační poradkyně, analýza a nákup mateřského mléka",
              "sk": "Služby laktační poradkyne, analýza a nákup materského mléka",
              "en": "Lactation consultant services, analysis and purchase of breast milk"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 3 000 Kč pojištěnkám na služby laktační poradkyně, analýza a nákup mateřského mléka",
              "sk": "Až 3 000 Kč pojištěnkám na služby laktační poradkyně, analýza a nákup mateřského mléka",
              "en": "Up to CZK 3 000 to female clients for lactation consultant services, analysis, and purchase of breast milk"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na služby laktační poradkyně, nákup mateřského mléka, analýzu mateřského mléka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "sk": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, alebo od 1. ledna 2026 do 31. presince 2026 porodily (do 6 měsíců po porodu), na služby laktační poradkyně, nákup mateřského mléka, analýzu mateřského mléka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "en": "We contribute up to CZK 3 000 to insured women who are pregnant in 2026 or who gave birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for the services of a lactation consultant, the purchase of breast milk, and breast milk analysis. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sluzby-laktacni-poradkyne-analyza-a-nakup-materskeho-mleka",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní preventivní prohlídka",
              "sk": "Športové preventivní prehlídka",
              "en": "Preventive examination for athletes"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 500 Kč sportovcům na preventivní prohlídku",
              "sk": "Až 500 Kč sportovcům na preventivní prehlídku",
              "en": "Up to CZK 500 for athletes for preventive medical examinations"
            },
            "description": {
              "cs": "Přispíváme dospělým až 500 Kč na preventivní prohlídku, kterou vyžadují sportovní kluby a svazy. Obsahem prohlídky je zpravidla základní interní vyšetření, základní anamnéza, zhodnocení rozboru krve a vyšetření moči, základní vyšetření pohybového aparátu, antropometrie, popř. klidová spirometrie; určení tělesné skladby bioimpedanční metodou, klidové i zátěžové EKG (na běžeckém pásu nebo cyklotrenažeru).\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme dospělým až 500 Kč na preventivní prehlídku, kterou vyžadují športové kluby a svazy. Obsahem prehlídky je zpravidla základní interní vyšetření, základní anamnéza, zhodnocení rozboru krve a vyšetření moči, základní vyšetření pohybového aparátu, antropometrie, popř. klidová spirometrie; určení tělesné skladby bioimpedanční metodou, klidové i zátěžové EKG (na běžeckém pásu alebo cyklotrenažeru).\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for a preventive examination required by sports clubs and associations. The examination is usually includes a basic internal examination, basic history, assessment of blood and urine tests, basic examination of the musculoskeletal apparatus, anthropometry or resting spirometry; body composition analysis using the bioimpedance method, resting and active ECG (on a treadmill or stationary bicycle). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-preventivni-prohlidka",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence nadváhy a obezity",
              "sk": "Prevence nadváhy a obezity",
              "en": "Overweight and obesity prevention"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou",
              "sk": "Až 500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou",
              "en": "Up to CZK 500 for an examination that includes body composition analysis, particularly using the bioelectric impedance method."
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for and examination that includes body composition analysis, particularly using the bioelectrical impedance method. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-nadvahy-a-obezity",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu prsu\n",
              "sk": "Prevence karcinomu prsu\n",
              "en": "Breast cancer prevention"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření karcinomu prsu",
              "sk": "Až 500 Kč na vyšetření karcinomu prsu",
              "en": "Up to CZK 500 for breast cancer screening"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru prsu, aby byla šance na vyléčení co největší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru prsu, aby byla šance na vyléčení co nevětší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for screening for timely detection of malignant breast cancer so that chances of recovery are as great as possible. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-prsu",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu tlustého střeva a konečníku",
              "sk": "Prevence karcinomu tlustého streva a konečníku",
              "en": "Prevention of colon and anal cancer"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru tlustého střeva a konečníku",
              "sk": "Až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru tlustého střeva a konečníku",
              "en": "Up to CZK 500 for an examination for the timely detection of malignant cancer of the colon and anus"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru tlustého střeva a konečníku, aby byla šance na vyléčení co největší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru tlustého střeva a konečníku, aby byla šance na vyléčení co nevětší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for screening for timely detection of malignant cancer of the colon and anus so that chances of recovery are as great as possible. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-tlusteho-streva-a-konecniku",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu kůže\n",
              "sk": "Prevence karcinomu kúže\n",
              "en": "Skin cancer prevention"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření dermatoskopem",
              "sk": "Až 500 Kč na vyšetření dermatoskopem",
              "en": "Up to CZK 500 for an examination using a dermatoscope"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření dermatoskopem, které slouží k včasnému zachycení kožního zhoubného nádoru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na vyšetření dermatoskopem, které slouží k včasnému zachycení kožního zhoubného nádoru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for an examination using a dermatoscope, which is used for timely detection of malignant skin cancer.\nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-kuze",
            "category": null
          },
          {
            "type": {
              "cs": "Zdravotnické prostředky\n",
              "sk": "Zdravotnické prestredky\n",
              "en": "Medical devices\n"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 500 Kč nad rámec ostatních preventivních programů na nákup zdravotnických prostředků",
              "sk": "Až 500 Kč nad rámec ostatních preventivních pregramů na nákup zdravotnických prestředků",
              "en": "Up to CZK 500 beyond the scope of other preventive programmes for the purchase of medical devices"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na nákup zdravotnických prostředků, které souvisejí s chronickým onemocněním a nejsou hrazeny z veřejného zdravotního pojištění. Např. Diabetes mellitus (cukrovka), Onemocnění respiračního systému (astma), Chronické onemocnění trávicího a močového systému a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na nákup zdravotnických prestředků, které souvisejí s chronickým onemocněním a nesou hrazeny z veřejného zdravotního pojištění. Např. Diabetes mellitus (cukrovka), Onemocnění respiračního systému (astma), Chronické onemocnění trávicího a močového systému a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for the purchase of medical devices related to a chronic illness that are not covered by public health insurance. For example diabetes, respiratory diseases (Asthma), Chronic gastrointestinal diseases, Chronic urinary system diseases and others. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/zdravotnicke-prostredky",
            "category": null
          },
          {
            "type": {
              "cs": "Specifické diety\n",
              "sk": "Specifické diety\n",
              "en": "Support for specific diets"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci",
              "sk": "Až 2 000 Kč na nákup speciálních potravin a obědů vhodných při alergii alebo intoleranci",
              "en": "Up to CZK 2 000 for the purchases of special foods and meals suitable for allergies or intolerances"
            },
            "description": {
              "cs": "Přispíváme dospělým s potravinovou intolerancí až 2 000 Kč nad rámec ostatních preventivních programů na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci. Napři: při celiakii, fenylketonurii a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme dospělým s potravinovou intolerancí až 2 000 Kč nad rámec ostatních preventivních pregramů na nákup speciálních potravin a obědů vhodných při alergii alebo intoleranci. Napři: při celiakii, fenylketonurii a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for adults with food intolerance beyond the scope of other preventive programmes for the purchase of special foods and meals suitable for allergies or intolerance. For example: in the case of coeliac disease, phenylketonuria, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specificke-diety",
            "category": null
          },
          {
            "type": {
              "cs": "Sestavení jídelníčku nutričním terapeutem ",
              "sk": "Sestavení jídelníčku nutričním terapeutem",
              "en": "Dietary recommendations by a nutritional therapist "
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 500 Kč na službu nutričního terapeuta ",
              "sk": "Až 500 Kč na službu nutričního terapeuta",
              "en": "Up to CZK 500 for the services of a nutritional therapist "
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na službu nutričního terapeuta, který sestaví jídelníček pro dosažení a udržení zdravé hmotnosti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na službu nutričního terapeuta, který sestaví jídelníček pre dosažení a udržení zdravé hmotnosti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for the services of a nutritional therapist, who will make dietary recommendations to achieve and maintain healthy weight. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sestaveni-jidelnicku-nutricnim-terapeutem",
            "category": null
          },
          {
            "type": {
              "cs": "Dentální hygiena pro dospělé\n",
              "sk": "Dentálne hygiena pre dospelé\n",
              "en": "Dental hygiene for adults"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 500 Kč na dentální hygienu",
              "sk": "Až 500 Kč na dentálne hygienu",
              "en": "Up to CZK 500 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na dentální hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na dentálne hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for training in proper dental cleaning as part of an unpaid dental hygiene service by a dental hygienist. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-dospele",
            "category": null
          },
          {
            "type": {
              "cs": "Cvičení pro těhotné a ženy po porodu\n",
              "sk": "Cvičení pre tehotné a ženy po porodu\n",
              "en": "Exercises for pregnant women and women after childbirth\n"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 3 000 Kč pojištěnkám na cvičení pro těhotné ženy a ženy po porodu",
              "sk": "Až 3 000 Kč pojištěnkám na cvičení pre těhotné ženy a ženy po porodu",
              "en": "Up to CZK 3 000 to female clients for exercise classes for pregnant women and women after childbirth"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na cvičení pro ženy po porodu. Akceptujeme i on-line kurzy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "sk": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, alebo od 1. ledna 2026 do 31. presince 2026 porodily (do 6 měsíců po porodu), na cvičení pre ženy po porodu. Akceptujeme i on-line kurzy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "en": "We contribute up to CZK 3 000 to female clients who are pregnant in 2026 or who give birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for postnatal exercise classes. We also accept online courses. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/cviceni-pro-tehotne-a-zeny-po-porodu",
            "category": null
          },
          {
            "type": {
              "cs": "Komplexní onkologické vyšetření",
              "sk": "Komplexní onkologické vyšetrení",
              "en": "Comprehensive oncology examination"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 2 000 Kč na preventivní onkologické prohlídky ",
              "sk": "Až 2 000 Kč na preventivní onkologické prehlídky",
              "en": "Up to CZK 2 000 for preventive oncological examinations "
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na preventivní onkologické prohlídky v rámci nabídky Komplexních onkologických center. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na preventivní onkologické prehlídky v rámci nabídky Komplexních onkologických center. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for preventive oncological examinations within the offer of the Comprehensive Cancer Centres. \nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/komplexni-onkologicke-vysetreni",
            "category": null
          },
          {
            "type": {
              "cs": "Telemonitoring\n",
              "sk": "Telemonitoring\n",
              "en": "Telemonitoring\n"
            },
            "icon": "register",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům zapojených do programů telemonitoringu",
              "sk": "Až 2 000 Kč pojištěncům zapojených do pregramů telemonitoringu",
              "en": "Up to CZK 2 000 for clients participating in telemonitoring programmes"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních programů pojištěncům zapojeným do programů telemonitoringu. Např. Telemonitoring pro pojištěnce s chronickým srdečním selháním, Telemonitoring pro pojištěnce s podezřením na poruchy srdečního rytmu nebo léčenou srdeční arytmií a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních pregramů pojištěncům zapojeným do pregramů telemonitoringu. Např. Telemonitoring pre pojištěnce s chronickým srdečním selháním, Telemonitoring pre pojištěnce s podezřením na poruchy srdečního rytmu alebo léčenou srdeční arytmií a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes to clients participating in telemonitoring programmes. For example telemonitoring for clients with chronic heart failure, telemonitoring for clients with suspected heart rhythm disturbances or being treated for heart arrhythmia, and others. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/telemonitoring",
            "category": null
          },
          {
            "type": {
              "cs": "Klinická psychologie - dospělí",
              "sk": "Klinická psychologie - dospelí",
              "en": "Clinical psychology - Adults"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 4 000 Kč na vyšetření v oboru klinické logopedie",
              "sk": "Až 4 000 Kč na vyšetření v oboru klinické logopedie",
              "en": "Up to CZK 4 000 for examinations in the field of clinical speech therapy"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for up to 10 examinations (i.e. up to CZK 400 per examination) in the field of clinical speech therapy. (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-psychologie-dospeli",
            "category": null
          },
          {
            "type": {
              "cs": "Klinická logopedie - dospělí",
              "sk": "Klinická logopedie - dospelí",
              "en": "Clinical speech therapy - Adults"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 4 000 Kč na různá vyšetření v oboru klinické logopedie",
              "sk": "Až 4 000 Kč na různá vyšetření v oboru klinické logopedie",
              "en": "Up to CZK 4 000 for various examinations in the field of clinical speech therapy"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na různá vyšetření v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na různá vyšetření v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for various examinations in the field of clinical speech therapy More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-logopedie-dospeli",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu děložního hrdla\n",
              "sk": "Prevence karcinomu deložního hrdla\n",
              "en": "Cervical cancer prevention"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nejlépe již prekancerózních stavů",
              "sk": "Až 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nelépe již prekancerózních stavů",
              "en": "Up to CZK 500 for a preventive uncovered examination for timely detection of (ideally) pre-cancerous conditions"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nejlépe již prekancerózních stavů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nelépe již prekancerózních stavů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for a preventive uncovered examination for timely detection of (ideally) pre-cancerous conditions. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-delozniho-hrdla",
            "category": null
          },
          {
            "type": {
              "cs": "Masáž pro těhotné",
              "sk": "Masáž pre tehotné",
              "en": "Massage during pregnancy"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 3 000 Kč pojištěnkám na masáž pro těhotné",
              "sk": "Až 3 000 Kč pojištěnkám na masáž pre těhotné",
              "en": "Up to CZK 3 000 to female clients for massage during pregnancy"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na masáž pro těhotné.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, alebo od 1. ledna 2026 do 31. presince 2026 porodily (do 6 měsíců po porodu), na masáž pre těhotné.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 000 to female clients who are pregnant in 2026 or who give birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for a massage for pregnant women.\nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/masaz-pro-tehotne",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora vícerčat",
              "sk": "Podpora vícerčat",
              "en": "Support for multiples"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 500 Kč navíc na každého novorozence z vícečetného těhotenství na různé pomůcky ",
              "sk": "Až 500 Kč navíc na každého novorozence z vícečetného těhotenství na rôzne pomůcky",
              "en": "Up to CZK 500 extra for each newborn from a multiple pregnancy for various aids"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč navíc na každého novorozence z vícečetného těhotenství narozeného od 1. ledna do 31. prosince 2026, jednou v roce na pomůcky na kojení, nákup mateřského mléka nebo nákup monitoru dechu.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč navíc na každého novorozence z vícečetného těhotenství narozeného od 1. ledna do 31. presince 2026, jednou v roce na pomůcky na kojení, nákup mateřského mléka alebo nákup monitoru dechu.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 extra for each newborn from a multiple pregnancy born between January 1 and December 31, 2026, once a year for breastfeeding aids, the purchase of breast milk, or the purchase of a breathing monitor.\nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-vicercat",
            "category": null
          },
          {
            "type": {
              "cs": "Dentální hygiena pro těhotné\n",
              "sk": "Dentálne hygiena pre tehotné\n",
              "en": "Dental hygiene for pregnant women\n"
            },
            "icon": "tooth",
            "benefit": {
              "cs": "Až 3 000 Kč pojištěnkám na dentální hygienu ",
              "sk": "Až 3 000 Kč pojištěnkám na dentálne hygienu",
              "en": "Up to CZK 3 000 to female clients for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na dentální hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "sk": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, alebo od 1. ledna 2026 do 31. presince 2026 porodily (do 6 měsíců po porodu), na dentálne hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "en": "We contribute up to CZK 3 000 to female clientswho are pregnant in 2026 or who give birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for dental hygiene, including training (instruction) in proper tooth cleaning as part of a non-covered service. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-tehotne",
            "category": null
          },
          {
            "type": {
              "cs": "Paruky, podprsenky a další prostředky pro onkologické pacienty",
              "sk": "Paruky, podprsenky a další prestredky pre onkologické pacienty",
              "en": "Wigs, bras, and other items for cancer patients"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod.",
              "sk": "Až 2 000 Kč na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod.",
              "en": "Up to CZK 2 000 for the purchase of a wig or headscarf, medicinal products containing panthenol for the treatment of burns after radiation therapy (radiotherapy), etc."
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč dospělým, kteří podstupují nebo podstoupili protinádorovou léčbu (chemoterapii), ozařování nebo operaci, na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč dospělým, kteří podstupují alebo podstoupili pretinádorovou léčbu (chemoterapii), ozařování alebo operaci, na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes for patients who are undergoing or have undergone anti-cancer treatment (chemotherapy), toward the purchase of a wig or a kerchief. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/paruky-podprsenky-a-dalsi-prostredky-pro-onkologicke-pacienty",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační pobyty pro klienty s diabetem II. typu",
              "sk": "Edukační pobyty pre klienty s diabetem II. typu",
              "en": "Educational stays for clients with Type II diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty",
              "en": "Up to CZK 2 000 for clients with Type II diabetes for educational stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty, které jsou organizované pacientskými organizacemi, např. členy Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty, které jsou organizované pacientskými organizacemi, např. členy Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for clients with Type II diabetes for educational stays organized by patient organizations such as the Alliance of Patients with Diabetes CR. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-ii-typu",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření kognitivních funkcí a pomůcky pro trénování paměti\n",
              "sk": "Vyšetrení kognitivních funkcí a pomúcky pre trénování pameti\n",
              "en": "Cognitive function testing and memory training aids\n\n"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření, jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby nebo dalších forem demence",
              "sk": "Až 500 Kč na vyšetření, jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby alebo dalších forem demence",
              "en": "Up to CZK 500 for examinations whose primary purpose is timely diagnosis of memory impairment due to Alzheimer's disease or other forms of dementia"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na následující vyšetření, která nejsou hrazena z veřejného zdravotního pojištění, a jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby nebo dalších forem demence. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na následující vyšetření, ktoré nesou hrazena z veřejného zdravotního pojištění, a jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby alebo dalších forem demence. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for examinations whose primary purpose is timely diagnosis of memory impairment due to Alzheimer's disease or other forms of dementia. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vysetreni-kognitivnich-funkci-a-pomucky-pro-trenovani-pameti",
            "category": null
          },
          {
            "type": {
              "cs": "Dopravně psychologické vyšetření",
              "sk": "Dopravne psychologické vyšetrení",
              "en": "Traffic psychological examination"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření u dopravního psychologa",
              "sk": "Až 500 Kč na vyšetření u dopravního psychologa",
              "en": "Up to CZK 500 for an examination by a traffic psychologist"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření u dopravního psychologa.\nDopravně psychologické vyšetření je povinné pro některé skupiny řidičských oprávnění, popřípadě si jej může vyžádat praktický lékař. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na vyšetření u dopravního psychologa.\nDopravně psychologické vyšetření je povinné pre některé skupiny řidičských oprávnění, popřípadě si jej může vyžádat praktický lékař. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for an examination by a traffic psychologist.\nA traffic psychology examination is mandatory for some groups of driver's licences, or can be requested by a GP. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dopravne-psychologicke-vysetreni",
            "category": null
          },
          {
            "type": {
              "cs": "Kurz pro rodiče - péče o dětské zuby\n",
              "sk": "Kurz pre rodiče - péče o detské zuby\n",
              "en": "Course for parents – children's dental care\n"
            },
            "icon": "tooth",
            "benefit": {
              "cs": "Až 500 Kč na úhradu kurzu pro rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů",
              "sk": "Až 500 Kč na úhradu kurzu pre rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů",
              "en": "Up to CZK 500 to pay for a course for parents focused on caring for children's teeth, including on-line courses"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na úhradu kurzu pro rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů.\nKurz musí být veden odborníkem, tj. zubním lékařem, zubní hygienistkou, zdravotní sestrou apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na úhradu kurzu pre rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů.\nKurz musí být veden odborníkem, tj. zubním lékařem, zubní hygienistkou, zdravotní sestrou apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to pay for a course for parents focused on caring for children's teeth, including on-line courses.\n The course must be given by a professional, i.e. a dentist, dental hygienist, nurse, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/kurz-pro-rodice-pece-o-detske-zuby",
            "category": null
          },
          {
            "type": {
              "cs": "Nutriční poradenství v souvislosti se specifickou dietou\n",
              "sk": "Nutriční poradenství v souvislosti se specifickou dietou\n",
              "en": "Nutritional counselling for special diets"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 2 000 Kč na sestavení jídelníčku s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii",
              "sk": "Až 2 000 Kč na sestavení jídelníčku s ohledem na např. nově zjištěnou potravinovou intoleranci alebo alergii",
              "en": "Up to CZK 2 000 for the creation of a special diet, for example due to a newly diagnosed food intolerance or allergy"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na konzultaci u nutričního terapeuta klientům, kteří potřebují sestavit jídelníček s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na konzultaci u nutričního terapeuta klientům, kteří potřebují sestavit jídelníček s ohledem na např. nově zjištěnou potravinovou intoleranci alebo alergii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to clients who need a special diet, for example due to a newly diagnosed food intolerance or allergy. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/nutricni-poradenstvi-v-souvislosti-se-specifickou-dietou",
            "category": null
          },
          {
            "type": {
              "cs": "Edukačně-rekondiční pobyty pro klienty s roztroušenou sklerózou",
              "sk": "Edukačne-rekondičné pobyty pre klienty s roztroušenou sklerózou",
              "en": "Educational recuperative stays for clients with multiple sclerosis"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondičné pobyty",
              "en": "Up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondičné pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti alebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays organized in cooperation with professional associations, clinics, or foundations lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacne-rekondicni-pobyty-pro-klienty-s-roztrousenou",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační pobyty pro klienty s diabetem I. typu",
              "sk": "Edukační pobyty pre klienty s diabetem I. typu",
              "en": "Educational stays for clients with Type I diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty ",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty",
              "en": "Up to CZK 2000 for clients with Type I diabetes for educational stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované pacientskými organizacemi, jako např. Sdružení rodičů a přátel diabetických dětí a Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované pacientskými organizacemi, jako např. Sdružení rodičů a přátel diabetických dětí a Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for clients with Type I diabetes for educational stays lasting at least 3 days (2 nights) organized by patient organizations such as the Association and Friends of Diabetic Children and the Alliance of Patients with Diabetes CR. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-i-typu",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora absolvování screeningového vyšetření",
              "sk": "Podpora absolvování screeningového vyšetrení",
              "en": "Support for screening examinations"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 500 Kč na ambulantní rehabilitaci ",
              "sk": "Až 500 Kč na ambulantní rehabilitaci",
              "en": "Up to CZK 500 for outpatient rehabilitation"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na ambulantní rehabilitaci. Příspěvek je možné čerpat po ověření absolvování alespoň jednoho ze screeningových vyšetření od 1. ledna 2026. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na ambulantní rehabilitaci. Príspevok je možné čerpat po ověření absolvování alespoň jednoho ze screeningových vyšetření od 1. ledna 2026. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards outpatient rehabilitation. The contribution can be drawn after verification of completion of at least one screening examination from January 1, 2026. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-screeningovych-vysetreni",
            "category": null
          },
          {
            "type": {
              "cs": "Psychoterapie\n",
              "sk": "Psychoterapie\n",
              "en": "Psychotherapy"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 4 000 Kč u psychoterapeuta",
              "sk": "Až 4 000 Kč u psychoterapeuta",
              "en": "Up to CZK 4 000 for a psychotherapist"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na až 10 sezení (konzultací) u psychoterapeuta (tedy až 400 Kč na jedno sezení). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na až 10 sezení (konzultací) u psychoterapeuta (tedy až 400 Kč na jedno sezení). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for up to 10 sessions (consultations) with a psychotherapist (up to CZK 400 per session). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/psychoterapie",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační pobyty pro klienty s poruchou autistického spektra",
              "sk": "Edukační pobyty pre klienty s poruchou autistického spektra",
              "en": "Educational stays for clients with autistic spectrum disorders"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty ",
              "sk": "Až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty",
              "en": "Up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo neziskovými organizacemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti alebo neziskovými organizacemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays lasting at least 3 days (2 nights) that are organized in cooperation with professional associations, clinics, or non-profit organizations. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-poruchou-autistickeho-spektra",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační kurz pro klienty s obezitou",
              "sk": "Edukační kurz pre klienty s obezitou",
              "en": "Educational course for clients with obesity"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 2 000 Kč na edukační kurz či pobyt ",
              "sk": "Až 2 000 Kč na edukační kurz či pobyt",
              "en": "Up to CZK 2 000 for an educational course or stay"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč našim pojištěncům na edukační kurz či pobyt v trvání alespoň 3 dny (2 noci), který je určen ke zlepšení zdravotního stavu - zhubnutí a udržení zdravé hmotnosti a změny životního stylu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč našim pojištěncům na edukační kurz či pobyt v trvání alespoň 3 dny (2 noci), který je určen ke zlepšení zdravotního stavu - zhubnutí a udržení zdravé hmotnosti a změny životního stylu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to our clients for an educational course or stay of at least 3 days (2 nights) intended to improve their health – weight loss and maintenance of a healthy weight, and lifestyle changes. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-kurz-pro-klienty-s-obezitou",
            "category": null
          },
          {
            "type": {
              "cs": "Rekondiční pobyty pro klienty s revmatoidní artritidou",
              "sk": "Rekondičné pobyty pre klienty s revmatoidní artritidou",
              "en": "Reconditioning stays for clients with rheumatoid arthritis"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondičné pobyty",
              "en": "Up to CZK 2 000 for insured persons with rheumatoid arthritis for convalescent stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondičné pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti alebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to insured persons with rheumatoid arthritis for convalescent stays that are organized in cooperation with professional societies, clinical workplaces or foundations, lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/rekondicni-pobyty-pro-klienty-s-revmatoidni-artritidou",
            "category": null
          },
          {
            "type": {
              "cs": "Třetí čtení mamografického snímku umělou inteligencí\n",
              "sk": "Tretie vyhodnotenie mamografického snímku pomocou umelej inteligencie",
              "en": "Interpretation of mammogram images using artificial intelligence\n"
            },
            "icon": "register",
            "benefit": {
              "cs": "Až 100 Kč na vyhodnocení mamografického snímku umělou inteligencí",
              "sk": "Až 100 Kč na vyhodnotenie mamografického snímku umelou inteligenciou",
              "en": "Up to CZK 100 for the interpretation of mammogram results using artificial intelligence"
            },
            "description": {
              "cs": "Přispíváme  až 100 Kč na vyhodnocení mamografického snímku umělou inteligencí, našim klientkám ve věku od 40 do 45 let.\nJedná se o využití umělé inteligence (AI) pro dodatečné vyhodnocení snímku z mamografického vyšetření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Našim klientkam vo veku od 40 do 45 rokov prispievame až 100 Kč na vyhodnotenie mamografického snímku pomocou umelej inteligencie.\nIde o využitie umelej inteligencie (AI) na dodatočné vyhodnotenie snímku z mamografického vyšetrenia. Viac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 100 for the interpretation of mammogram results using artificial intelligence for our clients aged 40 to 45.\nThis involves the use of artificial intelligence (AI) for additional interpretation of mammogram results.  More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/treti-cteni-mamografickeho-snimku-umelou-inteligenci",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora léčby obezity\n",
              "sk": "Podpora liečby obezity",
              "en": "Obesity treatment support\n"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč klientům, kteří úspěšně absolvují dlouhodobou léčbu obezity",
              "sk": "Až 2 000 Kč klientom, ktorí úspešne absolvujú dlhodobú liečbu obezity",
              "en": "Up to CZK 2 000 for clients who successfully complete long-term treatment for obesity"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč klientům, kteří úspěšně absolvují dlouhodobou léčbu obezity u smluvního poskytovatele zdravotních služeb nebo nutričního terapeuta, na další léčbu, případně další redukci hmotnosti pod dohledem zdravotníka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 2 000 Kč klientom, ktorí úspešne absolvujú dlhodobú liečbu obezity u zmluvného poskytovateľa zdravotných služieb alebo nutričného terapeuta, na ďalšiu liečbu, prípadne ďalšie zníženie hmotnosti pod dohľadom zdravotníka. Viac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 2 000 to clients who successfully complete long-term obesity treatment with a contracted health care provider or nutritional therapist for further treatment or further weight reduction under the supervision of a health care professional. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-lecby-obezity",
            "category": null
          },
          {
            "type": {
              "cs": "Doprovod k porodu",
              "sk": "Sprevádzanie pri pôrode",
              "en": "Birth support"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Přispíváme až 3 000 Kč pojištěnkám na službu doprovodu k porodu",
              "sk": "Prispievame poistenkyniam až 3 000 Kč na službu sprievodu pri pôrode",
              "en": "Up to CZK 3 000 to insured women for birth support services."
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na službu doprovodu k porodu. Jedná se o nehrazenou službu, kterou poskytuje pojištěnkou zvolená porodní asistentka. Musí se jednat o registrovanou porodní asistentku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 3 000 Kč poistencom, ktoré sú v roku 2026 tehotné alebo od 1. januára 2026 do 31. decembra 2026 porodili (do 6 mesiacov po pôrode), na službu sprievodu pri pôrode. Ide o nehradenú službu, ktorú poskytuje pôrodná asistentka vybraná poistenkyňou. Musí ísť o registrovanú pôrodnú asistentku. Viac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 3 000 to insured women who are pregnant in 2026 or who give birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for the service of accompanying them during childbirth. This is a non-covered service provided by a birth assistant chosen by the insured woman. The birth assistant must be a registered practitioner. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/doprovod-k-porodu",
            "category": null
          },
          {
            "type": {
              "cs": "Program pro dárce ",
              "sk": "Pregram pre dárce",
              "en": "Donor Program "
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 10 000 Kč pro dárce krve, kostní dřeně a orgánů",
              "sk": "Až 10 000 Kč pre dárce krve, kostní dřeně a orgánů",
              "en": "Up to CZK 10 000 for blood, bone marrow, and organ donors"
            },
            "description": {
              "cs": "Přispíváme až 10 000 Kč pro dárce krve nebo jejích součástí, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 10 000 Kč pre dárce krve alebo jejích součástí, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 10 000 for donors of blood or blood components, bone marrow, and organs. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-pro-darce-krve-nebo-jejich-soucasti-kostni-drene-a-organu",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Děti",
          "sk": "Deti",
          "en": "Children"
        },
        "benefits": [
          {
            "type": {
              "cs": "Očkování pro děti",
              "sk": "Očkovanie pre deti",
              "en": "Vaccination for children"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 2 000 Kč na očkování pro děti",
              "sk": "Až 2 000 Kč na očkovanie pre děti",
              "en": "Up to CZK 2 000 for vaccination for children"
            },
            "description": {
              "cs": "Přispíváme v součtu až 2 000 Kč na všechna očkování, která nejsou hrazena z veřejného zdravotního pojištění (nebo mimo věkovou hranici, kdy hrazena jsou). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme v součtu až 2 000 Kč na všechna očkovanie, ktoré nesou hrazena z veřejného zdravotního pojištění (alebo mimo věkovou hranici, kdy hrazena jsou). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for children for all vaccination not covered by public health insurance (or outside the age range where it is covered).\nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ockovani-pro-deti",
            "category": "Deti"
          },
          {
            "type": {
              "cs": "Masáž pro novorozence a kojence do 1 roku, kurz první pomoci pro dítě",
              "sk": "Masáž pre novorozence a kojence do 1 roku, kurz první pomoci pre díte",
              "en": "Massage for newborns and infants up to 1 year old, first aid course for children"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 1 500 Kč na masáž pro novorozence a kojence nebo kurz první pomoci pro dítě",
              "sk": "Až 1 500 Kč na masáž pre novorozence a kojence alebo kurz první pomoci pre dítě",
              "en": "Up to  CZK 1 500 for a massage for newborns and infants or a first aid course for children "
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč na masáž pro novorozence a kojence. Pomáhá proti bolestem bříška a přispívá celkovému zklidnění a zlepšení spánku. Na platebním dokladu musí být uvedeno, že se jedná o masáž pro novorozence nebo kojence. Přispíváme také na kurz první pomoci pro dítě organizovaný zdravotníkem (včetně online formy). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč na masáž pre novorozence a kojence. Pomáhá preti bolestem bříška a přispívá celkovému zklidnění a zlepšení spánku. Na platebním dokladu musí být uvedeno, že se jedná o masáž pre novorozence alebo kojence. Přispíváme také na kurz první pomoci pre dítě organizovaný zdravotníkem (včetně online formy). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 for massages for newborns and infants. It helps relieve tummy ache and contributes to overall calmness and better sleep. The payment receipt must state that it is for a massage for newborns or infants. We also contribute to a first aid course for children organized by a healthcare professional (including online courses). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/masaz-pro-novorozence-a-kojence-do-1-roku-kurz-prvni-pomoci",
            "category": null
          },
          {
            "type": {
              "cs": "Pomůcky pro novorozence a kojence do 1 roku\n",
              "sk": "Pomúcky pre novorozence a kojence do 1 roku\n",
              "en": "Care products for newborns and infants up to 1 year old\n"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 1 500 Kč pro novorozence a kojence",
              "sk": "Až 1 500 Kč pre novorozence a kojence",
              "en": "Up to CZK 1 500 for newborns and infants"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč na nákup pomůcek pro bezpečí, sledování zdravého vývoje a pro zdravé prostředí novorozenců a kojenců. Zejména na následující položky: Teploměr, odsávačka hlenů, polohovací polštář pro kojení, chůvička, váha, monitor dechu, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč na nákup pomůcek pre bezpečí, sledování zdravého vývoje a pre zdravé prestředí novorozenců a kojenců. Zejména na následující položky: Teploměr, odsávačka hlenů, polohovací polštář pre kojení, chůvička, váha, monitor dechu, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 for the purchase of products for safety, monitoring healthy development, and to ensure a safe environment for newborns and infants Especially for the following items: Thermometer, mucus extractor, nursing pillow, baby monitor, scales, breath monitor, etc.\nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/pomucky-pro-novorozence-a-kojence-do-1-roku",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní pohybové aktivity pro děti\n",
              "sk": "Športové pohybové aktivity pre deti\n",
              "en": "Sports activities for children"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 1 000 Kč na pohybové aktivity pro děti",
              "sk": "Až 1 000 Kč na pohybové aktivity pre děti",
              "en": "Up to CZK 1 000 for physical activities for children"
            },
            "description": {
              "cs": "Přispíváme dětem od dvou let věku ročně až 1 000 Kč na organizované sportovní a pohybové aktivity určené pro děti. Zejména na následující aktivity: Organizované cvičení pro děti, Sportovní kroužky a kurzy, Cvičení dětí s rodiči, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme dětem od dvou let věku ročně až 1 000 Kč na organizované športové a pohybové aktivity určené pre děti. Zejména na následující aktivity: Organizované cvičení pre děti, Sportovní kroužky a kurzy, Cvičení dětí s rodiči, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 per year to children aged two and older for organized sports and physical activities designed for children. In particular, the following activities: Organized exercise for children, Sports clubs and courses, Exercise for children with parents, and others. \nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-pohybove-aktivity-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Ozdravný nebo sportovní pobyt pro děti\n",
              "sk": "Ozdravný alebo športové pobyt pre deti\n",
              "en": "Health or sports retreat for children\n"
            },
            "icon": "tent",
            "benefit": {
              "cs": "Až 500 Kč na ozdravný nebo sportovní pobyt pro děti",
              "sk": "Až 500 Kč na ozdravný alebo športové pobyt pre děti",
              "en": "Up to CZK 500 for Health or sports retreat for children"
            },
            "description": {
              "cs": "Přispíváme dětem až 500 Kč na pobytové aktivity. Jako třeba školu a školku v přírodě (pobyt spojený s aktivním pohybem v přírodě organizovaný školou nebo školkou), sportovní soustředění, lyžařský výcvik. Pobyt musí trvat nejméně 4 dny. Neakceptujeme: poznávací, vědomostní, vzdělávací, umělecký, zájmový, jazykový pobyt atd. - bez pohybového zaměření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme dětem až 500 Kč na pobytové aktivity. Jako třeba školu a školku v přírodě (pobyt spojený s aktivním pohybem v přírodě organizovaný školou alebo školkou), športové soustředění, lyžařský výcvik. Pobyt musí trvat neméně 4 dny. Neakceptujeme: poznávací, vědomostní, vzdělávací, umělecký, zájmový, jazykový pobyt atd. - bez pohybového zaměření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 per child for recreational activities. These include school and kindergarten trips (stays involving active outdoor activities organized by schools or kindergartens), sports camps, and ski lessons. The stay must last at least four days. We do not accept: sightseeing, knowledge, educational, artistic, hobby, language stays, etc. - without a focus on physical activity. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ozdravny-nebo-sportovni-pobyt-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Screeningové vyšetření tupozrakosti\n",
              "sk": "Screeningové vyšetrení tupozrakosti\n",
              "en": "Amblyopia screening examination \n"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 1 500 Kč dětem od 6 měsíců do 10 let na vyšetření, které slouží k včasnému záchytu tupozrakosti",
              "sk": "Až 1 500 Kč dětem od 6 měsíců do 10 let na vyšetření, které slouží k včasnému záchytu tupozrakosti",
              "en": "Up to CZK 1 500 for children from 6 months to 10 years of age for an examination used for the timely detection of amblyopia"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč dětem od 6 měsíců do 10 let na vyšetření, které slouží k včasnému záchytu tupozrakosti, přístrojem PlusOptix u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč dětem od 6 měsíců do 10 let na vyšetření, které slouží k včasnému záchytu tupozrakosti, přístrojem PlusOptix u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 for children from 6 months to 10 years of age for an examination used for the timely detection of amblyopia, with a PlusOptix device by a medical services provider. \nMore information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/screeningove-vysetreni-tupozrakosti",
            "category": null
          },
          {
            "type": {
              "cs": "Fixní nebo snímatelná rovnátka zubů\n",
              "sk": "Fixní alebo snímatelná rovnátka zubú\n",
              "en": "Fixed or removable dental braces"
            },
            "icon": "braces",
            "benefit": {
              "cs": "Až 1 500 Kč na rovnátka zubů",
              "sk": "Až 1 500 Kč na rovnátka zubů",
              "en": "Up to CZK 1 500 for dental braces"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč dětem do 18 let na fixní i snímatelná rovnátka zubů. Příspěvek je možné čerpat jednou za dva roky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč dětem do 18 let na fixní i snímatelná rovnátka zubů. Príspevok je možné čerpat jednou za dva roky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 to children under 18 years of age for fixed and removable dental braces. The contribution can be drawn once every two years. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/fixni-nebo-snimatelna-rovnatka-zubu",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní preventivní prohlídka pro děti\n",
              "sk": "Športové preventivní prehlídka pre deti\n",
              "en": "Preventive examination for child athletes"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 1 500 Kč dětem sportovcům na preventivní prohlídku",
              "sk": "Až 1 500 Kč dětem sportovcům na preventivní prehlídku",
              "en": "Up to CZK 1 500 for child athletes for a preventive examination"
            },
            "description": {
              "cs": "Přispíváme až 1500 Kč dětem sportovcům na preventivní prohlídku, kterou vyžadují sportovní kluby a svazy. Obsahem prohlídky je zpravidla základní interní vyšetření, základní anamnéza, zhodnocení rozboru krve a vyšetření moči, základní vyšetření pohybového aparátu, antropometrie, popř. klidová spirometrie; určení tělesné skladby bioimpedanční metodou, klidové i zátěžové EKG (na běžeckém pásu nebo cyklotrenažeru). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1500 Kč dětem sportovcům na preventivní prehlídku, kterou vyžadují športové kluby a svazy. Obsahem prehlídky je zpravidla základní interní vyšetření, základní anamnéza, zhodnocení rozboru krve a vyšetření moči, základní vyšetření pohybového aparátu, antropometrie, popř. klidová spirometrie; určení tělesné skladby bioimpedanční metodou, klidové i zátěžové EKG (na běžeckém pásu alebo cyklotrenažeru). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1500 for child athletes for a preventive examination required by sports clubs and associations. The examination is usually includes a basic internal examination, basic history, assessment of blood and urine tests, basic examination of the musculoskeletal apparatus, anthropometry or resting spirometry; body composition analysis using the bioimpedance method, resting and active ECG (on a treadmill or stationary bicycle). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-preventivni-prohlidka-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence nadváhy a obezity u dětí\n",
              "sk": "Prevence nadváhy a obezity u detí\n",
              "en": "Prevention of overweight and obesity among children\n"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 1500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou",
              "sk": "Až 1500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou",
              "en": "Up to CZK 1 500 for an examination that includes body composition analysis, primarily using the bioelectric impedance method"
            },
            "description": {
              "cs": "Přispíváme až 1500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 for an examination that includes body composition analysis, primarily using the bioelectric impedance method. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-nadvahy-a-obezity-u-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Zdravotnické prostředky\n",
              "sk": "Zdravotnické prestredky\n",
              "en": "Medical devices\n"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 1 500 Kč na nákup zdravotnických prostředků",
              "sk": "Až 1 500 Kč na nákup zdravotnických prestředků",
              "en": "Up to CZK 1 500 the purchase of medical devices"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč na nákup zdravotnických prostředků, které souvisejí s chronickým onemocněním a nejsou hrazeny z veřejného zdravotního pojištění. Např. Diabetes mellitus (cukrovka), Onemocnění respiračního systému (astma), a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč na nákup zdravotnických prestředků, které souvisejí s chronickým onemocněním a nesou hrazeny z veřejného zdravotního pojištění. Např. Diabetes mellitus (cukrovka), Onemocnění respiračního systému (astma), a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 for the purchase of medical devices related to a chronic illness that are not covered by public health insurance. For example diabetes, respiratory diseases (asthma), and others. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/zdravotnicke-prostredky",
            "category": null
          },
          {
            "type": {
              "cs": "Specifické diety\n",
              "sk": "Specifické diety\n",
              "en": "Support for specific diets"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci",
              "sk": "Až 2 000 Kč na nákup speciálních potravin a obědů vhodných při alergii alebo intoleranci",
              "en": "Up to CZK 2 000 toward the purchase of special foods and meals suitable for allergies or intolerance"
            },
            "description": {
              "cs": "Přispíváme dětem s potravinovou intolerancí až 2 000 Kč nad rámec ostatních preventivních programů na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci. Napři: při celiakii, fenylketonurii a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme dětem s potravinovou intolerancí až 2 000 Kč nad rámec ostatních preventivních pregramů na nákup speciálních potravin a obědů vhodných při alergii alebo intoleranci. Napři: při celiakii, fenylketonurii a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for children with food intolerance beyond the scope of other preventive programmes for the purchase of special foods and meals suitable for allergies or intolerance. For example: in the case of coeliac disease, phenylketonuria, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specificke-diety",
            "category": null
          },
          {
            "type": {
              "cs": "Organizované cvičení nebo plavání s kojencem do 1 roku\n",
              "sk": "Organizované cvičení alebo plavání s kojencem do 1 roku\n",
              "en": "Organized exercise or swimming with infants up to age 1"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 1 500 Kč na pohybové aktivity i pro ty nejmenší",
              "sk": "Až 1 500 Kč na pohybové aktivity i pre ty nemenší",
              "en": "Up to CZK 1 500 for physical activities for even the smallest children"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč na pohybové aktivity i pro ty nejmenší: Organizované plavání s kojencem, včetně vaničkování, organizované cvičení s kojencem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč na pohybové aktivity i pre ty nemenší: Organizované plavání s kojencem, včetně vaničkování, organizované cvičení s kojencem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1500 for physical activities for even the smallest children: organized swimming with infants, including bath conditioning, organized exercise with infants. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/organizovane-cviceni-nebo-plavani-s-kojencem-do-1-roku",
            "category": null
          },
          {
            "type": {
              "cs": "Genetické vyšetření při užívání hormonální antikoncepce pro dívky od 12 let\n",
              "sk": "Genetické vyšetrení pri užívání hormonální antikoncepce pre dívky od 12 let\n",
              "en": "Genetic testing when using hormonal contraception for girls aged 12 and older\n"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 1 500 Kč na preventivní genetické vyšetření rizika tromboembolické nemoci (TEN)",
              "sk": "Až 1 500 Kč na preventivní genetické vyšetření rizika tromboembolické nemoci (TEN)",
              "en": "Up to CZK 1 500 for a preventive genetic analysis of the risk of venous thromoboembolism (VET)"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč na preventivní genetické vyšetření rizika tromboembolické nemoci (TEN) při užívání hormonální antikoncepce dívkám od 12 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč na preventivní genetické vyšetření rizika tromboembolické nemoci (TEN) při užívání hormonální antikoncepce dívkám od 12 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1500 for a preventive genetic analysis to determine the risk of venous thromoboembolism (VET) in case of use of hormonal contraceptives by girls aged 12 and up. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/geneticke-vysetreni-pro-divky-od-12-let",
            "category": null
          },
          {
            "type": {
              "cs": "Sestavení jídelníčku nutričním terapeutem pro děti\n",
              "sk": "Sestavení jídelníčku nutričním terapeutem pre deti\n",
              "en": "Dietary recommendations by a nutritional therapist for children"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 1 500 Kč na službu nutričního terapeuta ",
              "sk": "Až 1 500 Kč na službu nutričního terapeuta",
              "en": "Up to CZK 1 500 for the services of a nutritional therapist "
            },
            "description": {
              "cs": "Přispíváme až 1500 Kč na službu nutričního terapeuta, který sestaví jídelníček pro dosažení a udržení zdravé hmotnosti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1500 Kč na službu nutričního terapeuta, který sestaví jídelníček pre dosažení a udržení zdravé hmotnosti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 for the services of a nutritional therapist, who will make dietary recommendations to achieve and maintain healthy weight. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sestaveni-jidelnicku-nutricnim-terapeutem-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Dětské sportovní léto\n",
              "sk": "Detské športové léto\n",
              "en": "Children's sports summer"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 500 Kč na letní sportovně pohybový pobyt",
              "sk": "Až 500 Kč na letní sportovně pohybový pobyt",
              "en": "Up to CZK 500 for summer stays involving sports"
            },
            "description": {
              "cs": "Přispíváme dětem ve věku od 6 do 15 let až 500 Kč na letní sportovně pohybový pobyt konaný v červenci a srpnu 2026, a to v délce minimálně 4 po sobě jdoucích dní (nocleh není podmínkou). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme dětem ve věku od 6 do 15 let až 500 Kč na letní sportovně pohybový pobyt konaný v červenci a srpnu 2026, a to v délce minimálně 4 po sobě jdoucích dní (nocleh není podmínkou). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to children aged 6 to 15 for a summer sports and exercise camp held in July and August 2026, lasting at least 4 consecutive days (overnight stay is not a requirement). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/detske-sportovni-leto-0",
            "category": null
          },
          {
            "type": {
              "cs": "Klinická psychologie - děti\n",
              "sk": "Klinická psychologie - deti\n",
              "en": "Clinical psychology - children"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 4 000 Kč na vyšetření v oboru klinické psychologie, která nejsou hrazena z veřejného zdravotního pojištění",
              "sk": "Až 4 000 Kč na vyšetření v oboru klinické psychologie, ktoré nesou hrazena z veřejného zdravotního pojištění",
              "en": "Up to CZK 4 000 for examinations in the field of clinical psychology that aren't covered by public health insurance"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické psychologie, která nejsou hrazena z veřejného zdravotního pojištění, a jejichž účelem je zejména včas diagnostikovat např. poruchy autistického spektra (PAS), případně poruchy chování nebo učení, které mohou mít za následek problémy se vzděláváním nebo začleněním do kolektivu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické psychologie, ktoré nesou hrazena z veřejného zdravotního pojištění, a jejichž účelem je zejména včas diagnostikovat např. poruchy autistického spektra (PAS), případně poruchy chování alebo učení, které mohou mít za následek preblémy se vzděláváním alebo začleněním do kolektivu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for up to 10 examinations (i.e. up to CZK 400 per examination) in the field of clinical psychology that are not covered by public health insurance and whose purpose is primarily to diagnose, for example, autism spectrum disorders (ASD), or behavioral or learning disorders that may result in problems with education or social integration. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-psychologie-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Klinická logopedie - děti",
              "sk": "Klinická logopedie - deti",
              "en": "Clinical speech therapy - children"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 4 000 Kč na vyšetření v oboru klinické logopedie",
              "sk": "Až 4 000 Kč na vyšetření v oboru klinické logopedie",
              "en": "Up to CZK 4 000 for examinations in the field of clinical speech therapy"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for up to 10 examinations (i.e. up to CZK 400 per examination) in the field of clinical speech therapy. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-logopedie-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Speciální výživa pro nedonošené děti\n",
              "sk": "Speciální výživa pre nedonošené deti\n",
              "en": "Special nutrition for premature babies"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 2 000 Kč na nákup výživy (umělého mléka) pro nedonošené děti - novorozence do 1 roku s porodní váhou do 1 500 g",
              "sk": "Až 2 000 Kč na nákup výživy (umělého mléka) pre nedonošené děti - novorozence do 1 roku s porodní váhou do 1 500 g",
              "en": "Up to CZK 2 000 toward the purchase of formula for premature infants up to the age of one year with a birth weight of up to 1500 g."
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních programů na nákup výživy (umělého mléka) pro nedonošené děti - novorozence do 1 roku s porodní váhou do 1 500 g. Výživa musí být zakoupena v lékárně nebo internetové lékárně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních pregramů na nákup výživy (umělého mléka) pre nedonošené děti - novorozence do 1 roku s porodní váhou do 1 500 g. Výživa musí být zakoupena v lékárně alebo internetové lékárně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 toward the purchase of formula for premature infants up to the age of one year with a birth weight of up to 1500 g. The formula must be purchased in a pharmacy or on-line pharmacy. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specialni-vyziva-pro-nedonosene-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Paruky, podprsenky a další prostředky pro onkologické pacienty\n",
              "sk": "Paruky, podprsenky a další prestredky pre onkologické pacienty\n",
              "en": "Wigs, bras, and other items for cancer patients\n\n"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod.",
              "sk": "Až 2 000 Kč na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod.",
              "en": "Up to CZK 2 000 for the purchase of a wig or headscarf, medicinal products containing panthenol for the treatment of burns after radiation therapy (radiotherapy), etc."
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč dospělým, kteří podstupují nebo podstoupili protinádorovou léčbu (chemoterapii), ozařování nebo operaci, na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč dospělým, kteří podstupují alebo podstoupili pretinádorovou léčbu (chemoterapii), ozařování alebo operaci, na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes for patients who are undergoing or have undergone anti-cancer treatment (chemotherapy), toward the purchase of a wig or a kerchief. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/paruky-podprsenky-a-dalsi-prostredky-pro-onkologicke-pacienty",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační pobyty pro klienty s diabetem II. typu",
              "sk": "Vzdelávacie pobyty pre klientov s diabetem II. typu",
              "en": "Educational stays for clients with Type II diabetes"
            },
            "icon": "suitcase",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty",
              "sk": "Až 2 000 Kč pre poistencov s onemocněním diabetes mellitus II. typu na vzdelávacie pobyty",
              "en": "Up to CZK 2 000 for clients with Type II diabetes for educational stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty, které jsou organizované pacientskými organizacemi, např. členy Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 2 000 Kč poistencom s onemocněním diabetes mellitus II. typu na vzdelávacie pobyty, ktoré organizujú pacientské organizácie, napr. členovia Aliance pacientů s diabetem ČR, z.s.  Viac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 2 000 for clients with Type II diabetes for educational stays organized by patient organizations such as the Alliance of Patients with Diabetes CR. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-ii-typu",
            "category": null
          },
          {
            "type": {
              "cs": "Nutriční poradenství v souvislosti se specifickou dietou\n",
              "sk": "Výživové poradenstvo v súvislosti so špecifickou diétou",
              "en": "Nutritional counselling for special diets"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 2 000 Kč na sestavení jídelníčku s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii",
              "sk": "Až 2 000 Kč na zostavenie jedálneho lístka s ohľadom napr. na novo zistenú potravinovú intoleranciu alebo alergiu",
              "en": "Up to CZK 2 000 for the creation of a special diet, for example due to a newly diagnosed food intolerance or allergy"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na konzultaci u nutričního terapeuta klientům, kteří potřebují sestavit jídelníček s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Prispievame až 2 000 Kč na konzultáciu u výživového terapeuta klientom, ktorí potrebujú zostaviť jedálny lístok s ohľadom na napr. novo zistenú potravinovú intoleranciu alebo alergiu. Viac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "We contribute up to CZK 2 000 to clients who need a special diet, for example due to a newly diagnosed food intolerance or allergy. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/nutricni-poradenstvi-v-souvislosti-se-specifickou-dietou",
            "category": null
          },
          {
            "type": {
              "cs": "Edukačně-rekondiční pobyty pro klienty s roztroušenou sklerózou\n",
              "sk": "Edukačne-rekondičné pobyty pre klienty s roztroušenou sklerózou\n",
              "en": "Educational recuperative stays for clients with multiple sclerosis"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondičné pobyty",
              "en": "Up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondičné pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti alebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays organized in cooperation with professional associations, clinics, or foundations lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacne-rekondicni-pobyty-pro-klienty-s-roztrousenou",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační pobyty pro klienty s diabetem I. typu",
              "sk": "Edukační pobyty pre klienty s diabetem I. typu",
              "en": "Educational stays for clients with Type I diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty ",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty",
              "en": "Up to CZK 2 000 for clients with Type I diabetes for educational stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované pacientskými organizacemi, jako např. Sdružení rodičů a přátel diabetických dětí a Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované pacientskými organizacemi, jako např. Sdružení rodičů a přátel diabetických dětí a Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for clients with Type I diabetes for educational stays lasting at least 3 days (2 nights) organized by patient organizations such as the Association and Friends of Diabetic Children and the Alliance of Patients with Diabetes CR. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-i-typu",
            "category": null
          },
          {
            "type": {
              "cs": "Psychoterapie\n",
              "sk": "Psychoterapie\n",
              "en": "Psychotherapy"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 4 000 Kč u psychoterapeuta",
              "sk": "Až 4 000 Kč u psychoterapeuta",
              "en": "Up to CZK 4 000 for a psychotherapist"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na až 10 sezení (konzultací) u psychoterapeuta (tedy až 400 Kč na jedno sezení). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na až 10 sezení (konzultací) u psychoterapeuta (tedy až 400 Kč na jedno sezení). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for up to 10 sessions (consultations) with a psychotherapist (up to CZK 400 per session). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/psychoterapie",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační pobyty pro klienty s poruchou autistického spektra",
              "sk": "Edukační pobyty pre klienty s poruchou autistického spektra",
              "en": "Educational stays for clients with autistic spectrum disorders"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty ",
              "sk": "Až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty",
              "en": "Up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo neziskovými organizacemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti alebo neziskovými organizacemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays lasting at least 3 days (2 nights) that are organized in cooperation with professional associations, clinics, or non-profit organizations. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-poruchou-autistickeho-spektra",
            "category": null
          },
          {
            "type": {
              "cs": "Edukační kurz pro klienty s obezitou",
              "sk": "Edukační kurz pre klienty s obezitou",
              "en": "Educational course for clients with obesity"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 2 000 Kč na edukační kurz či pobyt ",
              "sk": "Až 2 000 Kč na edukační kurz či pobyt",
              "en": "Up to CZK 2 000 for an educational course or stay"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč našim pojištěncům na edukační kurz či pobyt v trvání alespoň 3 dny (2 noci), který je určen ke zlepšení zdravotního stavu - zhubnutí a udržení zdravé hmotnosti a změny životního stylu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč našim pojištěncům na edukační kurz či pobyt v trvání alespoň 3 dny (2 noci), který je určen ke zlepšení zdravotního stavu - zhubnutí a udržení zdravé hmotnosti a změny životního stylu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to our insured for an educational course or stay lasting at least 3 days (2 nights), which is designed to improve health - losing weight and maintaining a healthy weight and changing lifestyle. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-kurz-pro-klienty-s-obezitou",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence komplikací spojených s obezitou",
              "sk": "Prevence komplikací spojených s obezitou",
              "en": "Prevention of obesity-related complications"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 4 000 Kč dětem od 12 let, kteří úspěšně absolvují dlouhodobou léčbu obezity",
              "sk": "Až 4 000 Kč dětem od 12 let, kteří úspěšně absolvují dlouhodobou léčbu obezity",
              "en": "Up to CZK 4 000 for children aged 12 and over who successfully complete long-term treatment for obesity"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč dětem od 12 let, kteří úspěšně absolvují dlouhodobou léčbu obezity u smluvního poskytovatele zdravotních služeb nebo nutričního terapeuta, na další léčbu, případně další redukci hmotnosti pod dohledem zdravotníka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč dětem od 12 let, kteří úspěšně absolvují dlouhodobou léčbu obezity u smluvního poskytovatele zdravotních služeb alebo nutričního terapeuta, na další léčbu, případně další redukci hmotnosti pod dohledem zdravotníka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 to children aged 12 and over who successfully complete long-term obesity treatment with a contracted health care provider or nutritional therapist for further treatment or further weight reduction under the supervision of a health care professional. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-komplikaci-spojenych-s-obezitou",
            "category": null
          },
          {
            "type": {
              "cs": "Rekondiční pobyty pro klienty s revmatoidní artritidou",
              "sk": "Rekondičné pobyty pre klienty s revmatoidní artritidou",
              "en": "Reconditioning stays for clients with rheumatoid arthritis"
            },
            "icon": "briefcase",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty",
              "sk": "Až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondičné pobyty",
              "en": "Up to CZK 2 000 for insured persons with rheumatoid arthritis for convalescent stays"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondičné pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti alebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to insured persons with rheumatoid arthritis for convalescent stays that are organized in cooperation with professional societies, clinical workplaces or foundations, lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/rekondicni-pobyty-pro-klienty-s-revmatoidni-artritidou",
            "category": null
          },
          {
            "type": {
              "cs": "Dentální hygiena pro děti\n",
              "sk": "Dentálne hygiena pre deti\n",
              "en": "Dental hygiene for children\n"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 1 500 Kč na dentální hygienu",
              "sk": "Až 1 500 Kč na dentálne hygienu",
              "en": "Up to CZK 1 500 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme dětem až 1 500 Kč na dentální hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme dětem až 1 500 Kč na dentálne hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz..",
              "en": "We contribute up to CZK 1 500 per child for dental hygiene, including training (instruction) in proper tooth brushing as part of a non-covered service. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu kůže pro děti\n",
              "sk": "Prevence karcinomu kúže pre deti\n",
              "en": "Skin cancer prevention"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 1 500 Kč dětem na vyšetření dermatoskopem",
              "sk": "Až 1 500 Kč dětem na vyšetření dermatoskopem",
              "en": "Up to CZK 1 500 for an examination using a dermatoscope"
            },
            "description": {
              "cs": "Přispíváme dětem až 1 500 Kč na vyšetření dermatoskopem, které slouží k včasnému zachycení kožního zhoubného nádoru. Na dokladu musí být uvedeno, že se jedná o vyšetření dermatoskopem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme dětem až 1 500 Kč na vyšetření dermatoskopem, které slouží k včasnému zachycení kožního zhoubného nádoru. Na dokladu musí být uvedeno, že se jedná o vyšetření dermatoskopem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 for children for an examination using a dermatoscope, which is used for timely detection of malignant skin cancer The payment receipt must specify a dermatoscope examination.\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-kuze-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu děložního hrdla pro dívky od 15 let\n",
              "sk": "Prevence karcinomu deložního hrdla pre dívky od 15 let\n",
              "en": "Prevention of cervical cancer for girls aged 15 and older\n"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 1 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nejlépe již prekancerózních stavů",
              "sk": "Až 1 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nelépe již prekancerózních stavů",
              "en": "Up to CZK 1 500 for a preventive uncovered examination for timely detection of (ideally) pre-cancerous conditions"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nejlépe již prekancerózních stavů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nelépe již prekancerózních stavů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 for a preventive uncovered examination for timely detection of (ideally) pre-cancerous conditions. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-delozniho-hrdla-od-15-let",
            "category": null
          },
          {
            "type": {
              "cs": "Logopedické pomůcky",
              "sk": "Logopedické pomúcky",
              "en": "Speech therapy aids"
            },
            "icon": "chat",
            "benefit": {
              "cs": "Až 2 000 Kč na logopedické pomůcky předepsané klinickým logopedem",
              "sk": "Až 2 000 Kč na logopedické pomůcky předepsané klinickým logopedem",
              "en": "Up to CZK 2 000 for speech therapy aids prescribed by a clinical speech therapist"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na logopedické pomůcky předepsané klinickým logopedem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na logopedické pomůcky předepsané klinickým logopedem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 towards speech therapy aids prescribed by a clinical speech therapist. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/logopedicke-pomucky",
            "category": null
          },
          {
            "type": {
              "cs": "Telemedicína",
              "sk": "Telemedicína",
              "en": "Telemedicine"
            },
            "icon": "register",
            "benefit": {
              "cs": "Až 2 000 Kč pojištěncům zapojených do programů telemonitoringu",
              "sk": "Až 2 000 Kč pojištěncům zapojených do pregramů telemonitoringu",
              "en": "Up to CZK 2000 for clients participating in telemonitoring programmes"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních programů pojištěncům zapojeným do programů telemonitoringu. Např. Telemonitoring pro pojištěnce s chronickým srdečním selháním, Telemonitoring pro pojištěnce s podezřením na poruchy srdečního rytmu nebo léčenou srdeční arytmií a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních pregramů pojištěncům zapojeným do pregramů telemonitoringu. Např. Telemonitoring pre pojištěnce s chronickým srdečním selháním, Telemonitoring pre pojištěnce s podezřením na poruchy srdečního rytmu alebo léčenou srdeční arytmií a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes to clients participating in telemonitoring programmes. For example telemonitoring for clients with chronic heart failure, telemonitoring for clients with suspected heart rhythm disturbances or being treated for heart arrhythmia, and others. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-telemedicina",
            "category": null
          }
        ]
      }
    ],
    "updateDate": "27.1.2026",
    "companyBenefitsLink": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence"
  },
  {
    "slug": "cpzp",
    "genders": [
      {
        "name": {
          "cs": "Muži",
          "sk": "Muži",
          "en": "Men"
        },
        "benefits": [
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na různé druhy očkování",
              "sk": "Až 1 000 Kč na rôzne druhy očkovanie",
              "en": "Up to CZK 1 000 for various types of vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pro všechna očkování proti infekčním onemocněním nehrazená z veřejného zdravotního pojištění. Příspěvek je poskytován na kteroukoliv dávku/vakcínu očkovacího cyklu. Příspěvek se nevztahuje na doplatky za očkovací vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pre všechna očkovanie preti infekčním onemocněním nehrazená z veřejného zdravotního pojištění. Príspevok je poskytovaný na kteroukoliv dávku/vakcínu očkovacího cyklu. Príspevok se nevztahuje na doplatky za očkovací vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 this can be used for all infectious disease vaccinations not covered by public health insurance. The contribution can be used for any dose/vaccine in a vaccination cycle. The contribution does not apply to vaccine surcharges. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/14",
            "category": "Muži"
          },
          {
            "type": {
              "cs": "Pravidelný pohyb",
              "sk": "Pravidelný pohyb",
              "en": "Regular movement"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 700 Kč na pohybové aktivity ve věku od 18 let",
              "sk": "Až 700 Kč na pohybové aktivity ve věku od 18 let",
              "en": "Up to CZK 700 for physical activities for ages 18 and up"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na pravidelnou pohybovou aktivitu v rámci prevence kardiovaskulárních chorob a obezity pojištěncům od 18 let. Možnosti čerpání: Pravidelná pohybová aktivita, vč. plavání (netýká se lyžování, masáží, sauny, solária a jiných regeneračních aktivit). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na pravidelnú pohybovú aktivitu v rámci prevence kardiovaskulárních chorob a obezity pojištěncům od 18 let. Možnosti čerpání: Pravidelná pohybová aktivita, vč. plavání (netýká se lyžování, masáží, sauny, solária a jiných regeneračních aktivit). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to regular physical activity as part of the prevention of cardiovascular disease and obesity for our insured clients aged 18 and over. Options for use: Regular physical activity, including swimming (does not apply to skiing, massages, saunas, solariums, and other regenerative activities). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/36",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní prohlídka",
              "sk": "Športové prehlídka",
              "en": "Sports check-up"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 500 Kč na sportovní prohlídku",
              "sk": "Až 500 Kč na športové prehlídku",
              "en": "Up to CZK 500 for a sports check-up"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na úhradu sportovní lékařské prohlídky provedené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz ",
              "sk": "Přispíváme až 500 Kč na úhradu športové lékařské prehlídky prevedené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "en": "We contribute up to CZK 500 towards the cost of a sports medical examination carried out by a healthcare provider. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/22",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření zrakového nervu",
              "sk": "Vyšetrení zrakového nervu",
              "en": "Optic nerve examination"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 300 Kč na vyšetření zrakového nervu",
              "sk": "Až 300 Kč na vyšetření zrakového nervu",
              "en": "Up to CZK 300 for an optical nerve examination"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč na vyšetření zrakového nervu, a to na: GDx – analyzátoru nervových vláken, HRT – Heidelberg Retina Tomograf, OCT – Optical Coherent Tomograf. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč na vyšetření zrakového nervu, a to na: GDx – analyzátoru nervových vláken, HRT – Heidelberg Retina Tomograf, OCT – Optical Coherent Tomograf. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 for optical nerve examination, on the following: GDx – nerve fibre analyzer, HRT – Heidelberg Retina Tomography, OCT – Optical Coherent Tomography. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/18",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence rakoviny kůže\n",
              "sk": "Prevence rakoviny kúže\n",
              "en": "Skin cancer prevention"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření pigmentových skvrn",
              "sk": "Až 500 Kč na vyšetření pigmentových skvrn",
              "en": "Up to CZK 500 for diagnosis of pigment spots."
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření pigmentových skvrn. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na vyšetření pigmentových skvrn. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for diagnosis of pigment spots. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/17",
            "category": null
          },
          {
            "type": {
              "cs": "Zdraví 65+\n",
              "sk": "Zdraví 65+\n",
              "en": "Health 65+\n"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 500 Kč pojištěncům od 65 let na nákup doplňků stravy a vitaminů v lékárně",
              "sk": "Až 500 Kč pojištěncům od 65 let na nákup doplňků stravy a vitaminů v lékárně",
              "en": "Up to CZK 500 for clients aged 65 and up for the purchase of food supplements and vitamins at a pharmacy"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům od 65 let na nákup doplňků výživy a vitaminů v lékárně. Příspěvek je možno uplatnit především na podporu imunity, k prevenci zhoršení stavu kloubů a na paměť. Akceptujeme pouze nákup v lékárně (popř. v e-shopu lékárny). Příspěvek lze uplatnit pouze na přípravky, které se užívají orálně (tzn. nelze uplatnit např. na podání vitaminů formou injekcí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům od 65 let na nákup doplňků výživy a vitaminů v lékárně. Príspevok je možno uplatnit především na podporu imunity, k prevenci zhoršení stavu kloubů a na paměť. Akceptujeme pouze nákup v lékárně (popř. v e-shopu lékárny). Príspevok lze uplatnit pouze na přípravky, které se užívají orálně (tzn. nelze uplatnit např. na podání vitaminů formou injekcí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to insured persons aged 65 and over for the purchase of food supplements and vitamins at a pharmacy. The contribution can be used in particular to support immunity, prevent joint deterioration, and improve memory. We only accept purchases made at a pharmacy (or pharmacy e-shop). The contribution can only be used for products that are taken orally (i.e., it cannot be used for vitamins in the form of injections, for example). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/33",
            "category": null
          },
          {
            "type": {
              "cs": "Laserové operace očí",
              "sk": "Laserové operace očí",
              "en": "Laser eye surgery"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 1000 Kč na laserové operace očí",
              "sk": "Až 1000 Kč na laserové operace očí",
              "en": "Up to CZK 1 000 for laser eye surgery"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na laserové operace očí - odstranění krátkozrakosti a dalekozrakosti a na laserovou operaci katarakty (šedý zákal). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na laserové operace očí - odstranění krátkozrakosti a dalekozrakosti a na laserovou operaci katarakty (šedý zákal). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for laser eye surgery - elimination of far-sightedness and near-sightedness, and for laser cataract surgery. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/21",
            "category": null
          },
          {
            "type": {
              "cs": "Vysoký krevní tlak",
              "sk": "Vysoký krevní tlak",
              "en": "High blood pressure"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 500 Kč příspěvek na zakoupení pažního tlakoměru",
              "sk": "Až 500 Kč príspevok na zakoupení pažního tlakoměru",
              "en": "A contribution of up to CZK 500 for the purchase of a forearm blood pressure monitor."
            },
            "description": {
              "cs": "Přispíváme až 500 Kč svým pojištěncům na zakoupení pažního tlakoměru. Příspěvek je určen chronicky nemocným pacientům s diagnózou \"hypertenze\" . Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč svým pojištěncům na zakoupení pažního tlakoměru. Príspevok je určen chronicky nemocným pacientům s diagnózou \"hypertenze\" . Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients for the purchase of a forearm blood pressure monitor. The contribution is intended for chronically ill patients diagnosed with hypertension. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/54",
            "category": null
          },
          {
            "type": {
              "cs": "Cholesterol",
              "sk": "Cholesterol",
              "en": "Cholesterol"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 200 Kč na koupi doplňku stravy obsahující Omega 3 mastné kyseliny ",
              "sk": "Až 200 Kč na koupi doplňku stravy obsahující Omega 3 mastné kyseliny",
              "en": "Up to CZK 200 for the purchase of food supplements containing Omega 3 fatty acids."
            },
            "description": {
              "cs": "Přispíváme až 200 Kč svým chronicky nemocným pojištěncům s diagnózou \"hyperlipidemie\" na koupi doplňku stravy obsahující Omega 3 mastné kyseliny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 200 Kč svým chronicky nemocným pojištěncům s diagnózou \"hyperlipidemie\" na koupi doplňku stravy obsahující Omega 3 mastné kyseliny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 200 to our chronically ill clients with a \"hyperlipidemia\" diagnosis a for the purchase of food supplements containing Omega 3 fatty acids. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/55",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence rakoviny tlustého střeva\n",
              "sk": "Prevence rakoviny tlustého streva\n",
              "en": "Colon cancer prevention"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Až 500 Kč na prevenci rakoviny tlustého střeva",
              "sk": "Až 500 Kč na prevenci rakoviny tlustého střeva",
              "en": "Up to CZK 500 for colon cancer prevention"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na prevenci rakoviny tlustého střeva - vyšetření provedené u poskytovatele zdravotních služeb. Příspěvek se vztahuje na všechny metody nehrazené z veřejného zdravotního pojištění (např. Septin9). Příspěvek není určen na testy na domácí použití zakoupené v lékárně, ani na výplach Hydrocolon. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na prevenci rakoviny tlustého střeva - vyšetření prevedené u poskytovatele zdravotních služeb. Príspevok se vztahuje na všechny metody nehrazené z veřejného zdravotního pojištění (např. Septin9). Príspevok není určen na testy na domácí použití zakoupené v lékárně, ani na výplach Hydrocolon. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards colon cancer prevention – examinations provided by healthcare providers. The contribution applies to all methods not covered by public health insurance (e.g. Septin9). The contribution is not intended for home tests purchased at pharmacies or for hydrocolon therapy. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/24",
            "category": null
          },
          {
            "type": {
              "cs": "Erektilní dysfunkce\n",
              "sk": "Erektilní dysfunkce\n",
              "en": "Erectile dysfunction"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 500 Kč na léky s léčivou látkou: Avanafil, Sildenafil, Tadalafil, Vardenafil",
              "sk": "Až 500 Kč na léky s léčivou látkou: Avanafil, Sildenafil, Tadalafil, Vardenafil",
              "en": "Up to CZK 500 for medications with the following active ingredient: Avanafil, Sildenafil, Tadalafil, Vardenafil."
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na léky na lékařský předpis s léčivou látkou: Avanafil, Sildenafil, Tadalafil, Vardenafil. Léky musí být zakoupeny v lékárně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na léky na lékařský předpis s léčivou látkou: Avanafil, Sildenafil, Tadalafil, Vardenafil. Léky musí být zakoupeny v lékárně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards prescription drugs containing the following active ingredients: Avanafil, Sildenafil, Tadalafil, Vardenafil. The drugs must be purchased at a pharmacy. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/51",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence rakoviny prostaty",
              "sk": "Prevence rakoviny prestaty",
              "en": "Prostate cancer prevention"
            },
            "icon": "testicles",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření PSA - mužům ve věku od 40 let na prevenci onemocnění rakovinou prostat",
              "sk": "Až 500 Kč na vyšetření PSA - mužům ve věku od 40 let na prevenci onemocnění rakovinou prestat",
              "en": "Up to CZK 500 for a PSA test for men 40 and over for prostate cancer prevention"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč mužům ve věku od 40 let na prevenci onemocnění rakovinou prostaty, a to na vyšetření PSA - v případě, kdy není hrazeno z prostředků veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč mužům ve věku od 40 let na prevenci onemocnění rakovinou prestaty, a to na vyšetření PSA - v případě, kdy není hrazeno z prestředků veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to men aged 40 and over for prostate cancer prevention, specifically for PSA testing, in cases where it is not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/52",
            "category": null
          },
          {
            "type": {
              "cs": "Rázová vlna",
              "sk": "Rázová vlna",
              "en": "Shock wave"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč příspěvek na terapii rázovou vlnou ",
              "sk": "Až 500 Kč príspevok na terapii rázovou vlnou",
              "en": "Up to CZK 500 for shock wave therapy"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na terapii rázovou vlnou provedenou u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na terapii rázovou vlnou prevedenou u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to 500 for shock wave therapy performed by a medical services provider. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/69",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence obezity",
              "sk": "Prevence obezity",
              "en": "Obesity prevention"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 500 Kč příspěvek na prevenci obezity ",
              "sk": "Až 500 Kč príspevok na prevenci obezity",
              "en": "Up to CZK 500 for obesity prevention"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na prevenci obezity. Příspěvek je možno využít na: úhradu nákladů u obezitologa, dietologa, praktického lékaře nebo nutričního terapeuta, za účelem snížení nadváhy a obezity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na prevenci obezity. Príspevok je možno využít na: úhradu nákladů u obezitologa, dietologa, praktického lékaře alebo nutričního terapeuta, za účelem snížení nadváhy a obezity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for prevention of obesity. This contribution may be used to pay an obesitologist, dietologist, general practitioner or a nutritional therapist for purposes of reducing excess weight and obesity. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/71",
            "category": null
          },
          {
            "type": {
              "cs": "Dentální hygiena",
              "sk": "Dentálne hygiena",
              "en": "Dental hygiene"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 500 Kč na dentální hygienu",
              "sk": "Až 500 Kč na dentálne hygienu",
              "en": "Up to CZK 500 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na dentální hygienu provedenou stomatologem nebo zdravotnickým pracovníkem s odbornou způsobilostí k výkonu dentální hygieny. Příspěvek je poskytován do vyčerpání finančního limitu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 500 Kč na dentálne hygienu prevedenou stomatologem alebo zdravotnickým pracovníkem s odbornou způsobilostí k výkonu dentálne hygieny. Príspevok je poskytovaný do vyčerpání finančního limitu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for dental hygiene performed by a dentist or healthcare professional with professional qualifications to perform dental hygiene. The contribution is provided until the financial limit is exceeded. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/80",
            "category": null
          },
          {
            "type": {
              "cs": "Lehká sádra",
              "sk": "Lehká sádra",
              "en": "Lightweight cast\n"
            },
            "icon": "osteoporosis",
            "benefit": {
              "cs": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
              "sk": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
              "en": "Up to CZK 1 000 to cover the cost of lightweight and light casts"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na úhradu odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken (např. Opencast) u poskytovatele zdravotních služeb nebo zakoupené v prodejně zdravotnických potřeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč na úhradu odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken (např. Opencast) u poskytovatele zdravotních služeb alebo zakoupené v predejně zdravotnických potřeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for the purchase of lightweight or light casts made of plastic, resin, and carbon fiber (e.g., Opencast) from a healthcare provider or purchased at a medical supply store. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/81",
            "category": null
          },
          {
            "type": {
              "cs": "Ortopedické vložky",
              "sk": "Ortopedické vložky",
              "en": "Orthopedic insoles\n"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na nákup ortopedických vložek ",
              "sk": "Až 500 Kč na nákup ortopedických vložek",
              "en": "Up to CZK 500 for the purchase of orthopedic insoles"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům s ortopedickými vadami nohou na nákup ortopedických vložek do bot v lékárně, prodejně zdravotnických potřeb, ve specializované prodejně nebo od výrobce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům s ortopedickými vadami nohou na nákup ortopedických vložek do bot v lékárně, predejně zdravotnických potřeb, ve specializované predejně alebo od výrobce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients with orthopedic foot defects for the purchase of orthopedic insoles at a pharmacy, medical supply store, specialty store, or from the manufacturer. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/82",
            "category": null
          },
          {
            "type": {
              "cs": "Krok pro zdraví",
              "sk": "Krok pre zdraví",
              "en": "Steps for health"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu",
              "sk": "Až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu",
              "en": "Up to CZK 1 000 for steps taken in the \"Zdraví v mobilu\" [Mobile Health] app"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu. Příspěvek motivuje pojištěnce ČPZP k pravidelné pohybové aktivitě – chůzi. Program je založen na využití krokoměru v aplikaci Zdraví v mobilu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu. Príspevok motivuje pojištěnce ČPZP k pravidelné pohybové aktivitě – chůzi. Program je založen na využití krokoměru v aplikaci Zdraví v mobilu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1,000 for steps walked in the Zdraví v mobilu (Health on Your Mobile) app. The contribution motivates ČPZP policyholders to engage in regular physical activity – walking. The program is based on the use of a pedometer in the \"Zdraví v mobilu\" app. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/68",
            "category": null
          },
          {
            "type": {
              "cs": "Diabetes",
              "sk": "Diabetes",
              "en": "Diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 1 000 kč na na prevenci zhoršení diabetes.",
              "sk": "Až 1 000 kč na na prevenci zhoršení diabetes.",
              "en": "Up to CZK 1 000 to prevent deterioration of diabetes"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na prevenci zhoršení diabetes. Příspěvek je určen na jednu z vybraných služeb nebo pomůcek jako např.: jehly k inzulinovým perům, testovací a diagnostické proužky, příslušenství k inzulínové pumpě, atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "sk": "Přispíváme až 1 000 Kč na prevenci zhoršení diabetes. Príspevok je určen na jednu z vybraných služeb alebo pomůcek jako např.: jehly k inzulinovým perům, testovací a diagnostické preužky, příslušenství k inzulínové pumpě, atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "en": "We contribute up to CZK 1 000 for the prevention of diabetes complications. The contribution is intended for one of the selected services or aids, such as: needles for insulin pens, test and diagnostic strips, insulin pump accessories, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/32",
            "category": null
          },
          {
            "type": {
              "cs": "Celiakie, dědičné metabolické poruchy",
              "sk": "Celiakie, dedičné metabolické poruchy",
              "en": "Celiac disease, hereditary metabolic disorders\n"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 1 000 Kč celiakům na bezlepkovou dietu a příspěvek na nízkobilkovinovou dietu pro pojištěnce s dědičnými metabolickými poruchami",
              "sk": "Až 1 000 Kč celiakům na bezlepkovou dietu a príspevok na nízkobilkovinovou dietu pre pojištěnce s dědičnými metabolickými poruchami",
              "en": "A contribution of up to CZK 1 000 to those with coeliac disease for a gluten-free diet and a contribution for a low-protein diet for clients with hereditary metabolic disorders."
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům nemocným celiakií příspěvek na bezlepkovou dietu a příspěvek na nízkobilkovinovou dietu pro pojištěnce s dědičnými metabolickými poruchami. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pojištěncům nemocným celiakií príspevok na bezlepkovou dietu a príspevok na nízkobilkovinovou dietu pre pojištěnce s dědičnými metabolickými poruchami. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to clients with coeliac disease for a gluten-free diet and a contribution for a low-protein diet for clients with hereditary metabolic disorders. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/70",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykání kourení",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 2 000 Kč na odvykání kouření",
              "sk": "Až 2 000 Kč na odvykání kouření",
              "en": "Up to CZK 2 000 for smoking cessation."
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům na odvykání kouření. Příspěvek je určen na: nákup volně prodejných léčivých a podpůrných přípravků, zakoupených v lékárně a léčiva na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům na odvykání kouření. Príspevok je určen na: nákup volně predejných léčivých a podpůrných přípravků, zakoupených v lékárně a léčiva na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to insured persons for smoking cessation.The contribution is intended for: the purchase of over-the-counter medicines and support products purchased at a pharmacy and medicines for smoking cessation. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/35",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na paruku",
              "sk": "Príspevok na paruku",
              "en": "Wig contribution"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 2 000 Kč na paruku",
              "sk": "Až 2 000 Kč na paruku",
              "en": "Up to CZK 2 000 for a wig"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na zakoupení paruky pro onkologicky nemocné pacienty, kteří podstupují nebo podstoupili v rámci onkologického onemocnění léčbu chemoterapií a pro pojištěnce s diagnózou alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na zakoupení paruky pre onkologicky nemocné pacientov, kteří podstupují alebo podstoupili v rámci onkologického onemocnění léčbu chemoterapií a pre pojištěnce s diagnózou alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 towards the purchase of wigs for cancer patients who are undergoing or have undergone chemotherapy treatment for cancer, and for insured persons diagnosed with alopecia. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/59",
            "category": null
          },
          {
            "type": {
              "cs": "Program onkologické prevence\n",
              "sk": "Pregram onkologické prevence\n",
              "en": "Cancer prevention program\n"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 2 000 Kč na komplexní onkologickou preventivní prohlídku",
              "sk": "Až 2 000 Kč na komplexní onkologickou preventivní prehlídku",
              "en": "Up to CZK 2 000 for comprehensive preventive cancer screening"
            },
            "description": {
              "cs": "Příspíváme až 2 000 Kč pojištěncům od 35 let na komplexní onkologickou preventivní prohlídku provedenou na specializovaných pracovištích, ve kterých je možné absolvovat preventivní onkologickou prohlídku. Vyšetření zahrnuje laboratorní a další výkony potřebné k odhalení případného karcinomu. Rozsah a cenu vyšetření stanovují jednotlivá pracoviště. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Příspíváme až 2 000 Kč pojištěncům od 35 let na komplexní onkologickou preventivní prehlídku prevedenou na specializovaných pracovištích, ve kterých je možné absolvovat preventivní onkologickou prehlídku. Vyšetření zahrnuje laboratorní a další výkony potřebné k odhalení případného karcinomu. Rozsah a cenu vyšetření stanovují jednotlivá pracoviště. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "en": "We contribute up to CZK 2 000 to our clients aged 35 and over for comprehensive oncological preventive examinations performed at specialized facilities where it is possible to undergo preventive oncological examinations. The examination includes laboratory and other tests necessary to detect possible cancer. The scope and price of the examination are determined by the individual facilities. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/57",
            "category": null
          },
          {
            "type": {
              "cs": "Bonus plus",
              "sk": "Bonus plus",
              "en": "Bonus Plus"
            },
            "icon": "shield",
            "benefit": {
              "cs": "Až 500 Kč v doplňkovém preventivním programu na vybrané aktivity",
              "sk": "Až 500 Kč v doplňkovém preventivním pregramu na vybrané aktivity",
              "en": "Up to CZK 500 in an additional preventive program for selected activities"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč ročně v doplňkovém programu \"Bonus Plus\" na vybrané aktivity, např. zdravotní služby absolvované ve zdravotnických zařízeních, přípravky na ústní hygienu, brýlové obruby, opalovací krémy, sportovní ochranné pomůcky a další. Cílem programu je motivovat pojištěnce ČPZP k ochraně a maximální péči o zdraví a odměňovat je i za věrnost k ČPZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "sk": "Přispíváme až 500 Kč ročně v doplňkovém pregramu \"Bonus Plus\" na vybrané aktivity, např. zdravotní služby absolvované ve zdravotnických zařízeních, přípravky na ústní hygienu, brýlové obruby, opalovací krémy, športové ochranné pomůcky a další. Cílem pregramu je motivovat pojištěnce ČPZP k ochraně a maximální péči o zdraví a odměňovat je i za věrnost k ČPZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "en": "We contribute up to CZK 500 per year in the \"Bonus Plus\" additional programme for selected activities, such as healthcare services provided in healthcare facilities, oral hygiene products, eyeglass frames, sunscreen, sports protective equipment and more. The purpose of the program is to motivate ČPZP policyholders to protect and take maximum care of their health and to reward them for their loyalty to ČPZP. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/29",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na duševní zdraví",
              "sk": "Príspevok na duševní zdraví",
              "en": "Contribution for mental health"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 6 000 Kč na duševní zdraví",
              "sk": "Až 6 000 Kč na duševní zdraví",
              "en": "Up to CZK 6 000 for mental health"
            },
            "description": {
              "cs": "Přispíváme až 6 000 Kč pojištěncům na program pro zvýšení dostupnosti psychosociální podpory. Příspěvek je určen pojištěncům na psychosociální intervenci absolvovanou u vybraného odborníka - soukromého terapeuta s patřičnou kvalifikací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 6 000 Kč pojištěncům na pregram pre zvýšení dostupnosti psychosociální podpory. Príspevok je určen pojištěncům na psychosociální intervenci absolvovanou u vybraného odborníka - soukromého terapeuta s patřičnou kvalifikací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 6 000 to our clients for a program aimed at increasing the availability of psychosocial support. The contribution is intended for insured persons undergoing psychosocial intervention with a selected specialist – a private therapist with the appropriate qualifications. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/73",
            "category": null
          },
          {
            "type": {
              "cs": "BabyGen",
              "sk": "BabyGen",
              "en": "BabyGen"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím",
              "sk": "Až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím",
              "en": "Up to CZK 4 000 for genetic testing before planned pregnancy/parenthood"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím. Jedná se o genetickou analýzu závažných dědičných onemocnění, která vede k odhalení a minimalizaci rizik narození dítěte s těmito nemocemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím. Jedná se o genetickou analýzu závažných dědičných onemocnění, ktoré vede k odhalení a minimalizaci rizik narození dítěte s těmito nemocemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 towards genetic testing prior to planned pregnancy/parenthood. This involves genetic analysis of serious hereditary diseases, which leads to the detection and minimization of the risks of giving birth to a child with these diseases. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/77",
            "category": null
          },
          {
            "type": {
              "cs": "Program pro dárce ",
              "sk": "Pregram pre dárce",
              "en": "Donor Program "
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 6 000 Kč pro dárce krve a kostní dřeně",
              "sk": "Až 6 000 Kč pre dárce krve a kostní dřeně",
              "en": "Up to CZK 6 000 for blood and bone marrow donors"
            },
            "description": {
              "cs": "Přispíváme až 6 000 Kč pro dárce krve a kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 6 000 Kč pre dárce krve a kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 6 000 for blood and bone marrow donors. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-programy/4",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Ženy",
          "sk": "Ženy",
          "en": "Women"
        },
        "benefits": [
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na různé druhy očkování",
              "sk": "Až 1 000 Kč na rôzne druhy očkovanie",
              "en": "Up to CZK 1 000 for various types of vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pro všechna očkování proti infekčním onemocněním nehrazená z veřejného zdravotního pojištění. Příspěvek je poskytován na kteroukoliv dávku/vakcínu očkovacího cyklu. Příspěvek se nevztahuje na doplatky za očkovací vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pre všechna očkovanie preti infekčním onemocněním nehrazená z veřejného zdravotního pojištění. Príspevok je poskytovaný na kteroukoliv dávku/vakcínu očkovacího cyklu. Príspevok se nevztahuje na doplatky za očkovací vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 this can be used for all infectious disease vaccinations not covered by public health insurance. The contribution can be used for any dose/vaccine in a vaccination cycle. The contribution does not apply to vaccine surcharges. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/14",
            "category": "Ženy"
          },
          {
            "type": {
              "cs": "Pravidelný pohyb",
              "sk": "Pravidelný pohyb",
              "en": "Regular movement"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 700 Kč na pohybové aktivity ve věku od 18 let",
              "sk": "Až 700 Kč na pohybové aktivity ve věku od 18 let",
              "en": "Up to CZK 700 for physical activities for ages 18 and up"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na pravidelnou pohybovou aktivitu v rámci prevence kardiovaskulárních chorob a obezity pojištěncům od 18 let. Možnosti čerpání: Pravidelná pohybová aktivita, vč. plavání (netýká se lyžování, masáží, sauny, solária a jiných regeneračních aktivit). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na pravidelnú pohybovú aktivitu v rámci prevence kardiovaskulárních chorob a obezity pojištěncům od 18 let. Možnosti čerpání: Pravidelná pohybová aktivita, vč. plavání (netýká se lyžování, masáží, sauny, solária a jiných regeneračních aktivit). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to regular physical activity as part of the prevention of cardiovascular disease and obesity for our insured clients aged 18 and over. Options for use: Regular physical activity, including swimming (does not apply to skiing, massages, saunas, solariums, and other regenerative activities). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/36",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní prohlídka",
              "sk": "Športové prehlídka",
              "en": "Sports check-up"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 500 Kč na sportovní prohlídku",
              "sk": "Až 500 Kč na športové prehlídku",
              "en": "Up to CZK 500 for a sports check-up"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na úhradu sportovní lékařské prohlídky provedené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz \n",
              "sk": "Přispíváme až 500 Kč na úhradu športové lékařské prehlídky prevedené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz \n",
              "en": "We contribute up to CZK 500 towards the cost of a sports medical examination carried out by a healthcare provider. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/36",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence rakoviny prsu",
              "sk": "Prevence rakoviny prsu",
              "en": "Breast cancer prevention"
            },
            "icon": "breasts",
            "benefit": {
              "cs": "Až 500 Kč na prevenci rakoviny prsu",
              "sk": "Až 500 Kč na prevenci rakoviny prsu",
              "en": "Up to CZK 500 for breast cancer prevention"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na prevenci rakoviny prsu, a to: pro ženy ve věku od 30 - 40 let na mamografické vyšetření nebo ultrasonografické vyšetření. Vyšetření musí být provedeno na některém z pracovišť, která jsou k tomuto účelu akreditována. Seznam aktuálních vybraných zdravotnických zařízení je k dispozici na internetových stránkách Asociace mamodiagnostiků ČR www.mamo.cz. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na prevenci rakoviny prsu, a to: pre ženy ve věku od 30 - 40 let na mamografické vyšetření alebo ultrasonografické vyšetření. Vyšetření musí být prevedeno na některém z pracovišť, ktoré jsou k tomuto účelu akreditována. Seznam aktuálních vybraných zdravotnických zařízení je k dispozici na internetových stránkách Asociace mamodiagnostiků ČR www.mamo.cz. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to pay for breast cancer prevention - for women aged 30 - 40 and up for a mammography or ultrasound examination. The examination must be performed at an accredited facility. A list of currently selected medical facilities is available on the website of the Association of Czech Breast Radiologists (www.mamo.cz). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/15",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření zrakového nervu",
              "sk": "Vyšetrení zrakového nervu",
              "en": "Optic nerve examination"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 300 Kč na vyšetření zrakového nervu",
              "sk": "Až 300 Kč na vyšetření zrakového nervu",
              "en": "Up to CZK 300 for an optical nerve examination"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč na vyšetření zrakového nervu, a to na: GDx – analyzátoru nervových vláken, HRT – Heidelberg Retina Tomograf, OCT – Optical Coherent Tomograf. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč na vyšetření zrakového nervu, a to na: GDx – analyzátoru nervových vláken, HRT – Heidelberg Retina Tomograf, OCT – Optical Coherent Tomograf. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 for optical nerve examination, on the following: GDx – nerve fibre analyzer, HRT – Heidelberg Retina Tomography, OCT – Optical Coherent Tomography. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/18",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence rakoviny kůže",
              "sk": "Prevence rakoviny kúže",
              "en": "Skin cancer prevention"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření pigmentových skvrn",
              "sk": "Až 500 Kč na vyšetření pigmentových skvrn",
              "en": "Up to CZK 500 for diagnosis of pigment spots"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření pigmentových skvrn. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na vyšetření pigmentových skvrn. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for diagnosis of pigment spots. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/17",
            "category": null
          },
          {
            "type": {
              "cs": "Zdraví 65+\n",
              "sk": "Zdraví 65+\n",
              "en": "Health 65+\n"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 500 Kč pojištěncům od 65 let na nákup doplňků stravy a vitaminů v lékárně",
              "sk": "Až 500 Kč pojištěncům od 65 let na nákup doplňků stravy a vitaminů v lékárně",
              "en": "Up to CZK 500 for clients aged 65 and up for the purchase of food supplements and vitamins at a pharmacy"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům od 65 let na nákup doplňků výživy a vitaminů v lékárně. Příspěvek je možno uplatnit především na podporu imunity, k prevenci zhoršení stavu kloubů a na paměť. Akceptujeme pouze nákup v lékárně (popř. v e-shopu lékárny). Příspěvek lze uplatnit pouze na přípravky, které se užívají orálně (tzn. nelze uplatnit např. na podání vitaminů formou injekcí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům od 65 let na nákup doplňků výživy a vitaminů v lékárně. Príspevok je možno uplatnit především na podporu imunity, k prevenci zhoršení stavu kloubů a na paměť. Akceptujeme pouze nákup v lékárně (popř. v e-shopu lékárny). Príspevok lze uplatnit pouze na přípravky, které se užívají orálně (tzn. nelze uplatnit např. na podání vitaminů formou injekcí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to insured persons aged 65 and over for the purchase of food supplements and vitamins at a pharmacy. The contribution can be used in particular to support immunity, prevent joint deterioration, and improve memory. We only accept purchases made at a pharmacy (or pharmacy e-shop). The contribution can only be used for products that are taken orally (i.e., it cannot be used for vitamins in the form of injections, for example). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/33",
            "category": null
          },
          {
            "type": {
              "cs": "Laserové operace očí",
              "sk": "Laserové operace očí",
              "en": "Laser eye surgery"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 1 000 Kč na laserové operace očí",
              "sk": "Až 1 000 Kč na laserové operace očí",
              "en": "Up to CZK 1 000 for laser eye surgery"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na laserové operace očí - odstranění krátkozrakosti a dalekozrakosti a na laserovou operaci katarakty (šedý zákal). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč na laserové operace očí - odstranění krátkozrakosti a dalekozrakosti a na laserovou operaci katarakty (šedý zákal). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for laser eye surgery - elimination of far-sightedness and near-sightedness, and for laser cataract surgery. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/21",
            "category": null
          },
          {
            "type": {
              "cs": "Vysoký krevní tlak",
              "sk": "Vysoký krevní tlak",
              "en": "High blood pressure"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 500 Kč příspěvek na zakoupení pažního tlakoměru",
              "sk": "Až 500 Kč príspevok na zakoupení pažního tlakoměru",
              "en": "A contribution of up to CZK 500 for the purchase of a forearm blood pressure monitor"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč svým pojištěncům na zakoupení pažního tlakoměru. Příspěvek je určen chronicky nemocným pacientům s diagnózou \"hypertenze\" . Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč svým pojištěncům na zakoupení pažního tlakoměru. Príspevok je určen chronicky nemocným pacientům s diagnózou \"hypertenze\" . Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients for the purchase of a forearm blood pressure monitor. The contribution is intended for chronically ill patients diagnosed with hypertension. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/54",
            "category": null
          },
          {
            "type": {
              "cs": "Cholesterol",
              "sk": "Cholesterol",
              "en": "Cholesterol"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 200 Kč na koupi doplňku stravy obsahující Omega 3 mastné kyseliny  ",
              "sk": "Až 200 Kč na koupi doplňku stravy obsahující Omega 3 mastné kyseliny",
              "en": "Up to CZK 200 for the purchase of food supplements containing Omega 3 fatty acids"
            },
            "description": {
              "cs": "Přispíváme až 200 Kč svým chronicky nemocným pojištěncům s diagnózou \"hyperlipidemie\" na koupi doplňku stravy obsahující Omega 3 mastné kyseliny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 200 Kč svým chronicky nemocným pojištěncům s diagnózou \"hyperlipidemie\" na koupi doplňku stravy obsahující Omega 3 mastné kyseliny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 200 to our chronically ill clients with a \"hyperlipidemia\" diagnosis a for the purchase of food supplements containing Omega 3 fatty acids. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/55",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence rakoviny tlustého střeva",
              "sk": "Prevence rakoviny tlustého streva",
              "en": "Colon cancer prevention"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Až 500 Kč na prevenci rakoviny tlustého střeva",
              "sk": "Až 500 Kč na prevenci rakoviny tlustého střeva",
              "en": "Up to CZK 500 for colon cancer prevention"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na prevenci rakoviny tlustého střeva - vyšetření provedené u poskytovatele zdravotních služeb. Příspěvek se vztahuje na všechny metody nehrazené z veřejného zdravotního pojištění (např. Septin9). Příspěvek není určen na testy na domácí použití zakoupené v lékárně, ani na výplach Hydrocolon. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 500 Kč na prevenci rakoviny tlustého střeva - vyšetření prevedené u poskytovatele zdravotních služeb. Príspevok se vztahuje na všechny metody nehrazené z veřejného zdravotního pojištění (např. Septin9). Príspevok není určen na testy na domácí použití zakoupené v lékárně, ani na výplach Hydrocolon. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards colon cancer prevention – examinations provided by healthcare providers. The contribution applies to all methods not covered by public health insurance (e.g. Septin9). The contribution is not intended for home tests purchased at pharmacies or for hydrocolon therapy. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/24",
            "category": null
          },
          {
            "type": {
              "cs": "Rázová vlna",
              "sk": "Rázová vlna",
              "en": "Shock wave"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč příspěvek na terapii rázovou vlnou ",
              "sk": "Až 500 Kč príspevok na terapii rázovou vlnou",
              "en": "Up to CZK 500 for shock wave therapy"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na terapii rázovou vlnou provedenou u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na terapii rázovou vlnou prevedenou u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to 500 for shock wave therapy performed by a medical services provider. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/69",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence obezity",
              "sk": "Prevence obezity",
              "en": "Obesity prevention"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 500 Kč příspěvek na prevenci obezity",
              "sk": "Až 500 Kč príspevok na prevenci obezity",
              "en": "Up to CZK 500 for obesity prevention"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na prevenci obezity. Příspěvek je možno využít na: úhradu nákladů u obezitologa, dietologa, praktického lékaře nebo nutričního terapeuta, za účelem snížení nadváhy a obezity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na prevenci obezity. Príspevok je možno využít na: úhradu nákladů u obezitologa, dietologa, praktického lékaře alebo nutričního terapeuta, za účelem snížení nadváhy a obezity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for prevention of obesity. This contribution may be used to pay an obesitologist, dietologist, general practitioner or a nutritional therapist for purposes of reducing excess weight and obesity. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/71",
            "category": null
          },
          {
            "type": {
              "cs": "Dentální hygiena",
              "sk": "Dentálne hygiena",
              "en": "Dental hygiene"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 500 Kč na dentální hygienu",
              "sk": "Až 500 Kč na dentálne hygienu",
              "en": "Up to CZK 500 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na dentální hygienu provedenou stomatologem nebo zdravotnickým pracovníkem s odbornou způsobilostí k výkonu dentální hygieny. Příspěvek je poskytován do vyčerpání finančního limitu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 500 Kč na dentálne hygienu prevedenou stomatologem alebo zdravotnickým pracovníkem s odbornou způsobilostí k výkonu dentálne hygieny. Príspevok je poskytovaný do vyčerpání finančního limitu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for dental hygiene performed by a dentist or healthcare professional with professional qualifications to perform dental hygiene. The contribution is provided until the financial limit is exceeded. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/80",
            "category": null
          },
          {
            "type": {
              "cs": "Lehká sádra",
              "sk": "Lehká sádra",
              "en": "Lightweight cast\n"
            },
            "icon": "osteoporosis",
            "benefit": {
              "cs": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
              "sk": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
              "en": "Up to CZK 1 000 to cover the cost of lightweight and light casts"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na úhradu odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken (např. Opencast) u poskytovatele zdravotních služeb nebo zakoupené v prodejně zdravotnických potřeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč na úhradu odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken (např. Opencast) u poskytovatele zdravotních služeb alebo zakoupené v predejně zdravotnických potřeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for the purchase of lightweight or light casts made of plastic, resin, and carbon fiber (e.g., Opencast) from a healthcare provider or purchased at a medical supply store. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/81",
            "category": null
          },
          {
            "type": {
              "cs": "Ortopedické vložky",
              "sk": "Ortopedické vložky",
              "en": "Orthopedic insoles\n"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na nákup ortopedických vložek ",
              "sk": "Až 500 Kč na nákup ortopedických vložek",
              "en": "Up to CZK 500 for the purchase of orthopedic insoles"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům s ortopedickými vadami nohou na nákup ortopedických vložek do bot v lékárně, prodejně zdravotnických potřeb, ve specializované prodejně nebo od výrobce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům s ortopedickými vadami nohou na nákup ortopedických vložek do bot v lékárně, predejně zdravotnických potřeb, ve specializované predejně alebo od výrobce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients with orthopedic foot defects for the purchase of orthopedic insoles at a pharmacy, medical supply store, specialty store, or from the manufacturer. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/82",
            "category": null
          },
          {
            "type": {
              "cs": "Porod +",
              "sk": "Porod +",
              "en": "Birth +"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 500 Kč na nadstandardní služby související s porodem hrazené u poskytovatele zdravotních služeb.",
              "sk": "Až 500 Kč na nadstandardní služby související s porodem hrazené u poskytovatele zdravotních služeb.",
              "en": "Up to CZK 500 for premium services related to childbirth covered by the healthcare provider."
            },
            "description": {
              "cs": "Přispíváme až 500 Kč těhotným ženám na nadstandardní služby související s porodem hrazené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč těhotným ženám na nadstandardní služby související s porodem hrazené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to pregnant women for premium services related to childbirth covered by a healthcare provider. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/85",
            "category": null
          },
          {
            "type": {
              "cs": "Krok pro zdraví",
              "sk": "Krok pre zdraví",
              "en": "Steps for health"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu",
              "sk": "Až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu",
              "en": "Up to CZK 1 000 for steps taken in the \"Zdraví v mobilu\" [Mobile Health] app"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu. Příspěvek motivuje pojištěnce ČPZP k pravidelné pohybové aktivitě – chůzi. Program je založen na využití krokoměru v aplikaci Zdraví v mobilu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu. Príspevok motivuje pojištěnce ČPZP k pravidelné pohybové aktivitě – chůzi. Program je založen na využití krokoměru v aplikaci Zdraví v mobilu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1,000 for steps walked in the Zdraví v mobilu (Health on Your Mobile) app. The contribution motivates ČPZP policyholders to engage in regular physical activity – walking. The program is based on the use of a pedometer in the \"Zdraví v mobilu\" app. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/68",
            "category": null
          },
          {
            "type": {
              "cs": "Diabetes",
              "sk": "Diabetes",
              "en": "Diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 1 000 kč na na prevenci zhoršení diabetes.",
              "sk": "Až 1 000 kč na na prevenci zhoršení diabetes.",
              "en": "Up to CZK 1 000 to prevent deterioration of diabetes"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na prevenci zhoršení diabetes. Příspěvek je určen na jednu z vybraných služeb nebo pomůcek jako např.: jehly k inzulinovým perům, testovací a diagnostické proužky, příslušenství k inzulínové pumpě, atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "sk": "Přispíváme až 1 000 Kč na prevenci zhoršení diabetes. Príspevok je určen na jednu z vybraných služeb alebo pomůcek jako např.: jehly k inzulinovým perům, testovací a diagnostické preužky, příslušenství k inzulínové pumpě, atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "en": "We contribute up to CZK 1 000 for the prevention of diabetes complications. The contribution is intended for one of the selected services or aids, such as: needles for insulin pens, test and diagnostic strips, insulin pump accessories, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/32",
            "category": null
          },
          {
            "type": {
              "cs": "Celiakie, dědičné metabolické poruchy",
              "sk": "Celiakie, dedičné metabolické poruchy",
              "en": "Celiac disease, hereditary metabolic disorders\n"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 1 000 Kč celiakům na bezlepkovou dietu a příspěvek na nízkobilkovinovou dietu pro pojištěnce s dědičnými metabolickými poruchami",
              "sk": "Až 1 000 Kč celiakům na bezlepkovou dietu a príspevok na nízkobilkovinovou dietu pre pojištěnce s dědičnými metabolickými poruchami",
              "en": "A contribution of up to CZK 1 000 to those with coeliac disease for a gluten-free diet and a contribution for a low-protein diet for clients with hereditary metabolic disorders."
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům nemocným celiakií příspěvek na bezlepkovou dietu a příspěvek na nízkobilkovinovou dietu pro pojištěnce s dědičnými metabolickými poruchami. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pojištěncům nemocným celiakií príspevok na bezlepkovou dietu a príspevok na nízkobilkovinovou dietu pre pojištěnce s dědičnými metabolickými poruchami. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to clients with coeliac disease for a gluten-free diet and a contribution for a low-protein diet for clients with hereditary metabolic disorders. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/70",
            "category": null
          },
          {
            "type": {
              "cs": "Manažerka mateřství/Těhotenství +",
              "sk": "Manažerka materství/Tehotenství +",
              "en": "Motherhood manager/Pregnancy +"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 3 000 Kč na mateřství a těhotenství",
              "sk": "Až 3 000 Kč na mateřství a těhotenství",
              "en": "Up to CZK 3 000 for motherhood and pregnancy"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč těhotným ženám na klidné mateřství a těhotenství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 3 000 Kč těhotným ženám na klidné mateřství a těhotenství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 000 to pregnant women for a peaceful motherhood and pregnancy. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/38",
            "category": null
          },
          {
            "type": {
              "cs": "Žena po porodu\n",
              "sk": "Žena po porodu\n",
              "en": "Woman after childbirth"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 1 000 Kč po porodu",
              "sk": "Až 1 000 Kč po porodu",
              "en": "Up to CZK 1 000 after childbirth"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč ženám po porodu. Příspěvek je určen ženám po porodu miminka do 1 roku věku dítěte, u služby laktačních poradkyň do 6 měsíců po porodu. V případě vícečetného porodu nelze příspěvek navýšit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč ženám po porodu. Príspevok je určen ženám po porodu miminka do 1 roku věku dítěte, u služby laktačních poradkyň do 6 měsíců po porodu. V případě vícečetného porodu nelze príspevok navýšit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to women after childbirth. The contribution is intended for women after the birth of a baby up to 1 year of age, and for lactation consultants up to 6 months after childbirth. In the case of multiple births, the contribution cannot be increased. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/37",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykání kourení",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 2 000 Kč na odvykání kouření",
              "sk": "Až 2 000 Kč na odvykání kouření",
              "en": "Up to CZK 2 000 for smoking cessation."
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům na odvykání kouření. Příspěvek je určen na: nákup volně prodejných léčivých a podpůrných přípravků, zakoupených v lékárně a léčiva na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům na odvykání kouření. Príspevok je určen na: nákup volně predejných léčivých a podpůrných přípravků, zakoupených v lékárně a léčiva na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to insured persons for smoking cessation.The contribution is intended for: the purchase of over-the-counter medicines and support products purchased at a pharmacy and medicines for smoking cessation. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/35",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na paruku",
              "sk": "Príspevok na paruku",
              "en": "Wig contribution"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 2 000 Kč na paruku",
              "sk": "Až 2 000 Kč na paruku",
              "en": "Up to CZK 2000 for a wig"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na zakoupení paruky pro onkologicky nemocné pacienty, kteří podstupují nebo podstoupili v rámci onkologického onemocnění léčbu chemoterapií a pro pojištěnce s diagnózou alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na zakoupení paruky pre onkologicky nemocné pacientov, kteří podstupují alebo podstoupili v rámci onkologického onemocnění léčbu chemoterapií a pre pojištěnce s diagnózou alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 towards the purchase of wigs for cancer patients who are undergoing or have undergone chemotherapy treatment for cancer, and for insured persons diagnosed with alopecia. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/59",
            "category": null
          },
          {
            "type": {
              "cs": "Program onkologické prevence\n\n",
              "sk": "Pregram onkologické prevence\n\n",
              "en": "Cancer prevention programme"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 2 000 Kč na komplexní onkologickou preventivní prohlídku",
              "sk": "Až 2 000 Kč na komplexní onkologickou preventivní prehlídku",
              "en": "Up to CZK 2000 for comprehensive preventive cancer screening."
            },
            "description": {
              "cs": "Příspíváme až 2 000 Kč pojištěncům od 35 let na komplexní onkologickou preventivní prohlídku provedenou na specializovaných pracovištích, ve kterých je možné absolvovat preventivní onkologickou prohlídku. Vyšetření zahrnuje laboratorní a další výkony potřebné k odhalení případného karcinomu. Rozsah a cenu vyšetření stanovují jednotlivá pracoviště. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "sk": "Příspíváme až 2 000 Kč pojištěncům od 35 let na komplexní onkologickou preventivní prehlídku prevedenou na specializovaných pracovištích, ve kterých je možné absolvovat preventivní onkologickou prehlídku. Vyšetření zahrnuje laboratorní a další výkony potřebné k odhalení případného karcinomu. Rozsah a cenu vyšetření stanovují jednotlivá pracoviště. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "en": "We contribute up to CZK 2 000 to our clients aged 35 and over for comprehensive oncological preventive examinations performed at specialized facilities where it is possible to undergo preventive oncological examinations. The examination includes laboratory and other tests necessary to detect possible cancer. The scope and price of the examination are determined by the individual facilities. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/57",
            "category": null
          },
          {
            "type": {
              "cs": "Jedeme dál",
              "sk": "Jedeme dál",
              "en": "Keeping going"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 2 000 Kč na zakoupení protetické podprsenky, plavky, epitézy nebo na rekondiční pobyt ",
              "sk": "Až 2 000 Kč na zakoupení pretetické podprsenky, plavky, epitézy alebo na rekondičné pobyt",
              "en": "Up to CZK 2 000 for the purchase of a prosthetic bra, swimsuit, prosthesis, or for rehabilitation stay"
            },
            "description": {
              "cs": "Až 2 000 Kč ženám, které se léčí se zhoubným onemocněním prsu a je určen na zakoupení protetické podprsenky ve specializované prodejně nebo na rekondiční pobyt pořádaný pacientskými organizacemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Až 2 000 Kč ženám, které se léčí se zhoubným onemocněním prsu a je určen na zakoupení pretetické podprsenky ve specializované predejně alebo na rekondičné pobyt pořádaný pacientskými organizacemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to CZK 2 000 for women undergoing treatment for malignant breast disease, intended for the purchase of a prosthetic bra in a specialized store or for a reconditioning stay organized by patient organizations. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/72",
            "category": null
          },
          {
            "type": {
              "cs": "Bonus plus",
              "sk": "Bonus plus",
              "en": "Bonus Plus"
            },
            "icon": "shield",
            "benefit": {
              "cs": "Až 500 Kč v doplňkovém preventivním programu na vybrané aktivity",
              "sk": "Až 500 Kč v doplňkovém preventivním pregramu na vybrané aktivity",
              "en": "Up to CZK 500 in an additional preventive program for selected activities"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč ročně v doplňkovém programu \"Bonus Plus\" na vybrané aktivity, např. zdravotní služby absolvované ve zdravotnických zařízeních, přípravky na ústní hygienu, brýlové obruby, opalovací krémy, sportovní ochranné pomůcky a další. Cílem programu je motivovat pojištěnce ČPZP k ochraně a maximální péči o zdraví a odměňovat je i za věrnost k ČPZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "sk": "Přispíváme až 500 Kč ročně v doplňkovém pregramu \"Bonus Plus\" na vybrané aktivity, např. zdravotní služby absolvované ve zdravotnických zařízeních, přípravky na ústní hygienu, brýlové obruby, opalovací krémy, športové ochranné pomůcky a další. Cílem pregramu je motivovat pojištěnce ČPZP k ochraně a maximální péči o zdraví a odměňovat je i za věrnost k ČPZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "en": "We contribute up to CZK 500 per year in the \"Bonus Plus\" additional programme for selected activities, such as healthcare services provided in healthcare facilities, oral hygiene products, eyeglass frames, sunscreen, sports protective equipment and more. The purpose of the program is to motivate ČPZP policyholders to protect and take maximum care of their health and to reward them for their loyalty to ČPZP. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/29",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na duševní zdraví",
              "sk": "Príspevok na duševní zdraví",
              "en": "Contribution for mental health"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 6 000 Kč na duševní zdraví",
              "sk": "Až 6 000 Kč na duševní zdraví",
              "en": "Up to CZK 6 000 for mental health"
            },
            "description": {
              "cs": "Přispíváme až 6 000 Kč pojištěncům na program pro zvýšení dostupnosti psychosociální podpory. Příspěvek je určen pojištěncům na psychosociální intervenci absolvovanou u vybraného odborníka - soukromého terapeuta s patřičnou kvalifikací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 6 000 Kč pojištěncům na pregram pre zvýšení dostupnosti psychosociální podpory. Príspevok je určen pojištěncům na psychosociální intervenci absolvovanou u vybraného odborníka - soukromého terapeuta s patřičnou kvalifikací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 6 000 to our clients for a program aimed at increasing the availability of psychosocial support. The contribution is intended for insured persons undergoing psychosocial intervention with a selected specialist – a private therapist with the appropriate qualifications. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/73",
            "category": null
          },
          {
            "type": {
              "cs": "BabyGen",
              "sk": "BabyGen",
              "en": "BabyGen"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím",
              "sk": "Až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím",
              "en": "Up to CZK 4 000 for genetic testing before planned pregnancy/parenthood"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím. Jedná se o genetickou analýzu závažných dědičných onemocnění, která vede k odhalení a minimalizaci rizik narození dítěte s těmito nemocemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím. Jedná se o genetickou analýzu závažných dědičných onemocnění, ktoré vede k odhalení a minimalizaci rizik narození dítěte s těmito nemocemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 towards genetic testing prior to planned pregnancy/parenthood. This involves genetic analysis of serious hereditary diseases, which leads to the detection and minimization of the risks of giving birth to a child with these diseases. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/77",
            "category": null
          },
          {
            "type": {
              "cs": "Program pro dárce ",
              "sk": "Pregram pre dárce",
              "en": "Donor Program "
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 6 000 Kč pro dárce krve a kostní dřeně",
              "sk": "Až 6 000 Kč pre dárce krve a kostní dřeně",
              "en": "Up to CZK 6 000 for blood and bone marrow donors"
            },
            "description": {
              "cs": "Přispíváme až 6 000 Kč pro dárce krve a kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 6 000 Kč pre dárce krve a kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 6 000 for blood and bone marrow donors. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-programy/4",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Děti",
          "sk": "Deti",
          "en": "Children"
        },
        "benefits": [
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 500 Kč na různé druhy očkování",
              "sk": "Až 1 500 Kč na rôzne druhy očkovanie",
              "en": "Up to CZK 1 500 for various types of vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč pro všechna očkování proti infekčním onemocněním nehrazená z veřejného zdravotního pojištění. ČPZP poskytuje zákonným zástupcům dětí a mládeže ve věku do 17 let včetně příspěvek na preventivní očkování v rámci preventivních programů pro děti a mládež. Příspěvek je poskytován na kteroukoliv dávku/vakcínu očkovacího cyklu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč pre všechna očkovanie preti infekčním onemocněním nehrazená z veřejného zdravotního pojištění. ČPZP poskytuje zákonným zástupcům dětí a mládeže ve věku do 17 let včetně príspevok na preventivní očkovanie v rámci preventivních pregramů pre děti a mládež. Príspevok je poskytovaný na kteroukoliv dávku/vakcínu očkovacího cyklu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 for all vaccinations against infectious diseases not covered by public health insurance. ČPZP provides legal guardians of children and young people up to the age of 17 with a contribution towards preventive vaccinations as part of preventive programs for children and young people. The contribution is provided for any dose/vaccine in the vaccination cycle. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/30",
            "category": "Deti"
          },
          {
            "type": {
              "cs": "Letní tábory",
              "sk": "Letní tábory",
              "en": "Summer camps"
            },
            "icon": "tent",
            "benefit": {
              "cs": "Až 1 500 Kč na letní tábory",
              "sk": "Až 1 500 Kč na letní tábory",
              "en": "Up to CZK 1 500 for summer camps"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč na letní táboty pro děti od 3 let. Příspěvek bude uznán jen v případě jeho trvání v délce minimálně 4 kalendářní dny, a lze jej uplatnit na tábory pořádané v období letních prázdnin. Příspěvek se vztahuje i na příměstské tábory. Příspěvek lze poskytnout jen na tábory konané na území ČR. Příspěvek bude realizován až po absolvování letního tábora. O příspěvek je možné požádat pouze do 30.9.2026 včetně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč na letní táboty pre děti od 3 let. Príspevok bude uznán jen v případě jeho trvání v délce minimálně 4 kalendářní dny, a lze jej uplatnit na tábory pořádané v období letních prázdnin. Príspevok se vztahuje i na příměstské tábory. Príspevok lze poskytnout jen na tábory konané na území ČR. Príspevok bude realizován až po absolvování letního tábora. O príspevok je možné požádat pouze do 30.9.2026 včetně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 to summer camps for children aged 3 and above. The contribution will only be recognized if the camp lasts at least 4 calendar days and can be applied to camps organized during the summer holidays. The contribution also applies to suburban camps. The contribution can only be provided for camps held in the Czech Republic. The contribution will be made after the summer camp has been completed. Applications for the contribution can only be submitted until September 30, 2026, inclusive. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/3",
            "category": null
          },
          {
            "type": {
              "cs": "Školky a školy v přírodě, lyžařské výcviky",
              "sk": "Školky a školy v prírode, lyžarské výcviky",
              "en": "Kindergartens and outdoor schools, ski training courses\n"
            },
            "icon": "tent",
            "benefit": {
              "cs": "Až 500 Kč na školky a školy v přírodě, lyžařské výcviky\n",
              "sk": "Až 500 Kč na školky a školy v přírodě, lyžařské výcviky\n",
              "en": "Up to CZK 500 for kindergartens and outdoor schools, ski training courses"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč zákonným zástupcům dětí na školky a školy v přírodě. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč zákonným zástupcům dětí na školky a školy v přírodě. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to parents and legal guardians of children for open-air pre-schools and schools. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/2",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní kroužky",
              "sk": "Športové kroužky",
              "en": "Sports activities"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 700 Kč na sportovní pohybové kroužky, sportovní kurzy a členství ve sportovních klubech a oddílech",
              "sk": "Až 700 Kč na športové pohybové kroužky, športové kurzy a členství ve športovéch klubech a oddílech",
              "en": "Up to CZK 700 for sports activities, sports courses, and membership in sports clubs and teams."
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na sportovní pohybové kroužky (organizované školami i jinými subjekty), sportovní kurzy a členství ve sportovních klubech a oddílech pro děti a mládež od 3 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na športové pohybové kroužky (organizované školami i jinými subjekty), športové kurzy a členství ve športovéch klubech a oddílech pre děti a mládež od 3 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to sports clubs (organized by schools and other entities), sports courses, and membership in sports clubs and teams for children and young people aged 3 and above. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/56",
            "category": null
          },
          {
            "type": {
              "cs": "Ochranná přilba",
              "sk": "Ochranná prilba",
              "en": "Protective helmet"
            },
            "icon": "helmet",
            "benefit": {
              "cs": "Až 500 Kč na ochrannou přilbu",
              "sk": "Až 500 Kč na ochrannou přilbu",
              "en": "Up to CZK 500 for a protective helmet"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč zákonným zástupcům dětí na nákup ochranné přilby pro děti. Příspěvek se vztahuje na ochrannou přilbu na sport zakoupenou v kamenné prodejně, popř. e-shopu prodejny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 500 Kč zákonným zástupcům dětí na nákup ochranné přilby pre děti. Príspevok se vztahuje na ochrannou přilbu na sport zakoupenou v kamenné predejně, popř. e-shopu predejny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribure up to CZK 500 to parents and legal guardians of children a contribution for the purchase of a protective helmet for children. The contribution applies to a protective helmet for sports purchased at a brick-and-mortar shop or the shop's e-shop. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/27",
            "category": null
          },
          {
            "type": {
              "cs": "Zdravé dítě",
              "sk": "Zdravé díte",
              "en": "Healthy child"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 500 Kč na produkty pro zdravý rozvoj dítěte a cvičení pro děti do 2 let",
              "sk": "Až 500 Kč na predukty pre zdravý rozvoj dítěte a cvičení pre děti do 2 let",
              "en": "Up to CZK 500 for products for healthy child development and exercise for children up to two years of age"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč zákonným zástupcům dětí do 2 let včetně  na produkty pro zdravý rozvoj dítěte a cvičení pro děti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč zákonným zástupcům dětí do 2 let včetně  na predukty pre zdravý rozvoj dítěte a cvičení pre děti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to legal guardians of children under 2 years of age, including contributions for products for healthy child development and exercise for children. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/7",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření zraku",
              "sk": "Vyšetrení zraku",
              "en": "Eye examination"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření zraku přístrojem Plusoptix",
              "sk": "Až 500 Kč na vyšetření zraku přístrojem Plusoptix",
              "en": "Up to CZK 500 for an eye examination using the Plusoptix device"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč zákonným zástupcům dětí na vyšetření zraku přístrojem Plusoptix u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč zákonným zástupcům dětí na vyšetření zraku přístrojem Plusoptix u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to parents legal guardians of children for eye examinations using Plusoptix devices at healthcare providers. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/6",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní prohlídka",
              "sk": "Športové prehlídka",
              "en": "Sports check-up"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 500 Kč na úhradu sportovní lékařské prohlídky",
              "sk": "Až 500 Kč na úhradu športové lékařské prehlídky",
              "en": "Up to CZK 500 for a medical sports check-up"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč zákonným zástupcům dětí na úhradu sportovní lékařské prohlídky provedené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč zákonným zástupcům dětí na úhradu športové lékařské prehlídky prevedené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to parents and legal guardians of children to pay for a medical sports check-up performed by a medical services provider. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/11",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence obezity",
              "sk": "Prevence obezity",
              "en": "Obesity prevention"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 500 Kč na prevenci obezity",
              "sk": "Až 500 Kč na prevenci obezity",
              "en": "Up to CZK 500 for obesity prevention"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč zákonným zástupcům dětí  na prevenci obezity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč zákonným zástupcům dětí  na prevenci obezity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to parents legal guardians of children a contribution for obesity prevention. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/25",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence rakoviny kůže",
              "sk": "Prevence rakoviny kúže",
              "en": "Skin cancer prevention"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 500 Kč na vyšetření pigmentových skvrn",
              "sk": "Až 500 Kč na vyšetření pigmentových skvrn",
              "en": "Up to CZK 500 for diagnosis of pigment spots."
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření pigmentových skvrn. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na vyšetření pigmentových skvrn. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for diagnosis of pigment spots. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/13",
            "category": null
          },
          {
            "type": {
              "cs": "Chůva 24",
              "sk": "Chúva 24",
              "en": "Monitor 24"
            },
            "icon": "phone",
            "benefit": {
              "cs": "Až 500 Kč na monitor dechu a chůvičky pro děti do 2 let",
              "sk": "Až 500 Kč na monitor dechu a chůvičky pre děti do 2 let",
              "en": "Up to CZK 500 for breath and baby monitors for children up to the age of 2"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč zákonným zástupcům dětí do 2 let na monitor dechu a chůvičky (příspěvek lze poskytnout i na zakoupení náhradní podložky k monitoru dechu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč zákonným zástupcům dětí do 2 let na monitor dechu a chůvičky (príspevok lze poskytnout i na zakoupení náhradní podložky k monitoru dechu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to legal guardians of children under 2 years of age for a breath monitor and baby monitor (the contribution can also be used to purchase a replacement pad for the breath monitor). "
            },
            "url": "https://www.cpzp.cz/preventivni-program/63",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence trombózy",
              "sk": "Prevence trombózy",
              "en": "Thrombosis prevention"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 1 000 Kč na prevenci trombózy pro dívky od 12 let ",
              "sk": "Až 1 000 Kč na prevenci trombózy pre dívky od 12 let",
              "en": "Up to CZK 1 000 for thrombosis prevention for girls aged 12 and up"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč zákonným zástupcům dětí a mládeže na prevenci trombózy pro dívky od 12 let (příspěvek na genetické vyšetření DNA, které odhalí pravděpodobnost trombofilních komplikací - ve spojení zejména s užíváním hormonální antikoncepce). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč zákonným zástupcům dětí a mládeže na prevenci trombózy pre dívky od 12 let (príspevok na genetické vyšetření DNA, které odhalí pravděpodobnost trombofilních komplikací - ve spojení zejména s užíváním hormonální antikoncepce). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to parents and legal guardians of children and youths for a thrombosis prevention for girls aged 12 and up (a contribution for genetic DNA testing to determine the likelihood of thrombophilia complications - especially in relation to the use of hormonal contraceptives). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/12",
            "category": null
          },
          {
            "type": {
              "cs": "Lehká sádra",
              "sk": "Lehká sádra",
              "en": "Lightweight cast\n"
            },
            "icon": "osteoporosis",
            "benefit": {
              "cs": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
              "sk": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
              "en": "Up to CZK 1 000 to cover the cost of lightweight and light casts"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na úhradu odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken (např. Opencast) u poskytovatele zdravotních služeb nebo zakoupené v prodejně zdravotnických potřeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč na úhradu odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken (např. Opencast) u poskytovatele zdravotních služeb alebo zakoupené v predejně zdravotnických potřeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for the purchase of lightweight or light casts made of plastic, resin, and carbon fiber (e.g., Opencast) from a healthcare provider or purchased at a medical supply store. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/78",
            "category": null
          },
          {
            "type": {
              "cs": "Ortopedické vložky",
              "sk": "Ortopedické vložky",
              "en": "Orthopedic insoles\n"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na nákup ortopedických vložek ",
              "sk": "Až 500 Kč na nákup ortopedických vložek",
              "en": "Up to CZK 500 for the purchase of orthopedic insoles"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům s ortopedickými vadami nohou na nákup ortopedických vložek do bot v lékárně, prodejně zdravotnických potřeb, ve specializované prodejně nebo od výrobce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům s ortopedickými vadami nohou na nákup ortopedických vložek do bot v lékárně, predejně zdravotnických potřeb, ve specializované predejně alebo od výrobce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients with orthopedic foot defects for the purchase of orthopedic insoles at a pharmacy, medical supply store, specialty store, or from the manufacturer. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/79",
            "category": null
          },
          {
            "type": {
              "cs": "Diabetes",
              "sk": "Diabetes",
              "en": "Diabetes"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 2 000 Kč na prevenci zhoršení diabetes",
              "sk": "Až 2 000 Kč na prevenci zhoršení diabetes",
              "en": "Up to CZK 2 000 to prevent deterioration of diabetes"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč zákonným zástupcům dětí na produkty pro diabetiky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč zákonným zástupcům dětí na predukty pre diabetiky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to parents and legal guardians of children for products for diabetics. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/8",
            "category": null
          },
          {
            "type": {
              "cs": "Celiakie, dědičné metabolické poruchy",
              "sk": "Celiakie, dedičné metabolické poruchy",
              "en": "Celiac disease, hereditary metabolic disorders\n"
            },
            "icon": "gluten",
            "benefit": {
              "cs": "Až 4 000 Kč na bezlepkovou dietu a na nízkobilkovinovou dietu pro děti s dědičnými metabolickými poruchami",
              "sk": "Až 4 000 Kč na bezlepkovou dietu a na nízkobilkovinovou dietu pre děti s dědičnými metabolickými poruchami",
              "en": "Up to CZK 4000 for a gluten-free diet and a low-protein diet for children with hereditary metabolic disorders"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč zákonným zástupcům dětí nemocných celiakií příspěvek na bezlepkovou dietu a příspěvek na nízkobilkovinovou dietu pro děti s dědičnými metabolickými poruchami. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč zákonným zástupcům dětí nemocných celiakií príspevok na bezlepkovou dietu a príspevok na nízkobilkovinovou dietu pre děti s dědičnými metabolickými poruchami. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 to parents and legal guardians of children with coeliac disease for a gluten-free diet and a contribution for a low-protein diet for children with hereditary metabolic disorders. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/9",
            "category": null
          },
          {
            "type": {
              "cs": "Vitaminy pro děti",
              "sk": "Vitaminy pre deti",
              "en": "Vitamins for children"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Zdarma. Tento produkt se nezapočítává do celkového limitu 1 500 Kč na preventivní programy pro děti a mládež",
              "sk": "Zdarma. Tento predukt se nezapočítává do celkového limitu 1 500 Kč na preventivní pregramy pre děti a mládež",
              "en": "Free. This product does not count toward the overall limit of CZK 1500 for preventive programmes for children and youth."
            },
            "description": {
              "cs": "ČPZP poskytuje zákonným zástupcům dětí a mládeže ve věku 3 až 15 let včetně, vitaminy pro děti k odběru na pobočce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "ČPZP poskytuje zákonným zástupcům dětí a mládeže ve věku 3 až 15 let včetně, vitaminy pre děti k odběru na pobočce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "ČPZP provides vitamins to the legal guardians of children and youths between the ages of 3 to 15 (inclusive), which can be picked up at a branch. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/10",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na paruku",
              "sk": "Príspevok na paruku",
              "en": "Wig contribution"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 2 000 Kč na paruku",
              "sk": "Až 2 000 Kč na paruku",
              "en": "Up to CZK 2000 for a wig"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na zakoupení paruky pro onkologicky nemocné pacienty, kteří podstupují nebo podstoupili v rámci onkologického onemocnění léčbu chemoterapií a pro pojištěnce s diagnózou alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na zakoupení paruky pre onkologicky nemocné pacientov, kteří podstupují alebo podstoupili v rámci onkologického onemocnění léčbu chemoterapií a pre pojištěnce s diagnózou alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 towards the purchase of wigs for cancer patients who are undergoing or have undergone chemotherapy treatment for cancer, and for insured persons diagnosed with alopecia. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/61",
            "category": null
          },
          {
            "type": {
              "cs": "Bonus plus",
              "sk": "Bonus plus",
              "en": "Bonus plus"
            },
            "icon": "shield",
            "benefit": {
              "cs": "Až 500 Kč v doplňkovém preventivním programu na vybrané aktivity",
              "sk": "Až 500 Kč v doplňkovém preventivním pregramu na vybrané aktivity",
              "en": "Up to CZK 500 in an additional preventive program for selected activities"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč ročně v doplňkovém programu \"Bonus Plus\" na vybrané aktivity, např. zdravotní služby absolvované ve zdravotnických zařízeních, přípravky na ústní hygienu, brýlové obruby, opalovací krémy, sportovní ochranné pomůcky a další. Cílem programu je motivovat pojištěnce ČPZP k ochraně a maximální péči o zdraví a odměňovat je i za věrnost k ČPZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "sk": "Přispíváme až 500 Kč ročně v doplňkovém pregramu \"Bonus Plus\" na vybrané aktivity, např. zdravotní služby absolvované ve zdravotnických zařízeních, přípravky na ústní hygienu, brýlové obruby, opalovací krémy, športové ochranné pomůcky a další. Cílem pregramu je motivovat pojištěnce ČPZP k ochraně a maximální péči o zdraví a odměňovat je i za věrnost k ČPZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
              "en": "We contribute up to CZK 500 per year in the \"Bonus Plus\" additional programme for selected activities, such as healthcare services provided in healthcare facilities, oral hygiene products, eyeglass frames, sunscreen, sports protective equipment and more. The purpose of the program is to motivate ČPZP policyholders to protect and take maximum care of their health and to reward them for their loyalty to ČPZP. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/29",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na duševní zdraví",
              "sk": "Príspevok na duševní zdraví",
              "en": "Contribution for mental health"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 6 000 Kč na duševní zdraví pro děti od 7 let",
              "sk": "Až 6 000 Kč na duševní zdraví pre děti od 7 let",
              "en": "Up to CZK 6 000 for mental health for children aged 7 and older"
            },
            "description": {
              "cs": "Přispíváme až 6 000 Kč na duševní zdraví pro děti od 7 let .Příspěvek je určen pojištěncům od 7 let na psychosociální intervenci absolvovanou u vybraného odborníka - soukromého terapeuta s patřičnou kvalifikací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 6 000 Kč na duševní zdraví pre děti od 7 let .Príspevok je určen pojištěncům od 7 let na psychosociální intervenci absolvovanou u vybraného odborníka - soukromého terapeuta s patřičnou kvalifikací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 6 000 to mental health care for children aged 7 and older. The contribution is intended for insured persons aged 7 and older for psychosocial intervention provided by a selected specialist – a private therapist with the appropriate qualifications. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.cpzp.cz/preventivni-program/74",
            "category": null
          }
        ]
      }
    ],
    "updateDate": "28.1.2026",
    "companyBenefitsLink": "https://www.cpzp.cz/preventivni-programy"
  },
  {
    "slug": "ozp",
    "genders": [
      {
        "name": {
          "cs": "Muži",
          "sk": "Muži",
          "en": "Men"
        },
        "benefits": [
          {
            "type": {
              "cs": "Dentální hygiena",
              "sk": "Dentálne hygiena",
              "en": "Dental hygiene"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 1 000 Kč na dentální hygienu",
              "sk": "Až 1 000 Kč na dentálne hygienu",
              "en": "Up to CZK 1 000 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč jednou za rok na dentální hygienu pro dospělé. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč jednou za rok na dentálne hygienu pre dospělé. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 a year for dental hygiene for adults. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/benefityozp",
            "category": "Muži"
          },
          {
            "type": {
              "cs": "Očkování proti chřipce (do 65 let)",
              "sk": "Očkovanie preti chripce (do 65 let)",
              "en": "Flu vaccine (up to 65 years)"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 500 Kč na očkování proti chřipce, které není hrazené z veřejného zdravotního pojištění",
              "sk": "Až 500 Kč na očkovanie preti chřipce, které není hrazené z veřejného zdravotního pojištění",
              "en": "Up to CZK 500 for a flu vaccine that isn't covered by public health insurance"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na očkování proti chřipce dospělým do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na očkovanie preti chřipce dospělým do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to adults up to 65 years of age for flu vaccination. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/kupon-na-ockovani-chripka",
            "category": null
          },
          {
            "type": {
              "cs": "Ostatní očkování",
              "sk": "Ostatní očkovanie",
              "en": "Other vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč  na očkování, které není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč  na očkovanie, které není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/kupon-na-ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině kůže",
              "sk": "STOP rakovine kúže",
              "en": "STOP skin cancer"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 800 Kč na preventivní vyšetření rakoviny kůže ",
              "sk": "Až 800 Kč na preventivní vyšetření rakoviny kůže",
              "en": "Up to CZK 800 for preventive skin cancer examination"
            },
            "description": {
              "cs": "Přispíváme až 800 Kč na preventivní vyšetření rakoviny kůže. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 800 Kč na preventivní vyšetření rakoviny kůže. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 800 for preventive skin cancer examination. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-kuze",
            "category": null
          },
          {
            "type": {
              "cs": "Nutriční poradenství pro vybrané chronicky nemocné klienty",
              "sk": "Nutriční poradenství pre vybrané chronicky nemocné klienty",
              "en": "Nutritional consulting for selected chronically ill clients"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 1 000 Kč na nutriční poradenství pro vybrané chronicky nemocné klienty",
              "sk": "Až 1 000 Kč na nutriční poradenství pre vybrané chronicky nemocné klienty",
              "en": "Up to CZK 1 000 for nutritional counseling for selected chronically ill clients"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na nutriční poradenství pro vybrané chronicky nemocné klienty.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na nutriční poradenství pre vybrané chronicky nemocné klienty.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for nutritional counseling for selected chronically ill clients. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/pece-o-vybrane-chronicky-nemocne-klienty",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro klienty s nízkobílkovinnou dietou",
              "sk": "Príspevok pre klienty s nízkobílkovinnou dietou",
              "en": "A contribution for clients on a low-protein diet"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 5 000 Kč na nízkobílkovinnou dietou",
              "sk": "Až 5 000 Kč na nízkobílkovinnou dietou",
              "en": "Up to CZK 5 000 for a low-protein diet"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč klientům s dědičnou poruchou metabolismu – fenylketonurií na potraviny s nízkým obsahem bílkovin. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč klientům s dědičnou poruchou metabolismu – fenylketonurií na potraviny s nízkým obsahem bílkovin. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to clients with a hereditary metabolic disorder - phenylketonuria for low protein foods. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvky pro onkologicky nemocné",
              "sk": "Príspevky pre onkologicky nemocné",
              "en": "Contributions for cancer patients"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 4 000 Kč pro onkologicky nemocné pojištěnce na vybrané pomůcky ",
              "sk": "Až 4 000 Kč pre onkologicky nemocné pojištěnce na vybrané pomůcky",
              "en": "Up to CZK 4 000 for clients with cancer for selected aids"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč onkologicky nemocným klientům na paruky, epitézy, lymfodrenáže po ablaci prsu, stomické pomůcky, inkontineční pomůcky, respirátory a roušky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč onkologicky nemocným klientům na paruky, epitézy, lymfodrenáže po ablaci prsu, stomické pomůcky, inkontineční pomůcky, respirátory a roušky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "en": "We contribute up to CZK 4 000 to oncologically ill clients for wigs, epitheses, lymphatic drainage after breast ablation, ostomy aids, incontinence aids, respirators and masks. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/prispevky-pro-onkologicky-nemocne",
            "category": null
          },
          {
            "type": {
              "cs": "STOP kouření",
              "sk": "STOP kourení",
              "en": "STOP smoking"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 2 000 Kč na odvykání kouření",
              "sk": "Až 2 000 Kč na odvykání kouření",
              "en": "Up to CZK 2 000 for smoking cessation "
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contriubte up to CZK 2 000 for smoking cessation. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/stop-koureni",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině dutiny ústní",
              "sk": "STOP rakovine dutiny ústní",
              "en": "STOP mouth cancer"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 700 Kč na preventivní vyšetření rakoviny dutiny ústní",
              "sk": "Až 700 Kč na preventivní vyšetření rakoviny dutiny ústní",
              "en": "Up to CZK 700 for preventive mouth cancer examination"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč dospělým od 25 let na preventivní vyšetření rakoviny dutiny ústní. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč dospělým od 25 let na preventivní vyšetření rakoviny dutiny ústní. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to 700 CZK to adults from 25 years of age for preventive examinations for oral cancer. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-dutiny-ustni",
            "category": null
          },
          {
            "type": {
              "cs": "STOP infarktu",
              "sk": "STOP infarktu",
              "en": "STOP heart attack"
            },
            "icon": "heart-attack",
            "benefit": {
              "cs": "Až 1 200 Kč na preventivní vyšetření rizika infarktu ",
              "sk": "Až 1 200 Kč na preventivní vyšetření rizika infarktu",
              "en": "Up to CZK 1 200 for a preventive examination of the risk of heart attack"
            },
            "description": {
              "cs": "Přispíváme až 1 200 Kč dospělým od 30 do 55 let na preventivní vyšetření rizika infarktu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 200 Kč dospělým od 30 do 55 let na preventivní vyšetření rizika infarktu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 200 to adults aged 30 to 55 for preventive heart attack risk examinations. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-infarktu",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině prostaty",
              "sk": "STOP rakovine prestaty",
              "en": "STOP prostate cancer"
            },
            "icon": "prostate",
            "benefit": {
              "cs": "Až 1 200 Kč na preventivní vyšetření rakoviny prostaty",
              "sk": "Až 1 200 Kč na preventivní vyšetření rakoviny prestaty",
              "en": "Up to CZK 1 200 for a preventive prostate cancer examination "
            },
            "description": {
              "cs": "Přispíváme až 1 200 Kč dospělím od 40 do 49 let na preventivní vyšetření rakoviny prostaty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 200 Kč dospělím od 40 do 49 let na preventivní vyšetření rakoviny prestaty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 200 to adults aged 40 to 49 for preventive prostate cancer examination. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-prostaty",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině tlustého střeva a konečníku",
              "sk": "STOP rakovine tlustého streva a konečníku",
              "en": "STOP cancer of the colon and rectum"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Až 500 Kč na preventivní vyšetření rakoviny tlustho střeva a konečníku",
              "sk": "Až 500 Kč na preventivní vyšetření rakoviny tlustho střeva a konečníku",
              "en": "Up to CZK 500 for preventive colon and rectum cancer examination"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč dospělím od 40 do 44 let na preventivní vyšetření rakoviny tlustého střeva a konečníku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč dospělím od 40 do 44 let na preventivní vyšetření rakoviny tlustého střeva a konečníku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to adults aged 40 to 44 for preventive examination for colon and rectal cancer. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-konecniku",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence Alzheimerovy nemoci",
              "sk": "Prevence Alzheimerovy nemoci",
              "en": "Prevention of Alzheimer's disease"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na prevenci Alzheimerovy nemoci",
              "sk": "Až 500 Kč na prevenci Alzheimerovy nemoci",
              "en": "Up to CZK 500 for prevention of Alzheimer's disease"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč dospělím od 40 let na prevenci Alzheimerovy nemoci. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč dospělím od 40 let na prevenci Alzheimerovy nemoci. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to 500 CZK to adults aged 40 and over for the prevention of Alzheimer's disease. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/prevence-alzheimerovy-nemoci",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině ledvin a nádorům břišních orgánů",
              "sk": "STOP rakovine ledvin a nádorúm brišních orgánú",
              "en": "STOP kidney cancer and abdominal tumors"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 1 150 Kč na preventivní vyřetření rakoviny ledvin a nádorům břišních orgánů ",
              "sk": "Až 1 150 Kč na preventivní vyřetření rakoviny ledvin a nádorům břišních orgánů",
              "en": "Up to CZK 1 150 for preventive kindey cancer and abdominal tumors examination"
            },
            "description": {
              "cs": "Přispíváme až 1 150 Kč dospělím od 40 let na preventivní vyšetření rakoviny ledvin a nádorům břišních orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 150 Kč dospělím od 40 let na preventivní vyšetření rakoviny ledvin a nádorům břišních orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 150 to adults aged 40 and over for preventive examinations for kidney cancer and abdominal tumors. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-nadorum-brisnich-organu",
            "category": null
          },
          {
            "type": {
              "cs": "STOP osteoporóze",
              "sk": "STOP osteoporóze",
              "en": "STOP osteoporosis"
            },
            "icon": "osteoporosis",
            "benefit": {
              "cs": "Až 1 000 Kč na prevenci osteoporózy",
              "sk": "Až 1 000 Kč na prevenci osteoporózy",
              "en": "Up to CZK 1 000 for prevention of osteoporosis"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč dospělím od 50 let na prevenci osteoporózy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč dospělím od 50 let na prevenci osteoporózy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to adults aged 50 and over for osteoporosis prevention. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-osteoporoze",
            "category": null
          },
          {
            "type": {
              "cs": "Vitamíny pro seniory",
              "sk": "Vitamíny pre seniory",
              "en": "Vitamins for seniors"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 500 Kč na vitamíny pro seniory",
              "sk": "Až 500 Kč na vitamíny pre seniory",
              "en": "Up to CZK 500 on vitamins for seniors"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč seniorům nad 70 let na vitamíny a léčivé doplňky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč seniorům nad 70 let na vitamíny a léčivé doplňky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to seniors over 70 for vitamins and medicinal supplements. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/kupon-na-vitaminy",
            "category": null
          },
          {
            "type": {
              "cs": "Pro dárce",
              "sk": "Pre dárce",
              "en": "For donors"
            },
            "icon": "care",
            "benefit": {
              "cs": "Odměna až 3 000 Kč pro ty, kteří jsou solidární ke zdraví ostatních",
              "sk": "Odměna až 3 000 Kč pre ty, kteří jsou solidární ke zdraví ostatních",
              "en": ""
            },
            "description": {
              "cs": "Cílovou skupinou jsou dárci krve, dárci orgánů a dárci kostní dřeně. Za dárcovské úkony vám bude připsán kredit, který můžete následně čerpat na množství podpůrných programů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Cílovou skupinou jsou dárci krve, dárci orgánů a dárci kostní dřeně. Za dárcovské úkony vám bude připsán kredit, který můžete následně čerpat na množství podpůrných pregramů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The target group comprises blood donors, organ donors, and bone marrow donors. In return for donating, you will receive credits that you can then use for various support programmes. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/pro-darce",
            "category": null
          },
          {
            "type": {
              "cs": "Výhodné pojištění Vitalitas",
              "sk": "Výhodné pojištení Vitalitas",
              "en": "Attractive insurance packages from Vitalitas"
            },
            "icon": "suitcase",
            "benefit": {
              "cs": "Pro vás i vaše děti máme skvělé pojistné produkty",
              "sk": "Pro vás i vaše děti máme skvělé pojistné predukty",
              "en": "We have excellent insurance products for you and your children"
            },
            "description": {
              "cs": "U pojišťovny VITALITAS můžete využít výhodného cestovního pojištění či úrazového pojištění pro děti Zvonek a Gina. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "U pojišťovny VITALITAS můžete využít výhodného cestovního pojištění či úrazového pojištění pre děti Zvonek a Gina. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The Vitalitas insurance company offers attractive travel insurance and accident insurance packages for children: Zvonek and Gina. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vitalitas.cz/",
            "category": null
          },
          {
            "type": {
              "cs": "Další benefity",
              "sk": "Další benefity",
              "en": "Other benefits"
            },
            "icon": "payment",
            "benefit": {
              "cs": "Objevte svět výhodných benefitů, které vám OZP nabízí",
              "sk": "Objevte svět výhodných benefitů, které vám OZP nabízí",
              "en": "Discover the world of attractive benefits offered by OZP"
            },
            "description": {
              "cs": "VITAKARTA - on-line přepážka, podání přehledu OSVČ on-line, atlas lékařů a další on-line služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "VITAKARTA - on-line přepážka, podání přehledu OSVČ on-line, atlas lékařů a další on-line služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "VITAKARTA - an on-line counter, on-line overview submission for small businesses, doctors' atlas, and other on-line services. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/elektronicka-komunikace/informace/vitakarta-online-informace",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Ženy",
          "sk": "Ženy",
          "en": "Women"
        },
        "benefits": [
          {
            "type": {
              "cs": "Dentální hygiena",
              "sk": "Dentálne hygiena",
              "en": "Dental hygiene"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 1 000 Kč na dentální hygienu",
              "sk": "Až 1 000 Kč na dentálne hygienu",
              "en": "Up to CZK 1 000 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč jednou za rok na dentální hygienu pro dospělé. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč jednou za rok na dentálne hygienu pre dospělé. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 a year for dental hygiene for adults. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/benefityozp",
            "category": "Ženy"
          },
          {
            "type": {
              "cs": "Očkování proti chřipce (do 65 let)",
              "sk": "Očkovanie preti chripce (do 65 let)",
              "en": "Flu vaccine (up to 65 years)"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 500 Kč na očkování proti chřipce, které není hrazené z veřejného zdravotního pojištění",
              "sk": "Až 500 Kč na očkovanie preti chřipce, které není hrazené z veřejného zdravotního pojištění",
              "en": "Up to CZK 500 for a flu vaccine that isn't covered by public health insurance"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na očkování proti chřipce dospělým do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na očkovanie preti chřipce dospělým do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to adults up to 65 years of age. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/kupon-na-ockovani-chripka",
            "category": null
          },
          {
            "type": {
              "cs": "Ostatní očkování",
              "sk": "Ostatní očkovanie",
              "en": "Other vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč  na očkování, které není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč  na očkovanie, které není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/kupon-na-ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině kůže",
              "sk": "STOP rakovine kúže",
              "en": "STOP skin cancer"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 800 Kč na preventivní vyšetření rakoviny kůže",
              "sk": "Až 800 Kč na preventivní vyšetření rakoviny kůže",
              "en": "Up to CZK 800 for preventive skin cancer examination"
            },
            "description": {
              "cs": "Přispíváme až 800 Kč na preventivní vyšetření rakoviny kůže. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 800 Kč na preventivní vyšetření rakoviny kůže. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 800 for preventive skin cancer examination. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-kuze",
            "category": null
          },
          {
            "type": {
              "cs": "Nutriční poradenství pro vybrané chronicky nemocné klienty",
              "sk": "Nutriční poradenství pre vybrané chronicky nemocné klienty",
              "en": "Nutritional consulting for selected chronically ill clients"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 1 000 Kč na nutriční poradenství pro vybrané chronicky nemocné klienty",
              "sk": "Až 1 000 Kč na nutriční poradenství pre vybrané chronicky nemocné klienty",
              "en": "Up to CZK 1 000 for nutritional counseling for selected chronically ill clients"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na nutriční poradenství pro vybrané chronicky nemocné klienty.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na nutriční poradenství pre vybrané chronicky nemocné klienty.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for nutritional counseling for selected chronically ill clients. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/pece-o-vybrane-chronicky-nemocne-klienty",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro klienty s nízkobílkovinnou dietou",
              "sk": "Príspevok pre klienty s nízkobílkovinnou dietou",
              "en": "A contribution for clients on a low-protein diet"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 5 000 Kč na nízkobílkovinnou dietou",
              "sk": "Až 5 000 Kč na nízkobílkovinnou dietou",
              "en": "Up to CZK 5 000 for a low-protein diet"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč klientům s dědičnou poruchou metabolismu – fenylketonurií na potraviny s nízkým obsahem bílkovin. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč klientům s dědičnou poruchou metabolismu – fenylketonurií na potraviny s nízkým obsahem bílkovin. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to clients with a hereditary metabolic disorder - phenylketonuria for low protein foods. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvky pro onkologicky nemocné",
              "sk": "Príspevky pre onkologicky nemocné",
              "en": "Contributions for cancer patients"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 4 000 Kč pro onkologicky nemocné pojištěnce na vybrané pomůcky",
              "sk": "Až 4 000 Kč pre onkologicky nemocné pojištěnce na vybrané pomůcky",
              "en": "Up to CZK 4 000 for clients with cancer for selected aids"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč onkologicky nemocným klientům na paruky, epitézy, lymfodrenáže po ablaci prsu, stomické pomůcky, inkontineční pomůcky, respirátory a roušky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "sk": "Přispíváme až 4 000 Kč onkologicky nemocným klientům na paruky, epitézy, lymfodrenáže po ablaci prsu, stomické pomůcky, inkontineční pomůcky, respirátory a roušky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "en": "We contribute up to CZK 4 000 to oncologically ill clients for wigs, epitheses, lymphatic drainage after breast ablation, ostomy aids, incontinence aids, respirators and masks. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/prispevky-pro-onkologicky-nemocne",
            "category": null
          },
          {
            "type": {
              "cs": "STOP kouření",
              "sk": "STOP kourení",
              "en": "STOP smoking"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 2 000 Kč na odvykání kouření",
              "sk": "Až 2 000 Kč na odvykání kouření",
              "en": "Up to CZK 2 000 for smoking cessation"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contriubte up to CZK 2 000 for smoking cessation. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/stop-koureni",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině dutiny ústní",
              "sk": "STOP rakovine dutiny ústní",
              "en": "STOP mouth cancer"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 700 Kč na preventivní vyšetření rakoviny dutiny ústní",
              "sk": "Až 700 Kč na preventivní vyšetření rakoviny dutiny ústní",
              "en": "Up to CZK 700 for preventive mouth cancer examination"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč dospělým od 25 let na preventivní vyšetření rakoviny dutiny ústní. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč dospělým od 25 let na preventivní vyšetření rakoviny dutiny ústní. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to 700 CZK to adults from 25 years of age for preventive examinations for oral cancer. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-dutiny-ustni",
            "category": null
          },
          {
            "type": {
              "cs": "STOP infarktu",
              "sk": "STOP infarktu",
              "en": "STOP heart attack"
            },
            "icon": "heart-attack",
            "benefit": {
              "cs": "Až 1 200 Kč na preventivní vyšetření rizika infarktu",
              "sk": "Až 1 200 Kč na preventivní vyšetření rizika infarktu",
              "en": "Up to CZK 1 200 for a preventive examination of the risk of heart attack"
            },
            "description": {
              "cs": "Přispíváme až 1 200 Kč dospělým od 30 do 55 let na preventivní vyšetření rizika infarktu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 200 Kč dospělým od 30 do 55 let na preventivní vyšetření rizika infarktu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 200 to adults aged 30 to 55 for preventive heart attack risk examinations. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-infarktu",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině prsu",
              "sk": "STOP rakovine prsu",
              "en": "STOP breast cancer"
            },
            "icon": "breasts",
            "benefit": {
              "cs": "Až 1 200 Kč na prevenci rakoviny prsu",
              "sk": "Až 1 200 Kč na prevenci rakoviny prsu",
              "en": "Up to CZK 1 200 for brest cancer prevention"
            },
            "description": {
              "cs": "Přispíváme až 1200 Kč ženám od 40 let na prevenci rakoviny prsu + 100 Kč příspěvek na vyhodnocení snímku pomocí AI. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1200 Kč ženám od 40 let na prevenci rakoviny prsu + 100 Kč príspevok na vyhodnocení snímku pomocí AI. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 200 to women aged 40 and over for breast cancer prevention + CZK 100 for AI analysis of images. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-prsu",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině tlustého střeva a konečníku",
              "sk": "STOP rakovine tlustého streva a konečníku",
              "en": "STOP cancer of the colon and rectum"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Až 500 Kč na preventivní vyšetření rakoviny tlustho střeva a konečníku",
              "sk": "Až 500 Kč na preventivní vyšetření rakoviny tlustho střeva a konečníku",
              "en": "Up to CZK 500 for preventive colon and rectum cancer examination"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč dospělím od 40 do 44 let na preventivní vyšetření rakoviny tlustého střeva a konečníku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč dospělím od 40 do 44 let na preventivní vyšetření rakoviny tlustého střeva a konečníku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to adults aged 40 to 44 for preventive examination for colon and rectal cancer. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-konecniku",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence Alzheimerovy nemoci",
              "sk": "Prevence Alzheimerovy nemoci",
              "en": "Prevention of Alzheimer's disease"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na prevenci Alzheimerovy nemoci",
              "sk": "Až 500 Kč na prevenci Alzheimerovy nemoci",
              "en": "Up to CZK 500 for prevention of Alzheimer's disease"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč dospělím od 40 let na prevenci Alzheimerovy nemoci. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč dospělím od 40 let na prevenci Alzheimerovy nemoci. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to 500 CZK to adults aged 40 and over for the prevention of Alzheimer's disease. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/prevence-alzheimerovy-nemoci",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině ledvin a nádorům břišních orgánů",
              "sk": "STOP rakovine ledvin a nádorúm brišních orgánú",
              "en": "STOP kidney cancer and abdominal tumors"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 1 150 Kč na preventivní vyřetření rakoviny ledvin a nádorům břišních orgánů",
              "sk": "Až 1 150 Kč na preventivní vyřetření rakoviny ledvin a nádorům břišních orgánů",
              "en": "Up to CZK 1 150 for preventive kindey cancer and abdominal tumors examination"
            },
            "description": {
              "cs": "Přispíváme až 1 150 Kč dospělím od 40 let na preventivní vyšetření rakoviny ledvin a nádorům břišních orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 150 Kč dospělím od 40 let na preventivní vyšetření rakoviny ledvin a nádorům břišních orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 150 to adults aged 40 and over for preventive examinations for kidney cancer and abdominal tumors. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-nadorum-brisnich-organu",
            "category": null
          },
          {
            "type": {
              "cs": "STOP osteoporóze",
              "sk": "STOP osteoporóze",
              "en": "STOP osteoporosis"
            },
            "icon": "osteoporosis",
            "benefit": {
              "cs": "Až 1 000 Kč na prevenci osteoporózy",
              "sk": "Až 1 000 Kč na prevenci osteoporózy",
              "en": "Up to CZK 1 000 for prevention of osteoporosis"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč dospělím od 50 let na prevenci osteoporózy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč dospělím od 50 let na prevenci osteoporózy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to adults aged 50 and over for osteoporosis prevention. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-osteoporoze",
            "category": null
          },
          {
            "type": {
              "cs": "Vitamíny pro seniory",
              "sk": "Vitamíny pre seniory",
              "en": "Vitamins for seniors"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 500 Kč na vitamíny pro seniory",
              "sk": "Až 500 Kč na vitamíny pre seniory",
              "en": "Up to CZK 500 on vitamins for seniors"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč seniorům nad 70 let na vitamíny a léčivé doplňky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč seniorům nad 70 let na vitamíny a léčivé doplňky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to seniors over 70 for vitamins and medicinal supplements. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/kupon-na-vitaminy",
            "category": null
          },
          {
            "type": {
              "cs": "Pro dárce",
              "sk": "Pre dárce",
              "en": "For donors"
            },
            "icon": "care",
            "benefit": {
              "cs": "Odměna až 3 000 Kč pro ty, kteří jsou solidární ke zdraví ostatních",
              "sk": "Odměna až 3 000 Kč pre ty, kteří jsou solidární ke zdraví ostatních",
              "en": ""
            },
            "description": {
              "cs": "Cílovou skupinou jsou dárci krve, dárci orgánů a dárci kostní dřeně. Za dárcovské úkony vám bude připsán kredit, který můžete následně čerpat na množství podpůrných programů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Cílovou skupinou jsou dárci krve, dárci orgánů a dárci kostní dřeně. Za dárcovské úkony vám bude připsán kredit, který můžete následně čerpat na množství podpůrných pregramů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The target group comprises blood donors, organ donors, and bone marrow donors. In return for donating, you will receive credits that you can then use for various support programmes. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/pro-darce",
            "category": null
          },
          {
            "type": {
              "cs": "Výhodné pojištění Vitalitas",
              "sk": "Výhodné pojištení Vitalitas",
              "en": "Attractive insurance packages from Vitalitas"
            },
            "icon": "suitcase",
            "benefit": {
              "cs": "Pro vás i vaše děti máme skvělé pojistné produkty",
              "sk": "Pro vás i vaše děti máme skvělé pojistné predukty",
              "en": "We have excellent insurance products for you and your children"
            },
            "description": {
              "cs": "U pojišťovny VITALITAS můžete využít výhodného cestovního pojištění či úrazového pojištění pro děti Zvonek a Gina. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "U pojišťovny VITALITAS můžete využít výhodného cestovního pojištění či úrazového pojištění pre děti Zvonek a Gina. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The Vitalitas insurance company offers attractive travel insurance and accident insurance packages for children: Zvonek and Gina. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vitalitas.cz/",
            "category": null
          },
          {
            "type": {
              "cs": "Další benefity",
              "sk": "Další benefity",
              "en": "Other benefits"
            },
            "icon": "payment",
            "benefit": {
              "cs": "Objevte svět výhodných benefitů, které vám OZP nabízí",
              "sk": "Objevte svět výhodných benefitů, které vám OZP nabízí",
              "en": "Discover the world of attractive benefits offered by OZP"
            },
            "description": {
              "cs": "VITAKARTA - on-line přepážka, podání přehledu OSVČ on-line, atlas lékařů a další on-line služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "VITAKARTA - on-line přepážka, podání přehledu OSVČ on-line, atlas lékařů a další on-line služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "VITAKARTA - an on-line counter, on-line overview submission for small businesses, doctors' atlas, and other on-line services. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/elektronicka-komunikace/informace/vitakarta-online-informace",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro těhotné a novorozence\n",
              "sk": "Príspevok pre tehotné a novorozence\n",
              "en": "Contribution for pregnant women and newborns"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 6 000 Kč nastávajícím maminkám a jejich miminkům",
              "sk": "Až 6 000 Kč nastávajícím maminkám a jejich miminkům",
              "en": "Up to CZK 6 000 for expecting mothers and their babies"
            },
            "description": {
              "cs": "Přispíváme až 6 000 Kč nastávajícím maminkám a jejich miminkům. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 6 000 Kč nastávajícím maminkám a jejich miminkům. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 6 000 to expectant mothers and their babies. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/maminky-a-novorozenci",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Děti",
          "sk": "Deti",
          "en": "Children"
        },
        "benefits": [
          {
            "type": {
              "cs": "Dentální hygiena",
              "sk": "Dentálne hygiena",
              "en": "Dental hygiene"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 1 000 Kč na dentální hygienu",
              "sk": "Až 1 000 Kč na dentálne hygienu",
              "en": "Up to CZK 1 000 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč dětem na dentální hygienu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč dětem na dentálne hygienu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to children for dental hygiene. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/kupon-na-dentalni-hygienu",
            "category": "Deti"
          },
          {
            "type": {
              "cs": "Sportovní aktivity",
              "sk": "Športové aktivity",
              "en": "Sports activities"
            },
            "icon": "muscle",
            "benefit": {
              "cs": "Až 1 000 Kč pro děti od 6 do 14 let na sportovní aktivity",
              "sk": "Až 1 000 Kč pre děti od 6 do 14 let na športové aktivity",
              "en": "Up to CZK 1 000 for children aged 6 to 14 for sports activities"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč dětem ve věku 6 - 14 let na sportovní aktivity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč dětem ve věku 6 - 14 let na športové aktivity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to children aged 6 - 14 for sports activities. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/kupon-na-sportovni-aktivity",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování proti chřipce ",
              "sk": "Očkovanie preti chripce",
              "en": "Flu vaccine "
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 500 Kč na očkování proti chřipce, které není hrazené z veřejného zdravotního pojištění",
              "sk": "Až 500 Kč na očkovanie preti chřipce, které není hrazené z veřejného zdravotního pojištění",
              "en": "Up to CZK 500 for a flu vaccine that isn't covered by public health insurance"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč dětem na očkování proti chřipce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč dětem na očkovanie preti chřipce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to children for flu vaccination. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/kupon-na-ockovani-chripka",
            "category": null
          },
          {
            "type": {
              "cs": "Ostatní očkování",
              "sk": "Ostatní očkovanie",
              "en": "Other vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč  na očkování, které není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč  na očkovanie, které není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/kupon-na-ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro klienty s nízkobílkovinnou dietou",
              "sk": "Príspevok pre klienty s nízkobílkovinnou dietou",
              "en": "A contribution for clients on a low-protein diet"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 5000 Kč pro klienty s nízkobílkovinnou dietou",
              "sk": "Až 5000 Kč pre klienty s nízkobílkovinnou dietou",
              "en": "Up to CZK 5000 for clients on a low-protein diet"
            },
            "description": {
              "cs": "Program je zaměřený na podporu klientů OZP s nízkobílkovinnou dietou, tedy s dědičnou poruchou metabolismu, fenylketonurií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Program je zaměřený na podporu klientů OZP s nízkobílkovinnou dietou, tedy s dědičnou poruchou metabolismu, fenylketonurií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "This programme focuses on supporting OZP clients on a low-protein diet, hence with a hereditary metabolic disorder, phenylketonuria. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou",
            "category": null
          },
          {
            "type": {
              "cs": "STOP rakovině kůže",
              "sk": "STOP rakovine kúže",
              "en": "STOP skin cancer"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 800 Kč na preventivní vyšetření rakoviny kůže",
              "sk": "Až 800 Kč na preventivní vyšetření rakoviny kůže",
              "en": "Up to CZK 800 for preventive skin cancer examination"
            },
            "description": {
              "cs": "Přispíváme až 800 Kč na preventivní vyšetření rakoviny kůže. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 800 Kč na preventivní vyšetření rakoviny kůže. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 800 for preventive skin cancer examination. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-kuze",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na ozdravné pobyty pro děti",
              "sk": "Príspevok na ozdravné pobyty pre deti",
              "en": "\nContribution to therapeutic stays for children"
            },
            "icon": "suitcase",
            "benefit": {
              "cs": "Až 10 000 Kč pro děti s chronickými respiračními a dermatologickými chorobami (LOP) nebo pro děti s obezitou",
              "sk": "Až 10 000 Kč pre děti s chronickými respiračními a dermatologickými chorobami (LOP) alebo pre děti s obezitou",
              "en": "Up to CZK 10,000 for children with chronic respiratory and dermatological diseases (LOP) or children with obesity"
            },
            "description": {
              "cs": "Přispíváme až 10 000 Kč na klimatický (přímořský/vysokohorský) nebo lázeňský léčebně ozdravný pobyt, (který není hrazen z veřejného zdravotního pojištění) s minimální délkou pobytu 15 dní (14 nocí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 10 000 Kč na klimatický (přímořský/vysokohorský) alebo lázeňský léčebně ozdravný pobyt, (který není hrazen z veřejného zdravotního pojištění) s minimální délkou pobytu 15 dní (14 nocí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 10 000 for a climatic (seaside/high mountain) or spa stay (which is not covered by public health insurance) with a minimum length of stay of 15 days (14 nights). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/ozdravne-pobyty-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro klienty s nízkobílkovinnou dietou",
              "sk": "Príspevok pre klienty s nízkobílkovinnou dietou",
              "en": "A contribution for clients on a low-protein diet"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 5 000 Kč na nízkobílkovinnou dietou",
              "sk": "Až 5 000 Kč na nízkobílkovinnou dietou",
              "en": "Up to CZK 5 000 for a low-protein diet"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč klientům s dědičnou poruchou metabolismu – fenylketonurií na potraviny s nízkým obsahem bílkovin. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč klientům s dědičnou poruchou metabolismu – fenylketonurií na potraviny s nízkým obsahem bílkovin. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to clients with a hereditary metabolic disorder - phenylketonuria for low protein foods. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvky pro onkologicky nemocné",
              "sk": "Príspevky pre onkologicky nemocné",
              "en": "Contributions for cancer patients"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 4 000 Kč pro onkologicky nemocné pojištěnce na vybrané pomůcky",
              "sk": "Až 4 000 Kč pre onkologicky nemocné pojištěnce na vybrané pomůcky",
              "en": "Up to CZK 4 000 for clients with cancer for selected aids"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč onkologicky nemocným klientům na paruky, epitézy, lymfodrenáže po ablaci prsu, stomické pomůcky, inkontineční pomůcky, respirátory a roušky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "sk": "Přispíváme až 4 000 Kč onkologicky nemocným klientům na paruky, epitézy, lymfodrenáže po ablaci prsu, stomické pomůcky, inkontineční pomůcky, respirátory a roušky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
              "en": "We contribute up to CZK 4 000 to oncologically ill clients for wigs, epitheses, lymphatic drainage after breast ablation, ostomy aids, incontinence aids, respirators and masks. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/prispevky-pro-onkologicky-nemocne",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro děti s obezitou",
              "sk": "Príspevok pre deti s obezitou",
              "en": "Contribution for children with obesity"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 1 000 Kč pro děti s obezitou",
              "sk": "Až 1 000 Kč pre děti s obezitou",
              "en": "Up to CZK 1 000 for children with obesity"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč dětem s diagnózou E 66 – obezita, otylost můžete využít příspěvek - na služby specializované poradny pro děti s obezitou, pohybové aktivity dětí, speciální ozdravné pobyty (mimo léčbu v dětských ozdravovnách, která je hrazena z v.z.p.) či psychoterapeutické a psychologické podpůrné aktivity u PZS. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč dětem s diagnózou E 66 – obezita, otylost můžete využít príspevok - na služby specializované poradny pre děti s obezitou, pohybové aktivity dětí, speciální ozdravné pobyty (mimo léčbu v dětských ozdravovnách, ktoré je hrazena z v.z.p.) či psychoterapeutické a psychologické podpůrné aktivity u PZS. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to children diagnosed with E 66 – obesity. You can use the contribution for specialized counseling services for children with obesity, physical activities for children, special health stays (excluding treatment in children's health resorts, which is covered by health insurance), or psychotherapeutic and psychological support activities at PZS. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/prispevky-na-prevenci/prispevek-pro-deti-s-obezitou",
            "category": null
          },
          {
            "type": {
              "cs": "STOP kouření",
              "sk": "STOP kourení",
              "en": "STOP smoking"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 2 000 Kč na odvykání kouření",
              "sk": "Až 2 000 Kč na odvykání kouření",
              "en": "Up to CZK 2 000 for smoking cessation"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contriubte up to CZK 2 000 for smoking cessation. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/benefity/stop-koureni",
            "category": null
          },
          {
            "type": {
              "cs": "Výhodné pojištění Vitalitas",
              "sk": "Výhodné pojištení Vitalitas",
              "en": "Attractive insurance packages from Vitalitas"
            },
            "icon": "suitcase",
            "benefit": {
              "cs": "Pro vás i vaše děti máme skvělé pojistné produkty",
              "sk": "Pro vás i vaše děti máme skvělé pojistné predukty",
              "en": "We have excellent insurance products for you and your children"
            },
            "description": {
              "cs": "U pojišťovny VITALITAS můžete využít výhodného cestovního pojištění či úrazového pojištění pro děti Zvonek a Gina. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "U pojišťovny VITALITAS můžete využít výhodného cestovního pojištění či úrazového pojištění pre děti Zvonek a Gina. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The Vitalitas insurance company offers attractive travel insurance and accident insurance packages for children: Zvonek and Gina. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vitalitas.cz/",
            "category": null
          },
          {
            "type": {
              "cs": "Další benefity",
              "sk": "Další benefity",
              "en": "Other benefits"
            },
            "icon": "payment",
            "benefit": {
              "cs": "Objevte svět výhodných benefitů, které vám OZP nabízí",
              "sk": "Objevte svět výhodných benefitů, které vám OZP nabízí",
              "en": "Discover the world of attractive benefits offered by OZP"
            },
            "description": {
              "cs": "VITAKARTA - on-line přepážka, podání přehledu OSVČ on-line, atlas lékařů a další on-line služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "VITAKARTA - on-line přepážka, podání přehledu OSVČ on-line, atlas lékařů a další on-line služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "VITAKARTA - an on-line counter, on-line overview submission for small businesses, doctors' atlas, and other on-line services. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.ozp.cz/elektronicka-komunikace/informace/vitakarta-online-informace",
            "category": null
          }
        ]
      }
    ],
    "updateDate": "2.2.2026",
    "companyBenefitsLink": "https://www.ozp.cz/benefity/benefityozp"
  },
  {
    "slug": "vozp",
    "genders": [
      {
        "name": {
          "cs": "Muži",
          "sk": "Muži",
          "en": "Men"
        },
        "benefits": [
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům od 18 let věku na kterékoli očkování nehrazené z veřejného zdravotního pojištění (s výjimkou očkování proti lidskému papilomaviru – HPV), a to na kteroukoli dávku očkovacího cyklu. Příspěvek nelze poskytnout na doplatek částečně hrazené vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč pojištěncům od 18 let věku na kterékoli očkovanie nehrazené z veřejného zdravotního pojištění (s výjimkou očkovanie preti lidskému papilomaviru – HPV), a to na kteroukoli dávku očkovacího cyklu. Príspevok nelze poskytnout na doplatek částečně hrazené vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to insured persons aged 18 and over for any vaccination not covered by public health insurance (with the exception of vaccination against human papillomavirus – HPV), for any dose in the vaccination cycle. The contribution cannot be provided for the co-payment of a partially covered vaccine. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/ockovani-pro-dospele",
            "category": "Muži"
          },
          {
            "type": {
              "cs": "Aplikace Kalorické Tabulky\n",
              "sk": "Aplikace Kalorické Tabulky\n",
              "en": "Calorie Tables Application\n"
            },
            "icon": "phone",
            "benefit": {
              "cs": "Až 899 Kč na aplikaci Kalorické Tabulky",
              "sk": "Až 899 Kč na aplikaci Kalorické Tabulky",
              "en": "Up to CZK 899 for the Calorie Tables app"
            },
            "description": {
              "cs": "Přispíváme až 899 Kč Pojištěncům od 18 let na roční předplatné prémiové verze aplikace Kalorické Tabulky. Příspěvek lze poskytnout pouze na verzi Premium pro jednotlivce s min. roční platností (nikoli např. na měsíční předplatné nebo rodinné předplatné). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 899 Kč Pojištěncům od 18 let na roční předplatné prémiové verze aplikace Kalorické Tabulky. Príspevok lze poskytnout pouze na verzi Premium pre jednotlivce s min. roční platností (nikoli např. na měsíční předplatné alebo rodinné předplatné). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 899 to our clients aged 18 and over for an annual subscription to the premium version of the Calorie Tables app. The contribution can only be provided for the Premium version for individuals with a minimum annual validity (not, for example, for a monthly subscription or family subscription). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/aplikace-kaloricke-tabulky",
            "category": null
          },
          {
            "type": {
              "cs": "Dentální hygiena",
              "sk": "Dentálne hygiena",
              "en": "Dental hygiene"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 500 Kč na dentální hygienu",
              "sk": "Až 500 Kč na dentálne hygienu",
              "en": "Up to CZK 500 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč všem pojištěncům na dentální hygienu (ošetření či instruktáž). Příspěvek se nevztahuje na zubní lékařskou prohlídku nebo na jiné než hygienické výkony ani na dentální pomůcky či jiné zboží. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč všem pojištěncům na dentálne hygienu (ošetření či instruktáž). Príspevok se nevztahuje na zubní lékařskou prehlídku alebo na jiné než hygienické výkony ani na dentálne pomůcky či jiné zboží. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to all clients for dental hygiene (treatment or instruction). The contribution does not apply to a dental checkup or other non-hygiene procedures, dental products, or other goods. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/dentalni-hygiena",
            "category": null
          },
          {
            "type": {
              "cs": "Pravidelný pohyb",
              "sk": "Pravidelný pohyb",
              "en": "Regular exercise"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 700 Kč na pravidelné pohybové aktivity",
              "sk": "Až 700 Kč na pravidelné pohybové aktivity",
              "en": "Up to CZK 700 for regular physical activities"
            },
            "description": {
              "cs": "Příspíváme až 700 Kč pojištěncům od 18 let na pravidelné pohybové aktivity, jako jsou: kondiční cvičení, core trénink, fitness, aerobic, spinning, tabata, bodybuilding, bodyforming, hasičský sport, jóga, pilates, tai-či, kalanetika, zumba, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Příspíváme až 700 Kč pojištěncům od 18 let na pravidelné pohybové aktivity, jako jsou: kondiční cvičení, core trénink, fitness, aerobic, spinning, tabata, bodybuilding, bodyforming, hasičský sport, jóga, pilates, tai-či, kalanetika, zumba, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribure up to CZK 700 to our clients from 18 years of age for regular physical activities such as: fitness exercises, core training, fitness, aerobics, spinning, tabata, bodybuilding, bodyforming, firefighting, yoga, pilates, tai-chi, calanetics, zumba, and others. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/pravidelny-pohyb",
            "category": null
          },
          {
            "type": {
              "cs": "Plavání",
              "sk": "Plavání",
              "en": "Swimming"
            },
            "icon": "water",
            "benefit": {
              "cs": "Až 700 Kč na plavání",
              "sk": "Až 700 Kč na plavání",
              "en": "Up to CZK 700 for swimming"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč všem pojištěncům na plavání ve formě: Permanentní vstupenky (vč. dobití čipu či karty), Plaveckého kurzu, Kurzu plavání rodičů s dětmi (příspěvek je v tomto případě určen pouze pro dítě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 700 Kč všem pojištěncům na plavání ve formě: Permanentní vstupenky (vč. dobití čipu či karty), Plaveckého kurzu, Kurzu plavání rodičů s dětmi (príspevok je v tomto případě určen pouze pre dítě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to all clients for swimming as follows: Season tickets (including chip or card credit recharge), swimming lessons, swimming lessons for parents with children (in this case the contribution applies only to the child). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/plavani",
            "category": null
          },
          {
            "type": {
              "cs": "Kloubní výživa pro seniory",
              "sk": "Kloubní výživa pre seniory",
              "en": "Joint supplements for seniors"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů",
              "sk": "Až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů",
              "en": "Up to CZK 500 for clients aged 65 and over for the purchase of food supplements intended exclusively for the support of joint health"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů a jejich správné funkce a k prevenci artrózy (přípravky s kolagenem, glukosamin sulfátem, chondroitin sulfátem, methylsulfonylmetanem – MSM apod.), které byly zakoupeny v lékárně. Příspěvek není určen na jiné než kloubní doplňky. Nelze jej tedy využít např. na přípravky k prevenci úbytku kostní hmoty (osteoporózy), vitamíny, hořčík apod. Příspěvek lze čerpat pouze na doplňky stravy, nikoli na registrovaná léčiva (léčivé přípravky). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů a jejich správné funkce a k prevenci artrózy (přípravky s kolagenem, glukosamin sulfátem, chondroitin sulfátem, methylsulfonylmetanem – MSM apod.), které byly zakoupeny v lékárně. Príspevok není určen na jiné než kloubní doplňky. Nelze jej tedy využít např. na přípravky k prevenci úbytku kostní hmoty (osteoporózy), vitamíny, hořčík apod. Príspevok lze čerpat pouze na doplňky stravy, nikoli na registrovaná léčiva (léčivé přípravky). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients aged 65 and over for the purchase of dietary supplements intended exclusively to support joint health and proper function and to prevent osteoarthritis (products containing collagen, glucosamine sulfate, chondroitin sulfate, methylsulfonylmethane – MSM, etc.) purchased at a pharmacy. The contribution is not intended for supplements other than joint supplements. Therefore, it cannot be used, for example, for products to prevent bone loss (osteoporosis), vitamins, magnesium, etc. The contribution can only be used for dietary supplements, not for registered medicines (medicinal products). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/kloubni-vyziva-pro-seniory",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu prostaty",
              "sk": "Prevence karcinomu prestaty",
              "en": "Prostate cancer prevention"
            },
            "icon": "prostate",
            "benefit": {
              "cs": "Až 300 Kč na prevenci rakoviny prostaty",
              "sk": "Až 300 Kč na prevenci rakoviny prestaty",
              "en": "Up to CZK 300 for prostate cancer prevention"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč mužům od 40 let na preventivní vyšetření PSA z krve anebo ultrazvukové vyšetření prostaty, pokud není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 300 Kč mužům od 40 let na preventivní vyšetření PSA z krve aalebo ultrazvukové vyšetření prestaty, pokud není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 to men aged 40 and over for preventive PSA blood tests or prostate ultrasound examinations, if these are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prevence-karcinomu-prostaty",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření kožních znamének",
              "sk": "Vyšetrení kožních znamének",
              "en": "Examination of skin marks"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 400 Kč na vyšetření kožních znamének",
              "sk": "Až 400 Kč na vyšetření kožních znamének",
              "en": "Up to CZK 400 for skin mole examinations"
            },
            "description": {
              "cs": "Přispíváme až 400 Kč všem pojištěncům na dermatoskopické vyšetření kožních znamének. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 400 Kč všem pojištěncům na dermatoskopické vyšetření kožních znamének. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 400 to all our clients for dermatoscopic examination of skin lesions. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/vysetreni-koznich-znamenek",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence kolorektálního karcinomu",
              "sk": "Prevence kolorektálního karcinomu",
              "en": "Colorectal cancer prevention"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Až 300 Kč na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku",
              "sk": "Až 300 Kč na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku",
              "en": "Up to CZK 300 for the purchase of a self-test for the prevention of cancer of the colon and rectum"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč všem pojištěncům na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku nebo pojištěncům do 45 let na screeningové vyšetření k prevenci kolorektálního karcinomu provedené ve zdravotnickém zařízení (od 45. roku života je již vyšetření hrazeno z veřejného zdravotního pojištění). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč všem pojištěncům na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku alebo pojištěncům do 45 let na screeningové vyšetření k prevenci kolorektálního karcinomu prevedené ve zdravotnickém zařízení (od 45. roku života je již vyšetření hrazeno z veřejného zdravotního pojištění). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 to all insured persons for the purchase of a self-collection test for the prevention of colon and rectal cancer, or to insured persons under 45 years of age for screening tests for the prevention of colorectal cancer performed in a healthcare facility (from the age of 45, the test is covered by public health insurance). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prevence-kolorektalniho-karcinomu",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykání kourení",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 400 Kč na odvykání kouření",
              "sk": "Až 400 Kč na odvykání kouření",
              "en": "Up to CZK 400 for smoking cessation"
            },
            "description": {
              "cs": "Přispíváme až 400 Kč pojištěncům od 16 let věku na základě potvrzení o léčbě anebo o ukončení léčby vystaveného centrem pro odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 400 Kč pojištěncům od 16 let věku na základě potvrzení o léčbě aalebo o ukončení léčby vystaveného centrem pre odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 400 to our clients aged 16 and over on the basis of confirmation of treatment or completion of treatment issued by a smoking cessation center. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/odvykani-koureni",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu prsu",
              "sk": "Prevence karcinomu prsu",
              "en": "Breast cancer prevention"
            },
            "icon": "breasts",
            "benefit": {
              "cs": "Až 800 Kč na prevenci rakoviny prsu ",
              "sk": "Až 800 Kč na prevenci rakoviny prsu",
              "en": "Up to CZK 800 for breast cancer prevention"
            },
            "description": {
              "cs": "Přispíváme až 800 Kč mužům od 30 let na sonografické vyšetření. Jednou za 2 roky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 800 Kč mužům od 30 let na sonografické vyšetření. Jednou za 2 roky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 800 to men aged 30 and over for sonographic examinations. Once every 2 years. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prevence-karcinomu-prsu",
            "category": null
          },
          {
            "type": {
              "cs": "Paruka při onkologické léčbě/alopecii\n",
              "sk": "Paruka pri onkologické léčbe/alopecii\n",
              "en": "Wig for oncological treatment/alopecia"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 1 000 Kč na paruku při chemoterapii a autoimunitní alopecii",
              "sk": "Až 1 000 Kč na paruku při chemoterapii a autoimunitní alopecii",
              "en": "Up to CZK 1 000 for a wig in case of chemotherapy or autoimmune alopecia"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům, kteří podstoupili nebo podstupují léčbu onkologického onemocnění, nebo pojištěncům s diagnózou autoimunitní alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pojištěncům, kteří podstoupili alebo podstupují léčbu onkologického onemocnění, alebo pojištěncům s diagnózou autoimunitní alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to our clients who have undergone or are undergoing treatment for cancer, or to insured persons diagnosed with autoimmune alopecia. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/paruka-pri-chemoterapii",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence poruch paměti/kognitivních funkcí",
              "sk": "Prevence poruch pameti/kognitivních funkcí",
              "en": "Prevention of memory/cognitive function disorders"
            },
            "icon": "brain",
            "benefit": {
              "cs": "Až 300 Kč na preventivní vyšetření poruch paměti/kognitivních funkcí ",
              "sk": "Až 300 Kč na preventivní vyšetření poruch paměti/kognitivních funkcí",
              "en": "Up to CZK 300 for a preventive diagnosis of memory/cognitive function disorders"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč pojištěncům od 18 let na preventivní vyšetření poruch paměti/kognitivních funkcí (cílené psychiatrické či psychologické vyšetření dotazníky MMSE, AKT, MoCA), odborně vedený trénink paměti, kognitivní pomůcky doporučené Českou alzheimerovskou společností, terapie Feuersteinovou metodou instrumentálního obohacování pro osoby s poškozením mozku poskytovaná certifikovaným odborníkem – viz. seznam oprávněných osob (dostupný na webu www.cogito-centrum.cz v sekci tým – naši odborníci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč pojištěncům od 18 let na preventivní vyšetření poruch paměti/kognitivních funkcí (cílené psychiatrické či psychologické vyšetření dotazníky MMSE, AKT, MoCA), odborně vedený trénink paměti, kognitivní pomůcky doporučené Českou alzheimerovskou společností, terapie Feuersteinovou metodou instrumentálního obohacování pre osoby s poškozením mozku poskytovaná certifikovaným odborníkem – viz. seznam oprávněných osob (dostupný na webu www.cogito-centrum.cz v sekci tým – naši odborníci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 to our clients aged 18 and over for preventive examinations of memory/cognitive function disorders (targeted psychiatric or psychological examinations using MMSE, AKT, MoCA), professionally guided memory training, cognitive aids recommended by the Czech Alzheimer's Society, Feuerstein's instrumental enrichment therapy for people with brain damage provided by a certified specialist – see the list of authorized persons (available at www.cogito-centrum.cz in the team section – our experts). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prevence-poruch-pameti",
            "category": null
          },
          {
            "type": {
              "cs": "Terapeutické programy Mindwell",
              "sk": "Terapeutické programy Mindwell",
              "en": "Mindwell Therapy Programs"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Bezplatný program",
              "sk": "Bezplatný program",
              "en": "Free program"
            },
            "description": {
              "cs": "Při splnění podmínek pro zařazení do programu obdrží klient VoZP aktivační kód, který nahrazuje platbu při zakoupení programu na stránkách Mindwell. Program je určen pojištěncům VoZP starším 18 let a je vhodný pro osoby s lehkou až střední formou deprese či úzkostných stavů. Není vhodný pro osoby s akutními potížemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Ak klient VoZP splní podmienky na zaradenie do programu, dostane aktivačný kód, ktorý nahrádza platbu pri nákupe programu na stránkach Mindwell. Program je určený poistencom VoZP starším ako 18 rokov a je vhodný pre osoby s ľahkou až stredne ťažkou formou depresie alebo úzkostných stavov. Nie je vhodný pre osoby s akútnymi ťažkosťami. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "Upon meeting the conditions for inclusion in the program, the VoZP client will receive an activation code that replaces payment when purchasing the program on the Mindwell website. The program is intended for VoZP policyholders over the age of 18 and is suitable for people with mild to moderate depression or anxiety. It is not suitable for people with acute problems. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/mindwell",
            "category": null
          },
          {
            "type": {
              "cs": "Pro dárce",
              "sk": "Pre dárce",
              "en": "For donors"
            },
            "icon": "care",
            "benefit": {
              "cs": "Odměna až 5 000 Kč pro dárce krve a kostní dřeně",
              "sk": "Odměna až 5 000 Kč pre dárce krve a kostní dřeně",
              "en": "Reward of up to CZK 5 000 for blood and bone marrow donors"
            },
            "description": {
              "cs": "Cílovou skupinou jsou dárci krve a dárci kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Cílovou skupinou jsou dárci krve a dárci kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The target group is blood donors and bone marrow donors. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prispevky-pro-darce-krve-a-kostni-drene",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Ženy",
          "sk": "Ženy",
          "en": "Women"
        },
        "benefits": [
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům od 18 let věku na kterékoli očkování nehrazené z veřejného zdravotního pojištění (s výjimkou očkování proti lidskému papilomaviru – HPV), a to na kteroukoli dávku očkovacího cyklu. Příspěvek nelze poskytnout na doplatek částečně hrazené vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč pojištěncům od 18 let věku na kterékoli očkovanie nehrazené z veřejného zdravotního pojištění (s výjimkou očkovanie preti lidskému papilomaviru – HPV), a to na kteroukoli dávku očkovacího cyklu. Príspevok nelze poskytnout na doplatek částečně hrazené vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to insured persons aged 18 and over for any vaccination not covered by public health insurance (with the exception of vaccination against human papillomavirus – HPV), for any dose in the vaccination cycle. The contribution cannot be provided for the co-payment of a partially covered vaccine. More information (in Czech only) is available on the insurance company's website here: link. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/ockovani-pro-dospele",
            "category": "Ženy"
          },
          {
            "type": {
              "cs": "Aplikace Kalorické Tabulky\n",
              "sk": "Aplikace Kalorické Tabulky\n",
              "en": "Calorie Tables Application\n"
            },
            "icon": "phone",
            "benefit": {
              "cs": "Až 899 Kč na aplikaci Kalorické Tabulky",
              "sk": "Až 899 Kč na aplikaci Kalorické Tabulky",
              "en": "Up to CZK 899 for the Calorie Tables app"
            },
            "description": {
              "cs": "Přispíváme až 899 Kč Pojištěncům od 18 let na roční předplatné prémiové verze aplikace Kalorické Tabulky. Příspěvek lze poskytnout pouze na verzi Premium pro jednotlivce s min. roční platností (nikoli např. na měsíční předplatné nebo rodinné předplatné). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 899 Kč Pojištěncům od 18 let na roční předplatné prémiové verze aplikace Kalorické Tabulky. Príspevok lze poskytnout pouze na verzi Premium pre jednotlivce s min. roční platností (nikoli např. na měsíční předplatné alebo rodinné předplatné). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 899 to our clients aged 18 and over for an annual subscription to the premium version of the Calorie Tables app. The contribution can only be provided for the Premium version for individuals with a minimum annual validity (not, for example, for a monthly subscription or family subscription). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/aplikace-kaloricke-tabulky",
            "category": null
          },
          {
            "type": {
              "cs": "Dentální hygiena",
              "sk": "Dentálne hygiena",
              "en": "Dental hygiene"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 500 Kč na dentální hygienu",
              "sk": "Až 500 Kč na dentálne hygienu",
              "en": "Up to CZK 500 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč všem pojištěncům na dentální hygienu (ošetření či instruktáž). Příspěvek se nevztahuje na zubní lékařskou prohlídku nebo na jiné než hygienické výkony ani na dentální pomůcky či jiné zboží. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč všem pojištěncům na dentálne hygienu (ošetření či instruktáž). Príspevok se nevztahuje na zubní lékařskou prehlídku alebo na jiné než hygienické výkony ani na dentálne pomůcky či jiné zboží. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to all clients for dental hygiene (treatment or instruction). The contribution does not apply to a dental checkup or other non-hygiene procedures, dental products, or other goods. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/dentalni-hygiena",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence v těhotenství a po porodu",
              "sk": "Prevence v tehotenství a po porodu",
              "en": "Prevention during pregnancy"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 2 000 Kč ženám v těhotenství a po porodu  ",
              "sk": "Až 2 000 Kč ženám v těhotenství a po porodu",
              "en": "Up to CZK 2 000 for women during pregnancy and after childbirth"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč ženám v těhotenství a po porodu na různé kurzy, screening, dentální hygienu, služby laktační poradkyně, apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč ženám v těhotenství a po porodu na rôzne kurzy, screening, dentálne hygienu, služby laktační poradkyně, apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to women during pregnancy and after childbirth for various courses, screening, dental hygiene, lactation consultant services, etc.More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prevence-v-tehotenstvi",
            "category": null
          },
          {
            "type": {
              "cs": "Doplňky stravy pro těhotné",
              "sk": "Doplňky stravy pre tehotné",
              "en": "Food supplements during pregnancy"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 500 Kč těhotným ženám na doplňky stravy ",
              "sk": "Až 500 Kč těhotným ženám na doplňky stravy",
              "en": "Up to CZK 500 to pregnant women for food supplements"
            },
            "description": {
              "cs": "Přispíváme 500 Kč těhotným ženám na doplňky stravy vhodné k užívání v těhotenství zakoupené v lékárně (vitamíny, multivitamíny, kyselina listová, železo, vláknina, probiotika – živé kultury apod.).Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme 500 Kč těhotným ženám na doplňky stravy vhodné k užívání v těhotenství zakoupené v lékárně (vitamíny, multivitamíny, kyselina listová, železo, vláknina, prebiotika – živé kultury apod.).Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute CZK 500 to pregnant women for dietary supplements suitable for use during pregnancy purchased at a pharmacy (vitamins, multivitamins, folic acid, iron, fiber, probiotics – live cultures, etc.). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/doplnky-stravy-pro-tehotne",
            "category": null
          },
          {
            "type": {
              "cs": "Novorozenecký balíček",
              "sk": "Novorozenecký balíček",
              "en": "Newborn package"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Balíček pro novorozence",
              "sk": "Balíček pre novorozence",
              "en": "Newborn baby package"
            },
            "description": {
              "cs": "Balíček pro každého novorozence, který je přihlášen k VoZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Balíček pre každého novorozence, který je přihlášen k VoZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A package for every newborn registered with VoZP. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/novorozenecky-balicek",
            "category": null
          },
          {
            "type": {
              "cs": "Péče o miminko",
              "sk": "Péče o miminko",
              "en": "Baby care"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 2 000 Kč na různé pomůcky pro péči o miminko",
              "sk": "Až 2 000 Kč na rôzne pomůcky pre péči o miminko",
              "en": "Up to CZK 2 000 for various baby care products"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč jednorázově každému dítěti od narození do šesti měsíců na následující produkty podle výběru zákonného zástupce. Např: pomůcky ke kojení a krmení dětí: kojící kloboučky, kojící polštářek, odsávačka mateřského mléka atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč jednorázově každému dítěti od narození do šesti měsíců na následující predukty podle výběru zákonného zástupce. Např: pomůcky ke kojení a krmení dětí: kojící kloboučky, kojící polštářek, odsávačka mateřského mléka atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 as a one-off payment to each child from birth to six months of age for the following products, as selected by the legal guardian. E.g.: breastfeeding and feeding aids: nipple shields, nursing pillows, breast pumps, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/pece-o-miminko",
            "category": null
          },
          {
            "type": {
              "cs": "Pravidelný pohyb",
              "sk": "Pravidelný pohyb",
              "en": "Exercise and recovery"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 700 Kč na pravidelné pohybové aktivity",
              "sk": "Až 700 Kč na pravidelné pohybové aktivity",
              "en": "Up to CZK 700 for regular physical activities"
            },
            "description": {
              "cs": "Příspíváme až 700 Kč pojištěncům od 18 let na pravidelné pohybové aktivity, jako jsou: kondiční cvičení, core trénink, fitness, aerobic, spinning, tabata, bodybuilding, bodyforming, hasičský sport, jóga, pilates, tai-či, kalanetika, zumba, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Příspíváme až 700 Kč pojištěncům od 18 let na pravidelné pohybové aktivity, jako jsou: kondiční cvičení, core trénink, fitness, aerobic, spinning, tabata, bodybuilding, bodyforming, hasičský sport, jóga, pilates, tai-či, kalanetika, zumba, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribure up to CZK 700 to our clients from 18 years of age for regular physical activities such as: fitness exercises, core training, fitness, aerobics, spinning, tabata, bodybuilding, bodyforming, firefighting, yoga, pilates, tai-chi, calanetics, zumba, and others. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/pravidelny-pohyb",
            "category": null
          },
          {
            "type": {
              "cs": "Plavání",
              "sk": "Plavání",
              "en": "Swimming"
            },
            "icon": "water",
            "benefit": {
              "cs": "Až 700 Kč na plavání",
              "sk": "Až 700 Kč na plavání",
              "en": "Up to CZK 700 for swimming"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč všem pojištěncům na plavání ve formě: Permanentní vstupenky (vč. dobití čipu či karty), Plaveckého kurzu, Kurzu plavání rodičů s dětmi (příspěvek je v tomto případě určen pouze pro dítě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 700 Kč všem pojištěncům na plavání ve formě: Permanentní vstupenky (vč. dobití čipu či karty), Plaveckého kurzu, Kurzu plavání rodičů s dětmi (príspevok je v tomto případě určen pouze pre dítě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to all clients for swimming as follows: Season tickets (including chip or card credit recharge), swimming lessons, swimming lessons for parents with children (in this case the contribution applies only to the child). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/plavani",
            "category": null
          },
          {
            "type": {
              "cs": "Kloubní výživa pro seniory",
              "sk": "Kloubní výživa pre seniory",
              "en": "Joint supplements for seniors"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů",
              "sk": "Až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů",
              "en": "Up to CZK 500 for clients aged 65 and over for the purchase of food supplements intended exclusively for the support of joint health"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů a jejich správné funkce a k prevenci artrózy (přípravky s kolagenem, glukosamin sulfátem, chondroitin sulfátem, methylsulfonylmetanem – MSM apod.), které byly zakoupeny v lékárně. Příspěvek není určen na jiné než kloubní doplňky. Nelze jej tedy využít např. na přípravky k prevenci úbytku kostní hmoty (osteoporózy), vitamíny, hořčík apod. Příspěvek lze čerpat pouze na doplňky stravy, nikoli na registrovaná léčiva (léčivé přípravky). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů a jejich správné funkce a k prevenci artrózy (přípravky s kolagenem, glukosamin sulfátem, chondroitin sulfátem, methylsulfonylmetanem – MSM apod.), které byly zakoupeny v lékárně. Príspevok není určen na jiné než kloubní doplňky. Nelze jej tedy využít např. na přípravky k prevenci úbytku kostní hmoty (osteoporózy), vitamíny, hořčík apod. Príspevok lze čerpat pouze na doplňky stravy, nikoli na registrovaná léčiva (léčivé přípravky). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients aged 65 and over for the purchase of dietary supplements intended exclusively to support joint health and proper function and to prevent osteoarthritis (products containing collagen, glucosamine sulfate, chondroitin sulfate, methylsulfonylmethane – MSM, etc.) purchased at a pharmacy. The contribution is not intended for supplements other than joint supplements. Therefore, it cannot be used, for example, for products to prevent bone loss (osteoporosis), vitamins, magnesium, etc. The contribution can only be used for dietary supplements, not for registered medicines (medicinal products). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/kloubni-vyziva-pro-seniory",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu prsu\n",
              "sk": "Prevence karcinomu prsu\n",
              "en": "Breast cancer prevention"
            },
            "icon": "breasts",
            "benefit": {
              "cs": "Až 800 Kč na prevenci rakoviny prsu ",
              "sk": "Až 800 Kč na prevenci rakoviny prsu",
              "en": "Up to CZK 800 for breast cancer prevention "
            },
            "description": {
              "cs": "Přispíváme až 800 Kč ženám od 30 let na sonografické nebo mamografické vyšetření (od 45 let je ženám vyšetření k prevenci rakoviny prsu hrazeno z veřejného zdravotního pojištění každý druhý rok, příspěvek je v tomto případě určen na roky v mezidobí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 800 Kč ženám od 30 let na sonografické alebo mamografické vyšetření (od 45 let je ženám vyšetření k prevenci rakoviny prsu hrazeno z veřejného zdravotního pojištění každý druhý rok, príspevok je v tomto případě určen na roky v mezidobí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 800 to women aged 30 and over for sonographic or mammographic examinations (from the age of 45, breast cancer prevention examinations are covered by public health insurance every two years; in this case, the contribution is intended for the intervening years).\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prevence-karcinomu-prsu",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření kožních znamének",
              "sk": "Vyšetrení kožních znamének",
              "en": "Examination of skin marks"
            },
            "icon": "skin",
            "benefit": {
              "cs": "Až 400 Kč na vyšetření kožních znamének",
              "sk": "Až 400 Kč na vyšetření kožních znamének",
              "en": "Up to CZK 400 for diagnosis of skin marks"
            },
            "description": {
              "cs": "Přispíváme až 400 Kč všem pojištěncům na dermatoskopické vyšetření kožních znamének. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 400 Kč všem pojištěncům na dermatoskopické vyšetření kožních znamének. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 400 to all our clients for dermatoscopic examination of skin lesions. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/vysetreni-koznich-znamenek",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence kolorektálního karcinomu",
              "sk": "Prevence kolorektálního karcinomu",
              "en": "Colorectal cancer prevention"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Až 300 Kč na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku",
              "sk": "Až 300 Kč na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku",
              "en": "Up to CZK 300 for the purchase of a self-test for the prevention of cancer of the colon and rectum"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč všem pojištěncům na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku nebo pojištěncům do 45 let na screeningové vyšetření k prevenci kolorektálního karcinomu provedené ve zdravotnickém zařízení (od 45. roku života je již vyšetření hrazeno z veřejného zdravotního pojištění). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč všem pojištěncům na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku alebo pojištěncům do 45 let na screeningové vyšetření k prevenci kolorektálního karcinomu prevedené ve zdravotnickém zařízení (od 45. roku života je již vyšetření hrazeno z veřejného zdravotního pojištění). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 to all insured persons for the purchase of a self-collection test for the prevention of colon and rectal cancer, or to insured persons under 45 years of age for screening tests for the prevention of colorectal cancer performed in a healthcare facility (from the age of 45, the test is covered by public health insurance). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prevence-kolorektalniho-karcinomu",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykání kourení",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 400 Kč na odvykání kouření",
              "sk": "Až 400 Kč na odvykání kouření",
              "en": "Up to CZK 400 for smoking cessation"
            },
            "description": {
              "cs": "Přispíváme až 400 Kč pojištěncům od 16 let věku na základě potvrzení o léčbě anebo o ukončení léčby vystaveného centrem pro odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 400 Kč pojištěncům od 16 let věku na základě potvrzení o léčbě aalebo o ukončení léčby vystaveného centrem pre odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 400 to our clients aged 16 and over on the basis of confirmation of treatment or completion of treatment issued by a smoking cessation center. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/odvykani-koureni",
            "category": null
          },
          {
            "type": {
              "cs": "Paruka při onkologické léčbě/alopecii",
              "sk": "Paruka pri onkologické léčbe/alopecii",
              "en": "Wig for oncological treatment/alopecia"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 1 000 Kč na paruku při chemoterapii a autoimunitní alopecii",
              "sk": "Až 1 000 Kč na paruku při chemoterapii a autoimunitní alopecii",
              "en": "Up to CZK 1 000 for a wig in case of chemotherapy or autoimmune alopecia"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům, kteří podstoupili nebo podstupují léčbu onkologického onemocnění, nebo pojištěncům s diagnózou autoimunitní alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pojištěncům, kteří podstoupili alebo podstupují léčbu onkologického onemocnění, alebo pojištěncům s diagnózou autoimunitní alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to our clients who have undergone or are undergoing treatment for cancer, or to insured persons diagnosed with autoimmune alopecia. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/paruka-pri-chemoterapii",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence poruch paměti/kognitivních funkcí",
              "sk": "Prevence poruch pameti/kognitivních funkcí",
              "en": "Prevention of memory/cognitive function disorders"
            },
            "icon": "brain",
            "benefit": {
              "cs": "Až 300 Kč na preventivní vyšetření poruch paměti/kognitivních funkcí ",
              "sk": "Až 300 Kč na preventivní vyšetření poruch paměti/kognitivních funkcí",
              "en": "Up to CZK 300 for a preventive diagnosis of memory/cognitive function disorders"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč pojištěncům od 18 let na preventivní vyšetření poruch paměti/kognitivních funkcí (cílené psychiatrické či psychologické vyšetření dotazníky MMSE, AKT, MoCA), odborně vedený trénink paměti, kognitivní pomůcky doporučené Českou alzheimerovskou společností, terapie Feuersteinovou metodou instrumentálního obohacování pro osoby s poškozením mozku poskytovaná certifikovaným odborníkem – viz. seznam oprávněných osob (dostupný na webu www.cogito-centrum.cz v sekci tým – naši odborníci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč pojištěncům od 18 let na preventivní vyšetření poruch paměti/kognitivních funkcí (cílené psychiatrické či psychologické vyšetření dotazníky MMSE, AKT, MoCA), odborně vedený trénink paměti, kognitivní pomůcky doporučené Českou alzheimerovskou společností, terapie Feuersteinovou metodou instrumentálního obohacování pre osoby s poškozením mozku poskytovaná certifikovaným odborníkem – viz. seznam oprávněných osob (dostupný na webu www.cogito-centrum.cz v sekci tým – naši odborníci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 to our clients aged 18 and over for preventive examinations of memory/cognitive function disorders (targeted psychiatric or psychological examinations using MMSE, AKT, MoCA), professionally guided memory training, cognitive aids recommended by the Czech Alzheimer's Society, Feuerstein's instrumental enrichment therapy for people with brain damage provided by a certified specialist – see the list of authorized persons (available at www.cogito-centrum.cz in the team section – our experts). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prevence-poruch-pameti",
            "category": null
          },
          {
            "type": {
              "cs": "Terapeutické programy Mindwell",
              "sk": "Terapeutické programy Mindwell",
              "en": "Mindwell Therapy Programs"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Bezplatný program",
              "sk": "Bezplatný program",
              "en": "Free program"
            },
            "description": {
              "cs": "Při splnění podmínek pro zařazení do programu obdrží klient VoZP aktivační kód, který nahrazuje platbu při zakoupení programu na stránkách Mindwell. Program je určen pojištěncům VoZP starším 18 let a je vhodný pro osoby s lehkou až střední formou deprese či úzkostných stavů. Není vhodný pro osoby s akutními potížemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Ak klient VoZP splní podmienky na zaradenie do programu, dostane aktivačný kód, ktorý nahrádza platbu pri nákupe programu na stránkach Mindwell. Program je určený poistencom VoZP starším ako 18 rokov a je vhodný pre osoby s ľahkou až stredne ťažkou formou depresie alebo úzkostných stavov. Nie je vhodný pre osoby s akútnymi ťažkosťami. \nViac informácií nájdete na stránkach zdravotnej poisťovne tu: odkaz.",
              "en": "Upon meeting the conditions for inclusion in the program, the VoZP client will receive an activation code that replaces payment when purchasing the program on the Mindwell website. The program is intended for VoZP policyholders over the age of 18 and is suitable for people with mild to moderate depression or anxiety. It is not suitable for people with acute problems. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/mindwell",
            "category": null
          },
          {
            "type": {
              "cs": "Pro dárce",
              "sk": "Pre dárce",
              "en": "For donors"
            },
            "icon": "care",
            "benefit": {
              "cs": "Odměna až 5 000 Kč pro dárce krve a kostní dřeně",
              "sk": "Odměna až 5 000 Kč pre dárce krve a kostní dřeně",
              "en": "Reward of up to CZK 5 000 for blood and bone marrow donors"
            },
            "description": {
              "cs": "Cílovou skupinou jsou dárci krve a dárci kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Cílovou skupinou jsou dárci krve a dárci kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The target group is blood donors and bone marrow donors. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prispevky-pro-darce-krve-a-kostni-drene",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Děti",
          "sk": "Deti",
          "en": "Children"
        },
        "benefits": [
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 2 000 Kč na očkování pro děti",
              "sk": "Až 2 000 Kč na očkovanie pre děti",
              "en": "Up to CZK 2 000 for vaccination for children"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům do dovršení 18 let věku na kterékoli očkování nehrazené z veřejného zdravotního pojištění (s výjimkou očkování proti lidskému papilomaviru HPV), a to na kteroukoli dávku očkovacího cyklu. Příspěvek nelze poskytnout na doplatek částečně hrazené vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům do dovršení 18 let věku na kterékoli očkovanie nehrazené z veřejného zdravotního pojištění (s výjimkou očkovanie preti lidskému papilomaviru HPV), a to na kteroukoli dávku očkovacího cyklu. Príspevok nelze poskytnout na doplatek částečně hrazené vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to our clients under the age of 18 for any vaccination not covered by public health insurance (with the exception of vaccination against human papillomavirus HPV), for any dose of the vaccination cycle. The contribution cannot be provided for the co-payment of a partially covered vaccine. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/ockovani-pro-deti",
            "category": "Deti"
          },
          {
            "type": {
              "cs": "Dentální hygiena",
              "sk": "Dentálne hygiena",
              "en": "Dental hygiene"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 500 Kč na dentální hygienu",
              "sk": "Až 500 Kč na dentálne hygienu",
              "en": "Up to CZK 500 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč všem pojištěncům na dentální hygienu (ošetření či instruktáž). Příspěvek se nevztahuje na zubní lékařskou prohlídku nebo na jiné než hygienické výkony ani na dentální pomůcky či jiné zboží. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč všem pojištěncům na dentálne hygienu (ošetření či instruktáž). Príspevok se nevztahuje na zubní lékařskou prehlídku alebo na jiné než hygienické výkony ani na dentálne pomůcky či jiné zboží. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to all clients for dental hygiene (treatment or instruction). The contribution does not apply to a dental checkup or other non-hygiene procedures, dental products, or other goods. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/dentalni-hygiena",
            "category": null
          },
          {
            "type": {
              "cs": "Dioptrické brýle pro děti",
              "sk": "Dioptrické brýle pre deti",
              "en": "Prescription glasses for children"
            },
            "icon": "glasses",
            "benefit": {
              "cs": "Až 500 Kč na dioptrické brýle pro děti",
              "sk": "Až 500 Kč na dioptrické brýle pre děti",
              "en": "Up to CZK 500 for prescription glasses for children"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům od 6 do dovršení 16 let na dioptrické brýle (obroučky i skla). Příspěvek se nevztahuje na samostatně zakoupené příslušenství ani na kontaktní čočky nebo na sluneční brýle bez dioptrických skel. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 500 Kč pojištěncům od 6 do dovršení 16 let na dioptrické brýle (obroučky i skla). Príspevok se nevztahuje na samostatně zakoupené příslušenství ani na kontaktní čočky alebo na sluneční brýle bez dioptrických skel. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients aged 6 to 16 for prescription glasses (frames and lenses). The contribution does not apply to separately purchased accessories, contact lenses, or sunglasses without prescription lenses. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/dioptricke-bryle-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Zubní rovnátka pro děti",
              "sk": "Zubní rovnátka pre deti",
              "en": "Braces"
            },
            "icon": "braces",
            "benefit": {
              "cs": "Až 1 500 Kč na zubní rovnátka pro děti\n",
              "sk": "Až 1 500 Kč na zubní rovnátka pre děti\n",
              "en": "Up to CZK 1 500 for dental braces for children"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč pojištěncům do dovršení 18 let věku na nesnímatelný (fixní) i snímatelný ortodontický aparát (vč. foliového) nebo jeho rekonstrukci (doplnění součástí) v době aktivní i retenční fáze léčby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč pojištěncům do dovršení 18 let věku na nesnímatelný (fixní) i snímatelný ortodontický aparát (vč. foliového) alebo jeho rekonstrukci (doplnění součástí) v době aktivní i retenční fáze léčby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 to our clients under the age of 18 for fixed and removable orthodontic appliances (including foil appliances) or their reconstruction (additional components) during the active and retention phases of treatment. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/zubni-rovnatka-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování proti papilomaviru",
              "sk": "Očkovanie preti papilomaviru",
              "en": "Papilloma virus vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 500 Kč na očkování proti lidskému papilomaviru (HPV) ",
              "sk": "Až 1 500 Kč na očkovanie preti lidskému papilomaviru (HPV)",
              "en": "Up to CZK 1 500 for vaccination against human papilloma virus (HPV)"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč Pojištěncům od 15 let do dovršení 18 let věku na očkování proti lidskému papilomaviru (HPV) podle doporučení lékaře (pojištěncům ve věku od 11 do dovršení 15 let je toto očkování hrazeno z veřejného zdravotního pojištění). Příspěvek nelze poskytnout na doplatek částečně hrazené vakcíny. íce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč Pojištěncům od 15 let do dovršení 18 let věku na očkovanie preti lidskému papilomaviru (HPV) podle doporučení lékaře (pojištěncům ve věku od 11 do dovršení 15 let je toto očkovanie hrazeno z veřejného zdravotního pojištění). Príspevok nelze poskytnout na doplatek částečně hrazené vakcíny. íce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 to our clients aged 15 to 18 for vaccination against human papillomavirus (HPV) as recommended by a doctor (for insured persons aged 11 to 15, this vaccination is covered by public health insurance). The contribution cannot be provided for the co-payment of a partially covered vaccine.  More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/ockovani-proti-papilomaviru",
            "category": null
          },
          {
            "type": {
              "cs": "Vitamíny pro děti",
              "sk": "Vitamíny pre deti",
              "en": "Vitamins for children"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 300 Kč na vitamíny pro děti",
              "sk": "Až 300 Kč na vitamíny pre děti",
              "en": "Up to CZK 300 for vitamins for children"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč pojištěncům do dovršení 18 let na vitamínový či multivitamínový doplněk stravy přiměřený věku žadatele a zakoupený v lékárně (přípravek musí obsahovat alespoň jeden vitamín). Příspěvek lze čerpat pouze na doplňky stravy, nikoli na registrovaná léčiva (léčivé přípravky). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč pojištěncům do dovršení 18 let na vitamínový či multivitamínový doplněk stravy přiměřený věku žadatele a zakoupený v lékárně (přípravek musí obsahovat alespoň jeden vitamín). Príspevok lze čerpat pouze na doplňky stravy, nikoli na registrovaná léčiva (léčivé přípravky). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 to insured persons under the age of 18 for vitamin or multivitamin supplements appropriate for the applicant's age and purchased at a pharmacy (the product must contain at least one vitamin). The contribution can only be used for dietary supplements, not for registered medicines (medicinal products). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prispevek-na-vitaminy",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence zubního kazu u dětí\n",
              "sk": "Prevence zubního kazu u detí\n",
              "en": "Prevention of tooth cavities for children"
            },
            "icon": "tooth-flawed",
            "benefit": {
              "cs": "Až 300 Kč na prevenci zubů pro děti",
              "sk": "Až 300 Kč na prevenci zubů pre děti",
              "en": "Up to CZK 300 for dental prevention for children"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč Pojištěncům od 6 do dovršení 14 let věku na pečetění fisur, tedy na ryze preventivní výkon spočívající v utěsnění štěrbin mezi hrbolky na kousacích ploškách postranních zubů. Příspěvek se nevztahuje na žádné jiné stomatologické výkony (na žádný druh výplně – plomby). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 300 Kč Pojištěncům od 6 do dovršení 14 let věku na pečetění fisur, tedy na ryze preventivní výkon spočívající v utěsnění štěrbin mezi hrbolky na kousacích ploškách postranních zubů. Príspevok se nevztahuje na žádné jiné stomatologické výkony (na žádný druh výplně – plomby). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 to insured persons aged 6 to 14 for fissure sealing, i.e., a purely preventive procedure consisting of sealing the gaps between the cusps on the chewing surfaces of the lateral teeth. The contribution does not apply to any other dental procedures (no type of filling). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prevence-zubniho-kazu-u-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Pohybové aktivity pro děti",
              "sk": "Pohybové aktivity pre deti",
              "en": "Physical activities for children"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 1000 Kč na pohybové aktivity pro děti",
              "sk": "Až 1000 Kč na pohybové aktivity pre děti",
              "en": "Up to CZK 1 000 for physical activities for children"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům do dovršení 18 let na pravidelné pohybové a sportovní aktivity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pojištěncům do dovršení 18 let na pravidelné pohybové a športové aktivity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to insured persons under the age of 18 for regular exercise and sports activities. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/pohybove-aktivity-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Plavání",
              "sk": "Plavání",
              "en": "Swimming"
            },
            "icon": "water",
            "benefit": {
              "cs": "Až 700 Kč na plavání",
              "sk": "Až 700 Kč na plavání",
              "en": "Up to CZK 700 for swimming"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč všem pojištěncům na plavání ve formě: Permanentní vstupenky (vč. dobití čipu či karty), Plaveckého kurzu, Kurzu plavání rodičů s dětmi (příspěvek je v tomto případě určen pouze pro dítě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz .",
              "sk": "Přispíváme až 700 Kč všem pojištěncům na plavání ve formě: Permanentní vstupenky (vč. dobití čipu či karty), Plaveckého kurzu, Kurzu plavání rodičů s dětmi (príspevok je v tomto případě určen pouze pre dítě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz .",
              "en": "We contribute up to CZK 700 to all clients for swimming as follows: Season tickets (including chip or card credit recharge), swimming lessons, swimming lessons for parents with children (in this case the contribution applies only to the child). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/plavani",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní a ozdravné pobyty",
              "sk": "Športové a ozdravné pobyty",
              "en": "Sports and recuperative stays"
            },
            "icon": "tent",
            "benefit": {
              "cs": "Až 1 000 Kč na sportovní či ozdravný pobyt pro děti",
              "sk": "Až 1 000 Kč na športové či ozdravný pobyt pre děti",
              "en": "Up to CZK 1 000 for children for a sports or recuperative stay"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům od 4 do dovršení 18 let na sportovní či ozdravný pobyt (lyžařský kurz, sportovní soustředění, škola v přírodě) nebo letní sportovně pohybový pobyt. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pojištěncům od 4 do dovršení 18 let na športové či ozdravný pobyt (lyžařský kurz, športové soustředění, škola v přírodě) alebo letní sportovně pohybový pobyt. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to clients from age 4 to their 18th birthday for a sports or recuperative stay (ski lessons, sports meet, open-air-school) or summer sports camp. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/sportovni-a-ozdravne-pobyty",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní přilba pro děti",
              "sk": "Športové prilba pre deti",
              "en": "Sports helmet for children"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 500 Kč na sportovní ochrannou přilbu ",
              "sk": "Až 500 Kč na športové ochrannou přilbu",
              "en": "Up to CZK 500 for a protective helmet"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům do dovršení 16 let na sportovní ochrannou přilbu (helmu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům do dovršení 16 let na športové ochrannou přilbu (helmu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to clients up to their 16th birthday for a protective sports helmet. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/sportovni-prilba-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Sportovní prohlídka pro děti",
              "sk": "Športové prehlídka pre deti",
              "en": "Sports check-up for children"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 500 Kč na lékařskou sportovní prohlídku ",
              "sk": "Až 500 Kč na lékařskou športové prehlídku",
              "en": "Up to CZK 500 for a medical sports check-up"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům do dovršení 18 let na lékařskou prohlídku nutnou k členství ve sportovní organizaci, kroužku nebo klubu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům do dovršení 18 let na lékařskou prehlídku nutnou k členství ve športové organizaci, kroužku alebo klubu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients under the age of 18 for medical examinations required for membership in a sports organization, club, or association. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/sportovni-prohlidka-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření kožních znamének",
              "sk": "Vyšetrení kožních znamének",
              "en": "Skin lesion examination"
            },
            "icon": "dermatology",
            "benefit": {
              "cs": "Až 400 Kč na vyšetření kožních znamének",
              "sk": "Až 400 Kč na vyšetření kožních znamének",
              "en": "Up to CZK 400 for skin lesion examination\n"
            },
            "description": {
              "cs": "Přispíváme až 400 Kč všem pojištěncům na dermatoskopické vyšetření kožních znamének. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 400 Kč všem pojištěncům na dermatoskopické vyšetření kožních znamének. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 400 to all our clients for dermatoscopic examination of skin lesions. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/vysetreni-koznich-znamenek",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykání kourení",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 400 Kč na odvykání kouření",
              "sk": "Až 400 Kč na odvykání kouření",
              "en": "Up to CZK 400 for smoking cessation"
            },
            "description": {
              "cs": "Přispíváme až 400 Kč pojištěncům od 16 let věku na základě potvrzení o léčbě anebo o ukončení léčby vystaveného centrem pro odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 400 Kč pojištěncům od 16 let věku na základě potvrzení o léčbě aalebo o ukončení léčby vystaveného centrem pre odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 400 to our clients aged 16 and over on the basis of confirmation of treatment or completion of treatment issued by a smoking cessation center. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/odvykani-koureni",
            "category": null
          },
          {
            "type": {
              "cs": "Paruka při onkologické léčbě/alopecii\n",
              "sk": "Paruka pri onkologické léčbe/alopecii\n",
              "en": "Wig for oncological treatment/alopecia"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 1 000 Kč na paruku při chemoterapii a autoimunitní alopecii",
              "sk": "Až 1 000 Kč na paruku při chemoterapii a autoimunitní alopecii",
              "en": "Up to CZK 1 000 for a wig in case of chemotherapy or autoimmune alopecia"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům, kteří podstoupili nebo podstupují léčbu onkologického onemocnění, nebo pojištěncům s diagnózou autoimunitní alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pojištěncům, kteří podstoupili alebo podstupují léčbu onkologického onemocnění, alebo pojištěncům s diagnózou autoimunitní alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to our clients who have undergone or are undergoing treatment for cancer, or to insured persons diagnosed with autoimmune alopecia. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/paruka-pri-chemoterapii",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence kolorektálního karcinomu",
              "sk": "Prevence kolorektálního karcinomu",
              "en": "Colorectal cancer prevention"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Až 300 Kč na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku",
              "sk": "Až 300 Kč na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku",
              "en": "Up to CZK 300 for the purchase of a self-test for the prevention of cancer of the colon and rectum"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč všem pojištěncům na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku nebo pojištěncům do 45 let na screeningové vyšetření k prevenci kolorektálního karcinomu provedené ve zdravotnickém zařízení (od 45. roku života je již vyšetření hrazeno z veřejného zdravotního pojištění). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč všem pojištěncům na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku alebo pojištěncům do 45 let na screeningové vyšetření k prevenci kolorektálního karcinomu prevedené ve zdravotnickém zařízení (od 45. roku života je již vyšetření hrazeno z veřejného zdravotního pojištění). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 to all insured persons for the purchase of a self-collection test for the prevention of colon and rectal cancer, or to insured persons under 45 years of age for screening tests for the prevention of colorectal cancer performed in a healthcare facility (from the age of 45, the test is covered by public health insurance). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/prevence-kolorektalniho-karcinomu",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora rozvoje dětí a prevence duševních poruch",
              "sk": "Podpora rozvoje detí a prevence duševních poruch",
              "en": "Support for child development and prevention of mental disorders"
            },
            "icon": "chat-unrelated",
            "benefit": {
              "cs": "Až 1 000 Kč na podporu rozvoje dětí a prevenci duševních poruch",
              "sk": "Až 1 000 Kč na podporu rozvoje dětí a prevenci duševních poruch",
              "en": "Up to CZK 1 000 for support for child development and prevention of mental disorders"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pojištěncům od 1 roku do dovršení 18 let na některou z níže vyjmenovaných forem podpory rozvoje dětí a prevence duševních poruch nehrazenou z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pojištěncům od 1 roku do dovršení 18 let na některou z níže vyjmenovaných forem podpory rozvoje dětí a prevence duševních poruch nehrazenou z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to insured persons aged 1 to 18 for any of the forms of support for child development and mental disorder prevention listed below that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/podpora-rozvoje-deti-a-prevence-dusevnich-poruch",
            "category": null
          },
          {
            "type": {
              "cs": "Produkt Simple Steps",
              "sk": "Predukt Simple Steps",
              "en": "The Simple Steps product"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 800 Kč dětem od 1 roku do dovršení 16 let, u kterých byla diagnostikována porucha autistického spektra ",
              "sk": "Až 800 Kč dětem od 1 roku do dovršení 16 let, u kterých byla diagnostikována porucha autistického spektra",
              "en": "Up to CZK 800 for children from one year of age until their 16th birthday who have been diagnosed with an autistic spectrum disorder"
            },
            "description": {
              "cs": "Přispíváme až 800 Kč dětem od 1 roku do dovršení 16 let, u kterých byla diagnostikována porucha autistického spektra (nebo bylo vysloveno podezření na tuto diagnózu), pro které bude zakoupena on-line výuková platforma Simple Steps pro terapii autismu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "sk": "Přispíváme až 800 Kč dětem od 1 roku do dovršení 16 let, u kterých byla diagnostikována porucha autistického spektra (alebo bylo vysloveno podezření na tuto diagnózu), pre které bude zakoupena on-line výuková platforma Simple Steps pre terapii autismu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "en": "We contribute up to CZK 800 to children from one year of age until their 16th birthday who have been diagnosed with (or are suspected of having) an autistic spectrum disorder, for which the Simple Steps on-line learning platform for autism therapy will be purchased. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/produkt-simple-steps",
            "category": null
          },
          {
            "type": {
              "cs": "Terénní poradenství pro děti v předškolním a školním zařízení",
              "sk": "Terénní poradenství pre deti v predškolním a školním zarízení",
              "en": "Field counselling for children in a pre-school and school facility"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na terénní služby klinického psychologa, dětského psychiatra nebo klinického logopeda",
              "sk": "Až 500 Kč na terénní služby klinického psychologa, dětského psychiatra alebo klinického logopeda",
              "en": "Up to CZK 500 for the field services of a clinical psychologist, children's psychiatrist, or clinical speech therapist"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům od 3 do dovršení 20 let na terénní služby klinického psychologa, dětského psychiatra nebo klinického logopeda plně hrazené pojištěncem, které jsou zprostředkovány pedagogicko-psychologickou poradnou, případně speciálně pedagogickým centrem. Jde o vyžádané návštěvy klinického psychologa, dětského psychiatra nebo klinického logopeda plně hrazené pojištěncem, které jsou poskytovány výlučně v místě předškolního nebo školního vzdělávání pojištěnce (terénní služby). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům od 3 do dovršení 20 let na terénní služby klinického psychologa, dětského psychiatra alebo klinického logopeda plně hrazené pojištěncem, které jsou zprestředkovány pedagogicko-psychologickou poradnou, případně speciálně pedagogickým centrem. Jde o vyžádané návštěvy klinického psychologa, dětského psychiatra alebo klinického logopeda plně hrazené pojištěncem, které jsou poskytovanýy výlučně v místě předškolního alebo školního vzdělávání pojištěnce (terénní služby). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients aged 3 to 20 for field services provided by a clinical psychologist, child psychiatrist, or clinical speech therapist, fully covered by the insured person and arranged by an educational-psychological counseling center or a special educational center. These are requested visits to a clinical psychologist, child psychiatrist, or clinical speech therapist fully covered by the insured person, which are provided exclusively at the insured person's preschool or school (field services). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/terenni-poradenstvi-pro-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Poradenství pro rodiče dětí s duševní poruchou",
              "sk": "Poradenství pre rodiče detí s duševní poruchou",
              "en": "Consultation for parents of children with a mental disorder"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na poradenské nebo konzultační služby u dětského psychiatra, klinického psychologa nebo klinického logopeda",
              "sk": "Až 500 Kč na poradenské alebo konzultační služby u dětského psychiatra, klinického psychologa alebo klinického logopeda",
              "en": "Up to CZK 500 for consulting services from a children's psychiatrist, clinical psychologist, or clinical speech therapist"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč pojištěncům do dovršení 18 let na poradenské nebo konzultační služby nehrazené z veřejného zdravotního pojištění u dětského psychiatra, klinického psychologa nebo klinického logopeda ohledně dalšího postupu u léčených dětí (příspěvek není určen na samotnou terapii ani vyšetření dítěte, pouze na konzultace s rodičem/zákonným zástupcem o postupu léčby). Příspěvek lze poskytnout na jednu nebo více služeb, avšak v maximální souhrnné výši 500 Kč. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč pojištěncům do dovršení 18 let na poradenské alebo konzultační služby nehrazené z veřejného zdravotního pojištění u dětského psychiatra, klinického psychologa alebo klinického logopeda ohledně dalšího postupu u léčených dětí (príspevok není určen na samotnou terapii ani vyšetření dítěte, pouze na konzultace s rodičem/zákonným zástupcem o postupu léčby). Príspevok lze poskytnout na jednu alebo více služeb, avšak v maximální souhrnné výši 500 Kč. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to our clients under the age of 18 for counseling or consultation services not covered by public health insurance with a child psychiatrist, clinical psychologist, or clinical speech therapist regarding further treatment for children undergoing treatment (the contribution is not intended for the therapy itself or for the examination of the child, but only for consultations with the parent/legal guardian about the treatment process). The contribution can be provided for one or more services, but up to a maximum total amount of CZK 500. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vozp.cz/prispevek/poradenstvi-pro-rodice-deti-s-dusevni-poruchou",
            "category": null
          }
        ]
      }
    ],
    "updateDate": "29.1.2026",
    "companyBenefitsLink": "https://www.vozp.cz/prispevky-na-prevenci"
  },
  {
    "slug": "rbp",
    "genders": [
      {
        "name": {
          "cs": "Muži",
          "sk": "Muži",
          "en": "Men"
        },
        "benefits": [
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na kterékoliv preventivní očkování nehrazené z veřejného zdravotního pojištění (např. břišní tyfus, pásový opar, chřipka, klíšťová encefalitida, pneumokokové nákazy, spalničky, vzteklina, meningitida, žloutenka, neštovice atd. včetně očkování pro cestovatele). Nevztahuje se na desenzibilizaci („očkování proti alergii“). Z dokladů musí být patrné druh očkovací látky a datum aplikace očkovací látky. Pro čerpání příspěvku doložte doklad o platbě vakcíny a ofocený očkovací průkaz. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na kterékoliv preventivní očkovanie nehrazené z veřejného zdravotního pojištění (např. břišní tyfus, pásový opar, chřipka, klíšťová encefalitida, pneumokokové nákazy, spalničky, vzteklina, meningitida, žloutenka, neštovice atd. včetně očkovanie pre cestovatele). Nevztahuje se na desenzibilizaci („očkovanie preti alergii“). Z dokladů musí být patrné druh očkovací látky a datum aplikace očkovací látky. Pro čerpání příspěvku doložte doklad o platbě vakcíny a ofocený očkovací průkaz. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards any preventive vaccination not covered by public health insurance (e.g., typhoid fever, shingles, influenza, tick-borne encephalitis, pneumococcal disease, measles, rabies, meningitis, hepatitis, chickenpox, etc., including vaccinations for travelers). This does not apply to desensitization (\"allergy vaccination\"). The documents must clearly show the type of vaccine and the date of administration. To claim the contribution, provide proof of payment for the vaccine and a photocopy of the vaccination card. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": "Muži"
          },
          {
            "type": {
              "cs": "Celiakie",
              "sk": "Celiakie",
              "en": "Celiac disease"
            },
            "icon": "gluten",
            "benefit": {
              "cs": "Až 1 000 Kč na bezlepkovou dietu pro klienty s celiakií ",
              "sk": "Až 1 000 Kč na bezlepkovou dietu pre klienty s celiakií",
              "en": "Up to CZK 1 000 for a gluten-free diet for clients with celiac disease"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na bezlepkovou dietu pro pojištěnce s celiakií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na bezlepkovou dietu pre pojištěnce s celiakií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards a gluten-free diet for insured persons with celiac disease. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Nízkobílkovinná dieta",
              "sk": "Nízkobílkovinná dieta",
              "en": "Low-protein diet"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 1 000 Kč na nízkobílkovinnou dietu",
              "sk": "Až 1 000 Kč na nízkobílkovinnou dietu",
              "en": "Up to CZK 1 000 for a low-protein diet"
            },
            "description": {
              "cs": "Příspíváme až 1 000 Kč na nízkobílkovinnou dietu (fenylketonurie, nemoc javorového sirupu, homocystinurie, isovalerova acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1, poruchy cyklu močoviny). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Příspíváme až 1 000 Kč na nízkobílkovinnou dietu (fenylketonurie, nemoc javorového sirupu, homocystinurie, isovalerova acidurie, prepionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1, poruchy cyklu močoviny). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for a low-protein diet (phenylketonuria, maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na paruky - Alopecie ",
              "sk": "Príspevok na paruky - Alopecie",
              "en": "Contribution for wigs - Alopecia"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 1 000 Kč na paruku pro klienty s alopecií",
              "sk": "Až 1 000 Kč na paruku pre klienty s alopecií",
              "en": "Up to CZK 1 000 for a wig for clients with alopecia"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pro klienty s alopecií na nákup paruky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pre klienty s alopecií na nákup paruky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for clients with alopecia to purchase a wig. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Diabetici ",
              "sk": "Diabetici",
              "en": "Diabetics"
            },
            "icon": "stamp",
            "benefit": {
              "cs": "Až 1 000 Kč pro klienty s diabetem ",
              "sk": "Až 1 000 Kč pre klienty s diabetem",
              "en": "Up to CZK 1 000 for clients with diabetes"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč klientům s diabetem na nákup permanentky na pohybové aktivity (50 % z ceny), testovacích proužků pro zjištění glukózy v moči, glukometru, diagnostických proužků a příslušenství k inzulínové pumpě, nákupu senzoru pro neinvazivní okamžité měření glukózy v krvi, prostředky pro lepší fixaci senzorů (tejpy, samodržící obinadla) a na podiatrické ošetření (přístrojová pedikúra) provedené u poskytovatelů uvedených na stránkách České podiatrické společnosti, České podologické společnosti a Asociace profesionálních pedikérů a pedikérek. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč klientům s diabetem na nákup permanentky na pohybové aktivity (50 % z ceny), testovacích preužků pre zjištění glukózy v moči, glukometru, diagnostických preužků a příslušenství k inzulínové pumpě, nákupu senzoru pre neinvazivní okamžité měření glukózy v krvi, prestředky pre lepší fixaci senzorů (tejpy, samodržící obinadla) a na podiatrické ošetření (přístrojová pedikúra) prevedené u poskytovatelů uvedených na stránkách České podiatrické společnosti, České podologické společnosti a Asociace prefesionálních pedikérů a pedikérek. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1,000 to clients with diabetes for the purchase of a season ticket for physical activities (50% of the price), test strips for detecting glucose in urine, a glucometer, diagnostic strips and accessories for an insulin pump, the purchase of a sensor for non-invasive immediate blood glucose measurement, products for better sensor fixation (tapes, self-adhesive bandages), and podiatric treatment (machine pedicure) performed by providers listed on the websites of the Czech Podiatric Society, the Czech Podological Society, and the Association of Professional Pedicurists. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Kryokomora",
              "sk": "Kryokomora",
              "en": "Cryochamber"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 700 Kč na návštěvu kryokomory",
              "sk": "Až 700 Kč na návštěvu kryokomory",
              "en": "Up to CZK 700 for a visit to the cryochamber"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč pojištěncům na návštěvu kryokomory pro posílení imunitního systému a regeneraci vašeho těla. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč pojištěncům na návštěvu kryokomory pre posílení imunitního systému a regeneraci vašeho těla. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to insured persons for visits to a cryochamber to strengthen the immune system and regenerate your body. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Sauna",
              "sk": "Sauna",
              "en": "Sauna "
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 700 Kč na saunu",
              "sk": "Až 700 Kč na saunu",
              "en": "Up to CZK 700 for sauna use"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na saunování v obdobích leden - duben a září - prosinec. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na saunování v obdobích leden - duben a září - presinec. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 for sauna use during the periods January–April and September–December. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Uživatelé MY213",
              "sk": "Uživatelé MY213",
              "en": "Users of MY213"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 700 Kč pro pojištěnce, kteří aktivně využívají aplikaci my213",
              "sk": "Až 700 Kč pre pojištěnce, kteří aktivně využívají aplikaci my213",
              "en": "Up to CZK 700 for insured persons who actively use the my213 app"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč pro naše pojištěnce, kteří aktivně využívají aplikaci my213 a žádost o úhradu preventivní péče z balíčku „Uživatelé my213“ podali výhradně jejím prostřednictvím nabízíme: permanentka na pohybové aktivity, diagnostické vyšetření nebo ošetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč pre naše pojištěnce, kteří aktivně využívají aplikaci my213 a žádost o úhradu preventivní péče z balíčku „Uživatelé my213“ podali výhradně jejím prestřednictvím nabízíme: permanentka na pohybové aktivity, diagnostické vyšetření alebo ošetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to our clients who are actively using the my213 app and have submitted a request for reimbursement of preventive care from the \"my213 Users\" package exclusively through the app, we offer: season tickets for physical activities, diagnostic examinations or treatments and more. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro registrované sportovce",
              "sk": "Príspevok pre registrované sportovce",
              "en": "Contribution for registered athletes"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 500 Kč pro registrované sportovce",
              "sk": "Až 500 Kč pre registrované sportovce",
              "en": "Up to CZK 500 for registered athletes"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na sportovní prohlídku nebo registrační a členské poplatky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na športové prehlídku alebo registrační a členské poplatky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to pay for a regular sports check-up or registration and membership fees. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na speciální vyšetření",
              "sk": "Príspevok na speciální vyšetrení",
              "en": "Contribution for a special examination"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na speciální vyšetření",
              "sk": "Až 500 Kč na speciální vyšetření",
              "en": "Up to CZK 500 for a special examination"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na speciální vyšetření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na speciální vyšetření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for a special examination. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykání kourení",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 500 Kč na odvykání kouření",
              "sk": "Až 500 Kč na odvykání kouření",
              "en": "Up to CZK 500 for smoking cessation"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na nákup volně prodejných léčivých a podpůrných přípravků, zakoupených v lékárně: náplastí, pastilek, ústního spreje, žvýkaček apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na nákup volně predejných léčivých a podpůrných přípravků, zakoupených v lékárně: náplastí, pastilek, ústního spreje, žvýkaček apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for the purchase of over-the-counter medicinal and supportive products purchased in a pharmacy: adhesive strips, lozenges, oral sprays, chewing gum, etc.\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Přípravky na prostatu",
              "sk": "Prípravky na prestatu",
              "en": "Prostate contributions"
            },
            "icon": "prostate",
            "benefit": {
              "cs": "Až 500 Kč na přípravky na prostatu",
              "sk": "Až 500 Kč na přípravky na prestatu",
              "en": "Up to CZK 500 for prostate products"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč mužům nad 45 let na nákup vybraných léčivých přípravků v lékárně při nezhoubnému zbytnění prostaty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč mužům nad 45 let na nákup vybraných léčivých přípravků v lékárně při nezhoubnému zbytnění prestaty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to men over 45 years of age for the purchase of selected medicinal products at a pharmacy for benign prostatic hyperplasia. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Otec u porodu",
              "sk": "Otec u porodu",
              "en": "Father present during childbirth"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 500 Kč pro otce u porodu",
              "sk": "Až 500 Kč pre otce u porodu",
              "en": "Up to CZK 500 to have the father present during childbirth"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na úhradu úkonů nebo služeb, které podporují psychickou pohodu matky během porodu a pobytu v porodnici, např. instruktáž otce u porodu, úhrada nadstandardního pokoje pro otce s matkou atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na úhradu úkonů alebo služeb, které podporují psychickou pohodu matky během porodu a pobytu v porodnici, např. instruktáž otce u porodu, úhrada nadstandardního pokoje pre otce s matkou atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards the cost of procedures or services that support the mother's mental well-being during childbirth and her stay in the maternity hospital, e.g., instruction for the father during childbirth, payment for a premium room for the father and mother, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Bonus 90+",
              "sk": "Bonus 90+",
              "en": "Bonus 90+"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 1 500 Kč pro věrné pojištěnce 90+",
              "sk": "Až 1 500 Kč pre věrné pojištěnce 90+",
              "en": "Up to CZK 1 500 for loyal insured 90+"
            },
            "description": {
              "cs": "Pokud věnujete svému zdraví náležitou péči a jste věrnými pojištěnci RBP, dokážeme to ocenit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Pokud věnujete svému zdraví náležitou péči a jste věrnými pojištěnci RBP, dokážeme to ocenit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "If you take proper care of your health and are a loyal RBP insured, we can appreciate it. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na paruku pro onkologické pacienty",
              "sk": "Príspevok na paruku pre onkologické pacienty",
              "en": "Wig contribution"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 3 000 Kč na paruku",
              "sk": "Až 3 000 Kč na paruku",
              "en": "Up to CZK 3 000 for a wig"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč na paruky pro pojištěnce muže, kteří podstupují (podstoupili) v rámci onkologického onemocnění léčbu chemoterapií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 3 000 Kč na paruky pre pojištěnce muže, kteří podstupují (podstoupili) v rámci onkologického onemocnění léčbu chemoterapií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 000 towards wigs for insured men who are undergoing (or have undergone) chemotherapy treatment for cancer. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Komplexní onkologická preventivní prohlídka",
              "sk": "Komplexní onkologická preventivní prehlídka",
              "en": "Comprehensive cancer examination"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 4 000 Kč na komplexní onkologickou preventivní prohlídku",
              "sk": "Až 4 000 Kč na komplexní onkologickou preventivní prehlídku",
              "en": "Up to CZK 4 000 for comprehensive preventive cancer screening."
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na komplexní onkologickou preventivní prohlídku absolvovanou v některém z Komplexních onkologických center. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na komplexní onkologickou preventivní prehlídku absolvovanou v některém z Komplexních onkologických center. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 towards a comprehensive oncological preventive examination performed at one of the Comprehensive Oncology Centers. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Geny213",
              "sk": "Geny213",
              "en": "Genes213 "
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 4 000 Kč na plánované těhotenství partnerky",
              "sk": "Až 4 000 Kč na plánované těhotenství partnerky",
              "en": "Up to CZK 4 000 for planned pregnancy"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na úhradu vyšetření nejčastějších mutací v 5 genech (cystická fibróza, spinální muskulární atrofie, vrozená hluchota, fenylketonurie, syndrom lomivého-fragilního X chromozomu) pro klienty, kteří plánují rodičovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na úhradu vyšetření nečastějších mutací v 5 genech (cystická fibróza, spinální muskulární atrofie, vrozená hluchota, fenylketonurie, syndrom lomivého-fragilního X chromozomu) pre klienty, kteří plánují rodičovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 towards the cost of testing for the most common mutations in five genes (cystic fibrosis, spinal muscular atrophy, congenital deafness, phenylketonuria, fragile X syndrome) for clients who are planning to have children. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Psychohygiena-Mojra\n\n",
              "sk": "Psychohygiena-Mojra\n\n",
              "en": "Mental Hygiene - Mojra"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 5 000 Kč na on-line psychologickou pomoc",
              "sk": "Až 5 000 Kč na on-line psychologickou pomoc",
              "en": "Up to CZK 5 000 for online psychological help"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč pojištěncům na online psychologickou pomoc psychologů a psychoterapeutů a je poskytován v maximální výši 5 000 Kč/rok. Konzultace jsou pojištěncům nabízeny v 30 min. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč pojištěncům na online psychologickou pomoc psychologů a psychoterapeutů a je poskytovaný v maximální výši 5 000 Kč/rok. Konzultace jsou pojištěncům nabízeny v 30 min. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to insured persons for online psychological assistance from psychologists and psychotherapists, up to a maximum of CZK 5 000 per year. Consultations are offered to insured persons in 30-minute sessions. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Duševní pohoda",
              "sk": "Duševní pohoda",
              "en": "Mental well-being"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 5 000 Kč na duševní pohodu",
              "sk": "Až 5 000 Kč na duševní pohodu",
              "en": "Up to CZK 5 000 for mental well-being"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč pojištěncům na odbornou terapeutickou pomoc v náročných životních situacích (stres, trauma, konflikty). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč pojištěncům na odbornou terapeutickou pomoc v náročných životních situacích (stres, trauma, konflikty). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to our clients for professional therapeutic assistance in difficult life situations (stress, trauma, conflicts). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Dárci krve a kostní dřeně",
              "sk": "Dárci krve a kostní drene",
              "en": "Blood and bone marrow donors"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 6 500 Kč dárcům krve a kostní dřeně",
              "sk": "Až 6 500 Kč dárcům krve a kostní dřeně",
              "en": "Up to CZK 6 500 for blood and bone marrow donors"
            },
            "description": {
              "cs": "Chcete pomáhat a zachraňovat život? Nebo tak již činíte a patříte mezi dárce krve a kostní dřeně? I vy můžete získat bonusové příspěvky za bezplatné dárcovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Chcete pomáhat a zachraňovat život? Nebo tak již činíte a patříte mezi dárce krve a kostní dřeně? I vy můžete získat bonusové příspěvky za bezplatné dárcovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you want to help and save lives? Or are you already doing so and are a blood and/or bone marrow donor? You too can obtain bonus contributions if you donate for free. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Lázeňský pobyt pro chronicky nemocné ",
              "sk": "Lázeňský pobyt pre chronicky nemocné",
              "en": "Spa stays for the chronically ill"
            },
            "icon": "payment",
            "benefit": {
              "cs": "Až 10 000 Kč na lázeňský pobyt pro chronicky nemocné ",
              "sk": "Až 10 000 Kč na lázeňský pobyt pre chronicky nemocné",
              "en": "Up to CZK 10 000 for a spa stay for the chronically ill"
            },
            "description": {
              "cs": "Přispíváme až 10 000 Kč na lázeňský pobyt, který je určen pro chronicky nemocné (pojištěnci s DM 1. typu, DM 2. typu nebo hypertenzí a současně s BMI nad 30), kteří v době podání žádosti dosáhnou věku minimálně 19 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 10 000 Kč na lázeňský pobyt, který je určen pre chronicky nemocné (pojištěnci s DM 1. typu, DM 2. typu alebo hypertenzí a současně s BMI nad 30), kteří v době podání žádosti dosáhnou věku minimálně 19 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 10 000 towards spa stays for chronically ill patients (insured persons with type 1 diabetes, type 2 diabetes or hypertension and a BMI over 30) who are at least 19 years of age at the time of application. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Sleva na cestovní pojištění",
              "sk": "Sleva na cestovní pojištení",
              "en": "Travel insurance discount"
            },
            "icon": "globus",
            "benefit": {
              "cs": "Až 30 % sleva na cestovní pojištění",
              "sk": "Až 30 % sleva na cestovní pojištění",
              "en": "Up to 30% discount on travel insurance"
            },
            "description": {
              "cs": "Pojistěte se na cesty se slevou až 30 %. Cestovní pojištění léčebných výloh v zahraničí s limitem plnění do 100 milionů Kč sjednáte online. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Pojistěte se na cesty se slevou až 30 %. Cestovní pojištění léčebných výloh v zahraničí s limitem plnění do 100 milionů Kč sjednáte online. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Insure yourself for travel with a discount of up to 30%. You can arrange travel insurance for medical expenses abroad with a coverage limit of up to CZK 100 million online. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Plavání v bazénech zdarma nebo se slevou ",
              "sk": "Plavání v bazénech zdarma alebo se slevou",
              "en": "Swimming at pools for free or at a discount"
            },
            "icon": "water",
            "benefit": {
              "cs": "Vstup do vybraných plaveckých bazénů budete mít zdarma nebo za výhodnější cenu.",
              "sk": "Vstup do vybraných plaveckých bazénů budete mít zdarma alebo za výhodnější cenu.",
              "en": "You will have admission to selected swimming pools either for free or at a discount"
            },
            "description": {
              "cs": "Vstup do vybraných bazénů po celé ČR budete mít zdarma nebo se slevou 50%. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Vstup do vybraných bazénů po celé ČR budete mít zdarma alebo se slevou 50%. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "You will have free or 50% discounted admission to selected swimming pools throughout the Czech Republic. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na implantát (věk 60+)",
              "sk": "Príspevok na implantát (vek 60+)",
              "en": "Implant contribution (age 60+)"
            },
            "icon": "tooth",
            "benefit": {
              "cs": "Až 1 000 Kč na úhradu implantátu",
              "sk": "Až 1 000 Kč na úhradu implantátu",
              "en": "Up to CZK 1 000 to pay for the implant"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na úhradu implantátu (nelze uplatnit na zubní náhrady, korunky atd.). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na úhradu implantátu (nelze uplatnit na zubní náhrady, korunky atd.). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to cover the cost of an implant (not applicable to dentures, crowns, etc.). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Hezký úsměv (věk 60+)",
              "sk": "Hezký úsmev (vek 60+)",
              "en": "Nice smile (age 60+)"
            },
            "icon": "tooth",
            "benefit": {
              "cs": "Až 1 000 Kč na nákup fixačních a čisticích prostředků pro celkové zubní náhrady ",
              "sk": "Až 1 000 Kč na nákup fixačních a čisticích prestředků pre celkové zubní náhrady",
              "en": "Up to CZK 1 000 for the purchase of fixing and cleaning agents for complete dentures "
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na nákup fixačních a čisticích prostředků pro celkové zubní náhrady v lékárnách a úhradu doplatků na celkové zubní náhrady i jejich opravy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na nákup fixačních a čisticích prestředků pre celkové zubní náhrady v lékárnách a úhradu doplatků na celkové zubní náhrady i jejich opravy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for the purchase of fixing and cleaning agents for complete dentures in pharmacies and reimbursement of additional payments for complete dentures and their repairs. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Dentální hygiena (věk 60+)",
              "sk": "Dentálne hygiena (vek 60+)",
              "en": "Dental hygiene (age 60+)"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 700 Kč na dentální hygienu",
              "sk": "Až 700 Kč na dentálne hygienu",
              "en": "Up to CZK 700 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na dentální hygienu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na dentálne hygienu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 for dental Hygiene. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Lepší paměť (věk 60+)",
              "sk": "Lepší pameť (vek 60+)",
              "en": "Better memory (age 60+)"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na prevenci poruch duševního zdraví",
              "sk": "Až 500 Kč na prevenci poruch duševního zdraví",
              "en": "Up to CZK 500 for mental health prevention"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na prevenci poruch duševního zdraví (kurzy tréninku paměti, pomůcky pro trénink paměti doporučené Českou alzheimerovskou společností. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na prevenci poruch duševního zdraví (kurzy tréninku paměti, pomůcky pre trénink paměti doporučené Českou alzheimerovskou společností. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to the prevention of mental health disorders (memory training courses, memory training aids recommended by the Czech Alzheimer's Society). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Permanentka na pohybové aktivity",
              "sk": "Permanentka na pohybové aktivity",
              "en": "Season ticket for sports activities"
            },
            "icon": "muscle",
            "benefit": {
              "cs": "Až 500 Kč permanentka na pohybové aktivity",
              "sk": "Až 500 Kč permanentka na pohybové aktivity",
              "en": "Up to CZK 500 for a pass for physical activities"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na permanentku na pohybové aktivity - příspěvek ve výši 50 % z ceny permanentky na plavání v krytých bazénech a fitness tj. spinning, posilovna, aktivní posilovací stroje, jóga, aerobik. Nehradí se solária, masáže, všechny typy tance, judo, karate, kick-box, jednodenní permanentky, permanentky na lyžování apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na permanentku na pohybové aktivity - príspevok ve výši 50 % z ceny permanentky na plavání v krytých bazénech a fitness tj. spinning, posilovna, aktivní posilovací stroje, jóga, aerobik. Nehradí se solária, masáže, všechny typy tance, judo, karate, kick-box, jednodenní permanentky, permanentky na lyžování apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards a pass for physical activities – a contribution of 50% of the price of a pass for swimming in indoor pools and fitness activities, i.e. spinning, gym, active weight training machines, yoga, aerobics. The following are not covered: solariums, massages, all types of dance, judo, karate, kickboxing, one-day passes, ski passes, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Léčivé přípravky (věk 60+)",
              "sk": "Léčivé prípravky (vek 60+)",
              "en": "Medicinal products (age 60+)"
            },
            "icon": "pills",
            "benefit": {
              "cs": "Až 500 Kč na nákup kloubní výživy a vybraných léčivých přípravků při nezhoubném zbytnění prostaty",
              "sk": "Až 500 Kč na nákup kloubní výživy a vybraných léčivých přípravků při nezhoubném zbytnění prestaty",
              "en": "Up to CZK 500 for the purchase of joint supplements and selected medicinal products for benign prostatic hyperplasia"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na nákup kloubní výživy, vitamínů a léčivých přípravků při nezhoubném zbytnění prostaty v lékárnách. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na nákup kloubní výživy, vitamínů a léčivých přípravků při nezhoubném zbytnění prestaty v lékárnách. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards the purchase of joint supplements, vitamins, and medicinal products for benign prostatic hyperplasia at pharmacies. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Ženy",
          "sk": "Ženy",
          "en": "Women"
        },
        "benefits": [
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na kterékoliv preventivní očkování nehrazené z veřejného zdravotního pojištění (např. břišní tyfus, pásový opar, chřipka, klíšťová encefalitida, pneumokokové nákazy, spalničky, vzteklina, meningitida, žloutenka, neštovice atd. včetně očkování pro cestovatele). Nevztahuje se na desenzibilizaci („očkování proti alergii“). Z dokladů musí být patrné druh očkovací látky a datum aplikace očkovací látky. Pro čerpání příspěvku doložte doklad o platbě vakcíny a ofocený očkovací průkaz. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč na kterékoliv preventivní očkovanie nehrazené z veřejného zdravotního pojištění (např. břišní tyfus, pásový opar, chřipka, klíšťová encefalitida, pneumokokové nákazy, spalničky, vzteklina, meningitida, žloutenka, neštovice atd. včetně očkovanie pre cestovatele). Nevztahuje se na desenzibilizaci („očkovanie preti alergii“). Z dokladů musí být patrné druh očkovací látky a datum aplikace očkovací látky. Pro čerpání příspěvku doložte doklad o platbě vakcíny a ofocený očkovací průkaz. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards any preventive vaccination not covered by public health insurance (e.g., typhoid fever, shingles, influenza, tick-borne encephalitis, pneumococcal disease, measles, rabies, meningitis, hepatitis, chickenpox, etc., including vaccinations for travelers). This does not apply to desensitization (\"allergy vaccination\"). The documents must clearly show the type of vaccine and the date of administration. To claim the contribution, provide proof of payment for the vaccine and a photocopy of the vaccination card. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": "Ženy"
          },
          {
            "type": {
              "cs": "Celiakie",
              "sk": "Celiakie",
              "en": "Celiac disease"
            },
            "icon": "gluten",
            "benefit": {
              "cs": "Až 1 000 Kč na bezlepkovou dietu pro klienty s celiakií ",
              "sk": "Až 1 000 Kč na bezlepkovou dietu pre klienty s celiakií",
              "en": "Up to CZK 1 000 for a gluten-free diet for clients with celiac disease"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na bezlepkovou dietu pro pojištěnce s celiakií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na bezlepkovou dietu pre pojištěnce s celiakií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards a gluten-free diet for insured persons with celiac disease. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Nízkobílkovinná dieta",
              "sk": "Nízkobílkovinná dieta",
              "en": "Low-protein diet"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 1 000 Kč na nízkobílkovinnou dietu",
              "sk": "Až 1 000 Kč na nízkobílkovinnou dietu",
              "en": "Up to CZK 1 000 for a low-protein diet"
            },
            "description": {
              "cs": "Příspíváme až 1 000 Kč na nízkobílkovinnou dietu (fenylketonurie, nemoc javorového sirupu, homocystinurie, isovalerova acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1, poruchy cyklu močoviny). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Příspíváme až 1 000 Kč na nízkobílkovinnou dietu (fenylketonurie, nemoc javorového sirupu, homocystinurie, isovalerova acidurie, prepionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1, poruchy cyklu močoviny). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for a low-protein diet (phenylketonuria, maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na paruky - Alopecie ",
              "sk": "Príspevok na paruky - Alopecie",
              "en": "Contribution for wigs - Alopecia"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 1 000 Kč na paruku pro klienty s alopecií",
              "sk": "Až 1 000 Kč na paruku pre klienty s alopecií",
              "en": "Up to CZK 1 000 for a wig for clients with alopecia"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pro klienty s alopecií na nákup paruky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pre klienty s alopecií na nákup paruky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for clients with alopecia to purchase a wig. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Diabetici ",
              "sk": "Diabetici",
              "en": "Diabetics"
            },
            "icon": "stamp",
            "benefit": {
              "cs": "Až 1 000 Kč pro klienty s diabetem ",
              "sk": "Až 1 000 Kč pre klienty s diabetem",
              "en": "Up to CZK 1 000 for clients with diabetes"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč klientům s diabetem na nákup permanentky na pohybové aktivity (50 % z ceny), testovacích proužků pro zjištění glukózy v moči, glukometru, diagnostických proužků a příslušenství k inzulínové pumpě, nákupu senzoru pro neinvazivní okamžité měření glukózy v krvi, prostředky pro lepší fixaci senzorů (tejpy, samodržící obinadla) a na podiatrické ošetření (přístrojová pedikúra) provedené u poskytovatelů uvedených na stránkách České podiatrické společnosti, České podologické společnosti a Asociace profesionálních pedikérů a pedikérek. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč klientům s diabetem na nákup permanentky na pohybové aktivity (50 % z ceny), testovacích preužků pre zjištění glukózy v moči, glukometru, diagnostických preužků a příslušenství k inzulínové pumpě, nákupu senzoru pre neinvazivní okamžité měření glukózy v krvi, prestředky pre lepší fixaci senzorů (tejpy, samodržící obinadla) a na podiatrické ošetření (přístrojová pedikúra) prevedené u poskytovatelů uvedených na stránkách České podiatrické společnosti, České podologické společnosti a Asociace prefesionálních pedikérů a pedikérek. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1,000 to clients with diabetes for the purchase of a season ticket for physical activities (50% of the price), test strips for detecting glucose in urine, a glucometer, diagnostic strips and accessories for an insulin pump, the purchase of a sensor for non-invasive immediate blood glucose measurement, products for better sensor fixation (tapes, self-adhesive bandages), and podiatric treatment (machine pedicure) performed by providers listed on the websites of the Czech Podiatric Society, the Czech Podological Society, and the Association of Professional Pedicurists. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Kryokomora",
              "sk": "Kryokomora",
              "en": "Cryochamber"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 700 Kč na návštěvu kryokomory",
              "sk": "Až 700 Kč na návštěvu kryokomory",
              "en": "Up to CZK 700 for a visit to the cryochamber"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč pojištěncům na návštěvu kryokomory pro posílení imunitního systému a regeneraci vašeho těla. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč pojištěncům na návštěvu kryokomory pre posílení imunitního systému a regeneraci vašeho těla. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to insured persons for visits to a cryochamber to strengthen the immune system and regenerate your body. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Sauna",
              "sk": "Sauna",
              "en": "Sauna "
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 700 Kč na saunu",
              "sk": "Až 700 Kč na saunu",
              "en": "Up to CZK 700 for sauna use"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na saunování v obdobích leden - duben a září - prosinec. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na saunování v obdobích leden - duben a září - presinec. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 for sauna use during the periods January–April and September–December. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Uživatelé MY213",
              "sk": "Uživatelé MY213",
              "en": "Users of MY213"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 700 Kč pro pojištěnce, kteří aktivně využívají aplikaci my213",
              "sk": "Až 700 Kč pre pojištěnce, kteří aktivně využívají aplikaci my213",
              "en": "Up to CZK 700 for insured persons who actively use the my213 app"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč pro naše pojištěnce, kteří aktivně využívají aplikaci my213 a žádost o úhradu preventivní péče z balíčku „Uživatelé my213“ podali výhradně jejím prostřednictvím nabízíme: permanentka na pohybové aktivity, diagnostické vyšetření nebo ošetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč pre naše pojištěnce, kteří aktivně využívají aplikaci my213 a žádost o úhradu preventivní péče z balíčku „Uživatelé my213“ podali výhradně jejím prestřednictvím nabízíme: permanentka na pohybové aktivity, diagnostické vyšetření alebo ošetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to our clients who are actively using the my213 app and have submitted a request for reimbursement of preventive care from the \"my213 Users\" package exclusively through the app, we offer: season tickets for physical activities, diagnostic examinations or treatments and more. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro registrované sportovce",
              "sk": "Príspevok pre registrované sportovce",
              "en": "Contribution for registered athletes"
            },
            "icon": "sport",
            "benefit": {
              "cs": "Až 500 Kč pro registrované sportovce",
              "sk": "Až 500 Kč pre registrované sportovce",
              "en": "Up to CZK 500 for registered athletes"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na sportovní prohlídku nebo registrační a členské poplatky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na športové prehlídku alebo registrační a členské poplatky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to pay for a regular sports check-up or registration and membership fees. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na speciální vyšetření",
              "sk": "Príspevok na speciální vyšetrení",
              "en": "Contribution for a special examination"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na speciální vyšetření",
              "sk": "Až 500 Kč na speciální vyšetření",
              "en": "Up to CZK 500 for a special examination"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na speciální vyšetření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na speciální vyšetření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for a special examination. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykání kourení",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 500 Kč na odvykání kouření",
              "sk": "Až 500 Kč na odvykání kouření",
              "en": "Up to CZK 500 for smoking cessation"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na nákup volně prodejných léčivých a podpůrných přípravků, zakoupených v lékárně: náplastí, pastilek, ústního spreje, žvýkaček apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 500 Kč na nákup volně predejných léčivých a podpůrných přípravků, zakoupených v lékárně: náplastí, pastilek, ústního spreje, žvýkaček apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for the purchase of over-the-counter medicinal and supportive products purchased in a pharmacy: adhesive strips, lozenges, oral sprays, chewing gum, etc.\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Osteoporóza a menopauza",
              "sk": "Osteoporóza a menopauza",
              "en": "Osteoporosis and menopause"
            },
            "icon": "pill",
            "benefit": {
              "cs": "Až 500 Kč na přípravky na osteoporózu a menopauzu",
              "sk": "Až 500 Kč na přípravky na osteoporózu a menopauzu",
              "en": "Up to CZK 500 for osteoporosis and menopause products"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč ženám nad 40 let na nákup vybraných hormonálních přípravků a nehormonálních přípravků na prevenci osteoporózy a negativních menopauzálních stavů, a to zakoupených pouze v lékárně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 500 Kč ženám nad 40 let na nákup vybraných hormonálních přípravků a nehormonálních přípravků na prevenci osteoporózy a negativních menopauzálních stavů, a to zakoupených pouze v lékárně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to women over 40 for the purchase of selected hormonal and non-hormonal preparations for the prevention of osteoporosis and negative menopausal symptoms, purchased only in pharmacies. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Po porodu",
              "sk": "Po porodu",
              "en": "Post-childbirth "
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 1 000 Kč na pomůcky po porodu",
              "sk": "Až 1 000 Kč na pomůcky po porodu",
              "en": "Up to CZK 1 000 for products after childbirth"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na nákup pomůcek ke kojení do 1 roku po porodu (zakoupených v lékárně nebo speciální prodejně s kojícími potřebami lze uplatnit na nákup absorpční prsní vložky a speciální podprsenky včetně vložek do nich, chrániče a formovače bradavek, kojící kloboučky a polštářky, odsávačky mateřského mléka, nádoby na uchování mateřského mléka, ohřívačky a sterilizátory). Nákup hygienických vložek s obsahem nanostříbra. Cvičení pro ženy do 6 měsíců po porodu. Tento bonus mohou získat i ženy mladší 18 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na nákup pomůcek ke kojení do 1 roku po porodu (zakoupených v lékárně alebo speciální predejně s kojícími potřebami lze uplatnit na nákup absorpční prsní vložky a speciální podprsenky včetně vložek do nich, chrániče a formovače bradavek, kojící kloboučky a polštářky, odsávačky mateřského mléka, nádoby na uchování mateřského mléka, ohřívačky a sterilizátory). Nákup hygienických vložek s obsahem nanostříbra. Cvičení pre ženy do 6 měsíců po porodu. Tento bonus mohou získat i ženy mladší 18 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards the purchase of breastfeeding aids within one year of giving birth (purchased at a pharmacy or specialist breastfeeding store, this can be used to buy absorbent breast pads and special bras including pads, nipple protectors and formers, nursing caps and pillows, breast pumps, breast milk storage containers, warmers, and sterilizers). Purchase of sanitary pads containing nanosilver. Exercise for women up to 6 months after giving birth. Women under the age of 18 are also eligible for this bonus. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Pro těhotné",
              "sk": "Pre tehotné",
              "en": "For pregnant women"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 1 000 Kč pro těhotné",
              "sk": "Až 1 000 Kč pre těhotné",
              "en": "Up to CZK 1 000 for pregnant women"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na kurz psychoprofylaxe a těhotenského tělocviku, tj. přípravy ženy k porodu, na nákup vitamínů v lékárnách v době těhotenství, a další. Příspěvek mohou získat i ženy mladší 18 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč na kurz psychoprefylaxe a těhotenského tělocviku, tj. přípravy ženy k porodu, na nákup vitamínů v lékárnách v době těhotenství, a další. Príspevok mohou získat i ženy mladší 18 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards psychoprophylaxis and prenatal exercise classes, i.e. preparing women for childbirth, purchasing vitamins from pharmacies during pregnancy, and more. Women under the age of 18 are also eligible for this contribution. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Pro vícerčata",
              "sk": "Pre vícerčata",
              "en": "For multiples"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 1213 Kč pro vícerčata",
              "sk": "Až 1213 Kč pre vícerčata",
              "en": "Up to CZK 1213 for multiples"
            },
            "description": {
              "cs": "Přispíváme až 1 213 Kč maminkám vícerčat. Čerpát můžete pro každé dítě na kterýkoli preventivních programů/finančních příspěvků určených pro děti a mládež do 18 let. Bonus získáte kdykoli od narození vícerčat do jejich 18 roku věku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 213 Kč maminkám vícerčat. Čerpát můžete pre každé dítě na kterýkoli preventivních pregramů/finančních příspěvků určených pre děti a mládež do 18 let. Bonus získáte kdykoli od narození vícerčat do jejich 18 roku věku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 213 to mothers of multiples. You can use this for any preventive programs/financial contributions intended for children and young people under the age of 18. You will receive the bonus at any time from the birth of the multiples until they reach the age of 18. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Bonus 90+",
              "sk": "Bonus 90+",
              "en": "Bonus 90+"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 1 500 Kč pro věrné pojištěnce 90+",
              "sk": "Až 1 500 Kč pre věrné pojištěnce 90+",
              "en": "Up to CZK 1 500 for loyal insured 90+"
            },
            "description": {
              "cs": "Pokud věnujete svému zdraví náležitou péči a jste věrnými pojištěnci RBP, dokážeme to ocenit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Pokud věnujete svému zdraví náležitou péči a jste věrnými pojištěnci RBP, dokážeme to ocenit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "If you take proper care of your health and are a loyal RBP insured, we can appreciate it. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na paruku pro onkologické pacienty",
              "sk": "Príspevok na paruku pre onkologické pacienty",
              "en": "Wig contribution for oncology patients"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 3 000 Kč na paruku",
              "sk": "Až 3 000 Kč na paruku",
              "en": "Up to CZK 3 000 for a wig"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč na paruky pro pojištěnce muže, kteří podstupují (podstoupili) v rámci onkologického onemocnění léčbu chemoterapií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 3 000 Kč na paruky pre pojištěnce muže, kteří podstupují (podstoupili) v rámci onkologického onemocnění léčbu chemoterapií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 000 towards wigs for insured men who are undergoing (or have undergone) chemotherapy treatment for cancer. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Komplexní onkologická preventivní prohlídka",
              "sk": "Komplexní onkologická preventivní prehlídka",
              "en": "Comprehensive cancer examination"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 4 000 Kč na komplexní onkologickou preventivní prohlídku",
              "sk": "Až 4 000 Kč na komplexní onkologickou preventivní prehlídku",
              "en": "Up to CZK 4 000 for comprehensive preventive cancer screening."
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na komplexní onkologickou preventivní prohlídku absolvovanou v některém z Komplexních onkologických center. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na komplexní onkologickou preventivní prehlídku absolvovanou v některém z Komplexních onkologických center. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 towards a comprehensive oncological preventive examination performed at one of the Comprehensive Oncology Centers. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Geny213 ",
              "sk": "Geny213",
              "en": "Genes213 "
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 4 000 Kč na plánované těhotenství ",
              "sk": "Až 4 000 Kč na plánované těhotenství",
              "en": "Up to CZK 4 000 for planned pregnancy"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na úhradu vyšetření nejčastějších mutací v 5 genech (cystická fibróza, spinální muskulární atrofie, vrozená hluchota, fenylketonurie, syndrom lomivého-fragilního X chromozomu) pro klienty, kteří plánují rodičovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na úhradu vyšetření nečastějších mutací v 5 genech (cystická fibróza, spinální muskulární atrofie, vrozená hluchota, fenylketonurie, syndrom lomivého-fragilního X chromozomu) pre klienty, kteří plánují rodičovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 towards the cost of testing for the most common mutations in five genes (cystic fibrosis, spinal muscular atrophy, congenital deafness, phenylketonuria, fragile X syndrome) for clients who are planning to have children. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování proti HPV ",
              "sk": "Očkovanie preti HPV",
              "en": "HPV vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 4 000 Kč na očkování proti HPV",
              "sk": "Až 4 000 Kč na očkovanie preti HPV",
              "en": "Up to CZK 4 000 for HPV vaccination"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč ženám do 30 let věku na očkování proti lidskému papilomaviru (prevence proti rakovině děložního čípku, genitálním bradavicím a análnímu karcinomu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč ženám do 30 let věku na očkovanie preti lidskému papilomaviru (prevence preti rakovině děložního čípku, genitálním bradavicím a análnímu karcinomu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 to women under 30 years of age for vaccination against human papillomavirus (prevention against cervical cancer, genital warts, and anal cancer). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Psychohygiena-Mojra\n\n",
              "sk": "Psychohygiena-Mojra\n\n",
              "en": "Mental Hygiene - Mojra"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 5 000 Kč na on-line psychologickou pomoc",
              "sk": "Až 5 000 Kč na on-line psychologickou pomoc",
              "en": "Up to CZK 5 000 for online psychological help"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč pojištěncům na online psychologickou pomoc psychologů a psychoterapeutů a je poskytován v maximální výši 5 000 Kč/rok. Konzultace jsou pojištěncům nabízeny v 30 min. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč pojištěncům na online psychologickou pomoc psychologů a psychoterapeutů a je poskytovaný v maximální výši 5 000 Kč/rok. Konzultace jsou pojištěncům nabízeny v 30 min. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to insured persons for online psychological assistance from psychologists and psychotherapists, up to a maximum of CZK 5 000 per year. Consultations are offered to insured persons in 30-minute sessions. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Duševní pohoda",
              "sk": "Duševní pohoda",
              "en": "Mental well-being"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 5 000 Kč na duševní pohodu",
              "sk": "Až 5 000 Kč na duševní pohodu",
              "en": "Up to CZK 5 000 for mental well-being"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč pojištěncům na odbornou terapeutickou pomoc v náročných životních situacích (stres, trauma, konflikty). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč pojištěncům na odbornou terapeutickou pomoc v náročných životních situacích (stres, trauma, konflikty). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to our clients for professional therapeutic assistance in difficult life situations (stress, trauma, conflicts). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Dárci krve a kostní dřeně",
              "sk": "Dárci krve a kostní drene",
              "en": "Blood and bone marrow donors"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 6 500 Kč dárcům krve a kostní dřeně",
              "sk": "Až 6 500 Kč dárcům krve a kostní dřeně",
              "en": "Up to CZK 6 500 for blood and bone marrow donors"
            },
            "description": {
              "cs": "Chcete pomáhat a zachraňovat život? Nebo tak již činíte a patříte mezi dárce krve a kostní dřeně? I vy můžete získat bonusové příspěvky za bezplatné dárcovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Chcete pomáhat a zachraňovat život? Nebo tak již činíte a patříte mezi dárce krve a kostní dřeně? I vy můžete získat bonusové příspěvky za bezplatné dárcovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you want to help and save lives? Or are you already doing so and are a blood and/or bone marrow donor? You too can obtain bonus contributions if you donate for free. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Lázeňský pobyt pro chronicky nemocné ",
              "sk": "Lázeňský pobyt pre chronicky nemocné",
              "en": "Spa stays for the chronically ill"
            },
            "icon": "payment",
            "benefit": {
              "cs": "Až 10 000 Kč na lázeňský pobyt pro chronicky nemocné ",
              "sk": "Až 10 000 Kč na lázeňský pobyt pre chronicky nemocné",
              "en": "Up to CZK 10 000 for a spa stay for the chronically ill"
            },
            "description": {
              "cs": "Přispíváme až 10 000 Kč na lázeňský pobyt, který je určen pro chronicky nemocné (pojištěnci s DM 1. typu, DM 2. typu nebo hypertenzí a současně s BMI nad 30), kteří v době podání žádosti dosáhnou věku minimálně 19 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 10 000 Kč na lázeňský pobyt, který je určen pre chronicky nemocné (pojištěnci s DM 1. typu, DM 2. typu alebo hypertenzí a současně s BMI nad 30), kteří v době podání žádosti dosáhnou věku minimálně 19 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 10 000 towards spa stays for chronically ill patients (insured persons with type 1 diabetes, type 2 diabetes or hypertension and a BMI over 30) who are at least 19 years of age at the time of application. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Sleva na cestovní pojištění",
              "sk": "Sleva na cestovní pojištení",
              "en": "Travel insurance discount"
            },
            "icon": "globus",
            "benefit": {
              "cs": "Až 30 % sleva na cestovní pojištění",
              "sk": "Až 30 % sleva na cestovní pojištění",
              "en": "Up to 30% discount on travel insurance"
            },
            "description": {
              "cs": "Pojistěte se na cesty se slevou až 30 %. Cestovní pojištění léčebných výloh v zahraničí s limitem plnění do 100 milionů Kč sjednáte online. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Pojistěte se na cesty se slevou až 30 %. Cestovní pojištění léčebných výloh v zahraničí s limitem plnění do 100 milionů Kč sjednáte online. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Insure yourself for travel with a discount of up to 30%. You can arrange travel insurance for medical expenses abroad with a coverage limit of up to CZK 100 million online. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Plavání v bazénech zdarma nebo se slevou ",
              "sk": "Plavání v bazénech zdarma alebo se slevou",
              "en": "Swimming at pools for free or at a discount"
            },
            "icon": "water",
            "benefit": {
              "cs": "Vstup do vybraných plaveckých bazénů budete mít zdarma nebo za výhodnější cenu.",
              "sk": "Vstup do vybraných plaveckých bazénů budete mít zdarma alebo za výhodnější cenu.",
              "en": "You will have admission to selected swimming pools either for free or at a discount"
            },
            "description": {
              "cs": "Vstup do vybraných bazénů po celé ČR budete mít zdarma nebo se slevou 50%. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Vstup do vybraných bazénů po celé ČR budete mít zdarma alebo se slevou 50%. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "You will have free or 50% discounted admission to selected swimming pools throughout the Czech Republic. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na implantát (věk 60+)",
              "sk": "Príspevok na implantát (vek 60+)",
              "en": "Implant contribution (age 60+)"
            },
            "icon": "tooth",
            "benefit": {
              "cs": "Až 1 000 Kč na úhradu implantátu",
              "sk": "Až 1 000 Kč na úhradu implantátu",
              "en": "Up to CZK 1 000 to pay for the implant"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na úhradu implantátu (nelze uplatnit na zubní náhrady, korunky atd.). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na úhradu implantátu (nelze uplatnit na zubní náhrady, korunky atd.). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to cover the cost of an implant (not applicable to dentures, crowns, etc.). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Hezký úsměv (věk 60+)",
              "sk": "Hezký úsmev (vek 60+)",
              "en": "Nice smile (age 60+)"
            },
            "icon": "tooth",
            "benefit": {
              "cs": "Až 1 000 Kč na nákup fixačních a čisticích prostředků pro celkové zubní náhrady ",
              "sk": "Až 1 000 Kč na nákup fixačních a čisticích prestředků pre celkové zubní náhrady",
              "en": "Up to CZK 1 000 for the purchase of fixing and cleaning agents for complete dentures "
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na nákup fixačních a čisticích prostředků pro celkové zubní náhrady v lékárnách a úhradu doplatků na celkové zubní náhrady i jejich opravy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na nákup fixačních a čisticích prestředků pre celkové zubní náhrady v lékárnách a úhradu doplatků na celkové zubní náhrady i jejich opravy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for the purchase of fixing and cleaning agents for complete dentures in pharmacies and reimbursement of additional payments for complete dentures and their repairs. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Dentální hygiena (věk 60+)",
              "sk": "Dentálne hygiena (vek 60+)",
              "en": "Dental hygiene (age 60+)"
            },
            "icon": "brush",
            "benefit": {
              "cs": "Až 700 Kč na dentální hygienu",
              "sk": "Až 700 Kč na dentálne hygienu",
              "en": "Up to CZK 700 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na dentální hygienu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na dentálne hygienu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 for dental Hygiene. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Lepší paměť (věk 60+)",
              "sk": "Lepší pameť (vek 60+)",
              "en": "Better memory (age 60+)"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 Kč na prevenci poruch duševního zdraví",
              "sk": "Až 500 Kč na prevenci poruch duševního zdraví",
              "en": "Up to CZK 500 for mental health prevention"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na prevenci poruch duševního zdraví (kurzy tréninku paměti, pomůcky pro trénink paměti doporučené Českou alzheimerovskou společností. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na prevenci poruch duševního zdraví (kurzy tréninku paměti, pomůcky pre trénink paměti doporučené Českou alzheimerovskou společností. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to the prevention of mental health disorders (memory training courses, memory training aids recommended by the Czech Alzheimer's Society). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Permanentka na pohybové aktivity",
              "sk": "Permanentka na pohybové aktivity",
              "en": "Season ticket for sports activities"
            },
            "icon": "muscle",
            "benefit": {
              "cs": "Až 500 Kč permanentka na pohybové aktivity",
              "sk": "Až 500 Kč permanentka na pohybové aktivity",
              "en": "Up to CZK 500 for a pass for physical activities"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na permanentku na pohybové aktivity - příspěvek ve výši 50 % z ceny permanentky na plavání v krytých bazénech a fitness tj. spinning, posilovna, aktivní posilovací stroje, jóga, aerobik. Nehradí se solária, masáže, všechny typy tance, judo, karate, kick-box, jednodenní permanentky, permanentky na lyžování apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na permanentku na pohybové aktivity - príspevok ve výši 50 % z ceny permanentky na plavání v krytých bazénech a fitness tj. spinning, posilovna, aktivní posilovací stroje, jóga, aerobik. Nehradí se solária, masáže, všechny typy tance, judo, karate, kick-box, jednodenní permanentky, permanentky na lyžování apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards a pass for physical activities – a contribution of 50% of the price of a pass for swimming in indoor pools and fitness activities, i.e. spinning, gym, active weight training machines, yoga, aerobics. The following are not covered: solariums, massages, all types of dance, judo, karate, kickboxing, one-day passes, ski passes, etc. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Léčivé přípravky (věk 60+)",
              "sk": "Léčivé prípravky (vek 60+)",
              "en": "Medicinal products (age 60+)"
            },
            "icon": "pills",
            "benefit": {
              "cs": "Až 500 Kč na nákup kloubní výživy a vybraných léčivých přípravků při nezhoubném zbytnění prostaty",
              "sk": "Až 500 Kč na nákup kloubní výživy a vybraných léčivých přípravků při nezhoubném zbytnění prestaty",
              "en": "Up to CZK 500 for the purchase of joint supplements and selected medicinal products for benign prostatic hyperplasia"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na nákup kloubní výživy, vitamínů a léčivých přípravků při nezhoubném zbytnění prostaty v lékárnách. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na nákup kloubní výživy, vitamínů a léčivých přípravků při nezhoubném zbytnění prestaty v lékárnách. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards the purchase of joint supplements, vitamins, and medicinal products for benign prostatic hyperplasia at pharmacies. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Děti",
          "sk": "Deti",
          "en": "Children"
        },
        "benefits": [
          {
            "type": {
              "cs": "Školka a škola v přírodě",
              "sk": "Školka a škola v prírode",
              "en": "Open-air pre-school and school"
            },
            "icon": "tent",
            "benefit": {
              "cs": "Až 1000 Kč na školky a školy v přírodě",
              "sk": "Až 1000 Kč na školky a školy v přírodě",
              "en": "Up to CZK 1 000 for open-air pre-schools and schools"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč dětem, které absolvují školku a školu až do ukončení povinné školní docházky. Na pobyty organizované školkou a školou mimo letní prázdniny, trvající minimálně 5 dní s noclehem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč dětem, které absolvují školku a školu až do ukončení povinné školní docházky. Na pobyty organizované školkou a školou mimo letní prázdniny, trvající minimálně 5 dní s noclehem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to children who attend kindergarten and school until the end of compulsory education. For stays organized by kindergarten and school outside the summer holidays, lasting at least 5 days with overnight stays. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": "Deti"
          },
          {
            "type": {
              "cs": "Dentální hygiena",
              "sk": "Dentálne hygiena",
              "en": "Dental hygiene"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 1 000 Kč na dentální hygienu",
              "sk": "Až 1 000 Kč na dentálne hygienu",
              "en": "Up to CZK 1 000 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč dětem na provedení dentální hygieny a nelze uplatnit na nákup prostředků dentální hygieny (např. zubní a mezizubní kartáčky nebo dentální nitě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč dětem na prevedení dentálne hygieny a nelze uplatnit na nákup prestředků dentálne hygieny (např. zubní a mezizubní kartáčky alebo dentálne nitě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to children for dental hygiene procedures and cannot be used to purchase dental hygiene products (e.g., toothbrushes, interdental brushes, or dental floss). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování",
              "sk": "Očkovanie",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na kterékoliv preventivní očkování nehrazené z veřejného zdravotního pojištění (např. břišní tyfus, pásový opar, chřipka, klíšťová encefalitida, pneumokokové nákazy, spalničky, vzteklina, meningitida, žloutenka, neštovice atd. včetně očkování pro cestovatele). Nevztahuje se na desenzibilizaci („očkování proti alergii“). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na kterékoliv preventivní očkovanie nehrazené z veřejného zdravotního pojištění (např. břišní tyfus, pásový opar, chřipka, klíšťová encefalitida, pneumokokové nákazy, spalničky, vzteklina, meningitida, žloutenka, neštovice atd. včetně očkovanie pre cestovatele). Nevztahuje se na desenzibilizaci („očkovanie preti alergii“). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards any preventive vaccination not covered by public health insurance (e.g., typhoid fever, shingles, influenza, tick-borne encephalitis, pneumococcal disease, measles, rabies, meningitis, hepatitis, chickenpox, etc., including vaccinations for travelers). This does not apply to desensitization (\"allergy vaccination\"). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Celiakie",
              "sk": "Celiakie",
              "en": "Celiac disease"
            },
            "icon": "gluten",
            "benefit": {
              "cs": "Až 1 000 Kč na bezlepkovou dietu pro klienty s celiakií ",
              "sk": "Až 1 000 Kč na bezlepkovou dietu pre klienty s celiakií",
              "en": "Up to CZK 1 000 for a gluten-free diet for clients with celiac disease"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na bezlepkovou dietu pro pojištěnce s celiakií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na bezlepkovou dietu pre pojištěnce s celiakií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards a gluten-free diet for insured persons with celiac disease. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Nízkobílkovinná dieta",
              "sk": "Nízkobílkovinná dieta",
              "en": "Low-protein diet"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 1 000 Kč na nízkobílkovinnou dietu",
              "sk": "Až 1 000 Kč na nízkobílkovinnou dietu",
              "en": "Up to CZK 1 000 for a low-protein diet"
            },
            "description": {
              "cs": "Příspíváme až 1 000 Kč na nízkobílkovinnou dietu (fenylketonurie, nemoc javorového sirupu, homocystinurie, isovalerova acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1, poruchy cyklu močoviny). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Příspíváme až 1 000 Kč na nízkobílkovinnou dietu (fenylketonurie, nemoc javorového sirupu, homocystinurie, isovalerova acidurie, prepionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1, poruchy cyklu močoviny). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for a low-protein diet (phenylketonuria, maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na paruky - Alopecie ",
              "sk": "Príspevok na paruky - Alopecie",
              "en": "Contribution for wigs - Alopecia"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 1 000 Kč na paruku pro klienty s alopecií",
              "sk": "Až 1 000 Kč na paruku pre klienty s alopecií",
              "en": "Up to CZK 1 000 for a wig for clients with alopecia"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pro klienty s alopecií na nákup paruky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pre klienty s alopecií na nákup paruky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 for clients with alopecia to purchase a wig. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Rovnátka",
              "sk": "Rovnátka",
              "en": "Braces"
            },
            "icon": "braces",
            "benefit": {
              "cs": "Až 1 000 Kč na rovnátka",
              "sk": "Až 1 000 Kč na rovnátka",
              "en": "Up to CZK 1000 for braces"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na zhotovení fixních nebo snímatelných aparátků včetně průběžných úprav a oprav. Příspěvek lze využít jen na výkony, které nejsou hrazeny z veřejného zdravotního pojištění a jsou v souladu se stanoveným léčebným plánem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na zhotovení fixních alebo snímatelných aparátků včetně průběžných úprav a oprav. Príspevok lze využít jen na výkony, které nesou hrazeny z veřejného zdravotního pojištění a jsou v souladu se stanoveným léčebným plánem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards the cost of fixed or removable braces, including ongoing adjustments and repairs. The contribution can only be used for services that are not covered by public health insurance and are in accordance with the specified treatment plan. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Diabetici ",
              "sk": "Diabetici",
              "en": "Diabetics"
            },
            "icon": "stamp",
            "benefit": {
              "cs": "Až 1 000 Kč pro děti s diabetem ",
              "sk": "Až 1 000 Kč pre děti s diabetem",
              "en": "Up to CZK 1 000 for children with diabetes"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč dětem s diabetem na nákup permanentky na pohybové aktivity (50 % z ceny), testovacích proužků pro zjištění glukózy v moči, glukometru, diagnostických proužků a příslušenství k inzulínové pumpě, nákupu senzoru pro neinvazivní okamžité měření glukózy v krvi, prostředky pro lepší fixaci senzorů (tejpy, samodržící obinadla) a na podiatrické ošetření (přístrojová pedikúra) provedené u poskytovatelů uvedených na stránkách České podiatrické společnosti, České podologické společnosti a Asociace profesionálních pedikérů a pedikérek. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč dětem s diabetem na nákup permanentky na pohybové aktivity (50 % z ceny), testovacích preužků pre zjištění glukózy v moči, glukometru, diagnostických preužků a příslušenství k inzulínové pumpě, nákupu senzoru pre neinvazivní okamžité měření glukózy v krvi, prestředky pre lepší fixaci senzorů (tejpy, samodržící obinadla) a na podiatrické ošetření (přístrojová pedikúra) prevedené u poskytovatelů uvedených na stránkách České podiatrické společnosti, České podologické společnosti a Asociace prefesionálních pedikérů a pedikérek. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1,000 to children with diabetes for the purchase of a season ticket for physical activities (50% of the price), test strips for detecting glucose in urine, a glucometer, diagnostic strips and accessories for an insulin pump, the purchase of a sensor for non-invasive immediate blood glucose measurement, products for better sensor fixation (tapes, self-adhesive bandages), and podiatric treatment (machine pedicure) performed by providers listed on the websites of the Czech Podiatric Society, the Czech Podological Society, and the Association of Professional Pedicurists. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Uživatelé MY213",
              "sk": "Uživatelé MY213",
              "en": "Users of MY213"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 1 000 Kč pro pojištěnce, kteří aktivně využívají aplikaci my213",
              "sk": "Až 1 000 Kč pre pojištěnce, kteří aktivně využívají aplikaci my213",
              "en": "Up to CZK 1 000 for insured persons who actively use the my213 app"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč pro naše pojištěnce, kteří aktivně využívají aplikaci my213 a žádost o úhradu preventivní péče z balíčku „Uživatelé my213“ podali výhradně jejím prostřednictvím nabízíme: permanentka na pohybové aktivity, diagnostické vyšetření nebo ošetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč pre naše pojištěnce, kteří aktivně využívají aplikaci my213 a žádost o úhradu preventivní péče z balíčku „Uživatelé my213“ podali výhradně jejím prestřednictvím nabízíme: permanentka na pohybové aktivity, diagnostické vyšetření alebo ošetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 to our clients who are actively using the my213 app and have submitted a request for reimbursement of preventive care from the \"my213 Users\" package exclusively through the app, we offer: season tickets for physical activities, diagnostic examinations or treatments and more. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Sauna",
              "sk": "Sauna",
              "en": "Sauna "
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 700 Kč na saunování pro děti od 3 let",
              "sk": "Až 700 Kč na saunování pre děti od 3 let",
              "en": "Up to CZK 700 for sauna use for children age 3 and above"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč a saunování pro děti od 3 let v obdobích leden - duben a září - prosinec. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč a saunování pre děti od 3 let v obdobích leden - duben a září - presinec. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 and sauna sessions for children aged 3 and above during the periods January–April and September–December. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Kurz plavání",
              "sk": "Kurz plavání",
              "en": "Swimming lessons"
            },
            "icon": "water",
            "benefit": {
              "cs": "Až 500 Kč na plavání",
              "sk": "Až 500 Kč na plavání",
              "en": "Up to CZK 500 for swimming"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na kurz plavání organizovaný školou nebo školkou pro všechny děti až do ukončení povinné školní docházky. Organizovaný kurz plavání pro děti do tří let věku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na kurz plavání organizovaný školou alebo školkou pre všechny děti až do ukončení povinné školní docházky. Organizovaný kurz plavání pre děti do tří let věku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for swimming lessons organized by a school or pre-school for all children until the end of compulsory school attendance. Organized swimming lessons for children up to the age of three. \n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Registrovaní sportovci",
              "sk": "Registrovaní sportovci",
              "en": "Registered athletes"
            },
            "icon": "register",
            "benefit": {
              "cs": "Až 500 Kč pro registrované sportovce",
              "sk": "Až 500 Kč pre registrované sportovce",
              "en": "Up to CZK 500 for registered athletes"
            },
            "description": {
              "cs": "Příspíváme až 500 Kč na pravidelnou sportovní prohlídku nebo registrační a členské poplatky. Preferuje se registrace sportovce u sportovního svazu. Příspěvek lze poskytnout dětem od 3 let věku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Příspíváme až 500 Kč na pravidelnú športové prehlídku alebo registrační a členské poplatky. Preferuje se registrace sportovce u športového svazu. Príspevok lze poskytnout dětem od 3 let věku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for a sports check-up, membership and registration fees.\n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Obezita",
              "sk": "Obezita",
              "en": "Obesity"
            },
            "icon": "weight",
            "benefit": {
              "cs": "Až 500 Kč proti obezitě",
              "sk": "Až 500 Kč preti obezitě",
              "en": "Up to CZK 500 against obesity"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na aktivity v programu STOB. Konzultace snižování nadváhy a obezity u obezitologa, dietologa a nutričního terapeuta (ne výživový poradce). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč na aktivity v pregramu STOB. Konzultace snižování nadváhy a obezity u obezitologa, dietologa a nutričního terapeuta (ne výživový poradce). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 towards activities in the STOB program. Consultations on weight loss and obesity with an obesity specialist, dietitian, and nutrition therapist (not a nutritionist). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Speciální vyšetření",
              "sk": "Speciální vyšetrení",
              "en": "Special examination"
            },
            "icon": "doctor",
            "benefit": {
              "cs": "Až 500 Kč na speciální vyšetření",
              "sk": "Až 500 Kč na speciální vyšetření",
              "en": "Up to CZK 500 for a special examination"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na vyšetření pigmentových změn kůže. Lze uplatnit jednou za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 500 Kč na vyšetření pigmentových změn kůže. Lze uplatnit jednou za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for an examination of skin pigment changes. Can be used once a year. \n More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Trombóza",
              "sk": "Trombóza",
              "en": "Thrombosis"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 500 na vyšetření rizika vzniku trombózy",
              "sk": "Až 500 na vyšetření rizika vzniku trombózy",
              "en": "Up to CZK 500 for diagnosis of thrombosis risk"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč na genetické vyšetření rizika vzniku trombózy ke zjištění mutace v genech. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 500 Kč na genetické vyšetření rizika vzniku trombózy ke zjištění mutace v genech. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 for a genetic diagnosis of the risk of thrombosis based on information regarding gene mutations. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Odlehčená sádrá",
              "sk": "Odlehčená sádrá",
              "en": "Lightweight cast"
            },
            "icon": "osteoporosis",
            "benefit": {
              "cs": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
              "sk": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
              "en": "Up to CZK 1 000 to cover the cost of lightweight and light plaster casts"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na odlehčené a lehké sádry z plastů, pryskyřic a karbonových vláken. Nevztahuje se na fixační ortézy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 1 000 Kč na odlehčené a lehké sádry z plastů, pryskyřic a karbonových vláken. Nevztahuje se na fixační ortézy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards lightweight and light casts made of plastic, resin, and carbon fiber. This does not apply to fixation braces. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Bonus 90+",
              "sk": "Bonus 90+",
              "en": "Bonus 90+"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 1 500 Kč pro věrné pojištěnce 90+",
              "sk": "Až 1 500 Kč pre věrné pojištěnce 90+",
              "en": "Up to CZK 1 500 for loyal insured 90+"
            },
            "description": {
              "cs": "Pokud věnujete svému zdraví náležitou péči a jste věrnými pojištěnci RBP, dokážeme to ocenit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Pokud věnujete svému zdraví náležitou péči a jste věrnými pojištěnci RBP, dokážeme to ocenit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "If you take proper care of your health and are a loyal RBP insured, we can appreciate it. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Letní prázdninový pobyt",
              "sk": "Letní prázdninový pobyt",
              "en": "Contribution for summer camp"
            },
            "icon": "tent",
            "benefit": {
              "cs": "Až 1 500 Kč na letní prázdninový pobyt",
              "sk": "Až 1 500 Kč na letní prázdninový pobyt",
              "en": "Up to CZK 1 500 for summer camp"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč dětem od 3 let až do ukončení základní školní docházky přispějeme na letní prázdninový tábor na území ČR nebo SR. Pro rok 2026 lze uplatnit příspěvek na prázdninový pobyt konaný v období od 1. 7. do 31. 8. 2026. Musí trvat minimálně 7 dní a být organizován školkou, školou, sportovní nebo zájmovou organizací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč dětem od 3 let až do ukončení základní školní docházky přispějeme na letní prázdninový tábor na území ČR alebo SR. Pro rok 2026 lze uplatnit príspevok na prázdninový pobyt konaný v období od 1. 7. do 31. 8. 2026. Musí trvat minimálně 7 dní a být organizován školkou, školou, športové alebo zájmovou organizací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 to children aged 3 and above until they finish elementary school for a summer camp in the Czech Republic or Slovakia. For 2026, the contribution can be used for a holiday stay taking place between July 1 and August 31, 2026. It must last at least 7 days and be organized by a kindergarten, school, sports or interest organization. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Příměstský sportovní tábor",
              "sk": "Prímestský športové tábor",
              "en": "Sports day camp"
            },
            "icon": "tent",
            "benefit": {
              "cs": "Až 1500 Kč na příměstský sportovní tábor",
              "sk": "Až 1500 Kč na příměstský športové tábor",
              "en": "Up to CZK 1 500 for a sports day camp"
            },
            "description": {
              "cs": "Přispíváme až 1 500 Kč dětem od 3 let až do ukončení základní školní docházky přispějeme na letní příměstský sportovně pohybový tábor. Pro rok 2026 lze uplatnit příspěvek na tábor konaný v období od 1. 7. do 31. 8. 2026 Musí trvat minimálně 5 po sobě jdoucích dnů a být organizován školkou, školou, sportovní nebo zájmovou organizací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 500 Kč dětem od 3 let až do ukončení základní školní docházky přispějeme na letní příměstský sportovně pohybový tábor. Pro rok 2026 lze uplatnit príspevok na tábor konaný v období od 1. 7. do 31. 8. 2026 Musí trvat minimálně 5 po sobě jdoucích dnů a být organizován školkou, školou, športové alebo zájmovou organizací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 500 to children aged 3 and above until the end of primary school for a summer sports and exercise camp. For 2026, the contribution can be applied to camps held between July 1 and August 31, 2026. The camp must last at least five consecutive days and be organized by a kindergarten, school, sports club, or hobby organization. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Miminka do jednoho roku",
              "sk": "Miminka do jednoho roku",
              "en": "Babies up to age one"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 2 000 Kč pro miminka do jednoho roku",
              "sk": "Až 2 000 Kč pre miminka do jednoho roku",
              "en": "Up to CZK 2 000 for babies up to the age of one year"
            },
            "description": {
              "cs": "Příspíváme až 2 000 Kč na nákup monitoru dechu pro děti do 6 měsíců věku (lze využít i na pronájem), pomůcek a potřeb určených pro vlastní potřebu miminka zakoupených v lékárnách - kojenecká mléka (nákup možný i u výrobce), dětské pleny, vlhčené ubrousky, probiotika, kapky proti nadýmání, krémy proti opruzeninám, pudry, vitamín D dle Seznamu přípravků do 1 roku věku, chůviček a kojeneckých potřeb - odsávačky hlenů a sterilizátor lahví. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Příspíváme až 2 000 Kč na nákup monitoru dechu pre děti do 6 měsíců věku (lze využít i na prenájem), pomůcek a potřeb určených pre vlastní potřebu miminka zakoupených v lékárnách - kojenecká mléka (nákup možný i u výrobce), dětské pleny, vlhčené ubrousky, prebiotika, kapky preti nadýmání, krémy preti opruzeninám, pudry, vitamín D dle Seznamu přípravků do 1 roku věku, chůviček a kojeneckých potřeb - odsávačky hlenů a sterilizátor lahví. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 towards the purchase of a breathing monitor for children under 6 months of age (can also be used for rental), aids and supplies for the baby's own use purchased in pharmacies - infant formula (can also be purchased from the manufacturer), baby diapers, wet wipes, probiotics, drops for flatulence, diaper rash creams, powders, vitamin D according to the List of Products for Children Under 1 Year of Age, baby monitors, and baby supplies—mucus extractors and bottle sterilizers. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Pro onkologické pacienty",
              "sk": "Pre onkologické pacienty",
              "en": "For cancer patients"
            },
            "icon": "ribbon",
            "benefit": {
              "cs": "Až 3 000 Kč pro onkologické pacienty",
              "sk": "Až 3 000 Kč pre onkologické pacientov",
              "en": "Up to CZK 3 000 for cancer patients"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč na paruky pro děti a mládež, kteří podstupují (podstoupili) léčbu chemoterapií, příspěvek na mammární epitézu pro dívky po operačním odstranění prsu z důvodu nádorového onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 3 000 Kč na paruky pre děti a mládež, kteří podstupují (podstoupili) léčbu chemoterapií, príspevok na mammární epitézu pre dívky po operačním odstranění prsu z důvodu nádorového onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 000 towards wigs for children and young people undergoing (or who have undergone) chemotherapy treatment, and towards breast prostheses for girls who have undergone breast removal surgery due to cancer. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování proti HPV",
              "sk": "Očkovanie preti HPV",
              "en": "HPV vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 4 000 Kč na očkování proti HPV",
              "sk": "Až 4 000 Kč na očkovanie preti HPV",
              "en": "Up to CZK 4 000 for vaccination against HPV"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč dívkám od 15 let (prevence proti rakovině děložního čípku, genitálním bradavicím a análnímu karcinomu) a pro chlapce od 15 let (prevence proti genitálním bradavicím a análnímu karcinomu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "sk": "Přispíváme až 4 000 Kč dívkám od 15 let (prevence preti rakovině děložního čípku, genitálním bradavicím a análnímu karcinomu) a pre chlapce od 15 let (prevence preti genitálním bradavicím a análnímu karcinomu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "en": "We contribute up to CZK 4 000 to girls aged 15 and over (prevention of cervical cancer, genital warts, and anal cancer) and boys aged 15 and over (prevention of genital warts and anal cancer). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Psychohygiena-Mojra",
              "sk": "Psychohygiena-Mojra",
              "en": "Mental Hygiene - Mojra"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 5 000 Kč na on-line psychologickou pomoc",
              "sk": "Až 5 000 Kč na on-line psychologickou pomoc",
              "en": "Up to CZK 5 000 for online psychological help"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč pojištěncům od 7 let na online psychologickou pomoc psychologů a psychoterapeutů a je poskytován v maximální výši 5 000 Kč/rok. Konzultace jsou pojištěncům nabízeny v 30 min. intervalech v objednaném počtu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč pojištěncům od 7 let na online psychologickou pomoc psychologů a psychoterapeutů a je poskytovaný v maximální výši 5 000 Kč/rok. Konzultace jsou pojištěncům nabízeny v 30 min. intervalech v objednaném počtu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to insured persons aged 7 and above for online psychological assistance from psychologists and psychotherapists, up to a maximum of CZK 5 000 per year. Consultations are offered to insured persons in 30-minute intervals in the agreed number. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Duševní pohoda",
              "sk": "Duševní pohoda",
              "en": "Mental well-being"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 5 000 Kč na duševní pohodu",
              "sk": "Až 5 000 Kč na duševní pohodu",
              "en": "Up to CZK 5 000 for mental well-being"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč pojištěncům od 7 let na odbornou terapeutickou pomoc ve svízelných životních situacích po prožitém stresu, traumatu a nevyřešených konfliktech, které komplikují kvalitu života, mezilidské vztahy a harmonické soužití každého z nás, absolvovanou u klinického psychologa (odbornost 901), kterého je možné si ověřit v registru poskytovatelů zdravotních služeb zde nebo terapeuta, který je členem ČAP. U ostatních neuvedených specialistů - psychoterapeutů bude vyžadováno prokázání absolvování psychoterapeutického výcviku a nárok na příspěvek bude posuzován individuálně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč pojištěncům od 7 let na odbornou terapeutickou pomoc ve svízelných životních situacích po prežitém stresu, traumatu a nevyřešených konfliktech, které komplikují kvalitu života, mezilidské vztahy a harmonické soužití každého z nás, absolvovanou u klinického psychologa (odbornost 901), kterého je možné si ověřit v registru poskytovatelů zdravotních služeb zde alebo terapeuta, který je členem ČAP. U ostatních neuvedených specialistů - psychoterapeutů bude vyžadováno prekázání absolvování psychoterapeutického výcviku a nárok na príspevok bude posuzován individuálně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to insured persons aged 7 and over for professional therapeutic assistance in difficult life situations following stress, trauma, and unresolved conflicts that complicate the quality of life, interpersonal relationships, and harmonious coexistence of each of us, provided by a clinical psychologist (specialization 901), who can be verified in the register of healthcare providers here, or a therapist who is a member of the Czech Association of Psychotherapists (ČAP). For other specialists not listed - psychotherapists - proof of completion of psychotherapy training will be required and eligibility for the contribution will be assessed on an individual basis. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Lázeňský ozdravný pobyt",
              "sk": "Lázeňský ozdravný pobyt",
              "en": "Recuperative spa retreat"
            },
            "icon": "payment",
            "benefit": {
              "cs": "Až 10 000 Kč na lázeňský ozdravný pobyt",
              "sk": "Až 10 000 Kč na lázeňský ozdravný pobyt",
              "en": "Up to CZK 10 000 for a recuperative spa retreat"
            },
            "description": {
              "cs": "Přispíváme až 10 000 Kč dětem ve věku 6 až 15 let s onemocněním horních cest dýchacích, alergiemi a dermatózami. Jde o příspěvek na 14 denní ozdravný lázeňský pobyt. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "sk": "Přispíváme až 10 000 Kč dětem ve věku 6 až 15 let s onemocněním horních cest dýchacích, alergiemi a dermatózami. Jde o príspevok na 14 denní ozdravný lázeňský pobyt. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "en": "We contribute up to CZK 10 000 to children aged 6 to 15 with upper respiratory tract diseases, allergies, and dermatoses. This contribution is for a 14-day therapeutic spa stay. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Přímořský ozdravný pobyt",
              "sk": "Prímorský ozdravný pobyt",
              "en": "Seaside recuperative retreat"
            },
            "icon": "payment",
            "benefit": {
              "cs": "Až 10 000 Kč na přímořský ozdravný pobyt",
              "sk": "Až 10 000 Kč na přímořský ozdravný pobyt",
              "en": "Up to CZK 10 000 for a seaside recuperative retreat"
            },
            "description": {
              "cs": "Přispíváme až 10 000 Kč dětem ve věku 6 až 15 let s opakujícím se onemocněním horních cest dýchacích, alergiemi a dermatózami. Jde o příspěvek na 15 denní ozdravný přímořský pobyt ve výši maximálně 10 000 Kč. Pobyt může být individuální s cestovní kanceláří nebo organizovaný, např. letní tábor, případně individuální v doprovodu rodičů či blízké rodiny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "sk": "Přispíváme až 10 000 Kč dětem ve věku 6 až 15 let s opakujícím se onemocněním horních cest dýchacích, alergiemi a dermatózami. Jde o príspevok na 15 denní ozdravný přímořský pobyt ve výši maximálně 10 000 Kč. Pobyt může být individuální s cestovní kanceláří alebo organizovaný, např. letní tábor, případně individuální v doprevodu rodičů či blízké rodiny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "en": "We contribute up to CZK 10 000 to children aged 6 to 15 with recurring upper respiratory tract diseases, allergies, and dermatoses. This is a contribution of up to CZK 10 000 for a 15-day seaside health stay. The stay can be individual with a travel agency or organized, e.g., a summer camp, or individual accompanied by parents or close family. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Vysokohorský ozdravný pobyt",
              "sk": "Vysokohorský ozdravný pobyt",
              "en": "Recuperative retreat in the mountains"
            },
            "icon": "payment",
            "benefit": {
              "cs": "Až 10 000 Kč na vysokohorský ozdravný pobyt",
              "sk": "Až 10 000 Kč na vysokohorský ozdravný pobyt",
              "en": "Up to CZK 10 000 for a recuperative retreat in the mountains"
            },
            "description": {
              "cs": "Přispíváme až 10 000 Kč dětem ve věku 6 až 15 let s opakujícími se recidivujícími onemocněními horních cest dýchacích a alergiemi. Pobyty jsou primárně určeny pro děti trpící dýchacím onemocněním. Pobyt může být individuální s cestovní kanceláří, nebo organizovaný, např. letní tábor, případně individuální v doprovodu rodičů či blízké osoby. Jde o příspěvek na 14 denní. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "sk": "Přispíváme až 10 000 Kč dětem ve věku 6 až 15 let s opakujícími se recidivujícími onemocněními horních cest dýchacích a alergiemi. Pobyty jsou primárně určeny pre děti trpící dýchacím onemocněním. Pobyt může být individuální s cestovní kanceláří, alebo organizovaný, např. letní tábor, případně individuální v doprevodu rodičů či blízké osoby. Jde o príspevok na 14 denní. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
              "en": "We contribute up to CZK 10 000 to children aged 6 to 15 with recurrent upper respiratory tract diseases and allergies. The stays are primarily intended for children suffering from respiratory diseases. The stay can be individual with a travel agency, or organized, e.g., a summer camp, or individual accompanied by parents or a close person. This is a contribution for 14 days. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Novorozenecký balíček",
              "sk": "Novorozenecký balíček",
              "en": "Newborn package"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Drobnosti pro maminku a dítě ",
              "sk": "Drobnosti pre maminku a dítě",
              "en": "Small gifts for mom and baby"
            },
            "description": {
              "cs": "Drobnosti pro maminku a dítě obdrží rodič jako pozornost při doložení dokladu novorozence na pobočce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Drobnosti pre maminku a dítě obdrží rodič jako pozornost při doložení dokladu novorozence na pobočce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Parents will receive small gifts for mother and child as a token of appreciation upon presenting proof of the newborn's birth at a branch. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Sleva na cestovní pojištění",
              "sk": "Sleva na cestovní pojištení",
              "en": "Travel insurance discount"
            },
            "icon": "globus",
            "benefit": {
              "cs": "Až 30 % sleva na cestovní pojištění",
              "sk": "Až 30 % sleva na cestovní pojištění",
              "en": "Up to 30% discount on travel insurance"
            },
            "description": {
              "cs": "Pojistěte se na cesty se slevou až 30 %. Cestovní pojištění léčebných výloh v zahraničí s limitem plnění do 100 milionů Kč sjednáte online. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Pojistěte se na cesty se slevou až 30 %. Cestovní pojištění léčebných výloh v zahraničí s limitem plnění do 100 milionů Kč sjednáte online. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Insure yourself for travel with a discount of up to 30%. You can arrange travel insurance for medical expenses abroad with a coverage limit of up to CZK 100 million online. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          },
          {
            "type": {
              "cs": "Plavání v bazénech zdarma nebo se slevou ",
              "sk": "Plavání v bazénech zdarma alebo se slevou",
              "en": "Swimming at pools for free or at a discount"
            },
            "icon": "water",
            "benefit": {
              "cs": "Vstup do vybraných plaveckých bazénů budete mít zdarma nebo za výhodnější cenu",
              "sk": "Vstup do vybraných plaveckých bazénů budete mít zdarma alebo za výhodnější cenu",
              "en": "You will have admission to selected swimming pools either for free or at a discount"
            },
            "description": {
              "cs": "Vstup do vybraných bazénů po celé ČR budete mít zdarma nebo se slevou 50%. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Vstup do vybraných bazénů po celé ČR budete mít zdarma alebo se slevou 50%. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "You will have free or 50% discounted admission to selected swimming pools throughout the Czech Republic. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
            "category": null
          }
        ]
      }
    ],
    "updateDate": "29.1.2026",
    "companyBenefitsLink": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
  },
  {
    "slug": "skoda",
    "genders": [
      {
        "name": {
          "cs": "Muži",
          "sk": "Muži",
          "en": "Men"
        },
        "benefits": [
          {
            "type": {
              "cs": "Dentální hygienu",
              "sk": "Dentálne hygienu",
              "en": "Dental hygiene"
            },
            "icon": "tooth-flawed",
            "benefit": {
              "cs": "Až 700 Kč na dentální hygienu",
              "sk": "Až 700 Kč na dentálne hygienu",
              "en": "Up to CZK 700 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na úhradu provedených výkonů dentální hygieny a další stomatologické péče zaplacené nad rámec úhrad ze základního fondu veřejného zdravotního pojištění. (Nevztahuje se na estetické výkony, např. bělení zubů, ozdobné doplňky na zuby apod.) Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na úhradu prevedených výkonů dentálne hygieny a další stomatologické péče zaplacené nad rámec úhrad ze základního fondu veřejného zdravotního pojištění. (Nevztahuje se na estetické výkony, např. bělení zubů, ozdobné doplňky na zuby apod.) Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 towards the cost of dental hygiene and other dental care paid for in excess of the basic public health insurance fund. (This does not apply to cosmetic procedures, such as teeth whitening, decorative dental accessories, etc.)  More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/pece-o-chrup",
            "category": "Muži"
          },
          {
            "type": {
              "cs": "Příspěvek SPORT",
              "sk": "Príspevok SPORT",
              "en": "SPORT contribution"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 700 Kč na pohybové aktivity",
              "sk": "Až 700 Kč na pohybové aktivity",
              "en": "Up to CZK 700 for physical activities"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na pravidelnou sportovní aktivitu včetně plavání a saunování, vyjma FBfit Mladá Boleslav, online kurzů, členských příspěvků a pronájmů sportovišť a aktivit hrazených MultiSport kartou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na pravidelnú športové aktivitu včetně plavání a saunování, vyjma FBfit Mladá Boleslav, online kurzů, členských příspěvků a prenájmů sportovišť a aktivit hrazených MultiSport kartou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 for regular sports activities, including swimming and sauna use, except for FBfit Mladá Boleslav, online courses, membership fees, and sports facility rentals and activities paid for with a MultiSport card. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/sport",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykání kourení",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 1 000 Kč na odvykání kouření",
              "sk": "Až 1 000 Kč na odvykání kouření",
              "en": "Up to CZK 1 000 for smoking cessation"
            },
            "description": {
              "cs": "Přispíváme až 2 x 500 Kč za rok, vždy po ukončení léčby, která probíhá min. 3 měsíce pouze na pracovištích, jejichž seznam naleznete na www.slzt.cz pod Centry pro závislé na tabáku; příspěvek lze proplatit po předložení zprávy o výsledku léčby a prokazatelného dokladu o zaplacení. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 x 500 Kč za rok, vždy po ukončení léčby, ktoré prebíhá min. 3 měsíce pouze na pracovištích, jejichž seznam naleznete na www.slzt.cz pod Centry pre závislé na tabáku; príspevok lze preplatit po předložení zprávy o výsledku léčby a prekazatelného dokladu o zaplacení. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 twice a year, always after completion of treatment lasting at least three months, only at facilities listed at www.slzt.cz under Centers for Tobacco Addiction; the contribution can be reimbursed upon submission of a report on the treatment results and verifiable proof of payment.  More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/odvykani-koureni",
            "category": null
          },
          {
            "type": {
              "cs": "Moderní diagnostické a léčebné metody",
              "sk": "Moderní diagnostické a léčebné metody",
              "en": "Modern diagnostic and treatment methods"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč na různé diagnostické a léčebné metody",
              "sk": "Až 2 000 Kč na rôzne diagnostické a léčebné metody",
              "en": "Up to CZK 2 000 for various diagnostic and treatment methods"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na diagnostické a léčebné metody, např. Operace varixů - Laser, Endoskopická operace karpálního tunelu, Podologické vyšetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na diagnostické a léčebné metody, např. Operace varixů - Laser, Endoskopická operace karpálního tunelu, Podologické vyšetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 toward diagnostic and treatment methods, such as varicose vein surgery (laser), endoscopic carpal tunnel surgery, podiatric examinations, and more. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/mdlm",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora péče duševního zdraví",
              "sk": "Podpora péče duševního zdraví",
              "en": "Mental health care support"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 4 000 Kč na péči o duševní zdraví",
              "sk": "Až 4 000 Kč na péči o duševní zdraví",
              "en": "Up to CZK 4 000 for mental health care"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na absolvování psychologického nebo psychoterapeutického poradenství certifikovaným specialistou v oblasti psychologie/psychoterapie zapsaným v České asociaci pro psychoterapii, mimo výkony hrazené z v. z. p. (včetně online poradenství). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na absolvování psychologického alebo psychoterapeutického poradenství certifikovaným specialistou v oblasti psychologie/psychoterapie zapsaným v České asociaci pre psychoterapii, mimo výkony hrazené z v. z. p. (včetně online poradenství). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 towards psychological or psychotherapeutic counseling provided by a certified specialist in psychology/psychotherapy registered with the Czech Association for Psychotherapy, excluding services covered by health insurance (including online counseling). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/dusevni-zdravi",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora nutričního poradenství",
              "sk": "Podpora nutričního poradenství",
              "en": "Nutritional counselling support"
            },
            "icon": "cabbage",
            "benefit": {
              "cs": "Až 2 000 Kč příspěvek na sestavení jídelníčku ",
              "sk": "Až 2 000 Kč príspevok na sestavení jídelníčku",
              "en": "Up to CZK 2 000 for dietary counselling"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s hodnotou BMI nad 30 nebo pod 18,5, příspěvek na sestavení jídelníčku nutričním terapeutem, obezitologem, diabetologem, praktickým lékařem nebo výživovým poradcem s platným osvědčením o profesní kvalifikaci (možno využít i na program \"Cukrovka bez obalu\"). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s hodnotou BMI nad 30 alebo pod 18,5, príspevok na sestavení jídelníčku nutričním terapeutem, obezitologem, diabetologem, praktickým lékařem alebo výživovým poradcem s platným osvědčením o prefesní kvalifikaci (možno využít i na pregram \"Cukrovka bez obalu\"). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to our clients with a BMI above 30 or below 18.5, a contribution for the preparation of a diet plan by a nutrition therapist, obesity specialist, diabetologist, general practitioner, or nutrition consultant with a valid professional qualification certificate (can also be used for the \"Diabetes Uncovered\" program). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy",
            "category": null
          },
          {
            "type": {
              "cs": "Nízkobílkovinná dieta a další vzácné metabolické poruchy",
              "sk": "Nízkobílkovinná dieta a další vzácné metabolické poruchy",
              "en": "Low-protein diet and other rare metabolic disorders"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 12 000 Kč na nízkobílkovinnou dietu",
              "sk": "Až 12 000 Kč na nízkobílkovinnou dietu",
              "en": "Up to CZK 12 000 for a low-protein diet"
            },
            "description": {
              "cs": "Přispíváme až 12 000 Kč pojištěncům, kteří mají z důvodu metabolického onemocnění indikovanou nízkobílkovinnou dietu, nebo specifickou diagnózu (nemoc javorového sirupu, homocystinurie, isovalerová acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1., poruchy cyklu močoviny). Při prvním čerpání je nutno doložit potvrzení ošetřujícího lékaře, které zdůvodňuje nezbytnost indikace této diety. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 12 000 Kč pojištěncům, kteří mají z důvodu metabolického onemocnění indikovanou nízkobílkovinnou dietu, alebo specifickou diagnózu (nemoc javorového sirupu, homocystinurie, isovalerová acidurie, prepionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1., poruchy cyklu močoviny). Při prvním čerpání je nutno doložit potvrzení ošetřujícího lékaře, které zdůvodňuje nezbytnost indikace této diety. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 12 000 to insured persons who have been prescribed a low-protein diet due to a metabolic disorder or specific diagnosis (maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). When claiming for the first time, it is necessary to provide confirmation from the attending physician justifying the necessity of this diet. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy",
            "category": null
          },
          {
            "type": {
              "cs": "Celiakie",
              "sk": "Celiakie",
              "en": "Celiac disease"
            },
            "icon": "gluten",
            "benefit": {
              "cs": "Až 5 000 Kč na bezlepkovou dietu",
              "sk": "Až 5 000 Kč na bezlepkovou dietu",
              "en": "Up to CZK 5 000 for a gluten-free diet"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč 1 x za rok, na bezlepkovu dietu nad rámec v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč 1 x za rok, na bezlepkovu dietu nad rámec v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 once a year for a gluten-free diet beyond the scope of the health insurance plan. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy",
            "category": null
          },
          {
            "type": {
              "cs": "Korekční laserové operace",
              "sk": "Korekční laserové operace",
              "en": "Corrective laser operations"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 4 000 Kč na laserovou operaci očí",
              "sk": "Až 4 000 Kč na laserovou operaci očí",
              "en": "Up to CZK 4 000 for laser eye operations"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na laserovou operaci očí. 1x za rok. 2 000 Kč na každé oko. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na laserovou operaci očí. 1x za rok. 2 000 Kč na každé oko. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 toward laser eye surgery. Once a year. CZK 2 000 for each eye.. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření přístrojem OCT",
              "sk": "Vyšetrení prístrojem OCT",
              "en": "OCT examination"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 800 Kč na vyšetření očí přístrojem OCT",
              "sk": "Až 800 Kč na vyšetření očí přístrojem OCT",
              "en": "Up to CZK 800 for an OCT eye exam"
            },
            "description": {
              "cs": "Přispíváme až 800 Kč na OCT vyšetření oči. Lze poskytnout 2x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 800 Kč na OCT vyšetření oči. Lze poskytnout 2x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 800 toward OCT eye examinations. Can be provided twice a year. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Nitrooční operace",
              "sk": "Nitrooční operace",
              "en": "Intraocular operations"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 2 000 Kč na operaci očí",
              "sk": "Až 2 000 Kč na operaci očí",
              "en": "Up to CZK 2 000 for eye operation"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na nitrooční operaci s použitím multifokální čočky, čočky s prodlouženým ohniskem, čočky pro korekci astigmatismu nebo nitrooční čočky (1 000 Kč na každé oko). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na nitrooční operaci s použitím multifokální čočky, čočky s predlouženým ohniskem, čočky pre korekci astigmatismu alebo nitrooční čočky (1 000 Kč na každé oko). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 toward intraocular surgery using multifocal lenses, extended focus lenses, lenses for astigmatism correction, or intraocular lenses (CZK 1 000 per eye). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Plastová sádra",
              "sk": "Plastová sádra",
              "en": "Plastic plaster"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 300 Kč na plastovou sádru",
              "sk": "Až 300 Kč na plastovou sádru",
              "en": "Up to CZK 300 for plastic plaster"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč na plastovou sádru. Příspěvek lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč na plastovou sádru. Príspevok lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 towards plastic plaster casts. This contribution can be provided once a year. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek SPORT Senior",
              "sk": "Príspevok SPORT Senior",
              "en": "SPORT Senior contribution"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 700 Kč na pohybové aktivity, pomůcky pro prevenci úrazů při sportu aj.",
              "sk": "Až 700 Kč na pohybové aktivity, pomůcky pre prevenci úrazů při sportu aj.",
              "en": "Up to CZK 700 for physical activities, sports injury prevention equipment, etc."
            },
            "description": {
              "cs": "Přispíváme až 700 Kč seniorům nad 65 let na pohybové aktivity včetně plavání a saunování, přístrojovou pedikúru pro diabetiky, pomůcky pro prevenci úrazů při sportu, hole Nordic Walking, na specifické pomůcky pro trénování paměti a prevenci rozvoje Alzheimerovy choroby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč seniorům nad 65 let na pohybové aktivity včetně plavání a saunování, přístrojovou pedikúru pre diabetiky, pomůcky pre prevenci úrazů při sportu, hole Nordic Walking, na specifické pomůcky pre trénování paměti a prevenci rozvoje Alzheimerovy choroby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to seniors over 65 for physical activities, including swimming and sauna, pedicures for diabetics, aids for preventing sports injuries, Nordic walking poles, specific aids for memory training, and prevention of Alzheimer's disease. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/sport",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování proti pásovému oparu",
              "sk": "Očkovanie preti pásovému oparu",
              "en": "Vaccination against shingles"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 4 000 Kč na očkování protí pásovému oparu",
              "sk": "Až 4 000 Kč na očkovanie pretí pásovému oparu",
              "en": "Up to CZK 4 000 for vaccination against shingles"
            },
            "description": {
              "cs": "Příspíváme až 4 000 Kč na očkování proti pásovému oparu (2 000 Kč na každou dávku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Příspíváme až 4 000 Kč na očkovanie preti pásovému oparu (2 000 Kč na každou dávku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 toward shingles vaccinations (CZK 2 000 per dose). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Balíček ostatních očkování",
              "sk": "Balíček ostatních očkovanie",
              "en": "Package of other vaccinations"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Příspíváme až 1 000 Kč na různá očkování, které nejsou hrazeny z v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Příspíváme až 1 000 Kč na různá očkovanie, které nesou hrazeny z v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards various vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Meningokok",
              "sk": "Meningokok",
              "en": "Meningococcus"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 3 600 Kč na očkování proti meningokoku",
              "sk": "Až 3 600 Kč na očkovanie preti meningokoku",
              "en": "Up to CZK 3 600 for vaccination against meningococus"
            },
            "description": {
              "cs": "Přispíváme až 3 600 Kč na očkování proti meningokoku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 3 600 Kč na očkovanie preti meningokoku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 600 for vaccination against meningococcus. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Hepatitida",
              "sk": "Hepatitida",
              "en": "Hepatitis"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 2 400 Kč na očkování",
              "sk": "Až 2 400 Kč na očkovanie",
              "en": "Up to CZK 2 400 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 2 400 Kč na očkování proti žloutence (hepatitidě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 400 Kč na očkovanie preti žloutence (hepatitidě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 400 for vaccination against hepatitis. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Klíšťová encefalitida",
              "sk": "Klíšťová encefalitida",
              "en": "Tick-borne encephalitis"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 2 100 Kč na očkování",
              "sk": "Až 2 100 Kč na očkovanie",
              "en": "Up to CZK 2 100 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 2 100 Kč na očkování proti klíšťové encefalitidě klientům do 50 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 100 Kč na očkovanie preti klíšťové encefalitidě klientům do 50 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 100 toward tick-borne encephalitis vaccinations for clients under 50 years of age. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Chřipka",
              "sk": "Chripka",
              "en": "Flu"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 400 Kč na očkování",
              "sk": "Až 400 Kč na očkovanie",
              "en": "Up to CZK 400 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 400 Kč na očkování proti chřipce klientům do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme až 400 Kč na očkovanie preti chřipce klientům do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 400 towards flu vaccinations for clients under 65 years of age. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence onemocnění štítné žlázy",
              "sk": "Prevence onemocnení štítné žlázy",
              "en": "Prevention of thyroid disease"
            },
            "icon": "shield-exclamation-marks",
            "benefit": {
              "cs": "Příspěvek 1x za rok",
              "sk": "Príspevok 1x za rok",
              "en": "Annual contribution"
            },
            "description": {
              "cs": "Přispíváme 1x za rok na odběr krve na vyšetření hormonů štítné žlázy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
              "sk": "Přispíváme 1x za rok na odběr krve na vyšetření hormonů štítné žlázy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute once a year to blood tests for thyroid hormone levels."
            },
            "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni",
            "category": null
          },
          {
            "type": {
              "cs": "Program pro zjišťování nádorů v oblasti dutiny břišní a ledvin",
              "sk": "Pregram pre zjišťování nádorú v oblasti dutiny brišní a ledvin",
              "en": "A programme for the detection of tumours in the area of the abdominal cavity and the kidneys"
            },
            "icon": "care",
            "benefit": {
              "cs": "Příspěvek 1x za rok",
              "sk": "Príspevok 1x za rok",
              "en": "Annual contribution"
            },
            "description": {
              "cs": "Přispíváme 1x za rok na preventivní sonografické vyšetření horní a dolní poloviny břicha, program je určen zejména pojištěncům s pozitivní rodinnou onkologickou anamnézou či s rizikem tohoto onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme 1x za rok na preventivní sonografické vyšetření horní a dolní poloviny břicha, pregram je určen zejména pojištěncům s pozitivní rodinnou onkologickou anamnézou či s rizikem tohoto onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute once a year to preventive sonographic examinations of the upper and lower abdomen. The program is intended primarily for insured persons with a positive family history of cancer or at risk of developing this disease. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu tlustého střeva a konečníku",
              "sk": "Prevence karcinomu tlustého streva a konečníku",
              "en": "Colon and anal cancer prevention"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Příspěvek 1x za rok",
              "sk": "Príspevok 1x za rok",
              "en": "Annual contribution"
            },
            "description": {
              "cs": "Přispíváme 1x za rok pojištěncům (od 35 do 45 let), na které se nevztahuje vyšetření na okultní krvácení v rámci preventivní prohlídky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme 1x za rok pojištěncům (od 35 do 45 let), na které se nevztahuje vyšetření na okultní krvácení v rámci preventivní prehlídky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute once a year to insured persons (aged 35 to 45) who are not covered by occult blood testing as part of preventive check-ups. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro onkologicky nemocné nebo jinak závažně nemocné",
              "sk": "Príspevok pre onkologicky nemocné alebo jinak závažne nemocné",
              "en": "Contribution for cancer patients or other seriously ill patients"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 4 000 Kč na paruku, nebo chladící čepici po chemoterapii ",
              "sk": "Až 4 000 Kč na paruku, alebo chladící čepici po chemoterapii",
              "en": "Up to CZK 4 000 for a wig or cooling cap after chemotherapy "
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč pojištěncům, kteří absolvovali aktivní onkologickou léčbu (nebo pro jiné systémové onemocnění) při které došlo ke ztrátě vlasů. Lze 1x za rok čerpat na paruku, nebo chladící čepici po chemoterapii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč pojištěncům, kteří absolvovali aktivní onkologickou léčbu (alebo pre jiné systémové onemocnění) při které došlo ke ztrátě vlasů. Lze 1x za rok čerpat na paruku, alebo chladící čepici po chemoterapii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 to our clients who have undergone active oncological treatment (or treatment for other systemic diseases) resulting in hair loss. This can be used once a year to purchase a wig or cooling cap after chemotherapy."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Cestovní pojištění ZDARMA",
              "sk": "Cestovní pojištení ZDARMA",
              "en": "FREE travel insurance"
            },
            "icon": "briefcase",
            "benefit": {
              "cs": "Cestovní pojištění ZDARMA pro dárce krve s odběrem za posledních 12 měsíců",
              "sk": "Cestovní pojištění ZDARMA pre dárce krve s odběrem za posledních 12 měsíců",
              "en": "FREE travel insurance for blood donors who have donated blood within the last 12 months"
            },
            "description": {
              "cs": "Cestovní pojištění pro dárce krve od našeho partnera VITALITAS pojišťovny a. s. platí na léčebné výlohy, celý svět a na 30 dnů. Podmínkou je kopie průkazu dárce krve s odběrem za posledních 12 měsíců. ",
              "sk": "Cestovní pojištění pre dárce krve od našeho partnera VITALITAS pojišťovny a. s. platí na léčebné výlohy, celý svět a na 30 dnů. Podmínkou je kopie průkazu dárce krve s odběrem za posledních 12 měsíců.",
              "en": "Travel insurance for blood donors from our partner VITALITAS pojišťovna a. s. covers medical expenses worldwide for up to 30 days. A copy of your blood donor card showing donations made within the last 12 months is required. "
            },
            "url": "https://www.zpskoda.cz/pro-darce-krve",
            "category": null
          },
          {
            "type": {
              "cs": "Ozdravný pobyt v ČR pro dárce kostní dřeně a dárce orgánů ",
              "sk": "Ozdravný pobyt v ČR pre dárce kostní drene a dárce orgánú",
              "en": "Recuperative stay in the Czech Republic for bone marrow and organ donors "
            },
            "icon": "tent",
            "benefit": {
              "cs": "Až 10 000 Kč na ozdravný pobyt v některém ze smluvních lázeňských zařízení",
              "sk": "Až 10 000 Kč na ozdravný pobyt v některém ze smluvních lázeňských zařízení",
              "en": "Up to CZK 10 000 for recuperative stays at one of our partner spa facilities"
            },
            "description": {
              "cs": "Přispíváme až 10 000 Kč na ozdravný pobyt dárcům kostní dřeně a dárce životně důležitých orgánů k transplantaci v některém ze smluvních lázeňských zařízení dle výběru a po domluvě s referentem lázeňské péče. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 10 000 Kč na ozdravný pobyt dárcům kostní dřeně a dárce životně důležitých orgánů k transplantaci v některém ze smluvních lázeňských zařízení dle výběru a po domluvě s referentem lázeňské péče. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 10 000 towards a recuperative stay for bone marrow donors and donors of vital organs for transplantation at one of our contracted spa facilities, as selected and agreed with the spa care representative. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/pro-darce-krve",
            "category": null
          },
          {
            "type": {
              "cs": "Pro dárce",
              "sk": "Pre dárce",
              "en": "For donors"
            },
            "icon": "bloodtest",
            "benefit": {
              "cs": "Odměna až 5 000 Kč pro ty, kteří jsou solidární ke zdraví ostatních",
              "sk": "Odměna až 5 000 Kč pre ty, kteří jsou solidární ke zdraví ostatních",
              "en": "Up to CZK 5 000 for those who show solidarity with the health of others"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč dárcům krve, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč dárcům krve, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to blood, bone marrow, and organ donors. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/pro-darce-krve",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Ženy",
          "sk": "Ženy",
          "en": "Women"
        },
        "benefits": [
          {
            "type": {
              "cs": "Dentální hygienu",
              "sk": "Dentálne hygienu",
              "en": "Dental hygiene"
            },
            "icon": "tooth-flawed",
            "benefit": {
              "cs": "Až 700 Kč na dentální hygienu",
              "sk": "Až 700 Kč na dentálne hygienu",
              "en": "Up to CZK 700 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na úhradu provedených výkonů dentální hygieny a další stomatologické péče zaplacené nad rámec úhrad ze základního fondu veřejného zdravotního pojištění. (Nevztahuje se na estetické výkony, např. bělení zubů, ozdobné doplňky na zuby apod.) Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na úhradu prevedených výkonů dentálne hygieny a další stomatologické péče zaplacené nad rámec úhrad ze základního fondu veřejného zdravotního pojištění. (Nevztahuje se na estetické výkony, např. bělení zubů, ozdobné doplňky na zuby apod.) Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 towards the cost of dental hygiene and other dental care paid for in excess of the basic public health insurance fund. (This does not apply to cosmetic procedures, such as teeth whitening, decorative dental accessories, etc.)  More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/pece-o-chrup",
            "category": "Ženy"
          },
          {
            "type": {
              "cs": "Podrobné morfologické vyšetření plodu",
              "sk": "Podrobné morfologické vyšetrení plodu",
              "en": "Detailed morphological examination of the fetus"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 1 000 Kč na vyšetření plodu ve 20. - 22. týdnu gravidity ",
              "sk": "Až 1 000 Kč na vyšetření plodu ve 20. - 22. týdnu gravidity",
              "en": "Up to CZK 1 000 for a fetal examination in the 20th - 22nd week of pregnancy "
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na vyšetření plodu ve 20. - 22. týdnu gravidity - bez doporučení gynekologa. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na vyšetření plodu ve 20. - 22. týdnu gravidity - bez doporučení gynekologa. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards fetal examinations in the 20th to 22nd week of pregnancy – no referral from a gynecologist required. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/maminky-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Novorozenecký balíček",
              "sk": "Novorozenecký balíček",
              "en": "Newborn package"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Novorozenecký balíček v hodnotě 2 500 Kč ",
              "sk": "Novorozenecký balíček v hodnotě 2 500 Kč",
              "en": "Newborn baby package "
            },
            "description": {
              "cs": "Krásný batůžek pro holčičky a kluky naplněný produkty od firmy SKIP HOP (lahvička se silikonovým brčkem, kalíšek na sušenky) a k tomu digitální teploměr Thermoval Baby, to vše v hodnotě 2 500 Kč. Na požádání také zdarma roční úrazové pojištění pro novorozence z programu Zvonek našeho partnera VITALITAS pojišťovna a. s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Krásný batůžek pre holčičky a kluky naplněný predukty od firmy SKIP HOP (lahvička se silikonovým brčkem, kalíšek na sušenky) a k tomu digitální teploměr Thermoval Baby, to vše v hodnotě 2 500 Kč. Na požádání také zdarma roční úrazové pojištění pre novorozence z pregramu Zvonek našeho partnera VITALITAS pojišťovna a. s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A beautiful backpack for girls and boys filled with products from SKIP HOP (bottle with silicone straw, cookie cup) and a Thermoval Baby digital thermometer, all worth CZK 2 500. Upon request, you can also receive free annual accident insurance for newborns from the Zvonek program offered by our partner VITALITAS pojišťovna a. s. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/maminky-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek po porodu",
              "sk": "Príspevok po porodu",
              "en": "After childbirth"
            },
            "icon": "birth",
            "benefit": {
              "cs": "Až 1 600 Kč po porodu",
              "sk": "Až 1 600 Kč po porodu",
              "en": "Up to CZK 1 600 after childbirth"
            },
            "description": {
              "cs": "Příspěvek až 1 600 Kč pro pobyt v porodnici na nadstandardním pokoji, autosedačku, přítomnost blízké osoby u porodu, laktační poradenství a pomůcky (kojící a absorpční podprsenky, kojící polštář..), pleny, vlhčené ubrousky, kojenecké plavání, monitor dechu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok až 1 600 Kč pre pobyt v porodnici na nadstandardním pokoji, autosedačku, přítomnost blízké osoby u porodu, laktační poradenství a pomůcky (kojící a absorpční podprsenky, kojící polštář..), pleny, vlhčené ubrousky, kojenecké plavání, monitor dechu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Contribution of up to CZK 1 600 for a stay in a maternity hospital in a premium room, car seat, presence of a loved one during childbirth, lactation counseling and aids (nursing and absorbent bras, nursing pillow, etc.), diapers, wet wipes, baby swimming, breath monitor. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/maminky-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek v době těhotenství",
              "sk": "Príspevok v dobe tehotenství",
              "en": "Contribution during pregnancy"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 500 Kč na pohybové aktivity, různé produkty, masáže, vitamíny, předporodní kurzy a další ",
              "sk": "Až 500 Kč na pohybové aktivity, rôzne predukty, masáže, vitamíny, předporodní kurzy a další",
              "en": "Up to CZK 500 for physical activities, various products, massages, vitamins, prenatal courses, and more"
            },
            "description": {
              "cs": "Přispíváme až 500 Kč ttěhotným ženám na pohybové aktivity, vitamínové prostředky, doplňky stravy, prostředky proti striím, masáže, prostředky dentální hygieny, na ošetření provedené dentální hygienistkou, sluneční brýle s UV filtrem, ortopedickou obuv a vložky zakoupené v lékárně nebo prodejně zdrav. potřeb, opalovací krémy s UV filtrem, předporodní kurzy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 500 Kč ttěhotným ženám na pohybové aktivity, vitamínové prestředky, doplňky stravy, prestředky preti striím, masáže, prestředky dentálne hygieny, na ošetření prevedené dentálne hygienistkou, sluneční brýle s UV filtrem, ortopedickou obuv a vložky zakoupené v lékárně alebo predejně zdrav. potřeb, opalovací krémy s UV filtrem, předporodní kurzy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 to pregnant women for physical activities, vitamins, dietary supplements, stretch mark prevention products, massages, dental hygiene products, dental hygienist treatments, sunglasses with UV filters, orthopedic shoes and insoles purchased at a pharmacy or medical supply store, sunscreen with UV filters, and prenatal classes. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/maminky-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření štítné žlázy",
              "sk": "Vyšetrení štítné žlázy",
              "en": "Thyroid gland examination during pregnancy"
            },
            "icon": "care",
            "benefit": {
              "cs": "Zcela hrazeno poskytovatelem zdravotních služeb",
              "sk": "Zcela hrazeno poskytovatelem zdravotních služeb",
              "en": "Fully covered by health services providers"
            },
            "description": {
              "cs": "Příspěvek je určen těhotným ženám na vyšetření štítné žlázy a je zcela hrazen poskytovatelem zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok je určen těhotným ženám na vyšetření štítné žlázy a je zcela hrazen poskytovatelem zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "This contribution is intended for pregnant women for thyroid gland examination, and is entirely covered by health services providers. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/maminky-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Neinvazivní prenatální testování",
              "sk": "Neinvazivní prenatální testování",
              "en": "Non-invasive pre-natal testing"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 4 000 Kč na neinvazivní prenatální testování\n",
              "sk": "Až 4 000 Kč na neinvazivní prenatální testování\n",
              "en": "Up to CZK 4 000 for non-invasive pre-natal testing"
            },
            "description": {
              "cs": "Příspěvek je určen na testování (NIPT) v indikovaných případech, po doporučení gynekologa a genetika. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok je určen na testování (NIPT) v indikovaných případech, po doporučení gynekologa a genetika. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "This contribution is for a NIPT in indicated cases upon recommendation by a gynaecologist and geneticist. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/maminky-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Prvotrimestrální screening",
              "sk": "Prvotrimestrální screening",
              "en": "First-trimester screening"
            },
            "icon": "pregnant",
            "benefit": {
              "cs": "Až 1 200 Kč na prvotrimestrální screening ",
              "sk": "Až 1 200 Kč na prvotrimestrální screening",
              "en": "Up to CZK 1 200 for fist-trimester screening"
            },
            "description": {
              "cs": "Přispíváme až 1 200 Kč na prvotrimestrální screening – bez doporučení gynekologa, na specializovaném akreditovaném pracovišti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 200 Kč na prvotrimestrální screening – bez doporučení gynekologa, na specializovaném akreditovaném pracovišti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 200 towards first trimester screening – without a gynecologist's referral, at a specialized accredited facility. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/maminky-deti",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora péče duševního zdraví",
              "sk": "Podpora péče duševního zdraví",
              "en": "Mental health care support"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 4 000 Kč na péči o duševní zdraví",
              "sk": "Až 4 000 Kč na péči o duševní zdraví",
              "en": "Up to CZK 4 000 for mental health care"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na absolvování psychologického nebo psychoterapeutického poradenství certifikovaným specialistou v oblasti psychologie/psychoterapie zapsaným v České asociaci pro psychoterapii, mimo výkony hrazené z v. z. p. (včetně online poradenství). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na absolvování psychologického alebo psychoterapeutického poradenství certifikovaným specialistou v oblasti psychologie/psychoterapie zapsaným v České asociaci pre psychoterapii, mimo výkony hrazené z v. z. p. (včetně online poradenství). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 towards psychological or psychotherapeutic counseling provided by a certified specialist in psychology/psychotherapy registered with the Czech Association for Psychotherapy, excluding services covered by health insurance (including online counseling). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/dusevni-zdravi",
            "category": null
          },
          {
            "type": {
              "cs": "Moderní diagnostické a léčebné metody",
              "sk": "Moderní diagnostické a léčebné metody",
              "en": "Modern diagnostic and treatment methods"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč na různé diagnostické a léčebné metody",
              "sk": "Až 2 000 Kč na rôzne diagnostické a léčebné metody",
              "en": "Up to CZK 2 000 for various diagnostic and treatment methods"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na diagnostické a léčebné metody, např. Operace varixů - Laser, Endoskopická operace karpálního tunelu, Podologické vyšetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na diagnostické a léčebné metody, např. Operace varixů - Laser, Endoskopická operace karpálního tunelu, Podologické vyšetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 toward diagnostic and treatment methods, such as varicose vein surgery (laser), endoscopic carpal tunnel surgery, podiatric examinations, and more. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/mdlm",
            "category": null
          },
          {
            "type": {
              "cs": "Odvykání kouření",
              "sk": "Odvykání kourení",
              "en": "Smoking cessation"
            },
            "icon": "smoke",
            "benefit": {
              "cs": "Až 1 000 Kč na odvykání kouření",
              "sk": "Až 1 000 Kč na odvykání kouření",
              "en": "Up to CZK 1 000 for smoking cessation"
            },
            "description": {
              "cs": "Přispíváme až 2 x 500 Kč za rok, vždy po ukončení léčby, která probíhá min. 3 měsíce pouze na pracovištích, jejichž seznam naleznete na www.slzt.cz pod Centry pro závislé na tabáku; příspěvek lze proplatit po předložení zprávy o výsledku léčby a prokazatelného dokladu o zaplacení. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 x 500 Kč za rok, vždy po ukončení léčby, ktoré prebíhá min. 3 měsíce pouze na pracovištích, jejichž seznam naleznete na www.slzt.cz pod Centry pre závislé na tabáku; príspevok lze preplatit po předložení zprávy o výsledku léčby a prekazatelného dokladu o zaplacení. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 500 twice a year, always after completion of treatment lasting at least three months, only at facilities listed at www.slzt.cz under Centers for Tobacco Addiction; the contribution can be reimbursed upon submission of a report on the treatment results and verifiable proof of payment.  More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/odvykani-koureni",
            "category": null
          },
          {
            "type": {
              "cs": "Korekční laserové operace",
              "sk": "Korekční laserové operace",
              "en": "Corrective laser operations"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 4 000 Kč na laserovou operaci očí",
              "sk": "Až 4 000 Kč na laserovou operaci očí",
              "en": "Up to CZK 4 000 for laser eye operations"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na laserovou operaci očí. 1x za rok. 2 000 Kč na každé oko. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na laserovou operaci očí. 1x za rok. 2 000 Kč na každé oko. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 toward laser eye surgery. Once a year. CZK 2 000 for each eye.. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření přístrojem OCT",
              "sk": "Vyšetrení prístrojem OCT",
              "en": "OCT examination"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 800 Kč na vyšetření očí přístrojem OCT",
              "sk": "Až 800 Kč na vyšetření očí přístrojem OCT",
              "en": "Up to CZK 800 for an OCT eye exam"
            },
            "description": {
              "cs": "Přispíváme až 800 Kč na OCT vyšetření oči. Lze poskytnout 2x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 800 Kč na OCT vyšetření oči. Lze poskytnout 2x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 800 toward OCT eye examinations. Can be provided twice a year. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Nitrooční operace",
              "sk": "Nitrooční operace",
              "en": "Intraocular operations"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 2 000 Kč na operaci očí",
              "sk": "Až 2 000 Kč na operaci očí",
              "en": "Up to CZK 2 000 for eye operation"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na nitrooční operaci s použitím multifokální čočky, čočky s prodlouženým ohniskem, čočky pro korekci astigmatismu nebo nitrooční čočky (1 000 Kč na každé oko). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na nitrooční operaci s použitím multifokální čočky, čočky s predlouženým ohniskem, čočky pre korekci astigmatismu alebo nitrooční čočky (1 000 Kč na každé oko). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 toward intraocular surgery using multifocal lenses, extended focus lenses, lenses for astigmatism correction, or intraocular lenses (CZK 1 000 per eye). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Plastová sádra",
              "sk": "Plastová sádra",
              "en": "Plastic plaster"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 300 Kč na plastovou sádru",
              "sk": "Až 300 Kč na plastovou sádru",
              "en": "Up to CZK 300 for plastic plaster"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč na plastovou sádru. Příspěvek lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč na plastovou sádru. Príspevok lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 towards plastic plaster casts. This contribution can be provided once a year. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro onkologicky nemocné nebo jinak závažně nemocné",
              "sk": "Príspevok pre onkologicky nemocné alebo jinak závažne nemocné",
              "en": "Contribution for cancer patients or other seriously ill patients"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 4 000 Kč na paruku, nebo chladící čepici po chemoterapii",
              "sk": "Až 4 000 Kč na paruku, alebo chladící čepici po chemoterapii",
              "en": "Up to CZK 4 000 for a wig or cooling cap after chemotherapy"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč pojištěncům, kteří absolvovali aktivní onkologickou léčbu (nebo pro jiné systémové onemocnění) při které došlo ke ztrátě vlasů. Lze 1x za rok čerpat na paruku, nebo chladící čepici po chemoterapii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč pojištěncům, kteří absolvovali aktivní onkologickou léčbu (alebo pre jiné systémové onemocnění) při které došlo ke ztrátě vlasů. Lze 1x za rok čerpat na paruku, alebo chladící čepici po chemoterapii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 to our clients who have undergone active oncological treatment (or treatment for other systemic diseases) resulting in hair loss. This can be used once a year to purchase a wig or cooling cap after chemotherapy."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek SPORT",
              "sk": "Príspevok SPORT",
              "en": "SPORT contribution"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 700 Kč na pohybové aktivity",
              "sk": "Až 700 Kč na pohybové aktivity",
              "en": "Up to CZK 700 for physical activities"
            },
            "description": {
              "cs": "Přispíváme až 700 Kč na pravidelnou sportovní aktivitu včetně plavání a saunování, vyjma FBfit Mladá Boleslav, online kurzů, členských příspěvků a pronájmů sportovišť a aktivit hrazených MultiSport kartou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč na pravidelnú športové aktivitu včetně plavání a saunování, vyjma FBfit Mladá Boleslav, online kurzů, členských příspěvků a prenájmů sportovišť a aktivit hrazených MultiSport kartou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 for regular sports activities, including swimming and sauna use, except for FBfit Mladá Boleslav, online courses, membership fees, and sports facility rentals and activities paid for with a MultiSport card. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/sport",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek SPORT Senior",
              "sk": "Príspevok SPORT Senior",
              "en": "SPORT Senior contribution"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 700 Kč na pohybové aktivity, pomůcky pro prevenci úrazů při sportu aj.",
              "sk": "Až 700 Kč na pohybové aktivity, pomůcky pre prevenci úrazů při sportu aj.",
              "en": "Up to CZK 700 for physical activities, sports injury prevention equipment, etc."
            },
            "description": {
              "cs": "Přispíváme až 700 Kč seniorům nad 65 let na pohybové aktivity včetně plavání a saunování, přístrojovou pedikúru pro diabetiky, pomůcky pro prevenci úrazů při sportu, hole Nordic Walking, na specifické pomůcky pro trénování paměti a prevenci rozvoje Alzheimerovy choroby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 700 Kč seniorům nad 65 let na pohybové aktivity včetně plavání a saunování, přístrojovou pedikúru pre diabetiky, pomůcky pre prevenci úrazů při sportu, hole Nordic Walking, na specifické pomůcky pre trénování paměti a prevenci rozvoje Alzheimerovy choroby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 700 to seniors over 65 for physical activities, including swimming and sauna, pedicures for diabetics, aids for preventing sports injuries, Nordic walking poles, specific aids for memory training, and prevention of Alzheimer's disease. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/sport",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování proti pásovému oparu",
              "sk": "Očkovanie preti pásovému oparu",
              "en": "Vaccination against shingles"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 4 000 Kč na očkování protí pásovému oparu",
              "sk": "Až 4 000 Kč na očkovanie pretí pásovému oparu",
              "en": "Up to CZK 4 000 for vaccination against shingles"
            },
            "description": {
              "cs": "Příspíváme až 4 000 Kč na očkování proti pásovému oparu (2 000 Kč na každou dávku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Příspíváme až 4 000 Kč na očkovanie preti pásovému oparu (2 000 Kč na každou dávku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 toward shingles vaccinations (CZK 2 000 per dose). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Balíček ostatních očkování",
              "sk": "Balíček ostatních očkovanie",
              "en": "Package of other vaccinations"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Příspíváme až 1 000 Kč na různá očkování, které nejsou hrazeny z v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Příspíváme až 1 000 Kč na různá očkovanie, které nesou hrazeny z v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards various vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "HPV infekce",
              "sk": "HPV infekce",
              "en": "HPV infection"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 4 000 Kč na očkování ",
              "sk": "Až 4 000 Kč na očkovanie",
              "en": "Up to CZK 4 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na očkování pro ženy (do 45 let), u kterých bylo zahájeno očkování do 6 měsíců po konizaci děložního čípku pro prekancerózu, po ukončení očkovacího schématu v roce 2026. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na očkovanie pre ženy (do 45 let), u kterých bylo zahájeno očkovanie do 6 měsíců po konizaci děložního čípku pre prekancerózu, po ukončení očkovacího schématu v roce 2026. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for women (up to 45 years of age) who have commenced vaccination within 6 months after cervical conization due to a pre-cancerous condition. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Meningokok",
              "sk": "Meningokok",
              "en": "Meningococcus"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 3 600 Kč na očkování proti meningokoku",
              "sk": "Až 3 600 Kč na očkovanie preti meningokoku",
              "en": "Up to CZK 3 600 for vaccination against meningococus"
            },
            "description": {
              "cs": "Přispíváme až 3 600 Kč na očkování proti meningokoku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 3 600 Kč na očkovanie preti meningokoku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 600 for vaccination against meningococcus. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Hepatitida",
              "sk": "Hepatitida",
              "en": "Hepatitis"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 2 400 Kč na očkování",
              "sk": "Až 2 400 Kč na očkovanie",
              "en": "Up to CZK 2 400 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 2 400 Kč na očkování proti žloutence (hepatitidě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 400 Kč na očkovanie preti žloutence (hepatitidě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 400 for vaccination against hepatitis. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Klíšťová encefalitida",
              "sk": "Klíšťová encefalitida",
              "en": "Tick-borne encephalitis"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 2 100 Kč na očkování",
              "sk": "Až 2 100 Kč na očkovanie",
              "en": "Up to CZK 2 100 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 2 100 Kč na očkování proti klíšťové encefalitidě klientům do 50 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 100 Kč na očkovanie preti klíšťové encefalitidě klientům do 50 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 100 toward tick-borne encephalitis vaccinations for clients under 50 years of age. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Chřipka",
              "sk": "Chripka",
              "en": "Flu"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 400 Kč na očkování",
              "sk": "Až 400 Kč na očkovanie",
              "en": "Up to CZK 400 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 400 Kč na očkování proti chřipce klientům do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 400 Kč na očkovanie preti chřipce klientům do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 400 towards flu vaccinations for clients under 65 years of age. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora nutričního poradenství",
              "sk": "Podpora nutričního poradenství",
              "en": "Nutritional counselling support"
            },
            "icon": "cabbage",
            "benefit": {
              "cs": "Až 2 000 Kč příspěvek na sestavení jídelníčku",
              "sk": "Až 2 000 Kč príspevok na sestavení jídelníčku",
              "en": "Up to CZK 2 000 for dietary counselling"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s hodnotou BMI nad 30 nebo pod 18,5, příspěvek na sestavení jídelníčku nutričním terapeutem, obezitologem, diabetologem, praktickým lékařem nebo výživovým poradcem s platným osvědčením o profesní kvalifikaci (možno využít i na program \"Cukrovka bez obalu\"). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s hodnotou BMI nad 30 alebo pod 18,5, príspevok na sestavení jídelníčku nutričním terapeutem, obezitologem, diabetologem, praktickým lékařem alebo výživovým poradcem s platným osvědčením o prefesní kvalifikaci (možno využít i na pregram \"Cukrovka bez obalu\"). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to our clients with a BMI above 30 or below 18.5, a contribution for the preparation of a diet plan by a nutrition therapist, obesity specialist, diabetologist, general practitioner, or nutrition consultant with a valid professional qualification certificate (can also be used for the \"Diabetes Uncovered\" program). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy",
            "category": null
          },
          {
            "type": {
              "cs": "Nízkobílkovinná dieta a další vzácné metabolické poruchy",
              "sk": "Nízkobílkovinná dieta a další vzácné metabolické poruchy",
              "en": "Low-protein diet and other rare metabolic disorders"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 12 000 Kč na nízkobílkovinnou dietu",
              "sk": "Až 12 000 Kč na nízkobílkovinnou dietu",
              "en": "Up to CZK 12 000 for a low-protein diet"
            },
            "description": {
              "cs": "Přispíváme až 12 000 Kč pojištěncům, kteří mají z důvodu metabolického onemocnění indikovanou nízkobílkovinnou dietu, nebo specifickou diagnózu (nemoc javorového sirupu, homocystinurie, isovalerová acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1., poruchy cyklu močoviny). Při prvním čerpání je nutno doložit potvrzení ošetřujícího lékaře, které zdůvodňuje nezbytnost indikace této diety. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 12 000 Kč pojištěncům, kteří mají z důvodu metabolického onemocnění indikovanou nízkobílkovinnou dietu, alebo specifickou diagnózu (nemoc javorového sirupu, homocystinurie, isovalerová acidurie, prepionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1., poruchy cyklu močoviny). Při prvním čerpání je nutno doložit potvrzení ošetřujícího lékaře, které zdůvodňuje nezbytnost indikace této diety. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 12 000 to insured persons who have been prescribed a low-protein diet due to a metabolic disorder or specific diagnosis (maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). When claiming for the first time, it is necessary to provide confirmation from the attending physician justifying the necessity of this diet. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy",
            "category": null
          },
          {
            "type": {
              "cs": "Celiakie",
              "sk": "Celiakie",
              "en": "Celiac disease"
            },
            "icon": "gluten",
            "benefit": {
              "cs": "Až 5 000 Kč na bezlepkovou dietu",
              "sk": "Až 5 000 Kč na bezlepkovou dietu",
              "en": "Up to CZK 5 000 for a gluten-free diet"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč 1 x za rok, na bezlepkovu dietu nad rámec v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč 1 x za rok, na bezlepkovu dietu nad rámec v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 once a year for a gluten-free diet beyond the scope of the health insurance plan. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence onemocnění štítné žlázy",
              "sk": "Prevence onemocnení štítné žlázy",
              "en": "Prevention of thyroid disease"
            },
            "icon": "shield-exclamation-marks",
            "benefit": {
              "cs": "Příspěvek 1x za rok",
              "sk": "Príspevok 1x za rok",
              "en": "Annual contribution"
            },
            "description": {
              "cs": "Přispíváme 1x za rok na odběr krve na vyšetření hormonů štítné žlázy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme 1x za rok na odběr krve na vyšetření hormonů štítné žlázy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute once a year to blood tests for thyroid hormone levels."
            },
            "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni",
            "category": null
          },
          {
            "type": {
              "cs": "Program pro zjišťování nádorů v oblasti dutiny břišní a ledvin",
              "sk": "Pregram pre zjišťování nádorú v oblasti dutiny brišní a ledvin",
              "en": "A programme for the detection of tumours in the area of the abdominal cavity and the kidneys"
            },
            "icon": "care",
            "benefit": {
              "cs": "Příspěvek 1x za rok",
              "sk": "Príspevok 1x za rok",
              "en": "Annual contribution"
            },
            "description": {
              "cs": "Přispíváme 1x za rok na preventivní sonografické vyšetření horní a dolní poloviny břicha, program je určen zejména pojištěncům s pozitivní rodinnou onkologickou anamnézou či s rizikem tohoto onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme 1x za rok na preventivní sonografické vyšetření horní a dolní poloviny břicha, pregram je určen zejména pojištěncům s pozitivní rodinnou onkologickou anamnézou či s rizikem tohoto onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute once a year to preventive sonographic examinations of the upper and lower abdomen. The program is intended primarily for insured persons with a positive family history of cancer or at risk of developing this disease. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu tlustého střeva a konečníku",
              "sk": "Prevence karcinomu tlustého streva a konečníku",
              "en": "Colon and anal cancer prevention"
            },
            "icon": "rectum",
            "benefit": {
              "cs": "Příspěvek 1x za rok",
              "sk": "Príspevok 1x za rok",
              "en": "Annual contribution"
            },
            "description": {
              "cs": "Přispíváme 1x za rok pojištěncům (od 35 do 45 let), na které se nevztahuje vyšetření na okultní krvácení v rámci preventivní prohlídky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme 1x za rok pojištěncům (od 35 do 45 let), na které se nevztahuje vyšetření na okultní krvácení v rámci preventivní prehlídky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute once a year to insured persons (aged 35 to 45) who are not covered by occult blood testing as part of preventive check-ups. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu prsu (SONO)\n",
              "sk": "Prevence karcinomu prsu (SONO)\n",
              "en": "Breast cancer prevention (ultrasound)"
            },
            "icon": "breasts-sono",
            "benefit": {
              "cs": "Až 800 Kč na sono prsou",
              "sk": "Až 800 Kč na sono prsou",
              "en": "Up to CZK 800 for a breast ultrasound examination"
            },
            "description": {
              "cs": "Přispíváme až 800 Kč na ultrasonografické vyšetření prsů pro ženy nesplňující podmínky pro úhradu vyšetření z prostředků v. z. p., ženy absolvují vyšetření na vlastní žádost s doporučením ošetřujícího lékaře. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 800 Kč na ultrasonografické vyšetření prsů pre ženy nesplňující podmínky pre úhradu vyšetření z prestředků v. z. p., ženy absolvují vyšetření na vlastní žádost s doporučením ošetřujícího lékaře. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 800 towards breast ultrasound examinations for women who do not meet the conditions for reimbursement of the examination from public health insurance funds. Women undergo the examination at their own request with a recommendation from their attending physician. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence karcinomu prsu (MAMOGRAF)",
              "sk": "Prevence karcinomu prsu (MAMOGRAF)",
              "en": "Breast cancer prevention (mammogram)"
            },
            "icon": "breasts-sono",
            "benefit": {
              "cs": "Až 1 000 Kč na mamografické vyšetření",
              "sk": "Až 1 000 Kč na mamografické vyšetření",
              "en": "Up to CZK 1 000 for a mammogram"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč ženám (od 35 do 45 let), které nespadající věkem do programu celostátního mamografického screeningu hrazeného z prostředků v.z.p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč ženám (od 35 do 45 let), které nespadající věkem do pregramu celostátního mamografického screeningu hrazeného z prestředků v.z.p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1,000 to women (aged 35 to 45) who are not eligible for the nationwide mammography screening program covered by health insurance funds due to their age. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni",
            "category": null
          },
          {
            "type": {
              "cs": "Cestovní pojištění ZDARMA",
              "sk": "Cestovní pojištení ZDARMA",
              "en": "FREE travel insurance"
            },
            "icon": "briefcase",
            "benefit": {
              "cs": "Cestovní pojištění ZDARMA pro dárce krve s odběrem za posledních 12 měsíců",
              "sk": "Cestovní pojištění ZDARMA pre dárce krve s odběrem za posledních 12 měsíců",
              "en": "FREE travel insurance for blood donors who have donated blood within the last 12 months"
            },
            "description": {
              "cs": "Cestovní pojištění pro dárce krve od našeho partnera VITALITAS pojišťovny a. s. platí na léčebné výlohy, celý svět a na 30 dnů. Podmínkou je kopie průkazu dárce krve s odběrem za posledních 12 měsíců. ",
              "sk": "Cestovní pojištění pre dárce krve od našeho partnera VITALITAS pojišťovny a. s. platí na léčebné výlohy, celý svět a na 30 dnů. Podmínkou je kopie průkazu dárce krve s odběrem za posledních 12 měsíců.",
              "en": "Travel insurance for blood donors from our partner VITALITAS pojišťovna a. s. covers medical expenses worldwide for up to 30 days. A copy of your blood donor card showing donations made within the last 12 months is required. "
            },
            "url": "https://www.zpskoda.cz/pro-darce-krve",
            "category": null
          },
          {
            "type": {
              "cs": "Ozdravný pobyt v ČR pro dárce kostní dřeně a dárce orgánů",
              "sk": "Ozdravný pobyt v ČR pre dárce kostní drene a dárce orgánú",
              "en": "Recuperative stay in the Czech Republic for bone marrow and organ donors"
            },
            "icon": "tent",
            "benefit": {
              "cs": "Až 10 000 Kč na ozdravný pobyt v některém ze smluvních lázeňských zařízení",
              "sk": "Až 10 000 Kč na ozdravný pobyt v některém ze smluvních lázeňských zařízení",
              "en": "Up to CZK 10 000 for recuperative stays at one of our partner spa facilities"
            },
            "description": {
              "cs": "Přispíváme až 10 000 Kč na ozdravný pobyt dárcům kostní dřeně a dárce životně důležitých orgánů k transplantaci v některém ze smluvních lázeňských zařízení dle výběru a po domluvě s referentem lázeňské péče. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 10 000 Kč na ozdravný pobyt dárcům kostní dřeně a dárce životně důležitých orgánů k transplantaci v některém ze smluvních lázeňských zařízení dle výběru a po domluvě s referentem lázeňské péče. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 10 000 towards a recuperative stay for bone marrow donors and donors of vital organs for transplantation at one of our contracted spa facilities, as selected and agreed with the spa care representative. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/pro-darce-krve",
            "category": null
          },
          {
            "type": {
              "cs": "Pro dárce",
              "sk": "Pre dárce",
              "en": "For donors"
            },
            "icon": "bloodtest",
            "benefit": {
              "cs": "Odměna až 5 000 Kč pro ty, kteří jsou solidární ke zdraví ostatních",
              "sk": "Odměna až 5 000 Kč pre ty, kteří jsou solidární ke zdraví ostatních",
              "en": "Up to CZK 5 000 for those who show solidarity with the health of others"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč dárcům krve, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč dárcům krve, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 to blood, bone marrow, and organ donors. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/pro-darce-krve",
            "category": null
          }
        ]
      },
      {
        "name": {
          "cs": "Děti",
          "sk": "Deti",
          "en": "Children"
        },
        "benefits": [
          {
            "type": {
              "cs": "Dentální hygiena pro děti",
              "sk": "Dentálne hygiena pre deti",
              "en": "Dental hygiene"
            },
            "icon": "tooth",
            "benefit": {
              "cs": "Až 1 000 Kč na dentální hygienu",
              "sk": "Až 1 000 Kč na dentálne hygienu",
              "en": "Up to CZK 1 000 for dental hygiene"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na úhradu provedených výkonů dentální hygieny a další stomatologické péče zaplacené nad rámec úhrad ze základního fondu veřejného zdravotního pojištění. (Nevztahuje se na estetické výkony, např. bělení zubů, ozdobné doplňky na zuby apod.). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na úhradu prevedených výkonů dentálne hygieny a další stomatologické péče zaplacené nad rámec úhrad ze základního fondu veřejného zdravotního pojištění. (Nevztahuje se na estetické výkony, např. bělení zubů, ozdobné doplňky na zuby apod.). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards the cost of dental hygiene and other dental care paid for in excess of the basic public health insurance fund. (This does not apply to cosmetic procedures, such as teeth whitening, decorative dental accessories, etc.). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/pece-o-chrup",
            "category": "Deti"
          },
          {
            "type": {
              "cs": "Rovnátka",
              "sk": "Rovnátka",
              "en": "Braces"
            },
            "icon": "braces",
            "benefit": {
              "cs": "Až 4 000 Kč na rovnátka",
              "sk": "Až 4 000 Kč na rovnátka",
              "en": "Up to CZK 4 000 for braces"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč  na každou čelist na fixní ortodontický aparát a neviditelná rovnátka. Nevztahuje se na deskové snímací aparáty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč  na každou čelist na fixní ortodontický aparát a neviditelná rovnátka. Nevztahuje se na deskové snímací aparáty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 for each jaw for fixed orthodontic appliances and invisible braces. This does not apply to removable appliances. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/pece-o-chrup",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora péče duševního zdraví",
              "sk": "Podpora péče duševního zdraví",
              "en": "Mental health care support"
            },
            "icon": "happy",
            "benefit": {
              "cs": "Až 4 000 Kč na péči o duševní zdraví",
              "sk": "Až 4 000 Kč na péči o duševní zdraví",
              "en": "Up to CZK 4 000 for mental health care"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč na absolvování psychologického nebo psychoterapeutického poradenství certifikovaným specialistou v oblasti psychologie/psychoterapie zapsaným v České asociaci pro psychoterapii, mimo výkony hrazené z v. z. p. (včetně online poradenství). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč na absolvování psychologického alebo psychoterapeutického poradenství certifikovaným specialistou v oblasti psychologie/psychoterapie zapsaným v České asociaci pre psychoterapii, mimo výkony hrazené z v. z. p. (včetně online poradenství). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 towards psychological or psychotherapeutic counseling provided by a certified specialist in psychology/psychotherapy registered with the Czech Association for Psychotherapy, excluding services covered by health insurance (including online counseling). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/dusevni-zdravi",
            "category": null
          },
          {
            "type": {
              "cs": "Ozdravný pobyt pro pojištěnce s chronickým onemocněním kůže, dýchacích cest",
              "sk": "Ozdravný pobyt pre pojištence s chronickým onemocnením kúže, dýchacích cest",
              "en": "Recuperative stay for the ill"
            },
            "icon": "bath",
            "benefit": {
              "cs": "Až 1 000 Kč na ozdravný pobyt",
              "sk": "Až 1 000 Kč na ozdravný pobyt",
              "en": "Up to CZK 1 000 for a recuperative stay"
            },
            "description": {
              "cs": "Přispíváme až 1 000 Kč na přímořský nebo vysokohorský ozdravný pobyt uskutečněný v roce 2026; pobyt musí být zabezpečen přes cestovní agenturu nebo cestovní kancelář; na doporučení pediatra nebo specialisty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 1 000 Kč na přímořský alebo vysokohorský ozdravný pobyt uskutečněný v roce 2026; pobyt musí být zabezpečen přes cestovní agenturu alebo cestovní kancelář; na doporučení pediatra alebo specialisty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards a seaside or mountain health retreat in 2026; the retreat must be booked through a travel agency or tour operator; on the recommendation of a pediatrician or specialist. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ozdravne-pobyty",
            "category": null
          },
          {
            "type": {
              "cs": "Ozdravný pobyt pro pojištěnce s neurologickým, onkologickým onemocněním, obezitou ",
              "sk": "Ozdravný pobyt pre pojištence s neurologickým, onkologickým onemocnením, obezitou",
              "en": "Recuperative stays for clients with chronic skin or respiratory disease"
            },
            "icon": "tent",
            "benefit": {
              "cs": "Až 5 000 Kč na ozdravný pobyt",
              "sk": "Až 5 000 Kč na ozdravný pobyt",
              "en": "Up to CZK 5 000 for a recuperative stay"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč na ozdravný pobyt uskutečněný v roce 2026; pobyt musí být zabezpečen odborným lékařským dohledem; na doporučení pediatra nebo specialisty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč na ozdravný pobyt uskutečněný v roce 2026; pobyt musí být zabezpečen odborným lékařským dohledem; na doporučení pediatra alebo specialisty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 for a health stay in 2026; the stay must be supervised by a medical professional; on the recommendation of a pediatrician or specialist. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ozdravne-pobyty",
            "category": null
          },
          {
            "type": {
              "cs": "Moderní diagnostické a léčebné metody",
              "sk": "Moderní diagnostické a léčebné metody",
              "en": "Modern diagnostic and treatment methods"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 2 000 Kč na různé diagnostické a léčebné metody",
              "sk": "Až 2 000 Kč na rôzne diagnostické a léčebné metody",
              "en": "Up to CZK 2 000 for various diagnostic and treatment methods"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na diagnostické a léčebné metody, např. Operace varixů - Laser, Endoskopická operace karpálního tunelu, Podologické vyšetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na diagnostické a léčebné metody, např. Operace varixů - Laser, Endoskopická operace karpálního tunelu, Podologické vyšetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 toward diagnostic and treatment methods, such as varicose vein surgery (laser), endoscopic carpal tunnel surgery, podiatric examinations, and more. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/mdlm",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek na zdravotní pomůcky pro pojištěnce s diabetem a na diabetickou dietu",
              "sk": "Príspevok na zdravotní pomúcky pre pojištence s diabetem a na diabetickou dietu",
              "en": "Contribution towards medical aids for insured persons with diabetes and for diabetic diets"
            },
            "icon": "diabetes",
            "benefit": {
              "cs": "Až 5 000 Kč na diabetickou dietu a pomůcky ",
              "sk": "Až 5 000 Kč na diabetickou dietu a pomůcky",
              "en": "Up to CZK 5 000 for diabetic diet and aids"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč 1x za rok, na diabetickou dietu a na pomůcky pro pojištěnce s diabetem nad rámec v.z.p. nutné předložit potvrzení ošetřujícího lékaře o nezbytné dietě (požadujeme pouze při prvním čerpání příspěvku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč 1x za rok, na diabetickou dietu a na pomůcky pre pojištěnce s diabetem nad rámec v.z.p. nutné předložit potvrzení ošetřujícího lékaře o nezbytné dietě (požadujeme pouze při prvním čerpání příspěvku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5,000 once a year towards a diabetic diet and aids for insured persons with diabetes beyond the scope of the basic health insurance. It is necessary to submit a confirmation from the attending physician regarding the necessary diet (we only require this when the contribution is drawn for the first time). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření přístrojem OCT",
              "sk": "Vyšetrení prístrojem OCT",
              "en": "OCT examination"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 800 Kč na vyšetření očí přístrojem OCT",
              "sk": "Až 800 Kč na vyšetření očí přístrojem OCT",
              "en": "Up to CZK 800 for an OCT eye exam"
            },
            "description": {
              "cs": "Přispíváme až 800 Kč na OCT vyšetření oči. Lze poskytnout 2x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 800 Kč na OCT vyšetření oči. Lze poskytnout 2x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 800 toward OCT eye examinations. Can be provided twice a year. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Nitrooční operace",
              "sk": "Nitrooční operace",
              "en": "Intraocular operations"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 2 000 Kč na operaci očí",
              "sk": "Až 2 000 Kč na operaci očí",
              "en": "Up to CZK 2 000 for eye operation"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč na nitrooční operaci s použitím multifokální čočky, čočky s prodlouženým ohniskem, čočky pro korekci astigmatismu nebo nitrooční čočky (1 000 Kč na každé oko). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč na nitrooční operaci s použitím multifokální čočky, čočky s predlouženým ohniskem, čočky pre korekci astigmatismu alebo nitrooční čočky (1 000 Kč na každé oko). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 toward intraocular surgery using multifocal lenses, extended focus lenses, lenses for astigmatism correction, or intraocular lenses (CZK 1 000 per eye). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Plastová sádra",
              "sk": "Plastová sádra",
              "en": "Plastic plaster"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 300 Kč na plastovou sádru",
              "sk": "Až 300 Kč na plastovou sádru",
              "en": "Up to CZK 300 for plastic plaster"
            },
            "description": {
              "cs": "Přispíváme až 300 Kč na plastovou sádru. Příspěvek lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 300 Kč na plastovou sádru. Príspevok lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 300 towards plastic plaster casts. This contribution can be provided once a year. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek pro onkologicky nemocné nebo jinak závažně nemocné",
              "sk": "Príspevok pre onkologicky nemocné alebo jinak závažne nemocné",
              "en": "Contribution for cancer patients or other seriously ill patients"
            },
            "icon": "care",
            "benefit": {
              "cs": "Až 4 000 Kč na paruku, nebo chladící čepici po chemoterapii",
              "sk": "Až 4 000 Kč na paruku, alebo chladící čepici po chemoterapii",
              "en": "Up to CZK 4 000 for a wig or cooling cap after chemotherapy"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč pojištěncům, kteří absolvovali aktivní onkologickou léčbu (nebo pro jiné systémové onemocnění) při které došlo ke ztrátě vlasů. Lze 1x za rok čerpat na paruku, nebo chladící čepici po chemoterapii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč pojištěncům, kteří absolvovali aktivní onkologickou léčbu (alebo pre jiné systémové onemocnění) při které došlo ke ztrátě vlasů. Lze 1x za rok čerpat na paruku, alebo chladící čepici po chemoterapii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 to our clients who have undergone active oncological treatment (or treatment for other systemic diseases) resulting in hair loss. This can be used once a year to purchase a wig or cooling cap after chemotherapy."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Příspěvek SPORT Junior",
              "sk": "Príspevok SPORT Junior",
              "en": "SPORT Junior contribution"
            },
            "icon": "move",
            "benefit": {
              "cs": "Až 800 Kč na pohybové aktivity",
              "sk": "Až 800 Kč na pohybové aktivity",
              "en": "Up to CZK 800 for physical activities"
            },
            "description": {
              "cs": "Přispíváme až 800 Kč na pohybové aktivity, ochranné pomůcky pro prevenci úrazů, sportovní prohlídky, sportovní tábory, sportovní kroužky ve škole. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 800 Kč na pohybové aktivity, ochranné pomůcky pre prevenci úrazů, športové prehlídky, športové tábory, športové kroužky ve škole. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 800 for physical activities, protective equipment for accident prevention, sports check-ups, sports camps, and sports clubs at school. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/sport",
            "category": null
          },
          {
            "type": {
              "cs": "Očkování proti pásovému oparu",
              "sk": "Očkovanie preti pásovému oparu",
              "en": "Vaccination against shingles"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 4 000 Kč na očkování protí pásovému oparu",
              "sk": "Až 4 000 Kč na očkovanie pretí pásovému oparu",
              "en": "Up to CZK 4 000 for vaccination against shingles"
            },
            "description": {
              "cs": "Příspíváme až 4 000 Kč na očkování proti pásovému oparu (2 000 Kč na každou dávku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Příspíváme až 4 000 Kč na očkovanie preti pásovému oparu (2 000 Kč na každou dávku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 toward shingles vaccinations (CZK 2 000 per dose). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Balíček ostatních očkování",
              "sk": "Balíček ostatních očkovanie",
              "en": "Package of other vaccinations"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 1 000 Kč na očkování",
              "sk": "Až 1 000 Kč na očkovanie",
              "en": "Up to CZK 1 000 for vaccination"
            },
            "description": {
              "cs": "Příspíváme až 1 000 Kč na různá očkování, které nejsou hrazeny z v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Příspíváme až 1 000 Kč na různá očkovanie, které nesou hrazeny z v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 1 000 towards various vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "HPV infekce",
              "sk": "HPV infekce",
              "en": "HPV infection"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 4 000 Kč na očkování",
              "sk": "Až 4 000 Kč na očkovanie",
              "en": "Up to CZK 4 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 4 000 Kč pro mladistvé od 15-18 let na očkování proti HPV infekci. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 4 000 Kč pre mladistvé od 15-18 let na očkovanie preti HPV infekci. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 4 000 for young people aged 15-18 for vaccination against HPV infection. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Rotavirové infekce",
              "sk": "Rotavirové infekce",
              "en": "Rotavirus infection"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 3 000 Kč na očkování",
              "sk": "Až 3 000 Kč na očkovanie",
              "en": "Up to CZK 3 000 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 3 000 Kč pro miminka do 1 roku na očkování proti rotaviru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 3 000 Kč pre miminka do 1 roku na očkovanie preti rotaviru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 000 for babies under 1 year of age for rotavirus vaccination. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Meningokok",
              "sk": "Meningokok",
              "en": "Meningococcus"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 3 600 Kč na očkování proti meningokoku",
              "sk": "Až 3 600 Kč na očkovanie preti meningokoku",
              "en": "Up to CZK 3 600 for vaccination against meningococus"
            },
            "description": {
              "cs": "Přispíváme až 3 600 Kč na očkování proti meningokoku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 3 600 Kč na očkovanie preti meningokoku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 3 600 for vaccination against meningococcus. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Hepatitida",
              "sk": "Hepatitida",
              "en": "Hepatitis"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 2 400 Kč na očkování",
              "sk": "Až 2 400 Kč na očkovanie",
              "en": "Up to CZK 2 400 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 2 400 Kč na očkování proti žloutence (hepatitidě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 400 Kč na očkovanie preti žloutence (hepatitidě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 400 for vaccination against hepatitis. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Klíšťová encefalitida",
              "sk": "Klíšťová encefalitida",
              "en": "Tick-borne encephalitis"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 2 100 Kč na očkování",
              "sk": "Až 2 100 Kč na očkovanie",
              "en": "Up to CZK 2 100 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 2 100 Kč na očkování proti klíšťové encefalitidě klientům do 50 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 100 Kč na očkovanie preti klíšťové encefalitidě klientům do 50 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 100 toward tick-borne encephalitis vaccinations for clients under 50 years of age. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Chřipka",
              "sk": "Chripka",
              "en": "Flu"
            },
            "icon": "vaccine",
            "benefit": {
              "cs": "Až 400 Kč na očkování",
              "sk": "Až 400 Kč na očkovanie",
              "en": "Up to CZK 400 for vaccination"
            },
            "description": {
              "cs": "Přispíváme až 400 Kč na očkování proti chřipce klientům do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 400 Kč na očkovanie preti chřipce klientům do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 400 towards flu vaccinations for clients under 65 years of age. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ockovani",
            "category": null
          },
          {
            "type": {
              "cs": "Vyšetření přístrojem Plusoptix",
              "sk": "Vyšetrení prístrojem Plusoptix",
              "en": "Plusoptix examination"
            },
            "icon": "eye",
            "benefit": {
              "cs": "Až 200 Kč na vyšetření očí",
              "sk": "Až 200 Kč na vyšetření očí",
              "en": "Up to CZK 200 for an eye examination"
            },
            "description": {
              "cs": "Příspěvek na vyšetření přístrojem Plusoptix lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Príspevok na vyšetření přístrojem Plusoptix lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The Plusoptix examination contribution can be granted once a year. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/ostatni",
            "category": null
          },
          {
            "type": {
              "cs": "Podpora nutričního poradenství",
              "sk": "Podpora nutričního poradenství",
              "en": "Nutritional counselling support"
            },
            "icon": "cabbage",
            "benefit": {
              "cs": "Až 2 000 Kč příspěvek na sestavení jídelníčku",
              "sk": "Až 2 000 Kč príspevok na sestavení jídelníčku",
              "en": "Up to CZK 2 000 for dietary counselling"
            },
            "description": {
              "cs": "Přispíváme až 2 000 Kč pojištěncům s hodnotou BMI nad 30 nebo pod 18,5, příspěvek na sestavení jídelníčku nutričním terapeutem, obezitologem, diabetologem, praktickým lékařem nebo výživovým poradcem s platným osvědčením o profesní kvalifikaci (možno využít i na program \"Cukrovka bez obalu\"). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 2 000 Kč pojištěncům s hodnotou BMI nad 30 alebo pod 18,5, príspevok na sestavení jídelníčku nutričním terapeutem, obezitologem, diabetologem, praktickým lékařem alebo výživovým poradcem s platným osvědčením o prefesní kvalifikaci (možno využít i na pregram \"Cukrovka bez obalu\"). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 2 000 to our clients with a BMI above 30 or below 18.5, a contribution for the preparation of a diet plan by a nutrition therapist, obesity specialist, diabetologist, general practitioner, or nutrition consultant with a valid professional qualification certificate (can also be used for the \"Diabetes Uncovered\" program). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy",
            "category": null
          },
          {
            "type": {
              "cs": "Nízkobílkovinná dieta a další vzácné metabolické poruchy",
              "sk": "Nízkobílkovinná dieta a další vzácné metabolické poruchy",
              "en": "Low-protein diet and other rare metabolic disorders"
            },
            "icon": "nutrition",
            "benefit": {
              "cs": "Až 12 000 Kč na nízkobílkovinnou dietu",
              "sk": "Až 12 000 Kč na nízkobílkovinnou dietu",
              "en": "Up to CZK 12 000 for a low-protein diet"
            },
            "description": {
              "cs": "Přispíváme až 12 000 Kč pojištěncům, kteří mají z důvodu metabolického onemocnění indikovanou nízkobílkovinnou dietu, nebo specifickou diagnózu (nemoc javorového sirupu, homocystinurie, isovalerová acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1., poruchy cyklu močoviny). Při prvním čerpání je nutno doložit potvrzení ošetřujícího lékaře, které zdůvodňuje nezbytnost indikace této diety. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 12 000 Kč pojištěncům, kteří mají z důvodu metabolického onemocnění indikovanou nízkobílkovinnou dietu, alebo specifickou diagnózu (nemoc javorového sirupu, homocystinurie, isovalerová acidurie, prepionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1., poruchy cyklu močoviny). Při prvním čerpání je nutno doložit potvrzení ošetřujícího lékaře, které zdůvodňuje nezbytnost indikace této diety. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 12 000 to insured persons who have been prescribed a low-protein diet due to a metabolic disorder or specific diagnosis (maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). When claiming for the first time, it is necessary to provide confirmation from the attending physician justifying the necessity of this diet. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy",
            "category": null
          },
          {
            "type": {
              "cs": "Celiakie",
              "sk": "Celiakie",
              "en": "Celiac disease"
            },
            "icon": "gluten",
            "benefit": {
              "cs": "Až 5 000 Kč na bezlepkovou dietu",
              "sk": "Až 5 000 Kč na bezlepkovou dietu",
              "en": "Up to CZK 5 000 for a gluten-free diet"
            },
            "description": {
              "cs": "Přispíváme až 5 000 Kč 1 x za rok, na bezlepkovu dietu nad rámec v. z. p., požadujeme vyjádření ošetřujícího lékaře o nezbytné dietě (pouze u prvního čerpání). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme až 5 000 Kč 1 x za rok, na bezlepkovu dietu nad rámec v. z. p., požadujeme vyjádření ošetřujícího lékaře o nezbytné dietě (pouze u prvního čerpání). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute up to CZK 5 000 once a year for a gluten-free diet beyond the scope of the standard health insurance plan. We require a statement from the attending physician regarding the necessary diet (only for the first draw). More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy",
            "category": null
          },
          {
            "type": {
              "cs": "Prevence onemocnění štítné žlázy",
              "sk": "Prevence onemocnení štítné žlázy",
              "en": "Prevention of thyroid disease"
            },
            "icon": "shield-exclamation-marks",
            "benefit": {
              "cs": "Příspěvek 1x za rok",
              "sk": "Príspevok 1x za rok",
              "en": "Annual contribution"
            },
            "description": {
              "cs": "Přispíváme 1x za rok na odběr krve na vyšetření hormonů štítné žlázy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme 1x za rok na odběr krve na vyšetření hormonů štítné žlázy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute once a year to blood tests for thyroid hormone levels."
            },
            "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni",
            "category": null
          },
          {
            "type": {
              "cs": "Program pro zjišťování nádorů v oblasti dutiny břišní a ledvin",
              "sk": "Pregram pre zjišťování nádorú v oblasti dutiny brišní a ledvin",
              "en": "A programme for the detection of tumours in the area of the abdominal cavity and the kidneys"
            },
            "icon": "stop",
            "benefit": {
              "cs": "Příspěvek 1x za rok",
              "sk": "Príspevok 1x za rok",
              "en": "Annual contribution"
            },
            "description": {
              "cs": "Přispíváme 1x za rok na preventivní sonografické vyšetření horní a dolní poloviny břicha, program je určen zejména pojištěncům s pozitivní rodinnou onkologickou anamnézou či s rizikem tohoto onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "sk": "Přispíváme 1x za rok na preventivní sonografické vyšetření horní a dolní poloviny břicha, pregram je určen zejména pojištěncům s pozitivní rodinnou onkologickou anamnézou či s rizikem tohoto onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We contribute once a year to preventive sonographic examinations of the upper and lower abdomen. The program is intended primarily for insured persons with a positive family history of cancer or at risk of developing this disease. More information (in Czech only) is available on the insurance company's website here: link."
            },
            "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni",
            "category": null
          }
        ]
      }
    ],
    "updateDate": "30.1.2026",
    "companyBenefitsLink": "https://www.zpskoda.cz/zdravotni-programy-2023"
  },
  {
    "slug": "union",
    "genders": [
      {
        "name": {
          "sk": "Muži",
          "cs": "Muži",
          "en": "Men"
        },
        "benefits": [
          {
            "type": {
              "sk": "Očkovanie",
              "cs": "Očkování",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "sk": "Príspevky vo výške 50 % až 100 % z ceny očkovania",
              "cs": "Příspěvky ve výši 50 % až 100 % z ceny očkování",
              "en": "Contributions of 50 to 100 % of the cost of vaccination"
            },
            "description": {
              "sk": "Našim poistencom a poistenkám preplácame 50 % z ceny vakcíny pri viacerých dobrovoľných očkovaniach. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Našim pojištěncům proplácíme 50 % z ceny vakcíny při vícero dobrovolných očkováních. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We reimburse our policyholders 50% of the cost of vaccines for several voluntary vaccinations. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/ockovanie/",
            "category": "Muži"
          },
          {
            "type": {
              "sk": "Príspevok na umelé oplodnenie",
              "cs": "Příspěvek na umělé oplodnění",
              "en": "Contribution for artificial insemination"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Až 1 200 eur príspevok na umelé oplodnenie",
              "cs": "Až 1 200 EUR příspěvek na umělé oplodnění",
              "en": "Up to EUR 1 200 contribution for artificial insemination"
            },
            "description": {
              "sk": "Prispejeme vám na umelé oplodnenie až do 1 200 eur. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Přispějeme vám na umělé oplodnění až do 1 200 EUR. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We'll contribute up to EUR 1200 for artificial insemination. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/umele-oplodnenie-union-family/",
            "category": null
          },
          {
            "type": {
              "sk": "Prispevok na poplatky za lieky a dietetické potraviny",
              "cs": "Příspěvek na poplatky za léky a dietní potraviny",
              "en": "Contribution to the cost of medicines and dietary foods"
            },
            "icon": "zdravy-talir",
            "benefit": {
              "sk": "Až 300 eur vrátime doplatky za lieky a dietetické potraviny\n",
              "cs": "Až 300 EUR vrátíme doplatky za léky a dietní potraviny",
              "en": "We will refund up to EUR 300 for medicines and dietary foods"
            },
            "description": {
              "sk": "Každému, bez ohľadu na vek či rodinný stav, vrátime doplatky za lieky a dietetické potraviny až do výšky 300 eur. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Každému, bez ohledu na věk či rodinný stav, vrátíme doplatky za léky a dietní potraviny až do výšky 300 EUR. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will reimburse everyone, regardless of age or marital status, for additional payments for medicines and dietary foods up to EUR 300. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/vratenie-doplatkov-za-lieky-pre-dospelych",
            "category": null
          },
          {
            "type": {
              "sk": "Zrak",
              "cs": "Zrak",
              "en": "Vision"
            },
            "icon": "eye",
            "benefit": {
              "sk": "Až 150 eur na vyšetrenie zraku",
              "cs": "Až 150 EUR na vyšetření zraku",
              "en": "Up to EUR 150 for vision examination"
            },
            "description": {
              "sk": "Prispejeme vám až 150 eur na nadštandardnú zdravotnú starostlivosť vo vybraných očných klinikách a na nákup kvalitných okuliarov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Přispějeme vám až 150 EUR na nadstandardní zdravotní péči ve vybraných očních klinikách a na nákup kvalitních brýlí.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will contribute up to EUR 150 towards above-standard healthcare at selected eye clinics and the purchase of high-quality glasses. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/ocny-balik/",
            "category": null
          },
          {
            "type": {
              "sk": "Telefonická podpora weLive pre onkologických pacientov a ich rodiny",
              "cs": "Telefonická podpora weLive pro onkologické pacienty a jejich rodiny",
              "en": "weLive telephone support for cancer patients and their families"
            },
            "icon": "digitalni-zdravi",
            "benefit": {
              "sk": "Bezplatná telefonická podpora",
              "cs": "Bezplatná telefonická podpora",
              "en": "Free telephone support"
            },
            "description": {
              "sk": "V spolupráci s weLive vám prinášame bezplatnú telefonickú podporu pre onkologických pacientov a ich rodiny. Poraďte sa o diagnóze a zorientujte sa v možnostiach a povinnostiach. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "V spolupráci s weLive vám přinášíme bezplatnou telefonickou podporu pro onkologické pacienty a jejich rodiny. Poraďte se o diagnóze a zorientujte se v možnostech a povinnostech. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "In cooperation with weLive, we offer free telephone support for cancer patients and their families. Discuss your diagnosis and learn about your options and responsibilities. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/benefit/telefonicka-podpora-welive-pre-onkologickych-pacientov-a-ich-rodiny/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na operáciu kĺbov",
              "cs": "Příspěvek na operaci kloubů",
              "en": "Contribution to joint surgery"
            },
            "icon": "osteoporosis",
            "benefit": {
              "sk": "Až 3 000 eur na operáciu kĺbov a kvalitnú profesionálnu starostlivosť v zariadení Clinica Orthopedica\n",
              "cs": "Až 3 000 Kč na operáci kloubů a kvalitní profesionální péči v zařízení Clinica Orthopedica",
              "en": "Up to EUR 3 000 for joint surgery and high-quality professional care at Clinica Orthopedica"
            },
            "description": {
              "sk": "Ak potrebujete operáciu bedrového alebo kolenného kĺbu, doprajte si nadštandard. Za našich poistencov hradíme 3 000 eur na operáciu kĺbov a kvalitnú profesionálnu starostlivosť v zariadení Clinica Orthopedica. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pokud potřebujete operaci kyčelního nebo kolenního kloubu, dopřejete si nadstandard. Za naše pojištěnce hradíme 3 000 EUR za operaci kloubů a  kvalitní profesionální péči v zařízení Clinica Orthopedica.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "If you need hip or knee joint surgery, treat yourself to something above standard. We cover EUR 3 000 for joint surgery and high-quality professional care at Clinica Orthopedica for our policyholders. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/prispevok-na-operaciu-klbov/",
            "category": null
          },
          {
            "type": {
              "sk": "Nadštandardné OCT vyšetrenie očí",
              "cs": "Nadstandardní OCT vyšetření očí",
              "en": "Above-standard OCT eye examination"
            },
            "icon": "eye",
            "benefit": {
              "sk": "Vyšetrenie zadarmo",
              "cs": "Vyšetrení zdarma",
              "en": "Free examination"
            },
            "description": {
              "sk": "Včasná návšteva očného lekára dokáže zachrániť zrak. Pri mnohých očných ochoreniach platí, že sú dobre liečiteľné, pokiaľ sa diagnostikujú včas. Nepodceňte nastupujúce ťažkosti. S nami budete mať špeciálne vyšetrenie OCT - optickú koherentnú tomografiu - vo vybraných klinikách zadarmo. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Včasná návšteva očního lékaře dokáže zachránit zrak. U mnohých očních onemocněních platí, že jsou dobře léčitelná, pokud se diagnostikují včas. Nepodceňujte nastávající potíže. S námi budete mít speciální vyšetření OCT - optickou koherentní tomografii - ve vybraných klinikách zdarma.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "An early visit to an eye doctor can save your vision. Many eye diseases are easily treatable if diagnosed early. Don't underestimate the onset of problems. With us, you will receive a special OCT examination – optical coherence tomography – free of charge at selected clinics. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/opticka-koherentna-tomografia/",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy na vybrané komerčné poistenia Union poisťovne",
              "cs": "Slevy na vybraná komerční pojištění Union pojišťovny",
              "en": "Discounts on selected commercial insurance policies from Union Insurance Company"
            },
            "icon": "globus",
            "benefit": {
              "sk": "Zľavy až do výšky 30 % na komerčné poistenia Union poisťovne",
              "cs": "Slevy až do výše 30 % na komerční pojištění Union pojišťovny",
              "en": "Discounts of up to 30% on commercial insurance from Union Insurance Company"
            },
            "description": {
              "sk": "Poistenci a poistenky Union zdravotnej poisťovne môžu čerpať zľavy až do výšky 30 % na komerčné poistenia Union poisťovne. Využiť ich môžete ihneď. Či už ste poistencom, alebo ste len odoslali prihlášku. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pojištěnci a pojištěnky zdravotní pojišťovny Union mohou čerpat slevy až do výše 30 % na komerční pojištění pojišťovny Union. Využít je můžete ihned. Ať už jste pojištěnci, nebo jste pouze odeslali přihlášku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Union Health Insurance policyholders can get discounts of up to 30% on Union Insurance commercial insurance policies. You can use them right away, whether you're already insured or have just sent in your application. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/zlavy-na-komercne-poistenia/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na komplexné vyšetrenie spermiogramu",
              "cs": "Příspěvek na komplexní vyšetření spermiogramu",
              "en": "Contribution for a comprehensive spermiogram examination"
            },
            "icon": "testicles",
            "benefit": {
              "sk": "Až 100 eur na komplexné vyšetrenie spermiogramu",
              "cs": "Až 100 Kč EUR komplexní vyšetření spermiogramu",
              "en": "Up to EUR 100 for a comprehensive spermiogram examination"
            },
            "description": {
              "sk": "Union zdravotná poisťovňa poskytuje na komplexné vyšetrenie spermiogramu príspevok 100 EUR poskytovateľom zdravotnej starostlivosti – zmluvným centrám asistovanej reprodukcie. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravotní pojišťovna Union poskytuje na komplexní vyšetření spermiogramu příspěvek 100 EUR poskytovatelům zdravotnické péče – smluvním centrům asistované reprodukce. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The Union health insurance company will contribute EUR 100 for a comprehensive spermiogram examination performed by a health services providers - authorized assisted reproduction centres. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/spermiogram-komplexne-vysetrenie/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na mikromanipulačnú techniku ICSI ",
              "cs": "Příspěvek na mikromanipulační techniku ICSI",
              "en": "Contribution for ICSI (intracytoplasmic sperm injection)"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Príspevok 200 eur na mikromanipulačnú techniku ICSI",
              "cs": "Příspěvek 200 EUR na mikromanipulační techniku ICSI",
              "en": "A contribution of EUR 200 for ICSI"
            },
            "description": {
              "sk": "Union zdravotná poisťovňa poskytuje na intracytoplazmatickú injekciu spermie (ICSI) príspevok 200 EUR poskytovateľom zdravotnej starostlivosti – zmluvným centrám asistovanej reprodukcie. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravotní pojišťovna Union poskytuje na intracytoplazmatickou injekci spermie (ICSI) příspěvek 200 EUR poskytovatelům zdravotní péče – smluvním centrům asistované reprodukce.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The Union health insurance company will contribute EUR 200 for intracytoplasmic sperm injection (ICSI) performed by a health services providers - authorized assisted reproduction centres. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/icsi-mikromanipulacna-technika/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na predimplantačnú genetickú diagnostiku",
              "cs": "Příspěvek na predimplantační genetickou diagnostiku",
              "en": "Contribution for pre-implant genetic diagnostics"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Príspevok 900 EUR na predimplantačnú genetickú diagnostiku",
              "cs": "Příspěvek 900 EUR na predimplantační genetickou diagnostiku",
              "en": "A contribution of EUR 900 for pre-implant genetic diagnostics"
            },
            "description": {
              "sk": "Union zdravotná poisťovňa poskytuje na predimplantačnú genetickú diagnostiku (PGD) príspevok 900 EUR poskytovateľom zdravotnej starostlivosti – zmluvným centrám asistovanej reprodukcie. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravotní pojišťovna Union poskytuje na predimplantační genetickou diagnostiku (PGD) příspěvek 900 EUR  poskytovatelům zdravotní péče – smluvním centrům asistované reprodukce.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The Union health insurance company will contribute EUR 900 for pre-implant genetic diagnostics performed by a health services providers - authorized assisted reproduction centres. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/pgd-predimplantacna-geneticka-diagnostika/",
            "category": null
          },
          {
            "type": {
              "sk": "Preventívne vyšetrenie rakoviny prostaty",
              "cs": "Preventivní vyšetření rakoviny prostaty",
              "en": "Preventive examination for prostate cancer"
            },
            "icon": "prostate",
            "benefit": {
              "sk": "Vyšetrenie zadarmo",
              "cs": "Vyšetrení zdarma",
              "en": "Free examination"
            },
            "description": {
              "sk": "Preventívna prehliadka u urológa pomáha zachytiť rakovinu prostaty vo včasnej fáze. U Union zdravotné poisťovny máte preventívnu prehliadku už od štyridsiateho roku života. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Preventivní prohlídka u urologa pomáhá zachytit rakovinu prostaty v raném stádiu. U zdravotní pojišťovny Union máte preventivní prohlídku už od čtyřicátého roku života. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A preventive examination performed by a urologist helps detect prostate cancer it its early phase. At Union Health Insurance Company you can have a preventive examination as early as age 40. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/rakovina-prostaty/",
            "category": null
          },
          {
            "type": {
              "sk": "Preventívne vyšetrenie rakoviny hrubého čreva a konečníka",
              "cs": "Preventivní vyšetření rakoviny tlustého střeva a konečníku",
              "en": "Preventive examination for colon and anal cancer"
            },
            "icon": "rectum",
            "benefit": {
              "sk": "Vyšetrenie zadarmo",
              "cs": "Vyšetrení zdarma",
              "en": "Free examination"
            },
            "description": {
              "sk": "Preventívne vyšetrenie rakoviny hrubého čreva a konečníka. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Prevetivní vyšetření rakoviny tlustého střeva a konečníku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Preventive examination for colon and anal cancer More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/vysetrenie-hrube-crevo-konecnik/",
            "category": null
          },
          {
            "type": {
              "sk": "Test mentálneho zdravia ako prevencia demencie",
              "cs": "Test mentálního zdraví jako prevence demence",
              "en": "Mental health test for dementia prevention"
            },
            "icon": "happy",
            "benefit": {
              "sk": "Test mentálneho zdravia zadarmo",
              "cs": "Test mentálního zdraví zdarma",
              "en": "A free mental health test"
            },
            "description": {
              "sk": "Medzi najzávažnejšie choroby, ktoré ničia pamäť a duševné zdravie, patrí najmä Alzheimerova choroba. V rámci preventívnej prehliadky máte nárok na test mentálneho zdravia zadarmo. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Mezi najzávažneější choroby, které ničí paměť a duševní zdraví, patří zejména Alzheimerova choroba. V rámci preventivní prohlídky máte nárok na test mentálního zdraví zadarmo. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Alzheimer's disease is one of the most serious diseases destroying memory and mental health. The preventive examination includes a free mental health test. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/test-mentalneho-zdravia-ako-prevencia-demencie/",
            "category": null
          },
          {
            "type": {
              "sk": "Union zľavy",
              "cs": "Union slevy",
              "en": "Union discounts"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Zľavy až 1 000 eur ročne",
              "cs": "Slevy až 1 000 EUR ročně",
              "en": "Discounts of up to EUR 1 000 per year"
            },
            "description": {
              "sk": "Exkluzívne zľavy vám ušetria až 1 000 eur ročne, vďaka čomu bude starostlivosť o vaše zdravie a zdravie vašich blízkych ľahšia. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Díky exkluzivním slevám ušetříte až 1 000 EUR ročně, což vám usnadní péči o vaše zdraví i zdraví vašich blízkých.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Exclusive discounts will save you up to EUR 1 000 per year, making it easier to take care of your health and the health of your loved ones. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/union-zlavy/#volnopredajne-lieky-a-vyzivove-doplnky",
            "category": null
          },
          {
            "type": {
              "sk": "Ďalšie služby a výhody pre vás",
              "cs": "Další služby a výhody",
              "en": "More services and benefits for you"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Veľa ďalších služieb, výhod a zliav",
              "cs": "Spoustu dalších služeb, výhod a slev",
              "en": "Many other services, benefits, and discounts"
            },
            "description": {
              "sk": "Union zdravotná poisťovňa poskytuje veľa ďalších služieb, výhod a zliav. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravotní pojišťovna Union poskytuje spoustu dalších služeb, výhod a slev. \nUnion\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Union Health Insurance Company provides many other services, benefits, and discounts. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/spolocne-za-zdravie-poistencov/",
            "category": null
          }
        ]
      },
      {
        "name": {
          "sk": "Ženy",
          "cs": "Ženy",
          "en": "Women"
        },
        "benefits": [
          {
            "type": {
              "sk": "Očkovanie",
              "cs": "Očkování",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "sk": "Príspevky vo výške 50 až 100% z ceny očkovania",
              "cs": "Příspěvky ve výši 50 % až 100 % z ceny očkování",
              "en": "Contributions of 50 to 100 % of the cost of vaccination"
            },
            "description": {
              "sk": "Našim poistencom a poistenkám preplácame 50 % z ceny vakcíny pri viacerých dobrovoľných očkovaniach. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Našim pojištěncům proplácíme 50 % z ceny vakcíny při vícero dobrovolných očkováních. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We reimburse our policyholders 50% of the cost of vaccines for several voluntary vaccinations. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/ockovanie/",
            "category": "Ženy"
          },
          {
            "type": {
              "sk": "Príspevok na umelé oplodnenie",
              "cs": "Příspěvek na umělé oplodnění",
              "en": "Contribution for artificial insemination"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Až 1 200 eur príspevok na umelé oplodnenie",
              "cs": "Až 1 200 EUR příspěvek na umělé oplodnění",
              "en": "Up to EUR 1 200 contribution for artificial insemination"
            },
            "description": {
              "sk": "Prispejeme vám na umelé oplodnenie až do 1 200 eur. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Přispějeme vám na umělé oplodnění až do 1 200 EUR. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We'll contribute up to EUR 1200 for artificial insemination. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/umele-oplodnenie-union-family/",
            "category": null
          },
          {
            "type": {
              "sk": "Prispevok na poplatky za lieky a dietetické potraviny",
              "cs": "Příspěvek na poplatky za léky a dietní potraviny",
              "en": "Contribution to the cost of medicines and dietary foods"
            },
            "icon": "pill",
            "benefit": {
              "sk": "Až 300 eur vrátime doplatky za lieky a dietetické potraviny\n",
              "cs": "Až 300 EUR vrátíme doplatky za léky a dietní potraviny",
              "en": "We will refund up to EUR 300 for medicines and dietary foods"
            },
            "description": {
              "sk": "Každému, bez ohľadu na vek či rodinný stav, vrátime doplatky za lieky a dietetické potraviny až do výšky 300 eur. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Každému, bez ohledu na věk či rodinný stav, vrátíme doplatky za léky a dietní potraviny až do výšky 300 EUR. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will reimburse everyone, regardless of age or marital status, for additional payments for medicines and dietary foods up to EUR 300. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/vratenie-doplatkov-za-lieky-pre-dospelych",
            "category": null
          },
          {
            "type": {
              "sk": "Zrak",
              "cs": "Zrak",
              "en": "Vision"
            },
            "icon": "eye",
            "benefit": {
              "sk": "Až 150 eur na vyšetrenie zraku",
              "cs": "Až 150 EUR na vyšetření zraku",
              "en": "Up to EUR 150 for vision examination"
            },
            "description": {
              "sk": "Prispejeme vám až 150 eur na nadštandardnú zdravotnú starostlivosť vo vybraných očných klinikách a na nákup kvalitných okuliarov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Přispějeme vám až 150 EUR na nadstandardní zdravotní péči ve vybraných očních klinikách a na nákup kvalitních brýlí.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will contribute up to EUR 150 towards above-standard healthcare at selected eye clinics and the purchase of high-quality glasses. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/ocny-balik/",
            "category": null
          },
          {
            "type": {
              "sk": "Telefonická podpora weLive pre onkologických pacientov a ich rodiny",
              "cs": "Telefonická podpora weLive pro onkologické pacienty a jejich rodiny",
              "en": "weLive telephone support for cancer patients and their families"
            },
            "icon": "digitalni-zdravi",
            "benefit": {
              "sk": "bezplatná telefonická podpora",
              "cs": "Bezplatná telefonická podpora",
              "en": "Free telephone support"
            },
            "description": {
              "sk": "V spolupráci s weLive vám prinášame bezplatnú telefonickú podporu pre onkologických pacientov a ich rodiny. Poraďte sa o diagnóze a zorientujte sa v možnostiach a povinnostiach. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "V spolupráci s weLive vám přinášíme bezplatnou telefonickou podporu pro onkologické pacienty a jejich rodiny. Poraďte se o diagnóze a zorientujte se v možnostech a povinnostech. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "In cooperation with weLive, we offer free telephone support for cancer patients and their families. Discuss your diagnosis and learn about your options and responsibilities. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/benefit/telefonicka-podpora-welive-pre-onkologickych-pacientov-a-ich-rodiny/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na operáciu kĺbov",
              "cs": "Příspěvek na operaci kloubů",
              "en": "Contribution to joint surgery"
            },
            "icon": "osteoporosis",
            "benefit": {
              "sk": "Až 3 000 eur na operáciu kĺbov a kvalitnú profesionálnu starostlivosť v zariadení Clinica Orthopedica\n",
              "cs": "Až 3 000 Kč na operáci kloubů a kvalitní profesionální péči v zařízení Clinica Orthopedica",
              "en": "Up to EUR 3 000 for joint surgery and high-quality professional care at Clinica Orthopedica"
            },
            "description": {
              "sk": "Ak potrebujete operáciu bedrového alebo kolenného kĺbu, doprajte si nadštandard. Za našich poistencov hradíme 3 000 eur na operáciu kĺbov a kvalitnú profesionálnu starostlivosť v zariadení Clinica Orthopedica. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pokud potřebujete operaci kyčelního nebo kolenního kloubu, dopřejete si nadstandard. Za naše pojištěnce hradíme 3 000 EUR za operaci kloubů a  kvalitní profesionální péči v zařízení Clinica Orthopedica.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "If you need hip or knee joint surgery, treat yourself to something above standard. We cover EUR 3 000 for joint surgery and high-quality professional care at Clinica Orthopedica for our policyholders. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/prispevok-na-operaciu-klbov/",
            "category": null
          },
          {
            "type": {
              "sk": "Nadštandardné OCT vyšetrenie očí",
              "cs": "Nadstandardní OCT vyšetření očí",
              "en": "Above-standard OCT eye examination"
            },
            "icon": "eye",
            "benefit": {
              "sk": "Vyšetrenie zadarmo",
              "cs": "Vyšetrení zdarma",
              "en": "Free examination"
            },
            "description": {
              "sk": "Včasná návšteva očného lekára dokáže zachrániť zrak. Pri mnohých očných ochoreniach platí, že sú dobre liečiteľné, pokiaľ sa diagnostikujú včas. Nepodceňte nastupujúce ťažkosti. S nami budete mať špeciálne vyšetrenie OCT - optickú koherentnú tomografiu - vo vybraných klinikách zadarmo. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Včasná návšteva očního lékaře dokáže zachránit zrak. U mnohých očních onemocněních platí, že jsou dobře léčitelná, pokud se diagnostikují včas. Nepodceňujte nastávající potíže. S námi budete mít speciální vyšetření OCT - optickou koherentní tomografii - ve vybraných klinikách zdarma.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "An early visit to an eye doctor can save your vision. Many eye diseases are easily treatable if diagnosed early. Don't underestimate the onset of problems. With us, you will receive a special OCT examination – optical coherence tomography – free of charge at selected clinics. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/opticka-koherentna-tomografia/",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy na vybrané komerčné poistenia Union poisťovne",
              "cs": "Slevy na vybraná komerční pojištění Union pojišťovny",
              "en": "Discounts on selected commercial insurance policies from Union Insurance Company"
            },
            "icon": "globus",
            "benefit": {
              "sk": "Zľavy až do výšky 30 % na komerčné poistenia Union poisťovne",
              "cs": "Slevy až do výše 30 % na komerční pojištění Union pojišťovny",
              "en": "Discounts of up to 30% on commercial insurance from Union Insurance Company"
            },
            "description": {
              "sk": "Poistenci a poistenky Union zdravotnej poisťovne môžu čerpať zľavy až do výšky 30 % na komerčné poistenia Union poisťovne. Využiť ich môžete ihneď. Či už ste poistencom, alebo ste len odoslali prihlášku. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pojištěnci a pojištěnky zdravotní pojišťovny Union mohou čerpat slevy až do výše 30 % na komerční pojištění pojišťovny Union. Využít je můžete ihned. Ať už jste pojištěnci, nebo jste pouze odeslali přihlášku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Union Health Insurance policyholders can get discounts of up to 30% on Union Insurance commercial insurance policies. You can use them right away, whether you're already insured or have just sent in your application. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/zlavy-na-komercne-poistenia/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na mikromanipulačnú techniku ICSI",
              "cs": "Příspěvek na mikromanipulační techniku ICSI",
              "en": "Contribution for ICSI (intracytoplasmic sperm injection)"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Príspevok 200 eur na mikromanipulačnú techniku ICSI",
              "cs": "Příspěvek 200 EUR na mikromanipulační techniku ICSI",
              "en": "A contribution of EUR 200 for ICSI"
            },
            "description": {
              "sk": "Union zdravotná poisťovňa poskytuje na intracytoplazmatickú injekciu spermie (ICSI) príspevok 200 EUR poskytovateľom zdravotnej starostlivosti – zmluvným centrám asistovanej reprodukcie. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravotní pojišťovna Union poskytuje na intracytoplazmatickou injekci spermie (ICSI) příspěvek 200 EUR poskytovatelům zdravotní péče – smluvním centrům asistované reprodukce.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The Union health insurance company will contribute EUR 200 for intracytoplasmic sperm injection (ICSI) performed by a health services providers - authorized assisted reproduction centres. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/icsi-mikromanipulacna-technika/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na predimplantačnú genetickú diagnostiku",
              "cs": "Příspěvek na predimplantační genetickou diagnostiku",
              "en": "Contribution for pre-implant genetic diagnostics"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Príspevok 900 EUR na predimplantačnú genetickú diagnostiku",
              "cs": "Příspěvek 900 EUR na predimplantační genetickou diagnostiku",
              "en": "A contribution of EUR 900 for pre-implant genetic diagnostics"
            },
            "description": {
              "sk": "Union zdravotná poisťovňa poskytuje na predimplantačnú genetickú diagnostiku (PGD) príspevok 900 EUR poskytovateľom zdravotnej starostlivosti – zmluvným centrám asistovanej reprodukcie. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravotní pojišťovna Union poskytuje na predimplantační genetickou diagnostiku (PGD) příspěvek 900 EUR  poskytovatelům zdravotní péče – smluvním centrům asistované reprodukce.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The Union health insurance company will contribute EUR 900 for pre-implant genetic diagnostics performed by a health services providers - authorized assisted reproduction centres. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/pgd-predimplantacna-geneticka-diagnostika/",
            "category": null
          },
          {
            "type": {
              "sk": "Preventívne vyšetrenie rakoviny hrubého čreva a konečníka",
              "cs": "Preventivní vyšetření rakoviny tlustého střeva a konečníku",
              "en": "Preventive examination for colon and anal cancer"
            },
            "icon": "rectum",
            "benefit": {
              "sk": "Vyšetrenie zadarmo",
              "cs": "Vyšetrení zdarma",
              "en": "Free examination"
            },
            "description": {
              "sk": "Preventívne vyšetrenie rakoviny hrubého čreva a konečníka. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Prevetivní vyšetření rakoviny tlustého střeva a konečníku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Preventive examination for colon and anal cancer More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/vysetrenie-hrube-crevo-konecnik/",
            "category": null
          },
          {
            "type": {
              "sk": "Pomoc pôrodnej asistentky u vás doma",
              "cs": "Pomoc porodní asistentky u vás doma",
              "en": "A birth assistant in your home"
            },
            "icon": "care",
            "benefit": {
              "sk": "Pomoc pôrodnej asistentky u vás doma úplne zadarmo",
              "cs": "Pomoc porodní asistentky u vás doma zcela zdarma",
              "en": "A birth assistant in your home, completely free"
            },
            "description": {
              "sk": "Union zdravotná poisťovňa vám služby licencovanej asistentky preplatí v plnej výške. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravotní pojišťovna Union vám služby licencované asistentky proplatí v plné výši. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The Union health insurance company will completely cover the services of a licensed assistant. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/vyhody-porodna-asistencia/",
            "category": null
          },
          {
            "type": {
              "sk": "Test mentálneho zdravia ako prevencia demencie",
              "cs": "Test mentálního zdraví jako prevence demence",
              "en": "Mental health test for dementia prevention"
            },
            "icon": "happy",
            "benefit": {
              "sk": "Test mentálneho zdravia zadarmo",
              "cs": "Test mentálního zdraví zdarma",
              "en": "A free mental health test"
            },
            "description": {
              "sk": "Medzi najzávažnejšie choroby, ktoré ničia pamäť a duševné zdravie, patrí najmä Alzheimerova choroba. V rámci preventívnej prehliadky máte nárok na: Test mentálneho zdravia zadarmo. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Mezi najzávažneější choroby, které ničí paměť a duševní zdraví, patří zejména Alzheimerova choroba. V rámci preventivní prohlídky máte nárok na test mentálního zdraví zadarmo. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Alzheimer's disease is one of the most serious diseases destroying memory and mental health. The preventive examination includes a free mental health test. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/test-mentalneho-zdravia-ako-prevencia-demencie/",
            "category": null
          },
          {
            "type": {
              "sk": "Union zľavy",
              "cs": "Union slevy",
              "en": "Union discounts"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Zľavy až 1 000 eur ročne",
              "cs": "Slevy až 1 000 EUR ročně",
              "en": "Discounts of up to EUR 1 000 per year"
            },
            "description": {
              "sk": "Exkluzívne zľavy vám ušetria až 1 000 eur ročne, vďaka čomu bude starostlivosť o vaše zdravie a zdravie vašich blízkych ľahšia. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Díky exkluzivním slevám ušetříte až 1 000 EUR ročně, což vám usnadní péči o vaše zdraví i zdraví vašich blízkých.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Exclusive discounts will save you up to EUR 1 000 per year, making it easier to take care of your health and the health of your loved ones. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/union-zlavy/#volnopredajne-lieky-a-vyzivove-doplnky",
            "category": null
          },
          {
            "type": {
              "sk": "BRCAscreen test na odhalenie DNA predispozície rakoviny prsníka",
              "cs": "BRCAscreen test na odhalení DNA predispozice rakoviny prsu",
              "en": "BRCA screening test for genetic predisposition to breast cancer"
            },
            "icon": "ribbon",
            "benefit": {
              "sk": "Test, na odhalenie predispozície rakoviny prsníka v hodnote 145 eur ",
              "cs": "Test na odhalení predispozice rakoviny prsu v hodnotě 145 EUR",
              "en": "A test for genetic predisposition for breast cancer, worth EUR 145, free of charge"
            },
            "description": {
              "sk": "Preplatíme vám špeciálny test BRCAscreen, ktorý spoľahlivo odhalí predispozície na rakovinu prsníka. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Proplatíme vám speciální test BRCAscreen, který spolehlivě odhalí predispozice pro rakovinu prsu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will reimburse you for a special BRCA screening test that will reliably reveal breast cancer predisposition. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/brcascreen-test-na-zistenie-dna-predispozicie-k-rakovine-prsnika/",
            "category": null
          },
          {
            "type": {
              "sk": "Ďalšie služby a výhody pre vás",
              "cs": "Další služby a výhody",
              "en": "More services and benefits for you"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Veľa ďalších služieb, výhod a zliav",
              "cs": "Spoustu dalších služeb, výhod a slev",
              "en": "Many other services, benefits, and discounts"
            },
            "description": {
              "sk": "Union zdravotná poisťovňa poskytuje veľa ďalších služieb, výhod a zliav. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravotní pojišťovna Union poskytuje spoustu dalších služeb, výhod a slev. \nUnion\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Union Health Insurance Company provides many other services, benefits, and discounts. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/spolocne-za-zdravie-poistencov/",
            "category": null
          },
          {
            "type": {
              "sk": "Cytologické vyšetrenie metódou LBC ako prevencia rakoviny krčka maternice",
              "cs": "Cytologické vyšetření metodou LBC jako prevence rakoviny děložního čípku",
              "en": "Liquid Based Cytology (LBC) test for cervical cancer prevention"
            },
            "icon": "ribbon",
            "benefit": {
              "sk": "Vyšetrenie steru metódou LBC raz ročne bezplatne",
              "cs": "Vyšetrenie stěru metodou LBC jednou ročně",
              "en": "One free LBC swab test per year"
            },
            "description": {
              "sk": "Cytologické vyšetrenie metódou LBC, ktoré dokáže odhaliť aj včasné štádiá rakoviny krčka maternice, indikované u zmluvného gynekológa raz ročne bezplatne. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Cytologické vyšetření metodou LBC, které dokáže odhalit i raná stádia rakoviny děložního čípku, indikované u smluvního gynekologa jednou ročně bezplatně. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Cytological examination by the LBC method, which can also detect early stages of cervical cancer, indicated by a contracted gynaecologist once a year free of charge. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/vysetrenie-lbc-bez-doplatku/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na monitor dýchania bábätka",
              "cs": "Příspěvek na monitoru dechu miminka",
              "en": "A contribution for a baby breathing monitor"
            },
            "icon": "care",
            "benefit": {
              "sk": "Prispejeme vám 30 eur na zakúpenie monitoru dychu bábätka",
              "cs": "Až 30 EUR na zakoupení monitoru dechu miminka",
              "en": "We will contribute €30 towards the purchase of a baby breathing monitor."
            },
            "description": {
              "sk": "Monitor dychu postráži spánok vášho bábätka aj vo chvíľach, keď vy zaslúžene oddychujete. Prispejeme vám 30 eur na nákup vlastného zariadenia na sledovanie dychu novorodenca. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Monitor dechu pohlídá spánek vašeho miminka i ve chvílích, kdy vy zaslouženě odpočíváte. Přispějeme vám 30 EUR na nákup vlastního zařízení na sledování dechu novorozence. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The breath monitor watches over your baby's sleep even when you are taking a well-deserved rest. We will contribute EUR 30 towards the purchase of your own device for monitoring your newborn's breathing. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/monitor-dychu/",
            "category": null
          }
        ]
      },
      {
        "name": {
          "sk": "Deti",
          "cs": "Děti",
          "en": "Children"
        },
        "benefits": [
          {
            "type": {
              "sk": "Očkovanie",
              "cs": "Očkování",
              "en": "Vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "sk": "Príspevky vo výške 50 až 100% z ceny očkovania",
              "cs": "Příspěvky ve výši 50 % až 100 % z ceny očkování",
              "en": "Contributions of 50 to 100 % of the cost of vaccination"
            },
            "description": {
              "sk": "Našim poistencom a poistenkám preplácame 50 % z ceny vakcíny pri viacerých dobrovoľných očkovaniach. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Našim pojištěncům proplácíme 50 % z ceny vakcíny při vícero dobrovolných očkováních. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We reimburse our policyholders 50% of the cost of vaccines for several voluntary vaccinations. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/ockovanie/",
            "category": "Děti"
          },
          {
            "type": {
              "sk": "Zrak",
              "cs": "Zrak",
              "en": "Vision"
            },
            "icon": "eye",
            "benefit": {
              "sk": "Až 150 eur na vyšetrenie zraku",
              "cs": "Až 150 EUR na vyšetření zraku",
              "en": "Up to EUR 150 for vision examination"
            },
            "description": {
              "sk": "Prispejeme vám až 150 eur na nadštandardnú zdravotnú starostlivosť vo vybraných očných klinikách a na nákup kvalitných okuliarov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Přispějeme vám až 150 EUR na nadstandardní zdravotní péči ve vybraných očních klinikách a na nákup kvalitních brýlí.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will contribute up to EUR 150 towards above-standard healthcare at selected eye clinics and the purchase of high-quality glasses. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/ocny-balik/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na dioptrické okuliare pre deti",
              "cs": "Příspěvek na dioptrické brýle pro děti",
              "en": "Contribution towards prescription glasses for children"
            },
            "icon": "glasses",
            "benefit": {
              "sk": "Až 70 eur na dioptrické okuliare pre deti",
              "cs": "Až 70 EUR na dioptrické brýle pro děti",
              "en": "Up to EUR 70 for prescription glasses for children"
            },
            "description": {
              "sk": "Zrak sa u detí neustále vyvíja a včasné odhalenie problémov či správna korekcia sú kľúčové. Každoročne vám preto prispejeme na nákup okuliarov pre dieťa do 18 rokov sumou 70 eur. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zrak se u dětí neustále vyvíjí a včasné odhalení problémů či správná korekce jsou klíčové. Každoročně vám proto přispějeme na nákup brýlí pro dítě do 18 let částkou 70 EUR. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Children's eyesight is constantly developing, and early detection of problems and proper correction are key. That's why we will contribute EUR 70 towards the purchase of glasses for your child under the age of 18 every year. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/pomozeme-vam-s-doplatkom-na-okuliarove-ramy/",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na nákup plienok Pampers",
              "cs": "Sleva na nákup plen Pampers",
              "en": "Discount on the purchase of Pampers diapers"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Až 300 eur na nákup plienok Pampers",
              "cs": "Až 300 EUR na nákup plen Pampers",
              "en": "Up to EUR 300 toward the purchase of Pampers diapers"
            },
            "description": {
              "sk": "Zľava na plienky prémiovej značky Pampers v celkovej hodnote 300 eur.\nJe rozdelená na mesačný 10-25 eurový príspevok na balenie plienok na mesiac. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Sleva na plenky prémiové značky Pampers v celkové hodnotě 300 EUR.\nJe rozdělena na měsíční příspěvek ve výši 10–25 EUR na balení plen za měsíc. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Discount on Pampers premium diapers worth a total of 300 euros.\n The contribution is split into monthly contributions of EUR 10-25 for the purchase of diapers. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/prispevok-na-plienky-pampers/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na dojčenské mlieko, príkrmy a kozmetiku HiPP",
              "cs": "Příspěvek na kojenecké mléko, příkrmy a kosmetiku HiPP",
              "en": "Contribution towards infant milk, complementary foods, and HiPP cosmetics"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Až 150 eur na dojčenské mlieko, príkrmy a kozmetiku HiPP",
              "cs": "Až 150 EUR na kojenecké mléko, příkrmy a kosmetiku HiPP",
              "en": "Up to EUR 150 for HiPP baby milk, baby food and cosmetics"
            },
            "description": {
              "sk": "Deťom poisteným v našej Union zdravotnej poisťovni prispejeme na dojčenské mlieka, detské príkrmy, nápoje i kozmetiku značky HiPP viac ako 150 eur. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Dětem pojištěným v naší zdravotní pojišťovně Union přispějeme na kojenecké mléko, dětskou výživu, nápoje i kosmetiku značky HiPP částkou více než 150 Kč. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will contribute more than €150 towards baby milk, baby food, drinks, and HiPP brand cosmetics for children insured with our Union Health Insurance Company. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/prispevok-na-hipp/",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na kurz plávania pre vaše bábätko",
              "cs": "Příspěvek na kurz plavání pro vaše miminko",
              "en": "Contribution to a swimming course for your baby"
            },
            "icon": "move",
            "benefit": {
              "sk": "Až 30 eur na kurz plávania ",
              "cs": "Až 30 EUR na kurz plavání",
              "en": "Up to EUR 30 for swimming lessons "
            },
            "description": {
              "sk": "Union zdravotná poisťovňa vám prispeje až 30 euro na kurz plávania pre vaše bábätko. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravotní pojišťovna Union vám přispěje až 30 EUR na kurz plavání pro vaše miminko. Více informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Union Health Insurance Company will contribute up to EUR 30 for a swimming course for your baby. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/prispevok-babatka/",
            "category": null
          },
          {
            "type": {
              "sk": "Doplatky za lieky a dietetické potraviny bez obmedzenia",
              "cs": "Doplatky za léky a dietní potraviny bez omezení",
              "en": "Additional payments for medicines and dietetic foods without limit"
            },
            "icon": "pill",
            "benefit": {
              "sk": "Vrátime doplatky za lieky a dietetické potraviny bez obmedzenia ",
              "cs": "Vrátíme doplatky za léky a dietní potraviny bez omezení",
              "en": "We will reimburse co-payments for medicines and dietetic foods without limitation "
            },
            "description": {
              "sk": "Deťom do 18 rokov vrátime doplatky za lieky a dietetické potraviny bez obmedzenia. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Dětem do 18 let proplatíme doplatky za léky a dietní potraviny bez omezení. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will reimburse children under 18 for additional payments for medicines and dietary foods without restriction. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/vratenie-doplatkov-za-lieky-pre-deti/",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava v MamaClass.sk",
              "cs": "Sleva v MamaClass.sk",
              "en": "Discount at MamaClass.sk"
            },
            "icon": "pregnant",
            "benefit": {
              "sk": "Zľava 30 % v MamaClass.sk",
              "cs": "Sleva 30 % v MamaClass.sk",
              "en": "30% discount at MamaClass.sk"
            },
            "description": {
              "sk": "Získajte väčšiu sebadôveru v “mamovaní” a nájdite dôveryhodné odpovede na všetky otázky týkajúce sa tehotenstva, pôrodu a starostlivosti o bábätko. Na zakúpenie prístupu do online tried na MamaClass.sk máte od nás zľavu až 30 %. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Získejte větší sebevědomí v roli maminky a najděte spolehlivé odpovědi na všechny otázky týkající se těhotenství, porodu a péče o miminko. Na nákup přístupu do online kurzů na MamaClass.sk vám nabízíme slevu až 30 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Gain more confidence in motherhood and find reliable answers to all your questions about pregnancy, childbirth, and baby care. We offer a discount of up to 30% on access to online classes at MamaClass.sk. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/materstvo-online-informacie-premamicky-na-portali-mamaclass/",
            "category": null
          },
          {
            "type": {
              "sk": "Knižka Naše dieťatko ",
              "cs": "Kniha Naše dieťatko",
              "en": "The book Our Baby "
            },
            "icon": "child-photo",
            "benefit": {
              "sk": "Pamätníček na prvé spoločné spomienky",
              "cs": "Památníček na první společné vzpomínky",
              "en": "A memento of your first memories together"
            },
            "description": {
              "sk": "Knižka Naše dieťatko je pamätníček, ktorý vám pomôže zaznamenať všetky dôležité okamihy v živote vášho bábätka. Ako darček ju dostane každá tehotná žena. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Kniha Naše dieťatko je památník, který vám pomůže zaznamenat všechny důležité okamžiky v životě vašeho miminka. Jako dárek ji dostane každá těhotná žena. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The book Our Baby is a keepsake that will help you record all the important moments in your baby's life. Every pregnant woman receives it as a gift. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/registracia-knizka-nase-dietatko/",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy na letné pobyty pre deti s poruchami držania tela",
              "cs": "Slevy na letní pobyty pro děti s poruchami držení těla",
              "en": "Discounts on summer stays for children with posture disorders"
            },
            "icon": "tent",
            "benefit": {
              "sk": "Zľava až stopercent na letné pobyty pre deti s poruchami držania tela",
              "cs": "Sleva až 100 % na letní pobyty pro děti s poruchami držení těla",
              "en": "Up to 100% discount on summer camps for children with posture disorders"
            },
            "description": {
              "sk": "Naši detskí poistenci majú až stopercentnú zľavu z doplatku za letný týždňový zotavovací pobyt a zľavu 35 eur z doplatku za denný zotavovací pobyt. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Naši dětscí pojištěnci mají až stoprocentní slevu z doplatku za týdenní letní rekreační pobyt a slevu 35 EUR z doplatku za denní rekreační pobyt. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Our child policyholders receive a 100% discount on the additional fee for a week-long summer recovery stay and a €35 discount on the additional fee for a daily recovery stay. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/pobyty-pre-deti-s-poruchami-drzania-tela/",
            "category": null
          },
          {
            "type": {
              "sk": "Ďalšie služby a výhody pre vás",
              "cs": "Další služby a výhody",
              "en": "More services and benefits for you"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Veľa ďalších služieb, výhod a zliav",
              "cs": "Spoustu dalších služeb, výhod a slev",
              "en": "Many other services, benefits, and discounts"
            },
            "description": {
              "sk": "Union zdravotná poisťovňa poskytuje veľa ďalších služieb, výhod a zliav. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravotní pojišťovna Union poskytuje spoustu dalších služeb, výhod a slev. \nUnion\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Union Health Insurance Company provides many other services, benefits, and discounts. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.union.sk/spolocne-za-zdravie-poistencov/",
            "category": null
          }
        ]
      }
    ],
    "updateDate": "30.1.2026",
    "companyBenefitsLink": "https://www.union.sk/vyhody-pre-poistencov/"
  },
  {
    "slug": "dovera",
    "genders": [
      {
        "name": {
          "sk": "Muži",
          "cs": "Muži",
          "en": "Men"
        },
        "benefits": [
          {
            "type": {
              "sk": "Podpora duševného zdravia\n",
              "cs": "Podpora duševního zdraví",
              "en": "Mental health support"
            },
            "icon": "happy",
            "benefit": {
              "sk": "Až 40 eur na on-line konzultácie s psychológom",
              "cs": "Až 40 EUR na online konzultace s psychologem",
              "en": "Up to EUR 40 for an on-line consultation with a psychologist"
            },
            "description": {
              "sk": "Raz za kalendárny rok si môžete uplatniť zľavový kupón na online konzultácie v hodnote 40 eur. U partnera Mojra môžete navyše využiť aj 2x zľavu 12 % na ktorékoľvek dve sedenia po využití tohto kupónu. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Jednou za kalendářní rok můžete uplatnit slevový kupón na online konzultace v hodnotě 40 EUR. U partnera Mojra můžete navíc využít i 2x slevu 12 % na libovolné dvě sezení po uplatnění tohoto kupónu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Once per calendar year, you can redeem a discount coupon for online consultations worth EUR 40. With our partner Mojra, you can also take advantage of a 12% discount on any two sessions after using this coupon. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia",
            "category": "Muži"
          },
          {
            "type": {
              "sk": "Lekár na diaľku",
              "cs": "Lékař na dálku",
              "en": "Remote doctor"
            },
            "icon": "doctor",
            "benefit": {
              "sk": "Konzultácia s lekárom na diaľku zadarmo",
              "cs": "Konzultace s lékařem na dálku zdarma",
              "en": "Free remote consultation with a doctor"
            },
            "description": {
              "sk": "Netrávte hodiny v čakárni. S aplikáciou MEDDI môžete svoje zdravotné otázky riešiť pohodlne na diaľku, aj večer či cez víkend. Majte apku stále poruke, keď potrebujete odborne poradiť. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Netravte hodiny v čekárně. S aplikací MEDDI můžete své zdravotní dotazy řešit pohodlně na dálku, i večer nebo o víkendu. Mějte aplikaci vždy po ruce, když potřebujete odbornou radu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Don't spend hours in the waiting room. With the MEDDI app, you can conveniently address your health questions remotely, even in the evening or on weekends. Keep the app handy whenever you need expert advice. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/lekar-na-dialku",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy na okuliare a vyšetrenie zraku",
              "cs": "Slevy na brýle a vyšetření zraku",
              "en": "Discount on glasses and an eye exam"
            },
            "icon": "glasses",
            "benefit": {
              "sk": "Zľavy v očných optikách FOKUS",
              "cs": "Slevy v očních optikách FOKUS",
              "en": "Discounts at FOKUS opticians"
            },
            "description": {
              "sk": "Až 90 % všetkých vnemov máme vďaka zraku. Pomáhame vám starať sa o svoje oči. Dospelým poistencom ponúkame zľavy na vyhotovenie, opravu dioptrických okuliarov a kompletné vyšetrenie zraku v očných optikách FOKUS. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Až 90 % všech vjemů získáváme díky zraku. Pomáháme vám pečovat o vaše oči. Dospělým pojištěncům nabízíme slevy na výrobu a opravu dioptrických brýlí a kompletní vyšetření zraku v očních optikách FOKUS. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to 90% of all our perceptions come through our eyesight. We help you take care of your eyes. We offer adult policyholders discounts on the manufacture and repair of prescription glasses and comprehensive eye examinations at FOKUS opticians. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-okuliare-a-vysetrenie-zraku",
            "category": null
          },
          {
            "type": {
              "sk": "Kožné vyšetrenie online a zadarmo",
              "cs": "Online vyšetření kůže zdarma",
              "en": "Online skin examination for free"
            },
            "icon": "dermatology",
            "benefit": {
              "sk": "Kožné vyšetrenie online a zadarmo",
              "cs": "Online vyšetření kůže zdarma",
              "en": "Online skin examination for free"
            },
            "description": {
              "sk": "Máte akné či iný kožný problém? Odfoťte ho a rýchlo a bezpečne odošlite lekárovi. Kožný lekár vám stanoví diagnózu a odporučí liečbu už do 3 pracovných dní. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Máte akné nebo jiný kožní problém? Vyfoťte ho a rychle a bezpečně pošlete lékaři. Dermatolog stanoví diagnózu a doporučí léčbu do 3 pracovních dnů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you have acne or another skin problem? Take a photo and send it quickly and securely to a doctor. A dermatologist will diagnose you and recommend treatment within 3 business days. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/kozne-vysetrenie-online-a-zadarmo",
            "category": null
          },
          {
            "type": {
              "sk": "Fyzio vyšetrenie online a zadarmo",
              "cs": "Fyzioterapeutické vyšetření online a zdarma",
              "en": "Free online physical examination"
            },
            "icon": "running",
            "benefit": {
              "sk": "Fyzio vyšetrenie online a zadarmo",
              "cs": "Fyzioterapeutické vyšetření online a zdarma",
              "en": "Free online physical examination"
            },
            "description": {
              "sk": "Bolesti chrbta, svalov či kĺbov – poznáme to snáď všetci. Máme pre Vás pomoc z pohodlia domova. Opíšte svoj problém a lekár vám odporučí liečbu alebo cvičenia už do 3 pracovných dní. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Bolesti zad, svalů nebo kloubů – to známe snad všichni. Nabízíme vám pomoc z pohodlí domova. Popište svůj problém a lékař vám doporučí léčbu nebo cvičení do 3 pracovních dnů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Back, muscle, or joint pain – we've all been there. We can help you from the comfort of your own home. Describe your problem and a doctor will recommend treatment or exercises within 3 business days. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/fyzio-vysetrenie-online-a-zadarmo",
            "category": null
          },
          {
            "type": {
              "sk": "Zdravé zuby",
              "cs": "Zdravé zuby",
              "en": "Healthy teeth"
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Dospelým prispejeme 2 x 30 € na dentálnu hygienu",
              "cs": "Dospělým přispějeme 2 x 30 € na dentální hygienu",
              "en": "We will contribute EUR 30 twice to adults for dental hygiene."
            },
            "description": {
              "sk": "Dospelým prispejeme 2 x 30 € na dentálnu hygienu. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Dospělým přispějeme 2 x 30 € na dentální hygienu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will contribute EUR 30 twice to adults for dental hygiene. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zdrave-zuby-pre-dospelych-aj-deti",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na dobrovoľné očkovanie",
              "cs": "Příspěvek na dobrovolné očkování",
              "en": "Contribution to voluntary vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "sk": "Príspevok na rôzne typy očkovaní",
              "cs": "Příspěvek na různé typy očkování",
              "en": "Contribution for various types of vaccinations"
            },
            "description": {
              "sk": "Poistencom preplácame viaceré dobrovoľné očkovania, napríklad proti chrípke, kliešťom či HPV. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pojištěncům proplácíme řadu dobrovolných očkování, například proti chřipce, klíšťatům nebo HPV. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We reimburse our policyholders for several voluntary vaccinations, such as against influenza, ticks, and HPV. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispejeme-vam-na-dobrovolne-ockovanie#tabpanel-ockovanie_1",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na laserovú operáciu očí",
              "cs": "Sleva na laserovou operaci očí",
              "en": "Discount on eye surgery"
            },
            "icon": "eye",
            "benefit": {
              "sk": "Príspevok 500 eur na laserovú operáciu očí",
              "cs": "Příspěvek 500 EUR na laserovou operaci očí",
              "en": "Contribution of 500 eur for laser eye surgery"
            },
            "description": {
              "sk": "Chcete si užívať život bez okuliarov a kontaktných šošoviek? Vylepšite svoj zrak pomocou laserovej operácie očí metódou iLasik. Poistencom Dôvery ponúkame možnosť využiť zľavu 500 € na laserový zákrok v očnej klinike VESELY. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Chcete si užívat život bez brýlí a kontaktních čoček? Vylepšete si zrak pomocí laserové operace očí metodou iLasik. Pojištěncům Dôvěry nabízíme možnost využít slevu 500 € na laserový zákrok v oční klinice VESELY. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Want to enjoy life without glasses or contacts? Improve your vision with iLasik laser eye surgery. We offer Dôvera insurance policyholders a EUR 500 discount on laser surgery at the VESELY Eye Clinic. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-500-eur-na-laserovu-operaciu-oci",
            "category": null
          },
          {
            "type": {
              "sk": "Prednostné objednanie na MR, RTG, sono a mamografiu",
              "cs": "Přednostní objednání na MRI, RTG, ultrazvuk a mamografii",
              "en": "Priority appointments for MRI, X-ray, ultrasound, and mammography"
            },
            "icon": "calendar-previous",
            "benefit": {
              "sk": "Prednostné objednanie na MR, RTG, sono a mamografiu",
              "cs": "Přednostní objednání na MRI, RTG, ultrazvuk a mamografii",
              "en": "Priority appointments for MRI, X-ray, ultrasound, and mammography"
            },
            "description": {
              "sk": "Potrebujete ísť na vyšetrenie MR, RTG, sono alebo mamografiu? Ako poistenec Dôvery môžete získať rýchly termín v Poliklinike Bezručova v Bratislave. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Potřebujete jít na vyšetření MRI, RTG, ultrazvuk nebo mamografii? Jako pojištěnec pojišťovny Dôvera můžete získat rychlý termín v Poliklinice Bezručova v Bratislavě. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you need to go for an MRI, X-ray, ultrasound, or mammogram? As a Dôvera policyholder, you can get a quick appointment at the Bezručova Polyclinic in Bratislava. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/prednostne-objednanie-na-mr-rtg-sono-a-mamografiu",
            "category": null
          },
          {
            "type": {
              "sk": "Doprava do Nemocnice Bory",
              "cs": "Doprava do Nemocnice Bory",
              "en": "Transport to Bory Hospital"
            },
            "icon": "hospital",
            "benefit": {
              "sk": "Zabezpečíme vám odvoz na hospitalizáciu do Nemocnice Bory v Bratislave zadarmo.",
              "cs": "Zajistíme vám bezplatnou dopravu k hospitalizaci do Nemocnice Bory v Bratislavě",
              "en": "We will arrange free transportation to Bory Hospital in Bratislava for your hospitalization."
            },
            "description": {
              "sk": "Čaká vás operácia či iný zákrok a radi by ste ich absolvovali v jednej z najmodernejších nemocníc v strednej Európe? Zabezpečíme vám odvoz na hospitalizáciu do Nemocnice Bory v Bratislave zadarmo. Samozrejmosťou je aj bezplatná doprava späť domov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Čeká vás operace nebo jiný zákrok a rádi byste je podstoupili v jedné z nejmodernějších nemocnic ve střední Evropě? Zajistíme vám bezplatnou dopravu k hospitalizaci do Nemocnice Bory v Bratislavě. Samozřejmostí je i bezplatná doprava zpět domů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Are you awaiting surgery or another procedure and would like to have it done at one of the most modern hospitals in Central Europe? We will arrange free transportation to Bory Hospital in Bratislava for your hospitalization. Free transportation back home is also a matter of course. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/doprava-do-nemocnice-bory",
            "category": null
          },
          {
            "type": {
              "sk": "Samodiagnostický nástroj",
              "cs": "Samodiagnostický nástroj",
              "en": "Self-diagnostic tool"
            },
            "icon": "care",
            "benefit": {
              "sk": "Samodiagnostický nástroj je pre poistencov Dôvery bezplatný.",
              "cs": "Samodiagnostický nástroj je pro pojištěnce Dôvery bezplatný",
              "en": "The self-diagnostic tool is free of charge for Dôvera policyholders."
            },
            "description": {
              "sk": "Necítite sa dobre, pociťujete duševnú nepohodu a lekár nie je nablízku? Vyskúšajte  samodiagnostický nástroj, ktorý je pre poistencov Dôvery bezplatný. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Necítíte se dobře, trpíte psychickými potížemi a lékař není nablízku? Vyzkoušejte  samodiagnostický nástroj, který je pro pojištěnce Dôvery zdarma. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Are you feeling unwell, experiencing mental distress, and your doctor is not available? Try the self-diagnostic tool, which is free for Dôvera policyholders. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/samodiagnosticky-nastroj",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy na pobyty v kúpeľoch",
              "cs": "Slevy na pobyty v lázních",
              "en": "Discounts on stays at spas"
            },
            "icon": "bath",
            "benefit": {
              "sk": "Zľava až 70% na pobyty v Moderných kúpeľoch Turčianske Teplice",
              "cs": "Sleva až 70 % na pobyty v Moderních lázních Turčianske Teplice",
              "en": "Up to 70% discount on stays at Moderné kúpele Turčianske Teplice"
            },
            "description": {
              "sk": "Za relax a pevnejšie zdravie zaplatíte menej. Až 70% pre poistencov Dôvery máme vybrané kúpeľné pobyty v Moderných kúpeľoch Turčianske Teplice so zľavou. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Za relaxaci a lepší zdraví zaplatíte méně. Pro pojištěnce pojišťovny Dôvera máme vybrané lázeňské pobyty v Moderních lázních Turčianske Teplice se slevou až 70 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "You will pay less for relaxation and better health. We offer selected spa stays at Moderné kúpele Turčianske Teplice with a discount of up to 70% for Dôvera insurance policyholders. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-pobyty-v-modernych-kupeloch-turcianske-teplice",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na online terapiu",
              "cs": "Sleva na online terapii",
              "en": "Discount on online therapy"
            },
            "icon": "phone-video",
            "benefit": {
              "sk": "Zľava na online terapiu s Mojra, Hedepy a ksebe",
              "cs": "Sleva na online terapii s Mojra, Hedepy a ksebe",
              "en": "Discount on online therapy with Mojra, Hedepy, and ksebe"
            },
            "description": {
              "sk": "Zľava na online terapiu s Mojra, Hedepy a ksebe. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Sleva na online terapii s Mojra, Hedepy a ksebe. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Discount on online therapy with Mojra, Hedepy, and ksebe. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy na cestovné poistenie od Generali",
              "cs": "Slevy na cestovní pojištění od Generali",
              "en": "Discounts on travel insurance from Generali"
            },
            "icon": "suitcase",
            "benefit": {
              "sk": "Zľavy do 30 % na cestovné poistenie od Generali",
              "cs": "Slevy až 30 % na cestovní pojištění od Generali",
              "en": "Discounts of up to 30% on travel insurance from Generali"
            },
            "description": {
              "sk": "Zľavy do 30 % na cestovné poistenie od Generali. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Slevy až 30 % na cestovní pojištění od Generali. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Discounts of up to 30% on travel insurance from Generali. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-az-30-na-cestovne-poistenie",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok u nezmluvného lekára",
              "cs": "Příspěvek u nesmluvního lékaře",
              "en": "Allowance with a non-contractual doctor"
            },
            "icon": "two-doctors",
            "benefit": {
              "sk": "Vrátime vám až 80 % za ošetrenie u nezmluvného lekára",
              "cs": "Vrátíme vám až 80 % za ošetření u nesmluvního lékaře",
              "en": "We will reimburse you up to 80% for treatment at a non-contractual doctor"
            },
            "description": {
              "sk": "Potrebujete navštíviť lekára, ktorý s nami nemá zmluvu? Vrátime vám 80 % z obvyklej ceny, teda z ceny, ktorú by sme za dané vyšetrenie zaplatili zmluvnému lekárovi. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Potřebujete navštívit lékaře, který s námi nemá smlouvu? Vrátíme vám 80 % z obvyklé ceny, tedy z ceny, kterou bychom za dané vyšetření zaplatili smluvnímu lékaři. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you need to see a doctor who does not have a contract with us? We will refund you 80% of the usual price, i.e. of the price we would pay the contracted doctor for the given examination. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispevok-az-80-u-nezmluvneho-lekara",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na pobyty v kúpeľoch",
              "cs": "Sleva na pobyty v lázních",
              "en": "Discount on spa stays"
            },
            "icon": "bath",
            "benefit": {
              "sk": "Zľava do 13 % na pobyty v kúpeľoch",
              "cs": "Sleva až 13 % na pobyty v lázních",
              "en": "Discount up to 13% on spa stays"
            },
            "description": {
              "sk": "Hoďte na chvíľu starosti za hlavu a zrelaxujte sa s Dôverou v kúpeľoch. S nami si užijete liečebný pobyt v najvýznamnejších slovenských kúpeľoch so zľavou až do výšky 13 %. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Odložte na chvíli starosti a odpočiňte si s Dôverou v lázních. S námi si užijete léčebný pobyt v nejvýznamnějších slovenských lázních se slevou až 13 %. Více informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Leave your worries behind for a while and relax with Dôvera in the spa. With us, you can enjoy a therapeutic stay in the most important Slovak spas with a discount of up to 13%. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/lacnejsie-kupele",
            "category": null
          },
          {
            "type": {
              "sk": "Vzdelávanie pre ľudí s chronickým ochorením",
              "cs": "Vzdělávání pro osoby s chronickým onemocněním",
              "en": "Education for people with chronic illness"
            },
            "icon": "webinar",
            "benefit": {
              "sk": "Vzdelávanie zdarma pre ľudí s chronickým ochorením",
              "cs": "Bezplatné vzdělávání pro osoby s chronickým onemocněním",
              "en": "Free education for people with chronic illness"
            },
            "description": {
              "sk": "Máte vysoký krvný tlak, cukrovku, nadváhu, obezitu alebo sa liečite na srdcové zlyhávanie? Zapojte sa do programu a získajte nemedicínske vzdelávanie zdarma. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Trpíte vysokým krevním tlakem, cukrovkou, nadváhou, obezitou nebo se léčíte se srdečním selháním? Zapojte se do programu a získejte bezplatné nelékařské vzdělávání. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you have high blood pressure, diabetes, overweight, obesity or are you being treated for heart failure? Join the program and get non-medical education for free. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/poradenstvo-a-vzdelavanie-zdarma",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na online tréningový program",
              "cs": "Sleva na online tréninkový program",
              "en": "Discount on online training program"
            },
            "icon": "muscle",
            "benefit": {
              "sk": "Zľava 30 % na online tréningový program",
              "cs": "Sleva 30 % na online tréninkový program",
              "en": "30% discount on online training program"
            },
            "description": {
              "sk": "Pre priaznivcov zdravého životného štýlu alebo pre tých, ktorí chcú pre svoje zdravie urobiť niečo navyše, máme zaujímavú ponuku. Vyskúšajte tréningový program LIVE PLUS pod vedením profesionálneho trénera Janyho Landla a zdravé jedálničky pripravené na mieru. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pro příznivce zdravého životního stylu nebo pro ty, kteří chtějí pro své zdraví udělat něco navíc, máme zajímavou nabídku. Vyzkoušejte tréninkový program LIVE PLUS pod vedením profesionálního trenéra Janyho Landla a zdravé jídelníčky připravené na míru. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "For supporters of a healthy lifestyle or for those who want to do something extra for their health, we have an interesting offer. Try the LIVE PLUS training program under the guidance of professional trainer Jany Landl and healthy, custom-made meals.  More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-30-na-online-treningovy-program",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na DNA testy",
              "cs": "Sleva na DNA testy",
              "en": "Discount on DNA tests"
            },
            "icon": "genes",
            "benefit": {
              "sk": "Zľava až do 800 eur na DNA testy",
              "cs": "Sleva až 800 EUR na DNA testy",
              "en": "Discounts of up to EUR 800 on DNA tests"
            },
            "description": {
              "sk": "Zľava až do 800 eur na DNA testy. Radi by ste vedeli viac o fungovaní svojho tela? Analýza DNA vám môže pomôcť odhaliť prípadné zdravotné riziká, lepšie pochopiť fungovanie organizmu či odhaliť svoj športový potenciál. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Sleva až 800 EUR na DNA testy. Chtěli byste vědět více o fungování svého těla? Analýza DNA vám může pomoci odhalit případná zdravotní rizika, lépe pochopit fungování organismu nebo odhalit svůj sportovní potenciál. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Discounts of up to EUR 800 on DNA tests. Would you like to know more about how your body works? DNA analysis can help you identify potential health risks, better understand how your body works, and discover your athletic potential. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-az-do-800-eur-na-dna-testy",
            "category": null
          },
          {
            "type": {
              "sk": "Bezplatné vyšetrenie rakoviny hrubého čreva\n",
              "cs": "Bezplatné vyšetření rakoviny tlustého střeva",
              "en": "A free colon cancer examination"
            },
            "icon": "rectum",
            "benefit": {
              "sk": "Test na zistenie okultného čiže skrytého krvácania v stolici zadarmo",
              "cs": "Test na zjištění okultního, tedy skrytého krvácení ve stolici zdarma",
              "en": "A free fecal occult (hidden) bleeding test"
            },
            "description": {
              "sk": "Test na okultné krvácanie dokáže odhaliť rakovinu ešte predtým, ako skutočne prepukne. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Test na okultní krvácení dokáže odhalit rakovinu ještě předtím, než skutečně propukne. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A fecal occult bleeding test can detect cancer before it truly starts. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/bezplatne-vysetrenie-rakoviny-hrubeho-creva",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na testy od Unilabs Slovensko",
              "cs": "Sleva na testy od Unilabs Slovensko",
              "en": "Discount on tests from Unilabs Slovakia"
            },
            "icon": "bloodtest",
            "benefit": {
              "sk": "Zľava 20 % na testy od Unilabs Slovensko",
              "cs": "Sleva 20 % na testy od Unilabs Slovensko",
              "en": "20% discount on tests from Unilabs Slovakia"
            },
            "description": {
              "sk": "20% discount on tests from Unilabs Slovakia. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Sleva 20 % na testy od Unilabs Slovensko. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "20% discount on tests from Unilabs Slovakia. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-20-na-testy-od-unilabs-slovensko",
            "category": null
          },
          {
            "type": {
              "sk": "Pomáhame k zdravému srdcu",
              "cs": "Pomáháme k zdravému srdci",
              "en": "We help to have a healthy heart"
            },
            "icon": "heart",
            "benefit": {
              "sk": "Dôvera pomáha k zdravému srdcu",
              "cs": "Dôvera pomáhá k zdravému srdci",
              "en": "Dôvera helps to a healthy heart"
            },
            "description": {
              "sk": "Problémy so srdcom nás môžu zastihnúť v akomkoľvek veku. Spôsobujú krátkodobé aj dlhodobé komplikácie, no správnou životosprávou sa dajú liečiť. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Problémy se srdcem nás mohou postihnout v jakémkoli věku. Způsobují krátkodobé i dlouhodobé komplikace, ale správným životním stylem se dají léčit. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Heart problems can affect us at any age. They cause short-term and long-term complications, but can be treated with proper lifestyle. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/srdce/uvod",
            "category": null
          },
          {
            "type": {
              "sk": "Pomáhame s nadváhou, obezitou",
              "cs": "Pomáháme s nadváhou a obezitou",
              "en": "We help with overweight and obesity"
            },
            "icon": "weight",
            "benefit": {
              "sk": "Dôvera pomáha s nadváhou",
              "cs": "Dôvera pomáhá s nadváhou",
              "en": "Dôvera helps with overweight"
            },
            "description": {
              "sk": "Zmeňte svoj životný štýl a podporte svoje zdravie. Pomôžeme vám zorientovať sa v zmenách, pred ktorými stojíte, aby ste dosiahli a udržali svoj cieľ. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Změňte svůj životní styl a podpořte své zdraví. Pomůžeme vám zorientovat se ve změnách, které vás čekají, abyste dosáhli a udrželi svůj cíl. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Change your lifestyle and support your health. We will help you navigate the changes you face in order to reach and maintain your goal.  More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/nadvaha/uvod",
            "category": null
          },
          {
            "type": {
              "sk": "Pomáhame diabetikom",
              "cs": "Pomáháme diabetikům",
              "en": "We help diabetics"
            },
            "icon": "diabetes",
            "benefit": {
              "sk": "Program DôveraPomáha pre diabetikov zadarmo",
              "cs": "Program DôveraPomáha pro diabetiky zdarma",
              "en": "The DôveraPomáha [TrustHelps] programme, free for diabetics"
            },
            "description": {
              "sk": "Naši odborníci vás zadarmo naučia, ako žiť lepší život aj s cukrovkou. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Naši odborníci vás zdarma naučí, jak žít lepší život i s cukrovkou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Our experts will teach you for free how to live a better life with diabetes. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/lepsizivotscukrovkou/uvod",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy pre každého",
              "cs": "Slevy pro každého",
              "en": "Discounts for everyone"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Bohatá ponuka zliav pre každého",
              "cs": "Bohatá nabídka slev pro každého",
              "en": "A broad range of discounts for everyone"
            },
            "description": {
              "sk": "Z našej bohatej ponuky zliav si vyberie každý. Seniori, rodiny aj mladí ľudia. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Z naší bohaté nabídky slev si vybere každý. Senioři, rodiny i mladí lidé. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Our broad range of discounts has something for everyone. Seniors, families, and young people. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/preco-byt-v-dovere/zlavy",
            "category": null
          },
          {
            "type": {
              "sk": "Výhody pre darcov krvi",
              "cs": "Výhody pro dárce krve",
              "en": "Benefits for blood donors"
            },
            "icon": "bloodtest",
            "benefit": {
              "sk": "Vitamínové doplnky v hodnote približne 20 € aj zľavy do výšky 25 % na pobyt v kúpeľoch",
              "cs": "Vitamínové doplňky v hodnotě přibližně 20 € a slevy až 25 % na pobyt v lázních",
              "en": "Vitamin supplements worth approximately €20 and discounts of up to 25% on spa stays"
            },
            "description": {
              "sk": "Darcov krvi si vážime a o ich zdravie sa staráme. Každý z nich môže získať dva vitamínové doplnky v hodnote približne 20 € aj zľavy do výšky 25 % na pobyt v kúpeľoch. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Dárců krve si vážíme a staráme se o jejich zdraví. Každý z nich může získat dva vitamínové doplňky v hodnotě přibližně 20 € a slevy až do výše 25 % na pobyt v lázních. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We value blood donors and take care of their health. Each of them can receive two vitamin supplements worth approximately €20 and discounts of up to 25% on a stay in the spa. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/vyhody-pre-darcov-krvi",
            "category": null
          }
        ]
      },
      {
        "name": {
          "sk": "Ženy",
          "cs": "Ženy",
          "en": "Women"
        },
        "benefits": [
          {
            "type": {
              "sk": "Cytologické vyšetrenie LBC u gynekológa bezplatne",
              "cs": "Cytologické vyšetření LBC u gynekologa zdarma",
              "en": "A free Liquid Based Cytology (LBC) test performed by a gynaecologist"
            },
            "icon": "vulva",
            "benefit": {
              "sk": "Vyšetrenie zadarmo",
              "cs": "Vyšetření zdarma",
              "en": "Free examination"
            },
            "description": {
              "sk": "Pre všetky ženy, ktoré absolvujú pravidelnú preventívnu prehliadku u gynekológa. Metoda LBC je zameraná na odhalenie rakoviny. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pro všechny ženy, které absolvují pravidelnou preventivní prohlídku u gynekologa. Metoda LBC je zaměřena na odhalení rakoviny. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "For all women who go to a gynaecologist for a regular preventive examination. The LBC method is used to detect cancer. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/vsetky/cytologicke-vysetrenie-lbc-u-gynekologa-bezplatne",
            "category": "Ženy"
          },
          {
            "type": {
              "sk": "Zľava na laktačné poradenstvo",
              "cs": "Sleva na laktační poradenství",
              "en": "Discount on lactation consultation"
            },
            "icon": "birth",
            "benefit": {
              "sk": "Až 25 % zľava na laktačné poradenstvo",
              "cs": "Až 25% sleva na laktační poradenství",
              "en": "Up to 25% discount on lactation consultation"
            },
            "description": {
              "sk": "Využite služby laktačnej poradkyne a vylepšite si techniku dojčenia. Odborníci z We Care Centra vám poradia so zľavou. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Využijte služeb laktační poradkyně a zdokonalte si techniku kojení. Odborníci z We Care Centra vám poradí se slevou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Use the services of a lactation consultant and improve your breastfeeding technique. Experts from the We Care Center will advise you with a discount. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/rodina/zlava-na-laktacne-poradenstvo-vanickovanie-a-baby-masaze",
            "category": null
          },
          {
            "type": {
              "sk": "Lekár na diaľku",
              "cs": "Lékař na dálku",
              "en": "Remote doctor"
            },
            "icon": "doctor",
            "benefit": {
              "sk": "Konzultácia s lekárom na diaľku zadarmo",
              "cs": "Konzultace s lékařem na dálku zdarma",
              "en": "Free remote consultation with a doctor"
            },
            "description": {
              "sk": "Netrávte hodiny v čakárni. S aplikáciou MEDDI môžete svoje zdravotné otázky riešiť pohodlne na diaľku, aj večer či cez víkend. Majte apku stále poruke, keď potrebujete odborne poradiť. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Netravte hodiny v čekárně. S aplikací MEDDI můžete své zdravotní dotazy řešit pohodlně na dálku, i večer nebo o víkendu. Mějte aplikaci vždy po ruce, když potřebujete odbornou radu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Don't spend hours in the waiting room. With the MEDDI app, you can conveniently address your health questions remotely, even in the evening or on weekends. Keep the app handy whenever you need expert advice. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/lekar-na-dialku",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy na okuliare a vyšetrenie zraku",
              "cs": "Slevy na brýle a vyšetření zraku",
              "en": "Discount on glasses and an eye exam"
            },
            "icon": "glasses",
            "benefit": {
              "sk": "Zľavy v očných optikách FOKUS",
              "cs": "Slevy v očních optikách FOKUS",
              "en": "Discounts at FOKUS opticians"
            },
            "description": {
              "sk": "Až 90 % všetkých vnemov máme vďaka zraku. Pomáhame vám starať sa o svoje oči. Dospelým poistencom ponúkame zľavy na vyhotovenie, opravu dioptrických okuliarov a kompletné vyšetrenie zraku v očných optikách FOKUS. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Až 90 % všech vjemů získáváme díky zraku. Pomáháme vám pečovat o vaše oči. Dospělým pojištěncům nabízíme slevy na výrobu a opravu dioptrických brýlí a kompletní vyšetření zraku v očních optikách FOKUS. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to 90% of all our perceptions come through our eyesight. We help you take care of your eyes. We offer adult policyholders discounts on the manufacture and repair of prescription glasses and comprehensive eye examinations at FOKUS opticians. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-okuliare-a-vysetrenie-zraku",
            "category": null
          },
          {
            "type": {
              "sk": "Kožné vyšetrenie online a zadarmo",
              "cs": "Online vyšetření kůže zdarma",
              "en": "Online skin examination for free"
            },
            "icon": "dermatology",
            "benefit": {
              "sk": "Kožné vyšetrenie online a zadarmo",
              "cs": "Online vyšetření kůže zdarma",
              "en": "Online skin examination for free"
            },
            "description": {
              "sk": "Máte akné či iný kožný problém? Odfoťte ho a rýchlo a bezpečne odošlite lekárovi. Kožný lekár vám stanoví diagnózu a odporučí liečbu už do 3 pracovných dní. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Máte akné nebo jiný kožní problém? Vyfoťte ho a rychle a bezpečně pošlete lékaři. Dermatolog stanoví diagnózu a doporučí léčbu do 3 pracovních dnů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you have acne or another skin problem? Take a photo and send it quickly and securely to a doctor. A dermatologist will diagnose you and recommend treatment within 3 business days. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/kozne-vysetrenie-online-a-zadarmo",
            "category": null
          },
          {
            "type": {
              "sk": "Fyzio vyšetrenie online a zadarmo",
              "cs": "Fyzioterapeutické vyšetření online a zdarma",
              "en": "Free online physical examination"
            },
            "icon": "running",
            "benefit": {
              "sk": "Fyzio vyšetrenie online a zadarmo",
              "cs": "Fyzioterapeutické vyšetření online a zdarma",
              "en": "Free online physical examination"
            },
            "description": {
              "sk": "Bolesti chrbta, svalov či kĺbov – poznáme to snáď všetci. Máme pre Vás pomoc z pohodlia domova. Opíšte svoj problém a lekár vám odporučí liečbu alebo cvičenia už do 3 pracovných dní. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Bolesti zad, svalů nebo kloubů – to známe snad všichni. Nabízíme vám pomoc z pohodlí domova. Popište svůj problém a lékař vám doporučí léčbu nebo cvičení do 3 pracovních dnů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Back, muscle, or joint pain – we've all been there. We can help you from the comfort of your own home. Describe your problem and a doctor will recommend treatment or exercises within 3 business days. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/fyzio-vysetrenie-online-a-zadarmo",
            "category": null
          },
          {
            "type": {
              "sk": "Zdravé zuby",
              "cs": "Zdravé zuby",
              "en": "Healthy teeth"
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Dospelým prispejeme 2 x 30 € na dentálnu hygienu",
              "cs": "Dospělým přispějeme 2 x 30 € na dentální hygienu",
              "en": "We will contribute EUR 30 twice to adults for dental hygiene."
            },
            "description": {
              "sk": "Dospelým prispejeme 2 x 30 € na dentálnu hygienu. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Dospělým přispějeme 2 x 30 € na dentální hygienu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will contribute EUR 30 twice to adults for dental hygiene. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zdrave-zuby-pre-dospelych-aj-deti",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok na dobrovoľné očkovanie",
              "cs": "Příspěvek na dobrovolné očkování",
              "en": "Contribution to voluntary vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "sk": "Príspevok na rôzne typy očkovaní",
              "cs": "Příspěvek na různé typy očkování",
              "en": "Contribution for various types of vaccinations"
            },
            "description": {
              "sk": "Poistencom preplácame viaceré dobrovoľné očkovania, napríklad proti chrípke, kliešťom či HPV. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pojištěncům proplácíme řadu dobrovolných očkování, například proti chřipce, klíšťatům nebo HPV. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We reimburse our policyholders for several voluntary vaccinations, such as against influenza, ticks, and HPV. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispejeme-vam-na-dobrovolne-ockovanie#tabpanel-ockovanie_1",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na laserovú operáciu očí",
              "cs": "Sleva na laserovou operaci očí",
              "en": ""
            },
            "icon": "eye",
            "benefit": {
              "sk": "Príspevok 500 eur na laserovú operáciu očí",
              "cs": "Příspěvek 500 EUR na laserovou operaci očí",
              "en": "Contribution of 500 eur for laser eye surgery"
            },
            "description": {
              "sk": "Chcete si užívať život bez okuliarov a kontaktných šošoviek? Vylepšite svoj zrak pomocou laserovej operácie očí metódou iLasik. Poistencom Dôvery ponúkame možnosť využiť zľavu 500 € na laserový zákrok v očnej klinike VESELY. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Chcete si užívat život bez brýlí a kontaktních čoček? Vylepšete si zrak pomocí laserové operace očí metodou iLasik. Pojištěncům Dôvěry nabízíme možnost využít slevu 500 € na laserový zákrok v oční klinice VESELY. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Want to enjoy life without glasses or contacts? Improve your vision with iLasik laser eye surgery. We offer Dôvera insurance policyholders a EUR 500 discount on laser surgery at the VESELY Eye Clinic. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-500-eur-na-laserovu-operaciu-oci",
            "category": null
          },
          {
            "type": {
              "sk": "Prednostné objednanie na MR, RTG, sono a mamografiu",
              "cs": "Přednostní objednání na MRI, RTG, ultrazvuk a mamografii",
              "en": "Priority appointments for MRI, X-ray, ultrasound, and mammography"
            },
            "icon": "calendar-previous",
            "benefit": {
              "sk": "Prednostné objednanie na MR, RTG, sono a mamografiu",
              "cs": "Přednostní objednání na MRI, RTG, ultrazvuk a mamografii",
              "en": "Priority appointments for MRI, X-ray, ultrasound, and mammography"
            },
            "description": {
              "sk": "Potrebujete ísť na vyšetrenie MR, RTG, sono alebo mamografiu? Ako poistenec Dôvery môžete získať rýchly termín v Poliklinike Bezručova v Bratislave. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Potřebujete jít na vyšetření MRI, RTG, ultrazvuk nebo mamografii? Jako pojištěnec pojišťovny Dôvera můžete získat rychlý termín v Poliklinice Bezručova v Bratislavě. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you need to go for an MRI, X-ray, ultrasound, or mammogram? As a Dôvera policyholder, you can get a quick appointment at the Bezručova Polyclinic in Bratislava. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/prednostne-objednanie-na-mr-rtg-sono-a-mamografiu",
            "category": null
          },
          {
            "type": {
              "sk": "Doprava do Nemocnice Bory",
              "cs": "Doprava do Nemocnice Bory",
              "en": "Transport to Bory Hospital"
            },
            "icon": "hospital",
            "benefit": {
              "sk": "Zabezpečíme vám odvoz na hospitalizáciu do Nemocnice Bory v Bratislave zadarmo.",
              "cs": "Zajistíme vám bezplatnou dopravu k hospitalizaci do Nemocnice Bory v Bratislavě",
              "en": "We will arrange free transportation to Bory Hospital in Bratislava for your hospitalization."
            },
            "description": {
              "sk": "Čaká vás operácia či iný zákrok a radi by ste ich absolvovali v jednej z najmodernejších nemocníc v strednej Európe? Zabezpečíme vám odvoz na hospitalizáciu do Nemocnice Bory v Bratislave zadarmo. Samozrejmosťou je aj bezplatná doprava späť domov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Čeká vás operace nebo jiný zákrok a rádi byste je podstoupili v jedné z nejmodernějších nemocnic ve střední Evropě? Zajistíme vám bezplatnou dopravu k hospitalizaci do Nemocnice Bory v Bratislavě. Samozřejmostí je i bezplatná doprava zpět domů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Are you awaiting surgery or another procedure and would like to have it done at one of the most modern hospitals in Central Europe? We will arrange free transportation to Bory Hospital in Bratislava for your hospitalization. Free transportation back home is also a matter of course. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/doprava-do-nemocnice-bory",
            "category": null
          },
          {
            "type": {
              "sk": "Samodiagnostický nástroj",
              "cs": "Samodiagnostický nástroj",
              "en": "Self-diagnostic tool"
            },
            "icon": "care",
            "benefit": {
              "sk": "Samodiagnostický nástroj je pre poistencov Dôvery bezplatný.",
              "cs": "Samodiagnostický nástroj je pro pojištěnce Dôvery bezplatný",
              "en": "The self-diagnostic tool is free of charge for Dôvera policyholders."
            },
            "description": {
              "sk": "Necítite sa dobre, pociťujete duševnú nepohodu a lekár nie je nablízku? Vyskúšajte  samodiagnostický nástroj, ktorý je pre poistencov Dôvery bezplatný. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Necítíte se dobře, trpíte psychickými potížemi a lékař není nablízku? Vyzkoušejte  samodiagnostický nástroj, který je pro pojištěnce Dôvery zdarma. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Are you feeling unwell, experiencing mental distress, and your doctor is not available? Try the self-diagnostic tool, which is free for Dôvera policyholders. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/samodiagnosticky-nastroj",
            "category": null
          },
          {
            "type": {
              "sk": "Podpora duševného zdravia\n",
              "cs": "Podpora duševního zdraví",
              "en": "Mental health support"
            },
            "icon": "happy",
            "benefit": {
              "sk": "Až 40 eur na on-line konzultácie s psychológom",
              "cs": "Až 40 EUR na online konzultace s psychologem",
              "en": "Up to EUR 40 for an on-line consultation with a psychologist"
            },
            "description": {
              "sk": "Raz za kalendárny rok si môžete uplatniť zľavový kupón na online konzultácie v hodnote 40 eur. U partnera Mojra môžete navyše využiť aj 2x zľavu 12 % na ktorékoľvek dve sedenia po využití tohto kupónu. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Jednou za kalendářní rok můžete uplatnit slevový kupón na online konzultace v hodnotě 40 EUR. U partnera Mojra můžete navíc využít i 2x slevu 12 % na libovolné dvě sezení po uplatnění tohoto kupónu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Once per calendar year, you can redeem a discount coupon for online consultations worth EUR 40. With our partner Mojra, you can also take advantage of a 12% discount on any two sessions after using this coupon. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy na pobyty v kúpeľoch",
              "cs": "Slevy na pobyty v lázních",
              "en": "Discounts on stays at spas"
            },
            "icon": "bath",
            "benefit": {
              "sk": "Zľava až 70% na pobyty v Moderných kúpeľoch Turčianske Teplice",
              "cs": "Sleva až 70 % na pobyty v Moderních lázních Turčianske Teplice",
              "en": "Up to 70% discount on stays at Moderné kúpele Turčianske Teplice"
            },
            "description": {
              "sk": "Za relax a pevnejšie zdravie zaplatíte menej. Až 70% pre poistencov Dôvery máme vybrané kúpeľné pobyty v Moderných kúpeľoch Turčianske Teplice so zľavou. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Za relaxaci a lepší zdraví zaplatíte méně. Pro pojištěnce pojišťovny Dôvera máme vybrané lázeňské pobyty v Moderních lázních Turčianske Teplice se slevou až 70 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "You will pay less for relaxation and better health. We offer selected spa stays at Moderné kúpele Turčianske Teplice with a discount of up to 70% for Dôvera insurance policyholders. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-pobyty-v-modernych-kupeloch-turcianske-teplice",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na online terapiu",
              "cs": "Sleva na online terapii",
              "en": "Discount on online therapy"
            },
            "icon": "phone-video",
            "benefit": {
              "sk": "Zľava na online terapiu s Mojra, Hedepy a ksebe",
              "cs": "Sleva na online terapii s Mojra, Hedepy a ksebe",
              "en": "Discount on online therapy with Mojra, Hedepy, and ksebe"
            },
            "description": {
              "sk": "Zľava na online terapiu s Mojra, Hedepy a ksebe. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Sleva na online terapii s Mojra, Hedepy a ksebe. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Discount on online therapy with Mojra, Hedepy, and ksebe. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy na cestovné poistenie od Generali",
              "cs": "Slevy na cestovní pojištění od Generali",
              "en": "Discounts on travel insurance from Generali"
            },
            "icon": "suitcase",
            "benefit": {
              "sk": "Zľavy do 30 % na cestovné poistenie od Generali",
              "cs": "Slevy až 30 % na cestovní pojištění od Generali",
              "en": "Discounts of up to 30% on travel insurance from Generali"
            },
            "description": {
              "sk": "Zľavy do 30 % na cestovné poistenie od Generali. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Slevy až 30 % na cestovní pojištění od Generali. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Discounts of up to 30% on travel insurance from Generali. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-az-30-na-cestovne-poistenie",
            "category": null
          },
          {
            "type": {
              "sk": "Príspevok u nezmluvného lekára",
              "cs": "Příspěvek u nesmluvního lékaře",
              "en": "Allowance with a non-contractual doctor"
            },
            "icon": "two-doctors",
            "benefit": {
              "sk": "Vrátime vám až 80 % za ošetrenie u nezmluvného lekára",
              "cs": "Vrátíme vám až 80 % za ošetření u nesmluvního lékaře",
              "en": "We will reimburse you up to 80% for treatment at a non-contractual doctor"
            },
            "description": {
              "sk": "Potrebujete navštíviť lekára, ktorý s nami nemá zmluvu? Vrátime vám 80 % z obvyklej ceny, teda z ceny, ktorú by sme za dané vyšetrenie zaplatili zmluvnému lekárovi. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Potřebujete navštívit lékaře, který s námi nemá smlouvu? Vrátíme vám 80 % z obvyklé ceny, tedy z ceny, kterou bychom za dané vyšetření zaplatili smluvnímu lékaři. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you need to see a doctor who does not have a contract with us? We will refund you 80% of the usual price, i.e. of the price we would pay the contracted doctor for the given examination. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispevok-az-80-u-nezmluvneho-lekara",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na pobyty v kúpeľoch",
              "cs": "Sleva na pobyty v lázních",
              "en": "Discount on spa stays"
            },
            "icon": "bath",
            "benefit": {
              "sk": "Zľava do 13 % na pobyty v kúpeľoch",
              "cs": "Sleva až 13 % na pobyty v lázních",
              "en": "Discount up to 13% on spa stays"
            },
            "description": {
              "sk": "Hoďte na chvíľu starosti za hlavu a zrelaxujte sa s Dôverou v kúpeľoch. S nami si užijete liečebný pobyt v najvýznamnejších slovenských kúpeľoch so zľavou až do výšky 13 %. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Odložte na chvíli starosti a odpočiňte si s Dôverou v lázních. S námi si užijete léčebný pobyt v nejvýznamnějších slovenských lázních se slevou až 13 %. Více informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Leave your worries behind for a while and relax with Dôvera in the spa. With us, you can enjoy a therapeutic stay in the most important Slovak spas with a discount of up to 13%. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/lacnejsie-kupele",
            "category": null
          },
          {
            "type": {
              "sk": "Vzdelávanie pre ľudí s chronickým ochorením",
              "cs": "Vzdělávání pro osoby s chronickým onemocněním",
              "en": "Education for people with chronic illness"
            },
            "icon": "webinar",
            "benefit": {
              "sk": "Vzdelávanie zdarma pre ľudí s chronickým ochorením",
              "cs": "Bezplatné vzdělávání pro osoby s chronickým onemocněním",
              "en": "Free education for people with chronic illness"
            },
            "description": {
              "sk": "Máte vysoký krvný tlak, cukrovku, nadváhu, obezitu alebo sa liečite na srdcové zlyhávanie? Zapojte sa do programu a získajte nemedicínske vzdelávanie zdarma. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Trpíte vysokým krevním tlakem, cukrovkou, nadváhou, obezitou nebo se léčíte se srdečním selháním? Zapojte se do programu a získejte bezplatné nelékařské vzdělávání. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you have high blood pressure, diabetes, overweight, obesity or are you being treated for heart failure? Join the program and get non-medical education for free. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/poradenstvo-a-vzdelavanie-zdarma",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na online tréningový program",
              "cs": "Sleva na online tréninkový program",
              "en": "Discount on online training program"
            },
            "icon": "muscle",
            "benefit": {
              "sk": "Zľava 30 % na online tréningový program",
              "cs": "Sleva 30 % na online tréninkový program",
              "en": "30% discount on online training program"
            },
            "description": {
              "sk": "Pre priaznivcov zdravého životného štýlu alebo pre tých, ktorí chcú pre svoje zdravie urobiť niečo navyše, máme zaujímavú ponuku. Vyskúšajte tréningový program LIVE PLUS pod vedením profesionálneho trénera Janyho Landla a zdravé jedálničky pripravené na mieru. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pro příznivce zdravého životního stylu nebo pro ty, kteří chtějí pro své zdraví udělat něco navíc, máme zajímavou nabídku. Vyzkoušejte tréninkový program LIVE PLUS pod vedením profesionálního trenéra Janyho Landla a zdravé jídelníčky připravené na míru. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "For supporters of a healthy lifestyle or for those who want to do something extra for their health, we have an interesting offer. Try the LIVE PLUS training program under the guidance of professional trainer Jany Landl and healthy, custom-made meals.  More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-30-na-online-treningovy-program",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na DNA testy",
              "cs": "Sleva na DNA testy",
              "en": "Discount on DNA tests"
            },
            "icon": "genes",
            "benefit": {
              "sk": "Zľava až do 800 eur na DNA testy",
              "cs": "Sleva až 800 EUR na DNA testy",
              "en": "Discounts of up to EUR 800 on DNA tests"
            },
            "description": {
              "sk": "Zľava až do 800 eur na DNA testy. Radi by ste vedeli viac o fungovaní svojho tela? Analýza DNA vám môže pomôcť odhaliť prípadné zdravotné riziká, lepšie pochopiť fungovanie organizmu či odhaliť svoj športový potenciál. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Sleva až 800 EUR na DNA testy. Chtěli byste vědět více o fungování svého těla? Analýza DNA vám může pomoci odhalit případná zdravotní rizika, lépe pochopit fungování organismu nebo odhalit svůj sportovní potenciál. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Discounts of up to EUR 800 on DNA tests. Would you like to know more about how your body works? DNA analysis can help you identify potential health risks, better understand how your body works, and discover your athletic potential. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-az-do-800-eur-na-dna-testy",
            "category": null
          },
          {
            "type": {
              "sk": "Bezplatné vyšetrenie rakoviny hrubého čreva\n",
              "cs": "Bezplatné vyšetření rakoviny tlustého střeva",
              "en": "A free colon cancer examination"
            },
            "icon": "rectum",
            "benefit": {
              "sk": "Test na zistenie okultného čiže skrytého krvácania v stolici zadarmo",
              "cs": "Test na zjištění okultního, tedy skrytého krvácení ve stolici zdarma",
              "en": "A free fecal occult (hidden) bleeding test"
            },
            "description": {
              "sk": "Test na okultné krvácanie dokáže odhaliť rakovinu ešte predtým, ako skutočne prepukne. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Test na okultní krvácení dokáže odhalit rakovinu ještě předtím, než skutečně propukne. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A fecal occult bleeding test can detect cancer before it truly starts. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/bezplatne-vysetrenie-rakoviny-hrubeho-creva",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na testy od Unilabs Slovensko",
              "cs": "Sleva na testy od Unilabs Slovensko",
              "en": "Discount on tests from Unilabs Slovakia"
            },
            "icon": "bloodtest",
            "benefit": {
              "sk": "Zľava 20 % na testy od Unilabs Slovensko",
              "cs": "Sleva 20 % na testy od Unilabs Slovensko",
              "en": "20% discount on tests from Unilabs Slovakia"
            },
            "description": {
              "sk": "20% discount on tests from Unilabs Slovakia. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Sleva 20 % na testy od Unilabs Slovensko. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "20% discount on tests from Unilabs Slovakia. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-20-na-testy-od-unilabs-slovensko",
            "category": null
          },
          {
            "type": {
              "sk": "Pomáhame k zdravému srdcu",
              "cs": "Pomáháme k zdravému srdci",
              "en": "We help to have a healthy heart"
            },
            "icon": "heart",
            "benefit": {
              "sk": "Dôvera pomáha k zdravému srdcu",
              "cs": "Dôvera pomáhá k zdravému srdci",
              "en": "Dôvera helps to a healthy heart"
            },
            "description": {
              "sk": "Problémy so srdcom nás môžu zastihnúť v akomkoľvek veku. Spôsobujú krátkodobé aj dlhodobé komplikácie, no správnou životosprávou sa dajú liečiť. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Problémy se srdcem nás mohou postihnout v jakémkoli věku. Způsobují krátkodobé i dlouhodobé komplikace, ale správným životním stylem se dají léčit. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Heart problems can affect us at any age. They cause short-term and long-term complications, but can be treated with proper lifestyle. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/srdce/uvod",
            "category": null
          },
          {
            "type": {
              "sk": "Pomáhame s nadváhou, obezitou",
              "cs": "Pomáháme s nadváhou a obezitou",
              "en": "We help with overweight and obesity"
            },
            "icon": "weight",
            "benefit": {
              "sk": "Dôvera pomáha s nadváhou",
              "cs": "Dôvera pomáhá s nadváhou",
              "en": "Dôvera helps with overweight"
            },
            "description": {
              "sk": "Zmeňte svoj životný štýl a podporte svoje zdravie. Pomôžeme vám zorientovať sa v zmenách, pred ktorými stojíte, aby ste dosiahli a udržali svoj cieľ. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Změňte svůj životní styl a podpořte své zdraví. Pomůžeme vám zorientovat se ve změnách, které vás čekají, abyste dosáhli a udrželi svůj cíl. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Change your lifestyle and support your health. We will help you navigate the changes you face in order to reach and maintain your goal.  More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/nadvaha/uvod",
            "category": null
          },
          {
            "type": {
              "sk": "Pomáhame diabetikom",
              "cs": "Pomáháme diabetikům",
              "en": "We help diabetics"
            },
            "icon": "diabetes",
            "benefit": {
              "sk": "Program DôveraPomáha pre diabetikov zadarmo",
              "cs": "Program DôveraPomáha pro diabetiky zdarma",
              "en": "The DôveraPomáha [TrustHelps] programme, free for diabetics"
            },
            "description": {
              "sk": "Naši odborníci vás zadarmo naučia, ako žiť lepší život aj s cukrovkou. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Naši odborníci vás zdarma naučí, jak žít lepší život i s cukrovkou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Our experts will teach you for free how to live a better life with diabetes. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/lepsizivotscukrovkou/uvod",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy pre každého",
              "cs": "Slevy pro každého",
              "en": "Discounts for everyone"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Bohatá ponuka zliav pre každého",
              "cs": "Bohatá nabídka slev pro každého",
              "en": "A broad range of discounts for everyone"
            },
            "description": {
              "sk": "Z našej bohatej ponuky zliav si vyberie každý. Seniori, rodiny aj mladí ľudia. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Z naší bohaté nabídky slev si vybere každý. Senioři, rodiny i mladí lidé. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Our broad range of discounts has something for everyone. Seniors, families, and young people. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/preco-byt-v-dovere/zlavy",
            "category": null
          },
          {
            "type": {
              "sk": "Výhody pre darcov krvi",
              "cs": "Výhody pro dárce krve",
              "en": "Benefits for blood donors"
            },
            "icon": "bloodtest",
            "benefit": {
              "sk": "Vitamínové doplnky v hodnote približne 20 € aj zľavy do výšky 25 % na pobyt v kúpeľoch",
              "cs": "Vitamínové doplňky v hodnotě přibližně 20 € a slevy až 25 % na pobyt v lázních",
              "en": "Vitamin supplements worth approximately €20 and discounts of up to 25% on spa stays"
            },
            "description": {
              "sk": "Darcov krvi si vážime a o ich zdravie sa staráme. Každý z nich môže získať dva vitamínové doplnky v hodnote približne 20 € aj zľavy do výšky 25 % na pobyt v kúpeľoch. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Dárců krve si vážíme a staráme se o jejich zdraví. Každý z nich může získat dva vitamínové doplňky v hodnotě přibližně 20 € a slevy až do výše 25 % na pobyt v lázních. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We value blood donors and take care of their health. Each of them can receive two vitamin supplements worth approximately €20 and discounts of up to 25% on a stay in the spa. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/vyhody-pre-darcov-krvi",
            "category": null
          }
        ]
      },
      {
        "name": {
          "sk": "Deti",
          "cs": "Děti",
          "en": "Children"
        },
        "benefits": [
          {
            "type": {
              "sk": "Preplatenie doplatkov za lieky",
              "cs": "Proplacení doplatků za léky",
              "en": "Reimbursement of medication surcharges"
            },
            "icon": "pill",
            "benefit": {
              "sk": "Až 300 eur na každého člena rodiny",
              "cs": "Až 300 EUR na každého člena rodiny",
              "en": "Up to EUR 300 for each family member"
            },
            "description": {
              "sk": "Doplatky preplácame za kategorizované lieky a dietetické potraviny vydané na lekársky predpis, čiastočne hradené zo zdravotného poistenia a vyúčtované do poisťovne. To znamená za lieky, za ktoré si pacient dopláca. Patria sem: často predpisované lieky, viaceré antibiotiká, lieky proti alergiám, očkovacie vakcíny, dietetické potraviny (teda aj umelé mlieko). Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Doplatky proplácíme za léky a dietní potraviny zařazené do příslušné kategorie, vydané na lékařský předpis, částečně hrazené ze zdravotního pojištění a vyúčtované pojišťovně. To znamená za léky, za které pacient doplatí. Patří sem: často předepisované léky, řada antibiotik, léky proti alergiím, očkovací vakcíny, dietní potraviny (tedy i umělé mléko). \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We reimburse surcharges for categorized medications and dietary foods prescribed by a doctor, partly covered by health insurance, and billed to the insurance company. This means for medications where the patient pays the remainder. These include: frequently prescribed medications, multiple antibiotics, allergy medications, vaccines, dietary foods (including infant formula). More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/vsetky/vratime-az-300-eur-za-lieky-rodicom-aj-detom",
            "category": "Děti"
          },
          {
            "type": {
              "sk": "Nové okuliare",
              "cs": "Nové brýle",
              "en": "New glasses"
            },
            "icon": "glasses",
            "benefit": {
              "sk": "Až 100 euro na nové okuliare",
              "cs": "Až 100 EUR na nové brýle",
              "en": "Up to EUR 100 for new glasses"
            },
            "description": {
              "sk": "Deťom do 18 rokov prispejeme raz ročne na dioptrické okuliare. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Dětem do 18 let přispíváme jednou ročně na dioptrické brýle. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We'll contribute once a year for glasses for children up to the age of 18. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/vsetky/detom-do-18-rokov-prispejeme-70-eur-na-nove-okuliare",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy pre každého",
              "cs": "Slevy pro každého",
              "en": "Discounts for everyone"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Bohatá ponuka zliav pre každého",
              "cs": "Bohatá nabídka slev pro každého",
              "en": "A broad range of discounts for everyone"
            },
            "description": {
              "sk": "Z našej bohatej ponuky zliav si vyberie každý. Seniori, rodiny aj mladí ľudia. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Z naší bohaté nabídky slev si vybere každý. Senioři, rodiny i mladí lidé. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Our broad range of discounts has something for everyone. Seniors, families, and young people. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/preco-byt-v-dovere/zlavy",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na laktačné poradenstvo",
              "cs": "Sleva na laktační poradenství",
              "en": "Discount on lactation consultation"
            },
            "icon": "birth",
            "benefit": {
              "sk": "Až 25 % zľava na laktačné poradenstvo",
              "cs": "Až 25% sleva na laktační poradenství",
              "en": "Up to 25% discount on lactation consultation"
            },
            "description": {
              "sk": "Využite služby laktačnej poradkyne a vylepšite si techniku dojčenia. Odborníci z We Care Centra vám poradia so zľavou. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Využijte služeb laktační poradkyně a zdokonalte si techniku kojení. Odborníci z We Care Centra vám poradí se slevou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Use the services of a lactation consultant and improve your breastfeeding technique. Experts from the We Care Center will advise you with a discount. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/rodina/zlava-na-laktacne-poradenstvo-vanickovanie-a-baby-masaze",
            "category": null
          },
          {
            "type": {
              "sk": "Darček pre najmenších",
              "cs": "Dárek pro nejmenší    ",
              "en": "A gift for the littlest ones"
            },
            "icon": "birth",
            "benefit": {
              "sk": "BabyBox plný kozmetiky a potrieb pre deti aj mamičky za 80 eur",
              "cs": "BabyBox plný kosmetiky a potřeb pro děti i maminky za 80 EUR",
              "en": "A BabyBox full of cosmetics and other products for both mothers and children, worth EUR 80"
            },
            "description": {
              "sk": "Darčekovú tašku venujeme našim najmenším poistencom do 2. roku. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Dárkovou tašku věnujeme našim nejmenším pojištěncům do 2 let. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Our gift bag is for our littlest clients, up to the age of 2. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/vsetky/darcek-pre-najmensich-za-80-eur",
            "category": null
          },
          {
            "type": {
              "sk": "Samodiagnostický nástroj",
              "cs": "Samodiagnostický nástroj",
              "en": "Self-diagnostic tool"
            },
            "icon": "care",
            "benefit": {
              "sk": "Samodiagnostický nástroj je pre poistencov Dôvery bezplatný.",
              "cs": "Samodiagnostický nástroj je pro pojištěnce Dôvery bezplatný",
              "en": "The self-diagnostic tool is free of charge for Dôvera policyholders."
            },
            "description": {
              "sk": "Necítite sa dobre, pociťujete duševnú nepohodu a lekár nie je nablízku? Vyskúšajte  samodiagnostický nástroj, ktorý je pre poistencov Dôvery bezplatný. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Necítíte se dobře, trpíte psychickými potížemi a lékař není nablízku? Vyzkoušejte  samodiagnostický nástroj, který je pro pojištěnce Dôvery zdarma. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Are you feeling unwell, experiencing mental distress, and your doctor is not available? Try the self-diagnostic tool, which is free for Dôvera policyholders. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/samodiagnosticky-nastroj",
            "category": null
          },
          {
            "type": {
              "sk": "Lekár na diaľku",
              "cs": "Lékař na dálku",
              "en": "Remote doctor"
            },
            "icon": "doctor",
            "benefit": {
              "sk": "Konzultácia s lekárom na diaľku zadarmo",
              "cs": "Konzultace s lékařem na dálku zdarma",
              "en": "Free remote consultation with a doctor"
            },
            "description": {
              "sk": "Netrávte hodiny v čakárni. S aplikáciou MEDDI môžete svoje zdravotné otázky riešiť pohodlne na diaľku, aj večer či cez víkend. Majte apku stále poruke, keď potrebujete odborne poradiť. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Netravte hodiny v čekárně. S aplikací MEDDI můžete své zdravotní dotazy řešit pohodlně na dálku, i večer nebo o víkendu. Mějte aplikaci vždy po ruce, když potřebujete odbornou radu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Don't spend hours in the waiting room. With the MEDDI app, you can conveniently address your health questions remotely, even in the evening or on weekends. Keep the app handy whenever you need expert advice. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/lekar-na-dialku",
            "category": null
          },
          {
            "type": {
              "sk": "Kožné vyšetrenie online a zadarmo",
              "cs": "Online vyšetření kůže zdarma",
              "en": "Online skin examination for free"
            },
            "icon": "dermatology",
            "benefit": {
              "sk": "Kožné vyšetrenie online a zadarmo",
              "cs": "Online vyšetření kůže zdarma",
              "en": "Online skin examination for free"
            },
            "description": {
              "sk": "Máte akné či iný kožný problém? Odfoťte ho a rýchlo a bezpečne odošlite lekárovi. Kožný lekár vám stanoví diagnózu a odporučí liečbu už do 3 pracovných dní. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Máte akné nebo jiný kožní problém? Vyfoťte ho a rychle a bezpečně pošlete lékaři. Dermatolog stanoví diagnózu a doporučí léčbu do 3 pracovních dnů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Do you have acne or another skin problem? Take a photo and send it quickly and securely to a doctor. A dermatologist will diagnose you and recommend treatment within 3 business days. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/kozne-vysetrenie-online-a-zadarmo",
            "category": null
          },
          {
            "type": {
              "sk": "Výživa pre deti od značiek Hami a Nutrilon",
              "cs": "Dětská výživa značek Hami a Nutrilon",
              "en": "Nutrition for children from the brands Hami and Nutrilon"
            },
            "icon": "child-photo",
            "benefit": {
              "sk": "Zľava na výživu pre deti od značiek Hami a Nutrilon",
              "cs": "Sleva na dětskou výživu značek Hami a Nutrilon",
              "en": "Discount on nutrition for children from the brands Hami and Nutrilon"
            },
            "description": {
              "sk": "Kvalitná výživa je základom správneho vývoja dieťatka. Pre poistencov Dôvery máme zľavu na nákup vybraných dojčenských mliek, kašičiek a príkrmov od značiek Hami a Nutrilon. Uplatniť si ju môžete v e-shope Dr. Max. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Kvalitní výživa je základem správného vývoje dítěte. Pro pojištěnce pojišťovny Dôvera máme slevu na nákup vybraných kojeneckých mlék, kaší a příkrmů značek Hami a Nutrilon. Slevu můžete uplatnit v e-shopu Dr. Max. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Quality nutrition is the basis for the proper development of the child. For Dôvera policyholders, we have a discount on the purchase of selected infant milks, porridges and snacks from the Hami and Nutrilon brands. You can redeem it in the e-shop Dr. Max. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-na-vyzivu-pre-deti-od-znaciek-hami-a-nutrilon",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na produkty Sudocrem, Bepanthen a Kamistad",
              "cs": "Sleva na produkty Sudocrem, Bepanthen a Kamistad",
              "en": "Discount on Sudocrem, Bepanthen and Kamistad products"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Zľava do 20 % na produkty Sudocrem, Bepanthen a Kamistad",
              "cs": "Sleva až 20 % na produkty Sudocrem, Bepanthen a Kamistad",
              "en": "Discount up to 20% on Sudocrem, Bepanthen and Kamistad products"
            },
            "description": {
              "sk": "Detská pokožka si vyžaduje citlivú starostlivosť. Poistenci Dôvery môžu využiť zľavu na nákup vybraných produktov značiek Sudocrem, Bepanthen a Kamistad v e-shope a v sieti lekární Dr. Max. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Dětská pokožka vyžaduje citlivou péči. Pojištěnci pojišťovny Dôvera mohou využít slevu na nákup vybraných produktů značek Sudocrem, Bepanthen a Kamistad v e-shopu a v síti lékáren Dr. Max. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Children's skin requires sensitive care. Dôvera policyholders can use a discount on the purchase of selected products of the Sudocrem, Bepanthen and Kamistad brands in the e-shop and in the Dr. Max. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-do-20-na-produkty-sudocrem-bepanthen-a-kamistad",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na produkty pre novorodencov od značky NUK",
              "cs": "Sleva na produkty pro novorozence značky NUK",
              "en": "Discount on products for newborns from the NUK brand"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Zľava 20 % na produkty pre novorodencov od značky NUK",
              "cs": "Sleva 20 % na produkty pro novorozence značky NUK",
              "en": "20% discount on products for newborns from the NUK brand"
            },
            "description": {
              "sk": "Každý deň s bábätkom je plný nových výziev. S kvalitnou detskou výbavou ich zvládnete ľahšie. Pre poistencov Dôvery máme 20 % zľavu na všetky produkty značky NUK v e-shope Dr. Max. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Každý den s miminkem je plný nových výzev. S kvalitní výbavou pro děti je zvládnete snáze. Pro pojištěnce pojišťovny Dôvera máme 20% slevu na všechny produkty značky NUK v e-shopu Dr. Max. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Every day with a baby is full of new challenges. With high-quality children's equipment, you can handle them more easily. For Dôvera policyholders, we have a 20% discount on all NUK brand products in the Dr. Max. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-20-na-produkty-pre-novorodencov-od-znacky-nuk",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na nákup športového kočíka a autosedačky",
              "cs": "Sleva na nákup sportovního kočárku a autosedačky",
              "en": "Discount on the purchase of a sports stroller and car seat"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Zľava 15 % na nákup športového kočíka a autosedačky",
              "cs": "Sleva 15 % na nákup sportovního kočárku a autosedačky",
              "en": "15% discount on the purchase of a sports stroller and car seat"
            },
            "description": {
              "sk": "Keď vaše bábätko začne objavovať svet, prichádza čas na výmenu autosedačky aj kočíka. Naši poistenci ich môžu kúpiť online alebo v kamenných predajniach Feedo so zľavou. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Až vaše miminko začne objevovat svět, nastane čas na výměnu autosedačky i kočárku. Naši pojištěnci je mohou zakoupit online nebo v kamenných prodejnách Feedo se slevou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "When your baby starts exploring the world, it's time to change both the car seat and the stroller. Our policyholders can buy them online or in brick-and-mortar Feedo stores with a discount. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-15-na-nakup-sportoveho-kocika-a-autosedacky",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na nákup výbavičky pre bábätko",
              "cs": "Sleva na nákup výbavy pro miminko",
              "en": "Discount on the purchase of baby gear"
            },
            "icon": "birth",
            "benefit": {
              "sk": "Zľava 15 % na nákup výbavičky pre bábätko",
              "cs": "Sleva 15 % na nákup výbavy pro miminko",
              "en": "15% discount on the purchase of baby gear"
            },
            "description": {
              "sk": "Prvý kočík, autosedačka, pomôcky na dojčenie. S príchodom bábätka súvisia aj výdavky, ktorým sa nevyhnete. Pre bezpečnosť dieťatka a svoje pohodlie toho však rodičia potrebujú oveľa viac. V spolupráci so značkou Feedo ponúkame našim poistencom zľavu na nákup prvej výbavičky online aj v kamenných predajniach. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "První kočárek, autosedačka, pomůcky na kojení. S příchodem miminka jsou spojeny i výdaje, kterým se nevyhnete. Pro bezpečnost dítěte a své pohodlí však rodiče potřebují mnohem více. Ve spolupráci se značkou Feedo nabízíme našim pojištěncům slevu na nákup první výbavy online i v kamenných prodejnách. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "First stroller, car seat, breastfeeding aids. With the arrival of a baby, there are expenses that cannot be avoided. However, parents need much more for their child's safety and comfort. In cooperation with the Feedo brand, we offer our policyholders a discount on the purchase of their first piece of equipment online and in brick-and-mortar stores. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-15-na-nakup-vybavicky-pre-babatko",
            "category": null
          },
          {
            "type": {
              "sk": "Zdravé zuby",
              "cs": "Zdravé zuby",
              "en": "Healthy teeth"
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Deťom prispejeme 5 x 30 € na pečatenie, ošetrenie zubného kazu aj na dentálnu hygienu ",
              "cs": "Dětem přispějeme 5 x 30 € na lakování zubních zářezů, ošetření zubního kazu i na dentální hygienu",
              "en": "We will contribute €5 x €30 to the children for sealing, treatment of tooth decay and dental hygiene"
            },
            "description": {
              "sk": "Deťom prispejeme 5 x 30 € na pečatenie, ošetrenie zubného kazu aj na dentálnu hygienu. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Dětem přispějeme 5 x 30 € na lakování zubních zářezů, ošetření zubního kazu i na dentální hygienu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "We will contribute €5 x €30 to the children for sealing, treatment of tooth decay and dental hygiene More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.dovera.sk/poistenec/benefity/dospely/zdrave-zuby-pre-dospelych-aj-deti",
            "category": null
          }
        ]
      }
    ],
    "updateDate": "2.2.2026",
    "companyBenefitsLink": "https://www.dovera.sk/poistenec/preco-byt-v-dovere"
  },
  {
    "slug": "vzp-sk",
    "genders": [
      {
        "name": {
          "sk": "Muži",
          "cs": "Muži",
          "en": "Men"
        },
        "benefits": [
          {
            "type": {
              "sk": "Neviditeľný strojček na zuby ",
              "cs": "Neviditelná rovnátka",
              "en": "Invisible braces "
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Zľava 22 % na neviditeľný strojček na zuby \n",
              "cs": "Sleva 22 % na neviditelná rovnátka",
              "en": "A 22 % discount on invisible braces"
            },
            "description": {
              "sk": "Až do 22 % zľava na neviditeľný zubný strojček + Dental monitoring vo Family Dental Care - Ortho. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Až 22% sleva na neviditelná rovnátka + Dental monitoring ve Family Dental Care – Ortho. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to 22% discount on invisible braces + Dental monitoring at Family Dental Care - Ortho. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/zlava-neviditelny-zubny-strojcek-vo-family-dental-care-ortho.html",
            "category": "Muži"
          },
          {
            "type": {
              "sk": "Zľavy na okuliare ",
              "cs": "Slevy na brýle",
              "en": "Discount on glasses"
            },
            "icon": "glasses",
            "benefit": {
              "sk": "Zľava až 35 % na okuliare na vybraných pobočkách",
              "cs": "Sleva až 35 % na brýle ve vybraných pobočkách    ",
              "en": "Up to 35% discount on glasses at selected branches"
            },
            "description": {
              "sk": "Až 35 % zľava na okuliare vo vybraných pobočkách. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Až 35% sleva na brýle ve vybraných pobočkách. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to 35% discount on glasses at selected branches. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/?dospeli&checked0=490",
            "category": null
          },
          {
            "type": {
              "sk": "Protónová liečba pre onkologických pacientov",
              "cs": "Protonová léčba pro onkologické pacienty",
              "en": "Proton treatment for cancer patients"
            },
            "icon": "ribbon",
            "benefit": {
              "sk": "Liečba hradená poisťovňou",
              "cs": "Léčba hrazená pojišťovnou",
              "en": "Treatment covered by insurance"
            },
            "description": {
              "sk": "Protónová liečba sa využíva najmä pri nádoroch na mozgu, hlavy a krku (nádory oka, prínosových dutín, príušnej žľazy), nádoroch prsníka, prostaty, pečene, pankreasu a nádoroch v detskom veku. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Protonová léčba se využívá zejména u nádorů mozku, hlavy a krku (nádory oka, vedlejších nosních dutin, příušní žlázy), nádorů prsu, prostaty, jater, slinivky břišní a nádorů u dětí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Proton treatment is used primarily for tumours of the brain, head, and neck (tumours of the eye, nasal passages, parotid glands), tumours of the breast, prostate, and pancreas, and tumours in children. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/protonova-liecba-onkologickych-pacientov.html",
            "category": null
          },
          {
            "type": {
              "sk": "Test na okultné krvácanie",
              "cs": "Test na okultní krvácení",
              "en": "Occult bleeding test"
            },
            "icon": "rectum",
            "benefit": {
              "sk": "Test na okultné krvácanie už od 40 rokov zadarmo",
              "cs": "Test na okultní krvácení zdarma již od 40 let",
              "en": "An occult bleeding test starting at age 40 for free"
            },
            "description": {
              "sk": "Preventívne vyšetrenie zamerané na zistenie skrytého krvácania v stolici, ktoré môže včas odhaliť rakovinu hrubého čreva a konečníka. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Preventivní vyšetření zaměřené na zjištění skrytého krvácení ve stolici, které může včas odhalit rakovinu tlustého střeva a konečníku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A preventive examination that focuses on detecting hidden bleeding in the stool, which can help in early detection of colon and anal cancer. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-okultne-krvacanie-od-40-rokov-zdarma.html",
            "category": null
          },
          {
            "type": {
              "sk": "Vyšetrenie rizika vzniku cievnej mozgovej príhody",
              "cs": "Vyšetření rizika vzniku cévní mozkové příhody",
              "en": "Stroke Risk Assessment"
            },
            "icon": "brain",
            "benefit": {
              "sk": "Vyšetrenie hradené poisťovňou",
              "cs": "Vyšetření hrazené pojišťovnou",
              "en": "Examination covered by insurance"
            },
            "description": {
              "sk": "Vyšetrenie rizika vzniku cievnej mozgovej príhody hradené poisťovňou. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Vyšetření rizika vzniku cévní mozkové příhody hrazené pojišťovnou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Risk assessment for stroke covered by insurance. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/vysetrenie-rizika-vzniku-cievnej-mozgovej-prihody.html",
            "category": null
          },
          {
            "type": {
              "sk": "Stanovenie pomeru krvného tlaku na nohe a ruke – ABI index",
              "cs": "Stanovení poměru krevního tlaku na noze a ruce – ABI index",
              "en": "Ankle Brachial Index (ABI Test) - measurement of the ratio of blood pressure in the arms and legs"
            },
            "icon": "heart-attack",
            "benefit": {
              "sk": "Uhrádzame výkon 1x za 2 roky pri preventívnej prehliadke",
              "cs": "Hradíme výkon 1x za 2 roky při preventivní prohlídce",
              "en": "We pay for this test once every two years during a preventive check-up"
            },
            "description": {
              "sk": "Ide o dôležité vyšetrenie z hľadiska včasnej diagnostiky ischemickej choroby dolných končatín, ktorá predpovedá pravdepodobnosť vzniku srdcového infarktu alebo cievnej mozgovej príhody. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Jedná se o důležité vyšetření z hlediska včasné diagnostiky ischemické choroby dolních končetin, která předpovídá pravděpodobnost vzniku infarktu myokardu nebo cévní mozkové příhody. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "This test plays an important part in the early diagnosis of peripheral vascular disease, and predicts the likelihood of heart attacks or strokes. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/stanovenie-pomeru-krvneho-tlaku-nohe-aruke-abi-index.html",
            "category": null
          },
          {
            "type": {
              "sk": "Starostlivosť o pacientov s vysokým krvným tlakom v ambulancii všeobecného lekára",
              "cs": "Péče o pacienty s vysokým krevním tlakem v ordinaci praktického lékaře",
              "en": "Treatment of patients with high blood pressure by a general practitioner"
            },
            "icon": "heart-attack",
            "benefit": {
              "sk": "Starostlivosť priamo u všeobecného lekára",
              "cs": "Péče přímo u praktického lékaře",
              "en": "Care provided directly by a GP"
            },
            "description": {
              "sk": "Pacient nemusí čakať ani sa objednávať k odbornému lekárovi, diagnostiku i liečbu vybraných skupín pacientov s artériovou hypertenziou komplexne zabezpečí jeho všeobecný lekár. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pacient nemusí čekat ani se objednávat k odbornému lékaři, diagnostiku i léčbu vybraných skupin pacientů s arteriální hypertenzí komplexně zajistí jeho praktický lékař. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The patient doesn't need to wait for or make an appointment with a specialist; their GP will arrange diagnosis and treatment of selected groups of patients with hypertension. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/starostlivost-opacientov-svysokym-krvnym-tlakom-vambulancii-vseobecneho-lekara.html",
            "category": null
          },
          {
            "type": {
              "sk": "Diagnostika a liečba poruchy metabolizmu tukov u všeobecného lekára",
              "cs": "Diagnostika a léčba poruch metabolismu tuků u praktického lékaře",
              "en": "Diagnosis and treatment of fat metabolism disorders by a general practitioner"
            },
            "icon": "blood-fat",
            "benefit": {
              "sk": "Starostlivosť priamo u všeobecného lekára",
              "cs": "Péče přímo u praktického lékaře        ",
              "en": "Care provided directly by a GP"
            },
            "description": {
              "sk": "Všeobecný lekár našim klientom taktiež poskytuje diagnostiku a liečbu poruchy metabolizmu tukov bez potreby objednania sa u špecialistu. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Praktický lékař našim klientům rovněž poskytuje diagnostiku a léčbu poruch metabolismu tuků bez nutnosti objednání u specialisty. \nVíce informací naleznete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "General practitioners also provide our clients with diagnosis and treatment of fat metabolism disorders without the need to make an appointment with a specialist. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/diagnostika-aliecbaporuchy-metabolizmu-tukov-vseobecneho-lekara.html",
            "category": null
          },
          {
            "type": {
              "sk": "Preventívna urologická prehliadka pre mužov od 40 rokov",
              "cs": "Preventivní urologické vyšetření pro muže od 40 let",
              "en": "Preventive urology examination for men aged 40 and up"
            },
            "icon": "prostate",
            "benefit": {
              "sk": "Urologická prehliadka pre mužov od 40 rokov zadarmo",
              "cs": "Urologické vyšetření pro muže od 40 let zdarma",
              "en": "A free urology examination for men aged 40 and up"
            },
            "description": {
              "sk": "Vo VšZP sa zameriavajú na včasné zachytenie odvrátiteľných onkologických ochorení, akým je napríklad rakovina prostaty. Mužom ju uhrádza raz za tri roky už od 40. roku života. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Ve VšZP se zaměřují na včasné odhalení onkologických onemocnění, kterým lze předejít, jako je například rakovina prostaty. Mužům ji hradí jednou za tři roky již od 40. roku života. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "VšZP focuses on early detection of preventable oncological diseases, such as prostate cancer. This test is available to men once every three years starting at age 40. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/preventivna-urologicka-prehliadka-muzov-od-40-rokov.html",
            "category": null
          },
          {
            "type": {
              "sk": "Komplexná liečba morbídnej obezity",
              "cs": "Komplexní léčba morbidní obezity",
              "en": "Comprehensive treatment of morbid obesity"
            },
            "icon": "weight",
            "benefit": {
              "sk": "Komplexná liečba pre pacientov s morbídnou obezitou zadarmo",
              "cs": "Komplexní léčba pro pacienty s morbidní obezitou zdarma",
              "en": "Free comprehensive treatment for patients with morbid obesity"
            },
            "description": {
              "sk": "Našim poistencom s morbídnou obezitou hradíme komplexnú liečbu, ktorej súčasťou je nielen operačný zákrok, ale aj liečba u psychológa a ďalších špecialistov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Našim pojištěncům s morbidní obezitou hradíme komplexní léčbu, jejíž součástí je nejen chirurgický zákrok, ale i léčba u psychologa a dalších specialistů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "For our clients with morbid obesity, we cover comprehensive treatment that includes not only\nsurgery, but also treatment by a psychologist and other specialists. More information (in Slovak\nonly) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/komplexna-liecba-morbidnej-obezity.html",
            "category": null
          },
          {
            "type": {
              "sk": "Očkovanie proti chrípke",
              "cs": "Očkování proti chřipce",
              "en": "Flu vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "sk": "Vakcíny proti chrípke preplatené v plnej výške ich ceny ",
              "cs": "Vakcíny proti chřipce hrazené v plné výši",
              "en": "Coverage of the full price of flu vaccines"
            },
            "description": {
              "sk": "Očkovanie proti chrípke je účinnou formou prevencie, ktorá pomáha chrániť pred vážnymi komplikáciami tohto ochorenia. Je dostupné pre každého poistenca VšZP s nárokom na plnú zdravotnú starostlivosť. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Očkování proti chřipce je účinnou formou prevence, která pomáhá chránit před vážnými komplikacemi tohoto onemocnění. Je dostupné pro každého pojištěnce VZP s nárokem na plnou zdravotní péči. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Flu vaccination is an effective form of prevention that helps protect against serious complications of this disease. It is available to all VZP policyholders entitled to full healthcare. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke.html",
            "category": null
          },
          {
            "type": {
              "sk": "Nastavenie diabetika na inzulínovú pumpu v ambulancii",
              "cs": "Nastavení diabetika na inzulinovou pumpu v ambulanci",
              "en": "Setting up a diabetic patient for an insulin pump in an outpatient clinic"
            },
            "icon": "diabetes",
            "benefit": {
              "sk": "Ambulantné nastavenie inzulínovej pumpy zadarmo",
              "cs": "Ambulantní nastavení inzulinové pumpy zdarma",
              "en": "Free installation of an insulin pump on an outpatient basis"
            },
            "description": {
              "sk": "Pacient dostane niekoľkohodinové zaškolenie, nastavia ho na pumpu a získa všetky informácie potrebné pre praktický život s touto zdravotníckou pomôckou. Z ambulancie odíde už s funkčnou pumpou, zavedeným senzorom a aplikáciou v smartfóne. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pacient absolvuje několikahodinové zaškolení, bude mu nastavena pumpa a získá všechny informace potřebné pro praktický život s touto zdravotnickou pomůckou. Z ambulance odejde již s funkční pumpou, zavedeným senzorem a aplikací ve smartphonu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The patient will receive several hours of training, will be prepared for pump use, and will obtain all information necessary for practical living with this medical device. They will leave the clinic with a functional pump, an implanted sensor, and an application in their smartphone. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/nastavenie-diabetika-inzulinovu-pumpu-vambulancii.html",
            "category": null
          },
          {
            "type": {
              "sk": "EKG vyšetrenie ako súčasť preventívnej prehliadky od 40 rokov",
              "cs": "EKG vyšetření jako součást preventivní prohlídky od 40 let",
              "en": "ECG test as part of a preventive check-up starting at age 40"
            },
            "icon": "heart-attack",
            "benefit": {
              "sk": "EKG vyšetrenie u všeobecného lekára ako súčasť preventívnej prehliadky",
              "cs": "EKG vyšetření u praktického lékaře, a to jako součást preventivní prohlídky",
              "en": "An ECG test performed by a GP as part of a preventive check-up"
            },
            "description": {
              "sk": "EKG vyšetrenie patrí medzi základné vyšetrenia na odhalenie rizika vzniku cievnej mozgovej príhody. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "EKG vyšetření patří mezi základní vyšetření k odhalení rizika vzniku cévní mozkové příhody. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "An ECG test belongs among the basic examination methods used to detect the risk of stroke. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ekg-vysetrenie-ako-sucast-preventivnej-prehliadky-od-40-rokov.html",
            "category": null
          },
          {
            "type": {
              "sk": "Test mentálneho zdravia pre skoré odhalenie porúch s pamäťou",
              "cs": "Test duševního zdraví pro včasné odhalení poruch paměti",
              "en": "Mental health test for early detection of memory disorders"
            },
            "icon": "happy",
            "benefit": {
              "sk": "Kognitívny test MoCA zadarmo pacientom nad 60 rokov",
              "cs": "Kognitivní test MoCA zdarma pro pacienty starší 60 let",
              "en": "Free MoCA (Montreal Cognitive Assessment) test for patients over 60 years of age"
            },
            "description": {
              "sk": "Kognitívny test MoCa pomôže vo včasnom štádiu odhaliť začínajúce problémy. Vyšetrenie je možné absolvovať u svojho všeobecného lekára a je preplácané pacientom nad 60 rokov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Kognitivní test MoCA pomůže včas odhalit začínající problémy. Vyšetření je možné absolvovat u svého praktického lékaře a je hrazeno pacientům nad 60 let. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A MoCA test helps detect problems in their early stages. This test can be performed by your GP and is covered for patients over the age of 60. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-mentalneho-zdravia-skore-odhalenie-poruch-spamatou.html",
            "category": null
          },
          {
            "type": {
              "sk": "Testovanie Covid-19 versus chrípka",
              "cs": "Testování na Covid-19 versus chřipku",
              "en": "Covid-19 vs. flu testing"
            },
            "icon": "danger",
            "benefit": {
              "sk": "Kompletná diferenciálna diagnostika zadarmo",
              "cs": "Kompletní diferenciální diagnostika zdarma",
              "en": "A free complete differential diagnosis"
            },
            "description": {
              "sk": "Príznaky Covid-19 sú prakticky zhodné s chrípkovými symptómami. Výhodou tejto diagnostiky je včasná a účinná liečba pacienta s respiračným problémami. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Příznaky Covid-19 jsou prakticky totožné s příznaky chřipky. Výhodou této diagnostiky je včasná a účinná léčba pacienta s respiračními potížemi. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The symptoms of Covid-19 are practically identical to flu symptoms. The advantage of this diagnosis is early and effective treatment of a patient with respiratory problems. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/testovanie-covid-19-versus-chripka.html",
            "category": null
          },
          {
            "type": {
              "sk": "Samoodberové testy",
              "cs": "Samoodběrové testy",
              "en": "Self-collection tests"
            },
            "icon": "bloodtest",
            "benefit": {
              "sk": "Špeciálne samoodberové testy so zľavou 5 eur",
              "cs": "Speciální testy pro vlastní odběr se slevou 5 EUR",
              "en": "Special self-collection tests with a EUR 5 discount"
            },
            "description": {
              "sk": "Špeciálne samoodberové testy so zľavou 5 eur. Samotestom získate výsledky z certifikovaného laboratória už do 10 dní od odoslania vzorky. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Speciální testy pro vlastní odběr se slevou 5 EUR. Díky tomuto testu získáte výsledky z certifikované laboratoře již do 10 dnů od odeslání vzorku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Special self-collection tests with a discount of EUR 5. With the self-test, you will receive results from a certified laboratory within 10 days of sending the sample. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ziskajte-kontrolu-nad-vlastnym-zdravim-vdaka-medistom.html",
            "category": null
          },
          {
            "type": {
              "sk": "Potraviny bez lepku YAMIS",
              "cs": "Bezlepkové potraviny YAMIS",
              "en": "Gluten-free foods YAMIS"
            },
            "icon": "gluten",
            "benefit": {
              "sk": "Potraviny bez lepku YAMIS so zľavou 10 %",
              "cs": "Bezlepkové potraviny YAMIS se slevou 10 %",
              "en": "YAMIS gluten-free food with a 10% discount"
            },
            "description": {
              "sk": "Navštívte e-shop YAMIS a objavte pestrú ponuku kvalitných bezlepkových potravín vhodných pre ľudí s intoleranciou na lepok aj pre priaznivcov zdravého životného štýlu. Využite 10 % zľavu a nakupujte pohodlne online. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Navštivte e-shop YAMIS a objevte pestrou nabídku kvalitních bezlepkových potravin vhodných pro osoby s nesnášenlivostí lepku i pro příznivce zdravého životního stylu. Využijte 10% slevu a nakupujte pohodlně online. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Visit the YAMIS e-shop and discover a wide range of high-quality gluten-free foods suitable for people with gluten intolerance and for supporters of a healthy lifestyle. Take advantage of a 10% discount and shop comfortably online. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/potraviny-bez-lepku-yamis.html",
            "category": null
          },
          {
            "type": {
              "sk": "Úvodná DIA FIT konzultácia a jedálniček ",
              "cs": "Úvodní konzultace DIA FIT a jídelníček",
              "en": "Introductory DIA FIT consultation and diet plan"
            },
            "icon": "zdravy-talir",
            "benefit": {
              "sk": "Úvodná DIA FIT konzultácia a jedálniček zdarma pre diabetikov",
              "cs": "Úvodní konzultace DIA FIT a jídelníček zdarma pro diabetiky",
              "en": "Free initial consultation and DIA FIT diet plan for clients with diabetes"
            },
            "description": {
              "sk": "Zdravá strava a pohyb sú pri diabete kľúčové. Program DIA FIT ponúka poistencom VšZP možnosť absolvovať úvodnú konzultáciu a individuálny jedálniček úplne zdarma, pod vedením osobného trénera Martina Tkáča, ktorý už 27 rokov aktívne športuje a žije s diabetom. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravá strava a pohyb jsou při cukrovce klíčové. Program DIA FIT nabízí pojištěncům VšZP možnost absolvovat úvodní konzultaci a individuální jídelníček zcela zdarma pod vedením osobního trenéra Martina Tkáče, který již 27 let aktivně sportuje a žije s cukrovkou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A healthy diet and exercise are key in diabetes. The DIA FIT program offers VšZP policyholders the opportunity to undergo an initial consultation and an individual diet completely free of charge, under the guidance of personal trainer Martin Tkáč, who has been active in sports and lives with diabetes for 27 years. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/konzultacia-jedalnicek-diafit-programu-diabetikov.html",
            "category": null
          },
          {
            "type": {
              "sk": "Poistenie úrazu a života SPIRIT v ČSOB",
              "cs": "Úrazové a životní pojištění SPIRIT v ČSOB",
              "en": "Accident and life insurance SPIRIT at ČSOB"
            },
            "icon": "shield",
            "benefit": {
              "sk": "Poistenie úrazu a života SPIRIT v ČSOB so zľavou 15 %",
              "cs": "Úrazové a životní pojištění SPIRIT v ČSOB se slevou 15 %",
              "en": "SPIRIT accident and life insurance at ČSOB with a 15% discount"
            },
            "description": {
              "sk": "Poistenie úrazu a života SPIRIT v ČSOB so zľavou 15 %. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Úrazové a životní pojištění SPIRIT v ČSOB se slevou 15 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "SPIRIT accident and life insurance at ČSOB with a 15% discount. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/poistenie-urazu-zivota-spirit-csob.html",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na lieky, výživové doplnky a kozmetiku",
              "cs": "Sleva na léky, doplňky stravy a kosmetiku",
              "en": "Discount on medicines, nutritional supplements, and cosmetics"
            },
            "icon": "pill",
            "benefit": {
              "sk": "Až 15 % zľava na lieky, výživové doplnky a kozmetiku",
              "cs": "Až 15% sleva na léky, doplňky stravy a kosmetiku",
              "en": "Up to 15% discount on medicines, nutritional supplements, and cosmetics"
            },
            "description": {
              "sk": "Na internetovom obchode si môžete zakúpiť voľnopredajné lieky, výživové doplnky, ale aj kozmetiku. Lieky24.sk je overeným obchodom, ktorý ponúka dopravu zdarma, zaručuje rýchle dodanie tovaru a ponúka široký sortiment výrobkov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "V internetovém obchodě si můžete zakoupit volně prodejné léky, doplňky stravy, ale i kosmetiku. Lieky24.sk je ověřený obchod, který nabízí dopravu zdarma, zaručuje rychlé doručení zboží a nabízí široký sortiment produktů. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "You can purchase over-the-counter medications, nutritional supplements, and even cosmetics on-line. Lieky24.sk is a trusted e-shop with a broad range of products, offering free shipping with guaranteed quick delivery. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/e-shop-lieky24-sk.html",
            "category": null
          },
          {
            "type": {
              "sk": "Extrakcia zuba múdrosti a iné dentálne zákroky so zľavou",
              "cs": "Extrakce zubů moudrosti a další zubní zákroky se slevou",
              "en": "Wisdom tooth extraction and other dental procedures with discounts "
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Extrakcia zuba múdrosti a iné dentálne zákroky so zľavou až do 50 %",
              "cs": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %",
              "en": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%"
            },
            "description": {
              "sk": "Extrakcia zuba múdrosti a iné dentálne zákroky so zľavou až do 50 %. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/?checked0=494&docId=6949&count=20",
            "category": null
          },
          {
            "type": {
              "sk": "Ďalšie výhody a zľavy pre všetkých",
              "cs": "Další výhody a slevy pro všechny",
              "en": "More benefits and discounts for all"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Výhody pre celú rodinu",
              "cs": "Výhody pro celou rodinu    ",
              "en": "Benefits for the whole family"
            },
            "description": {
              "sk": "Užite si ďalšie benefity a výhody, ktoré vám poisťovňa ponúka. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Využijte další benefity a výhody, které vám pojišťovna nabízí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Take advantage of more benefits and discounts offered by your insurer. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/?",
            "category": null
          }
        ]
      },
      {
        "name": {
          "sk": "Ženy",
          "cs": "Ženy",
          "en": "Women"
        },
        "benefits": [
          {
            "type": {
              "sk": "Neviditeľný strojček na zuby",
              "cs": "Neviditelná rovnátka",
              "en": "Invisible braces"
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Zľava 22 % na neviditeľný strojček na zuby \n",
              "cs": "Sleva 22 % na neviditelná rovnátka",
              "en": "A 22 % discount on invisible braces"
            },
            "description": {
              "sk": "Až do 22 % zľava na neviditeľný zubný strojček + Dental monitoring vo Family Dental Care - Ortho. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Až 22% sleva na neviditelná rovnátka + Dental monitoring ve Family Dental Care – Ortho. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to 22% discount on invisible braces + Dental monitoring at Family Dental Care - Ortho. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/zlava-neviditelny-zubny-strojcek-vo-family-dental-care-ortho.html",
            "category": "Ženy"
          },
          {
            "type": {
              "sk": "Zľavy na okuliare ",
              "cs": "Slevy na brýle",
              "en": "Discount on glasses"
            },
            "icon": "glasses",
            "benefit": {
              "sk": "Zľava až 35 % na okuliare na vybraných pobočkách",
              "cs": "Sleva až 35 % na brýle ve vybraných pobočkách    ",
              "en": "Up to 35% discount on glasses at selected branches"
            },
            "description": {
              "sk": "Až 35 % zľava na okuliare vo vybraných pobočkách. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Až 35% sleva na brýle ve vybraných pobočkách. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to 35% discount on glasses at selected branches. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/?dospeli&checked0=490",
            "category": null
          },
          {
            "type": {
              "sk": "Protónová liečba pre onkologických pacientov",
              "cs": "Protonová léčba pro onkologické pacienty",
              "en": "Proton treatment for cancer patients"
            },
            "icon": "ribbon",
            "benefit": {
              "sk": "Liečba hradená poisťovňou",
              "cs": "Léčba hrazená pojišťovnou",
              "en": "Treatment covered by insurance"
            },
            "description": {
              "sk": "Protónová liečba sa využíva najmä pri nádoroch na mozgu, hlavy a krku (nádory oka, prínosových dutín, príušnej žľazy), nádoroch prsníka, prostaty, pečene, pankreasu a nádoroch v detskom veku. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Protonová léčba se využívá zejména u nádorů mozku, hlavy a krku (nádory oka, vedlejších nosních dutin, příušní žlázy), nádorů prsu, prostaty, jater, slinivky břišní a nádorů u dětí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Proton treatment is used primarily for tumours of the brain, head, and neck (tumours of the eye, nasal passages, parotid glands), tumours of the breast, prostate, and pancreas, and tumours in children. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/protonova-liecba-onkologickych-pacientov.html",
            "category": null
          },
          {
            "type": {
              "sk": "Test na okultné krvácanie",
              "cs": "Test na okultní krvácení",
              "en": "Occult bleeding test"
            },
            "icon": "rectum",
            "benefit": {
              "sk": "Test na okultné krvácanie už od 40 rokov zadarmo",
              "cs": "Test na okultní krvácení zdarma již od 40 let",
              "en": "An occult bleeding test starting at age 40 for free"
            },
            "description": {
              "sk": "Preventívne vyšetrenie zamerané na zistenie skrytého krvácania v stolici, ktoré môže včas odhaliť rakovinu hrubého čreva a konečníka. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Preventivní vyšetření zaměřené na zjištění skrytého krvácení ve stolici, které může včas odhalit rakovinu tlustého střeva a konečníku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A preventive examination that focuses on detecting hidden bleeding in the stool, which can help in early detection of colon and anal cancer. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-okultne-krvacanie-od-40-rokov-zdarma.html",
            "category": null
          },
          {
            "type": {
              "sk": "Vyšetrenie rizika vzniku cievnej mozgovej príhody",
              "cs": "Vyšetření rizika vzniku cévní mozkové příhody",
              "en": "Stroke Risk Assessment"
            },
            "icon": "brain",
            "benefit": {
              "sk": "Vyšetrenie hradené poisťovňou",
              "cs": "Vyšetření hrazené pojišťovnou",
              "en": "Examination covered by insurance"
            },
            "description": {
              "sk": "Vyšetrenie rizika vzniku cievnej mozgovej príhody hradené poisťovňou. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Vyšetření rizika vzniku cévní mozkové příhody hrazené pojišťovnou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Risk assessment for stroke covered by insurance. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/vysetrenie-rizika-vzniku-cievnej-mozgovej-prihody.html",
            "category": null
          },
          {
            "type": {
              "sk": "Stanovenie pomeru krvného tlaku na nohe a ruke – ABI index",
              "cs": "Stanovení poměru krevního tlaku na noze a ruce – ABI index",
              "en": "Ankle Brachial Index (ABI Test) - measurement of the ratio of blood pressure in the arms and legs"
            },
            "icon": "heart-attack",
            "benefit": {
              "sk": "Uhrádzame výkon 1x za 2 roky pri preventívnej prehliadke",
              "cs": "Hradíme výkon 1x za 2 roky při preventivní prohlídce",
              "en": "We pay for this test once every two years during a preventive check-up"
            },
            "description": {
              "sk": "Ide o dôležité vyšetrenie z hľadiska včasnej diagnostiky ischemickej choroby dolných končatín, ktorá predpovedá pravdepodobnosť vzniku srdcového infarktu alebo cievnej mozgovej príhody. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Jedná se o důležité vyšetření z hlediska včasné diagnostiky ischemické choroby dolních končetin, která předpovídá pravděpodobnost vzniku infarktu myokardu nebo cévní mozkové příhody. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "This test plays an important part in the early diagnosis of peripheral vascular disease, and predicts the likelihood of heart attacks or strokes. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/stanovenie-pomeru-krvneho-tlaku-nohe-aruke-abi-index.html",
            "category": null
          },
          {
            "type": {
              "sk": "Starostlivosť o pacientov s vysokým krvným tlakom v ambulancii všeobecného lekára",
              "cs": "Péče o pacienty s vysokým krevním tlakem v ordinaci praktického lékaře",
              "en": "Treatment of patients with high blood pressure by a general practitioner"
            },
            "icon": "heart-attack",
            "benefit": {
              "sk": "Starostlivosť priamo u všeobecného lekára",
              "cs": "Péče přímo u praktického lékaře",
              "en": "Care provided directly by a GP"
            },
            "description": {
              "sk": "Pacient nemusí čakať ani sa objednávať k odbornému lekárovi, diagnostiku i liečbu vybraných skupín pacientov s artériovou hypertenziou komplexne zabezpečí jeho všeobecný lekár. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pacient nemusí čekat ani se objednávat k odbornému lékaři, diagnostiku i léčbu vybraných skupin pacientů s arteriální hypertenzí komplexně zajistí jeho praktický lékař. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The patient doesn't need to wait for or make an appointment with a specialist; their GP will arrange diagnosis and treatment of selected groups of patients with hypertension. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/starostlivost-opacientov-svysokym-krvnym-tlakom-vambulancii-vseobecneho-lekara.html",
            "category": null
          },
          {
            "type": {
              "sk": "Diagnostika a liečba poruchy metabolizmu tukov u všeobecného lekára",
              "cs": "Diagnostika a léčba poruch metabolismu tuků u praktického lékaře",
              "en": "Diagnosis and treatment of fat metabolism disorders by a general practitioner"
            },
            "icon": "blood-fat",
            "benefit": {
              "sk": "Starostlivosť priamo u všeobecného lekára",
              "cs": "Péče přímo u praktického lékaře        ",
              "en": "Care provided directly by a GP"
            },
            "description": {
              "sk": "Všeobecný lekár našim klientom taktiež poskytuje diagnostiku a liečbu poruchy metabolizmu tukov bez potreby objednania sa u špecialistu. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Praktický lékař našim klientům rovněž poskytuje diagnostiku a léčbu poruch metabolismu tuků bez nutnosti objednání u specialisty. \nVíce informací naleznete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "General practitioners also provide our clients with diagnosis and treatment of fat metabolism disorders without the need to make an appointment with a specialist. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/diagnostika-aliecbaporuchy-metabolizmu-tukov-vseobecneho-lekara.html",
            "category": null
          },
          {
            "type": {
              "sk": "Komplexná liečba morbídnej obezity",
              "cs": "Komplexní léčba morbidní obezity",
              "en": "Comprehensive treatment of morbid obesity"
            },
            "icon": "weight",
            "benefit": {
              "sk": "Komplexná liečba pre pacientov s morbídnou obezitou zadarmo",
              "cs": "Komplexní léčba pro pacienty s morbidní obezitou zdarma",
              "en": "Free comprehensive treatment for patients with morbid obesity"
            },
            "description": {
              "sk": "Našim poistencom s morbídnou obezitou hradíme komplexnú liečbu, ktorej súčasťou je nielen operačný zákrok, ale aj liečba u psychológa a ďalších špecialistov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Našim pojištěncům s morbidní obezitou hradíme komplexní léčbu, jejíž součástí je nejen chirurgický zákrok, ale i léčba u psychologa a dalších specialistů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "For our clients with morbid obesity, we cover comprehensive treatment that includes not only\nsurgery, but also treatment by a psychologist and other specialists. More information (in Slovak\nonly) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/komplexna-liecba-morbidnej-obezity.html",
            "category": null
          },
          {
            "type": {
              "sk": "Očkovanie proti chrípke",
              "cs": "Očkování proti chřipce",
              "en": "Flu vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "sk": "Vakcíny proti chrípke preplatené v plnej výške ich ceny",
              "cs": "Vakcíny proti chřipce hrazené v plné výši",
              "en": "Coverage of the full price of flu vaccines"
            },
            "description": {
              "sk": "Očkovanie proti chrípke je účinnou formou prevencie, ktorá pomáha chrániť pred vážnymi komplikáciami tohto ochorenia. Je dostupné pre každého poistenca VšZP s nárokom na plnú zdravotnú starostlivosť. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Očkování proti chřipce je účinnou formou prevence, která pomáhá chránit před vážnými komplikacemi tohoto onemocnění. Je dostupné pro každého pojištěnce VZP s nárokem na plnou zdravotní péči. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Flu vaccination is an effective form of prevention that helps protect against serious complications of this disease. It is available to all VZP policyholders entitled to full healthcare. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke.html",
            "category": null
          },
          {
            "type": {
              "sk": "Očkovanie proti chrípke pre tehotné",
              "cs": "Očkování proti chřipce pro těhotné",
              "en": "Flu vaccination for pregnant"
            },
            "icon": "vaccine",
            "benefit": {
              "sk": "Vakcíny proti chrípke preplatené v plnej výške ich ceny",
              "cs": "Vakcíny proti chřipce hrazené v plné výši",
              "en": "Coverage of the full price of flu vaccines"
            },
            "description": {
              "sk": "Chrípka prekonaná v tehotenstve môže vážne ohroziť dieťatko. Tehotné poistenky VšZP už nemusia kvôli očkovaniu vyhľadávať ambulanciu všeobecného lekára, na požiadanie ich proti chrípke zaočkuje aj gynekológ počas bežnej kontroly. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Chřipka prodělaná v těhotenství může vážně ohrozit dítě. Těhotné pojištěnkyně Všeobecné zdravotní pojišťovny již nemusí kvůli očkování vyhledávat ordinaci praktického lékaře, na požádání je proti chřipce naočkuje i gynekolog během běžné prohlídky. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Flu contracted during pregnancy can seriously endanger the baby. Pregnant women insured by VšZP no longer need to visit a general practitioner for vaccination; upon request, their gynecologist will also vaccinate them against flu during a routine check-up. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke-tehotne.html",
            "category": null
          },
          {
            "type": {
              "sk": "Nastavenie diabetika na inzulínovú pumpu v ambulancii",
              "cs": "Nastavení diabetika na inzulinovou pumpu v ambulanci",
              "en": "Setting up a diabetic patient for an insulin pump in an outpatient clinic"
            },
            "icon": "diabetes",
            "benefit": {
              "sk": "Ambulantné nastavenie inzulínovej pumpy zadarmo",
              "cs": "Ambulantní nastavení inzulinové pumpy zdarma",
              "en": "Free installation of an insulin pump on an outpatient basis"
            },
            "description": {
              "sk": "Pacient dostane niekoľkohodinové zaškolenie, nastavia ho na pumpu a získa všetky informácie potrebné pre praktický život s touto zdravotníckou pomôckou. Z ambulancie odíde už s funkčnou pumpou, zavedeným senzorom a aplikáciou v smartfóne. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pacient absolvuje několikahodinové zaškolení, bude mu nastavena pumpa a získá všechny informace potřebné pro praktický život s touto zdravotnickou pomůckou. Z ambulance odejde již s funkční pumpou, zavedeným senzorem a aplikací ve smartphonu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The patient will receive several hours of training, will be prepared for pump use, and will obtain all information necessary for practical living with this medical device. They will leave the clinic with a functional pump, an implanted sensor, and an application in their smartphone. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/nastavenie-diabetika-inzulinovu-pumpu-vambulancii.html",
            "category": null
          },
          {
            "type": {
              "sk": "EKG vyšetrenie ako súčasť preventívnej prehliadky od 40 rokov",
              "cs": "EKG vyšetření jako součást preventivní prohlídky od 40 let",
              "en": "ECG test as part of a preventive check-up starting at age 40"
            },
            "icon": "heart-attack",
            "benefit": {
              "sk": "EKG vyšetrenie u všeobecného lekára, a to ako súčasť preventívnej prehliadky",
              "cs": "EKG vyšetření u praktického lékaře, a to jako součást preventivní prohlídky",
              "en": "An ECG test performed by a GP as part of a preventive check-up"
            },
            "description": {
              "sk": "EKG vyšetrenie patrí medzi základné vyšetrenia na odhalenie rizika vzniku cievnej mozgovej príhody. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "EKG vyšetření patří mezi základní vyšetření k odhalení rizika vzniku cévní mozkové příhody. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "An ECG test belongs among the basic examination methods used to detect the risk of stroke. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ekg-vysetrenie-ako-sucast-preventivnej-prehliadky-od-40-rokov.html",
            "category": null
          },
          {
            "type": {
              "sk": "Test mentálneho zdravia pre skoré odhalenie porúch s pamäťou",
              "cs": "Test duševního zdraví pro včasné odhalení poruch paměti",
              "en": "Mental health test for early detection of memory disorders"
            },
            "icon": "happy",
            "benefit": {
              "sk": "Kognitívny test MoCA zadarmo pacientom nad 60 rokov",
              "cs": "Kognitivní test MoCA zdarma pro pacienty starší 60 let",
              "en": "Free MoCA (Montreal Cognitive Assessment) test for patients over 60 years of age"
            },
            "description": {
              "sk": "Kognitívny test MoCa pomôže vo včasnom štádiu odhaliť začínajúce problémy. Vyšetrenie je možné absolvovať u svojho všeobecného lekára a je preplácané pacientom nad 60 rokov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Kognitivní test MoCA pomůže včas odhalit začínající problémy. Vyšetření je možné absolvovat u svého praktického lékaře a je hrazeno pacientům nad 60 let. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A MoCA test helps detect problems in their early stages. This test can be performed by your GP and is covered for patients over the age of 60. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-mentalneho-zdravia-skore-odhalenie-poruch-spamatou.html",
            "category": null
          },
          {
            "type": {
              "sk": "Testovanie Covid-19 versus chrípka",
              "cs": "Testování na Covid-19 versus chřipku",
              "en": "Covid-19 vs. flu testing"
            },
            "icon": "danger",
            "benefit": {
              "sk": "Kompletná diferenciálna diagnostika zadarmo",
              "cs": "Kompletní diferenciální diagnostika zdarma",
              "en": "A free complete differential diagnosis"
            },
            "description": {
              "sk": "Príznaky Covid-19 sú prakticky zhodné s chrípkovými symptómami. Výhodou tejto diagnostiky je včasná a účinná liečba pacienta s respiračným problémami. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Příznaky Covid-19 jsou prakticky totožné s příznaky chřipky. Výhodou této diagnostiky je včasná a účinná léčba pacienta s respiračními potížemi. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The symptoms of Covid-19 are practically identical to flu symptoms. The advantage of this diagnosis is early and effective treatment of a patient with respiratory problems. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/testovanie-covid-19-versus-chripka.html",
            "category": null
          },
          {
            "type": {
              "sk": "Samoodberové testy",
              "cs": "Samoodběrové testy",
              "en": "Self-collection tests"
            },
            "icon": "bloodtest",
            "benefit": {
              "sk": "Špeciálne samoodberové testy so zľavou 5 eur",
              "cs": "Speciální testy pro vlastní odběr se slevou 5 EUR",
              "en": "Special self-collection tests with a EUR 5 discount"
            },
            "description": {
              "sk": "Špeciálne samoodberové testy so zľavou 5 eur. Samotestom získate výsledky z certifikovaného laboratória už do 10 dní od odoslania vzorky. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Speciální testy pro vlastní odběr se slevou 5 EUR. Díky tomuto testu získáte výsledky z certifikované laboratoře již do 10 dnů od odeslání vzorku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Special self-collection tests with a discount of EUR 5. With the self-test, you will receive results from a certified laboratory within 10 days of sending the sample. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ziskajte-kontrolu-nad-vlastnym-zdravim-vdaka-medistom.html",
            "category": null
          },
          {
            "type": {
              "sk": "Potraviny bez lepku YAMIS",
              "cs": "Bezlepkové potraviny YAMIS",
              "en": "Gluten-free foods YAMIS"
            },
            "icon": "gluten",
            "benefit": {
              "sk": "Potraviny bez lepku YAMIS so zľavou 10 %",
              "cs": "Bezlepkové potraviny YAMIS se slevou 10 %",
              "en": "YAMIS gluten-free food with a 10% discount"
            },
            "description": {
              "sk": "Navštívte e-shop YAMIS a objavte pestrú ponuku kvalitných bezlepkových potravín vhodných pre ľudí s intoleranciou na lepok aj pre priaznivcov zdravého životného štýlu. Využite 10 % zľavu a nakupujte pohodlne online. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Navštivte e-shop YAMIS a objevte pestrou nabídku kvalitních bezlepkových potravin vhodných pro osoby s nesnášenlivostí lepku i pro příznivce zdravého životního stylu. Využijte 10% slevu a nakupujte pohodlně online. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Visit the YAMIS e-shop and discover a wide range of high-quality gluten-free foods suitable for people with gluten intolerance and for supporters of a healthy lifestyle. Take advantage of a 10% discount and shop comfortably online. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/potraviny-bez-lepku-yamis.html",
            "category": null
          },
          {
            "type": {
              "sk": "Úvodná DIA FIT konzultácia a jedálniček",
              "cs": "Úvodní konzultace DIA FIT a jídelníček",
              "en": "Introductory DIA FIT consultation and diet plan"
            },
            "icon": "zdravy-talir",
            "benefit": {
              "sk": "Úvodná DIA FIT konzultácia a jedálniček zdarma pre diabetikov",
              "cs": "Úvodní konzultace DIA FIT a jídelníček zdarma pro diabetiky",
              "en": "Free initial consultation and DIA FIT diet plan for clients with diabetes"
            },
            "description": {
              "sk": "Zdravá strava a pohyb sú pri diabete kľúčové. Program DIA FIT ponúka poistencom VšZP možnosť absolvovať úvodnú konzultáciu a individuálny jedálniček úplne zdarma, pod vedením osobného trénera Martina Tkáča, ktorý už 27 rokov aktívne športuje a žije s diabetom. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravá strava a pohyb jsou při cukrovce klíčové. Program DIA FIT nabízí pojištěncům VšZP možnost absolvovat úvodní konzultaci a individuální jídelníček zcela zdarma pod vedením osobního trenéra Martina Tkáče, který již 27 let aktivně sportuje a žije s cukrovkou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A healthy diet and exercise are key in diabetes. The DIA FIT program offers VšZP policyholders the opportunity to undergo an initial consultation and an individual diet completely free of charge, under the guidance of personal trainer Martin Tkáč, who has been active in sports and lives with diabetes for 27 years. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/konzultacia-jedalnicek-diafit-programu-diabetikov.html",
            "category": null
          },
          {
            "type": {
              "sk": "Poistenie úrazu a života SPIRIT v ČSOB",
              "cs": "Úrazové a životní pojištění SPIRIT v ČSOB",
              "en": "Accident and life insurance SPIRIT at ČSOB"
            },
            "icon": "shield",
            "benefit": {
              "sk": "Poistenie úrazu a života SPIRIT v ČSOB so zľavou 15 %",
              "cs": "Úrazové a životní pojištění SPIRIT v ČSOB se slevou 15 %",
              "en": "SPIRIT accident and life insurance at ČSOB with a 15% discount"
            },
            "description": {
              "sk": "Poistenie úrazu a života SPIRIT v ČSOB so zľavou 15 %. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Úrazové a životní pojištění SPIRIT v ČSOB se slevou 15 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "SPIRIT accident and life insurance at ČSOB with a 15% discount. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/poistenie-urazu-zivota-spirit-csob.html",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na lieky, výživové doplnky a kozmetiku",
              "cs": "Sleva na léky, doplňky stravy a kosmetiku",
              "en": "Discount on medicines, nutritional supplements, and cosmetics"
            },
            "icon": "pill",
            "benefit": {
              "sk": "Až 15 % zľava na lieky, výživové doplnky a kozmetiku",
              "cs": "Až 15% sleva na léky, doplňky stravy a kosmetiku",
              "en": "Up to 15% discount on medicines, nutritional supplements, and cosmetics"
            },
            "description": {
              "sk": "Na internetovom obchode si môžete zakúpiť voľnopredajné lieky, výživové doplnky, ale aj kozmetiku. Lieky24.sk je overeným obchodom, ktorý ponúka dopravu zdarma, zaručuje rýchle dodanie tovaru a ponúka široký sortiment výrobkov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "V internetovém obchodě si můžete zakoupit volně prodejné léky, doplňky stravy, ale i kosmetiku. Lieky24.sk je ověřený obchod, který nabízí dopravu zdarma, zaručuje rychlé doručení zboží a nabízí široký sortiment produktů. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "You can purchase over-the-counter medications, nutritional supplements, and even cosmetics on-line. Lieky24.sk is a trusted e-shop with a broad range of products, offering free shipping with guaranteed quick delivery. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/e-shop-lieky24-sk.html",
            "category": null
          },
          {
            "type": {
              "sk": "Extrakcia zuba múdrosti a iné dentálne zákroky so zľavou",
              "cs": "Extrakce zubů moudrosti a další zubní zákroky se slevou",
              "en": "Wisdom tooth extraction and other dental procedures with discounts "
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Extrakcia zuba múdrosti a iné dentálne zákroky so zľavou až do 50 %",
              "cs": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %",
              "en": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%"
            },
            "description": {
              "sk": "Extrakcia zuba múdrosti a iné dentálne zákroky so zľavou až do 50 %. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/?checked0=494&docId=6949&count=20",
            "category": null
          },
          {
            "type": {
              "sk": "Ďalšie výhody a zľavy pre všetkých",
              "cs": "Další výhody a slevy pro všechny",
              "en": "More benefits and discounts for all"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Výhody pre celú rodinu",
              "cs": "Výhody pro celou rodinu    ",
              "en": "Benefits for the whole family"
            },
            "description": {
              "sk": "Užite si ďalšie benefity a výhody, ktoré vám poisťovňa ponúka. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Využijte další benefity a výhody, které vám pojišťovna nabízí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Take advantage of more benefits and discounts offered by your insurer. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/?",
            "category": null
          },
          {
            "type": {
              "sk": "Štvrté sonografické vyšetrenie pre tehotné",
              "cs": "Čtvrté ultrazvukové vyšetření pro těhotné",
              "en": "Fourth ultrasound examination for pregnant women"
            },
            "icon": "pregnant",
            "benefit": {
              "sk": "Štvrté sonografické vyšetrenie grátis",
              "cs": "Čtvrté ultrazvukové vyšetření zdarma",
              "en": "A free fourth ultrasound examination"
            },
            "description": {
              "sk": "Poistenky VšZP dostanú od nás štvrté sonografické vyšetrenie grátis, nad rámec verejného zdravotného poistenia. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pojištěnkyně VšZP od nás získají čtvrté ultrazvukové vyšetření zdarma, nad rámec veřejného zdravotního pojištění. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Female VšZP clients will receive a free fourth ultrasound examination from us, over and above public health insurance. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/stvrte-sonograficke-vysetrenie-tehotne.html",
            "category": null
          },
          {
            "type": {
              "sk": "Predpôrodné a popôrodné poradenstvo",
              "cs": "Prenatální a poporodní poradenství",
              "en": "Prenatal and postnatal counseling"
            },
            "icon": "pregnant",
            "benefit": {
              "sk": "Bezplatné predpôrodné, popôrodné a laktačné poradenstvo",
              "cs": "Bezplatné prenatální, poporodní a laktační poradenství",
              "en": "Free prenatal, postnatal, and lactation counseling"
            },
            "description": {
              "sk": "Bezplatné predpôrodné, popôrodné a laktačné poradenstvo, ktoré môžu mamičky využiť päť dní v týždni. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Bezplatné prenatální, poporodní a laktační poradenství, které mohou maminky využívat pět dní v týdnu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Free prenatal, postnatal, and lactation counseling available to new mothers five days a week. \nFor more information, visit the health insurance company’s website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/bezplatne-predporodne-poporodne-poradenstvo.html",
            "category": null
          }
        ]
      },
      {
        "name": {
          "sk": "Deti",
          "cs": "Děti",
          "en": "Children"
        },
        "benefits": [
          {
            "type": {
              "sk": "Neviditeľný strojček na zuby",
              "cs": "Neviditelná rovnátka",
              "en": "Invisible braces"
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Zľava 22 % na neviditeľný strojček na zuby \n",
              "cs": "Sleva 22 % na neviditelná rovnátka",
              "en": "A 22 % discount on invisible braces"
            },
            "description": {
              "sk": "Až do 22 % zľava na neviditeľný zubný strojček + Dental monitoring vo Family Dental Care - Ortho. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Až 22% sleva na neviditelná rovnátka + Dental monitoring ve Family Dental Care – Ortho. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to 22% discount on invisible braces + Dental monitoring at Family Dental Care - Ortho. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/zlava-neviditelny-zubny-strojcek-vo-family-dental-care-ortho.html",
            "category": "Děti"
          },
          {
            "type": {
              "sk": "Extrakcia zuba múdrosti a iné dentálne zákroky so zľavou",
              "cs": "Extrakce zubů moudrosti a další zubní zákroky se slevou",
              "en": "Wisdom tooth extraction and other dental procedures with discounts"
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Extrakcia zuba múdrosti a iné dentálne zákroky so zľavou až do 50 %",
              "cs": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %",
              "en": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%"
            },
            "description": {
              "sk": "Extrakcia zuba múdrosti a iné dentálne zákroky so zľavou až do 50 %. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/?checked0=494&docId=6949&count=20",
            "category": null
          },
          {
            "type": {
              "sk": "U zubára jemne a bez bolesti ",
              "cs": "U zubaře šetrně a bez bolesti",
              "en": "At the dentist gently and painlessly"
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Anestézia u zubára deťom do 10 rokov",
              "cs": "Anestezie u zubaře pro děti do 10 let",
              "en": "We cover anesthesia for children under 10 years of age."
            },
            "description": {
              "sk": "Lokálna anestézia je určená všetkým deťom do 10 rokov, možno ju využiť aj u menších detí. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Lokální anestezie je určena všem dětem do 10 let, lze ji použít i u menších dětí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Local anesthesia is intended for all children under 10 years of age, and can also be used for younger children. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/u-zubara-bez-bolesti-hradime-anesteziu-detom-do-10-rokov.html",
            "category": null
          },
          {
            "type": {
              "sk": "Protónová liečba pre onkologických pacientov",
              "cs": "Protonová léčba pro onkologické pacienty",
              "en": "Proton treatment for cancer patients"
            },
            "icon": "ribbon",
            "benefit": {
              "sk": "Liečba hradená poisťovňou",
              "cs": "Léčba hrazená pojišťovnou",
              "en": "Treatment covered by insurance"
            },
            "description": {
              "sk": "Protónová liečba sa využíva najmä pri nádoroch na mozgu, hlavy a krku (nádory oka, prínosových dutín, príušnej žľazy), nádoroch prsníka, prostaty, pečene, pankreasu a nádoroch v detskom veku. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Protonová léčba se využívá zejména u nádorů mozku, hlavy a krku (nádory oka, vedlejších nosních dutin, příušní žlázy), nádorů prsu, prostaty, jater, slinivky břišní a nádorů u dětí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Proton treatment is used primarily for tumours of the brain, head, and neck (tumours of the eye, nasal passages, parotid glands), tumours of the breast, prostate, and pancreas, and tumours in children. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/protonova-liecba-onkologickych-pacientov.html",
            "category": null
          },
          {
            "type": {
              "sk": "Komplexné vstupné stomatologické vyšetrenie s röntgenovou a OPG snímkou",
              "cs": "Komplexní vstupní stomatologické vyšetření s rentgenovým snímkem a OPG snímkem",
              "en": "Comprehensive initial dental examination with X-ray and OPG image"
            },
            "icon": "tooth",
            "benefit": {
              "sk": "Hradené poisťovňou",
              "cs": "Hrazeno pojišťovnou",
              "en": "Covered by insurance"
            },
            "description": {
              "sk": "Komplexné vstupné stomatologické vyšetrenie s röntgenovou a OPG snímkou hradené poisťovňou. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Komplexní vstupní stomatologické vyšetření s rentgenovým snímkem a OPG snímkem hrazeno pojišťovnou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Comprehensive initial dental examination with X-ray and OPG image covered by insurance. More information (in Slovak only) is available on the insurance company's website here: link. "
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/komplexne-vstupne-stomatologicke-vysetrenie-rontgenovou-opg-snimkou.html",
            "category": null
          },
          {
            "type": {
              "sk": "Potraviny bez lepku YAMIS",
              "cs": "Bezlepkové potraviny YAMIS",
              "en": "Gluten-free foods YAMIS"
            },
            "icon": "gluten",
            "benefit": {
              "sk": "Potraviny bez lepku YAMIS so zľavou 10 %",
              "cs": "Bezlepkové potraviny YAMIS se slevou 10 %",
              "en": "YAMIS gluten-free food with a 10% discount"
            },
            "description": {
              "sk": "Navštívte e-shop YAMIS a objavte pestrú ponuku kvalitných bezlepkových potravín vhodných pre ľudí s intoleranciou na lepok aj pre priaznivcov zdravého životného štýlu. Využite 10 % zľavu a nakupujte pohodlne online. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Navštivte e-shop YAMIS a objevte pestrou nabídku kvalitních bezlepkových potravin vhodných pro osoby s nesnášenlivostí lepku i pro příznivce zdravého životního stylu. Využijte 10% slevu a nakupujte pohodlně online. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Visit the YAMIS e-shop and discover a wide range of high-quality gluten-free foods suitable for people with gluten intolerance and for supporters of a healthy lifestyle. Take advantage of a 10% discount and shop comfortably online. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/potraviny-bez-lepku-yamis.html",
            "category": null
          },
          {
            "type": {
              "sk": "Úvodná DIA FIT konzultácia a jedálniček",
              "cs": "Úvodní konzultace DIA FIT a jídelníček",
              "en": "Introductory DIA FIT consultation and diet plan"
            },
            "icon": "zdravy-talir",
            "benefit": {
              "sk": "Úvodná DIA FIT konzultácia a jedálniček zdarma pre diabetikov",
              "cs": "Úvodní konzultace DIA FIT a jídelníček zdarma pro diabetiky",
              "en": "Free initial consultation and DIA FIT diet plan for clients with diabetes"
            },
            "description": {
              "sk": "Zdravá strava a pohyb sú pri diabete kľúčové. Program DIA FIT ponúka poistencom VšZP možnosť absolvovať úvodnú konzultáciu a individuálny jedálniček úplne zdarma, pod vedením osobného trénera Martina Tkáča, ktorý už 27 rokov aktívne športuje a žije s diabetom. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Zdravá strava a pohyb jsou při cukrovce klíčové. Program DIA FIT nabízí pojištěncům VšZP možnost absolvovat úvodní konzultaci a individuální jídelníček zcela zdarma pod vedením osobního trenéra Martina Tkáče, který již 27 let aktivně sportuje a žije s cukrovkou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "A healthy diet and exercise are key in diabetes. The DIA FIT program offers VšZP policyholders the opportunity to undergo an initial consultation and an individual diet completely free of charge, under the guidance of personal trainer Martin Tkáč, who has been active in sports and lives with diabetes for 27 years. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/konzultacia-jedalnicek-diafit-programu-diabetikov.html",
            "category": null
          },
          {
            "type": {
              "sk": "Zľavy na okuliare ",
              "cs": "Slevy na brýle",
              "en": "Discount on glasses"
            },
            "icon": "glasses",
            "benefit": {
              "sk": "Zľava až 35 % na okuliare na vybraných pobočkách",
              "cs": "Sleva až 35 % na brýle ve vybraných pobočkách    ",
              "en": "Up to 35% discount on glasses at selected branches"
            },
            "description": {
              "sk": "Až 35 % zľava na okuliare vo vybraných pobočkách. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Až 35% sleva na brýle ve vybraných pobočkách. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Up to 35% discount on glasses at selected branches. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/?dospeli&checked0=490",
            "category": null
          },
          {
            "type": {
              "sk": "Podpora prevencie obezity a manažovanie obezity u detí",
              "cs": "Podpora prevence obezity a léčba obezity u dětí",
              "en": "Support for obesity prevention and obesity management in children"
            },
            "icon": "care",
            "benefit": {
              "sk": "Podpora prevencie obezity zadarmo",
              "cs": "Bezplatná podpora prevence obezity",
              "en": "Free obesity prevention support"
            },
            "description": {
              "sk": "Cieľom podpory prevencie je včasné zachytenie rizikových faktorov rôznych ochorení, ktoré sa bežne nehradí z verejného zdravotného poistenia. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Cílem podpory prevence je včasné odhalení rizikových faktorů různých onemocnění, která nejsou běžně hrazena z veřejného zdravotního pojištění. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The goal of prevention support is early detection of risk factors for various diseases that is not routinely covered by public health insurance. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/podpora-prevencie-obezity-amanazovanie-obezity-udeti.html",
            "category": null
          },
          {
            "type": {
              "sk": "Liečba porúch príjmu potravy pre deti",
              "cs": "Léčba poruch příjmu potravy u dětí",
              "en": "Treatment of eating disorders in children"
            },
            "icon": "nutrition",
            "benefit": {
              "sk": "Liečba na špecializovanom pracovisku zadarmo",
              "cs": "Léčba na specializovaném pracovišti zdarma",
              "en": "Free treatment at a specialized facility"
            },
            "description": {
              "sk": "Liečba je určená deťom do 18 rokov veku pri ťažkých stavoch anorexie a bulímie, ktoré nie je možné riešiť ambulantne. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Léčba je určena dětem do 18 let s těžkými formami anorexie a bulimie, které nelze řešit ambulantně. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "This treatment is intended for children up to the age of 18 with serious cases of anorexia and bulimia that cannot be treated on an outpatient basis. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/liecba-poruch-prijmu-potravy-deti-nad-ramec-zdravotneho-poistenia.html",
            "category": null
          },
          {
            "type": {
              "sk": "Nastavenie diabetika na inzulínovú pumpu v ambulancii",
              "cs": "Nastavení diabetika na inzulinovou pumpu v ambulanci",
              "en": "Setting up a diabetic patient for an insulin pump in an outpatient clinic"
            },
            "icon": "diabetes",
            "benefit": {
              "sk": "Ambulantné nastavenie inzulínovej pumpy zadarmo",
              "cs": "Ambulantní nastavení inzulinové pumpy zdarma",
              "en": "Free installation of an insulin pump on an outpatient basis"
            },
            "description": {
              "sk": "Pacient dostane niekoľkohodinové zaškolenie, nastavia ho na pumpu a získa všetky informácie potrebné pre praktický život s touto zdravotníckou pomôckou. Z ambulancie odíde už s funkčnou pumpou, zavedeným senzorom a aplikáciou v smartfóne. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Pacient absolvuje několikahodinové zaškolení, bude nastaven na pumpu a získá všechny informace potřebné pro praktický život s touto zdravotnickou pomůckou. Z ambulance odejde již s funkční pumpou, zavedeným senzorem a aplikací ve smartphonu. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The patient will receive several hours of training, will be prepared for pump use, and will obtain all information necessary for practical living with this medical device. They will leave the clinic with a functional pump, an implanted sensor, and an application in their smartphone. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/nastavenie-diabetika-inzulinovu-pumpu-vambulancii.html",
            "category": null
          },
          {
            "type": {
              "sk": "Balíček pre novorodencov plný prekvapení",
              "cs": "Balíček pro novorozence plný překvapení",
              "en": "A gift box full of surprises for newborns"
            },
            "icon": "birth",
            "benefit": {
              "sk": "Darčekový kufrík pre bábätká",
              "cs": "Dárkový kufřík pro miminka",
              "en": "A gift box for babies"
            },
            "description": {
              "sk": "Vo väčšine pôrodníc na Slovensku dostanú mamičky zdarma darčekový kufrík. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Ve většině porodnic na Slovensku dostanou maminky zdarma dárkový kufřík. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "In most maternity hospitals in Slovakia, mothers will receive a free gift box. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/balicek-novorodencov-plny-prekvapen.html",
            "category": null
          },
          {
            "type": {
              "sk": "Očkovanie proti chrípke",
              "cs": "Očkování proti chřipce",
              "en": "Flu vaccination"
            },
            "icon": "vaccine",
            "benefit": {
              "sk": "Vakcíny proti chrípke preplatené v plnej výške ich ceny",
              "cs": "Vakcíny proti chřipce hrazené v plné výši",
              "en": "Coverage of the full price of flu vaccines"
            },
            "description": {
              "sk": "Očkovanie proti chrípke je účinnou formou prevencie, ktorá pomáha chrániť pred vážnymi komplikáciami tohto ochorenia. Je dostupné pre každého poistenca VšZP s nárokom na plnú zdravotnú starostlivosť. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Očkování proti chřipce je účinnou formou prevence, která pomáhá chránit před vážnými komplikacemi tohoto onemocnění. Je dostupné pro každého pojištěnce VZP s nárokem na plnou zdravotní péči. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Flu vaccination is an effective form of prevention that helps protect against serious complications of this disease. It is available to all VZP policyholders entitled to full healthcare. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke.html",
            "category": null
          },
          {
            "type": {
              "sk": "Ďalšie výhody a zľavy pre všetkých",
              "cs": "Další výhody a slevy pro všechny",
              "en": "More benefits and discounts for all"
            },
            "icon": "payment",
            "benefit": {
              "sk": "Výhody pre celú rodinu",
              "cs": "Výhody pro celou rodinu    ",
              "en": "Benefits for the whole family"
            },
            "description": {
              "sk": "Užite si ďalšie benefity a výhody, ktoré vám poisťovňa ponúka. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Využijte další benefity a výhody, které vám pojišťovna nabízí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "Take advantage of more benefits and discounts offered by your insurer. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/?",
            "category": null
          },
          {
            "type": {
              "sk": "Zľava na lieky, výživové doplnky a kozmetiku",
              "cs": "Sleva na léky, doplňky stravy a kosmetiku",
              "en": "Discount on medicines, nutritional supplements, and cosmetics"
            },
            "icon": "pill",
            "benefit": {
              "sk": "Až 15 % zľava na lieky, výživové doplnky a kozmetiku",
              "cs": "Až 15% sleva na léky, doplňky stravy a kosmetiku",
              "en": "Up to 15% discount on medicines, nutritional supplements, and cosmetics"
            },
            "description": {
              "sk": "Na internetovom obchode si môžete zakúpiť voľnopredajné lieky, výživové doplnky, ale aj kozmetiku. Lieky24.sk je overeným obchodom, ktorý ponúka dopravu zdarma, zaručuje rýchle dodanie tovaru a ponúka široký sortiment výrobkov. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "V internetovém obchodě si můžete zakoupit volně prodejné léky, doplňky stravy, ale i kosmetiku. Lieky24.sk je ověřený obchod, který nabízí dopravu zdarma, zaručuje rychlé doručení zboží a nabízí široký sortiment produktů. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "You can purchase over-the-counter medications, nutritional supplements, and even cosmetics on-line. Lieky24.sk is a trusted e-shop with a broad range of products, offering free shipping with guaranteed quick delivery. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/e-shop-lieky24-sk.html",
            "category": null
          },
          {
            "type": {
              "sk": "Testovanie Covid-19 versus chrípka",
              "cs": "Testování na Covid-19 versus chřipku",
              "en": "Covid-19 vs. flu testing"
            },
            "icon": "danger",
            "benefit": {
              "sk": "Kompletná diferenciálna diagnostika zadarmo",
              "cs": "Kompletní diferenciální diagnostika zdarma",
              "en": "A free complete differential diagnosis"
            },
            "description": {
              "sk": "Príznaky Covid-19 sú prakticky zhodné s chrípkovými symptómami. Výhodou tejto diagnostiky je včasná a účinná liečba pacienta s respiračným problémami. Viac informácií sa dozviete na stránkach zdravotnej poisťovne tu: odkaz.",
              "cs": "Příznaky Covid-19 jsou prakticky totožné s příznaky chřipky. Výhodou této diagnostiky je včasná a účinná léčba pacienta s respiračními potížemi. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
              "en": "The symptoms of Covid-19 are practically identical to flu symptoms. The advantage of this diagnosis is early and effective treatment of a patient with respiratory problems. More information (in Slovak only) is available on the insurance company's website here: link."
            },
            "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/testovanie-covid-19-versus-chripka.html",
            "category": null
          }
        ]
      }
    ],
    "updateDate": "3.2.2026",
    "companyBenefitsLink": "https://www.vszp.sk/benefity/"
  }
]
